import * as M from "react";
import te, { useEffect as fe, createElement as F, forwardRef as ce, useRef as ee, Children as ht, isValidElement as kt, cloneElement as Ot, useState as le, useCallback as ge, useMemo as it, useLayoutEffect as Da, useReducer as $r, Component as Ym, createContext as qn, useContext as Lr, Fragment as gs } from "react";
import "./themes.css.ts.vanilla-4ed993c7.js";
import { c as ye, b as Bc, h as Wm } from "./text.css-a0bf9212.js";
import { a as wI, f as CI, d as NI, q as II, r as EI } from "./text.css-a0bf9212.js";
import * as Fs from "react-dom";
import cr, { flushSync as Hc } from "react-dom";
function Bm(e, t) {
  fe(() => {
    const n = r => {
      const o = r.composed && r.composedPath && r.composedPath().shift() || r.target;
      !e.current || e.current.contains(o) || t(r);
    };
    return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
    };
  },
  // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new ...
  // ... function on every render that will cause this effect ...
  // ... callback/cleanup to run every render. It's not a big deal ...
  // ... but to optimize you can wrap handler in useCallback before ...
  // ... passing it into this hook.
  [e, t]);
}
var Hm = "j04uv0";
var Us = "xippxe0";
var gN = "l6o05y9 l6o05y6 l6o05y0",
  hN = "l6o05y9 l6o05y6 l6o05y3",
  vN = "l6o05y9 l6o05y7 l6o05y0",
  Qm = "l6o05y9 l6o05y7 l6o05y3",
  Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ys(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ho = {
    exports: {}
  },
  ir = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wi;
function qm() {
  if (Wi) return ir;
  Wi = 1;
  var e = te,
    t = Symbol.for("react.element"),
    n = Symbol.for("react.fragment"),
    r = Object.prototype.hasOwnProperty,
    o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    s = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function a(i, l, c) {
    var d,
      f = {},
      g = null,
      p = null;
    c !== void 0 && (g = "" + c), l.key !== void 0 && (g = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (d in l) r.call(l, d) && !s.hasOwnProperty(d) && (f[d] = l[d]);
    if (i && i.defaultProps) for (d in l = i.defaultProps, l) f[d] === void 0 && (f[d] = l[d]);
    return {
      $$typeof: t,
      type: i,
      key: g,
      ref: p,
      props: f,
      _owner: o.current
    };
  }
  return ir.Fragment = n, ir.jsx = a, ir.jsxs = a, ir;
}
var lr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bi;
function Km() {
  return Bi || (Bi = 1, process.env.NODE_ENV !== "production" && function () {
    var e = te,
      t = Symbol.for("react.element"),
      n = Symbol.for("react.portal"),
      r = Symbol.for("react.fragment"),
      o = Symbol.for("react.strict_mode"),
      s = Symbol.for("react.profiler"),
      a = Symbol.for("react.provider"),
      i = Symbol.for("react.context"),
      l = Symbol.for("react.forward_ref"),
      c = Symbol.for("react.suspense"),
      d = Symbol.for("react.suspense_list"),
      f = Symbol.for("react.memo"),
      g = Symbol.for("react.lazy"),
      p = Symbol.for("react.offscreen"),
      x = Symbol.iterator,
      m = "@@iterator";
    function h(w) {
      if (w === null || typeof w != "object") return null;
      var W = x && w[x] || w[m];
      return typeof W == "function" ? W : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(w) {
      {
        for (var W = arguments.length, re = new Array(W > 1 ? W - 1 : 0), ve = 1; ve < W; ve++) re[ve - 1] = arguments[ve];
        _("error", w, re);
      }
    }
    function _(w, W, re) {
      {
        var ve = j.ReactDebugCurrentFrame,
          Ie = ve.getStackAddendum();
        Ie !== "" && (W += "%s", re = re.concat([Ie]));
        var Ae = re.map(function (be) {
          return String(be);
        });
        Ae.unshift("Warning: " + W), Function.prototype.apply.call(console[w], console, Ae);
      }
    }
    var k = !1,
      y = !1,
      b = !1,
      C = !1,
      N = !1,
      T;
    T = Symbol.for("react.module.reference");
    function z(w) {
      return !!(typeof w == "string" || typeof w == "function" || w === r || w === s || N || w === o || w === c || w === d || C || w === p || k || y || b || typeof w == "object" && w !== null && (w.$$typeof === g || w.$$typeof === f || w.$$typeof === a || w.$$typeof === i || w.$$typeof === l ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      w.$$typeof === T || w.getModuleId !== void 0));
    }
    function K(w, W, re) {
      var ve = w.displayName;
      if (ve) return ve;
      var Ie = W.displayName || W.name || "";
      return Ie !== "" ? re + "(" + Ie + ")" : re;
    }
    function L(w) {
      return w.displayName || "Context";
    }
    function H(w) {
      if (w == null) return null;
      if (typeof w.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof w == "function") return w.displayName || w.name || null;
      if (typeof w == "string") return w;
      switch (w) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof w == "object") switch (w.$$typeof) {
        case i:
          var W = w;
          return L(W) + ".Consumer";
        case a:
          var re = w;
          return L(re._context) + ".Provider";
        case l:
          return K(w, w.render, "ForwardRef");
        case f:
          var ve = w.displayName || null;
          return ve !== null ? ve : H(w.type) || "Memo";
        case g:
          {
            var Ie = w,
              Ae = Ie._payload,
              be = Ie._init;
            try {
              return H(be(Ae));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var Y = Object.assign,
      X = 0,
      ne,
      U,
      de,
      Z,
      S,
      R,
      ae;
    function P() {}
    P.__reactDisabledLog = !0;
    function D() {
      {
        if (X === 0) {
          ne = console.log, U = console.info, de = console.warn, Z = console.error, S = console.group, R = console.groupCollapsed, ae = console.groupEnd;
          var w = {
            configurable: !0,
            enumerable: !0,
            value: P,
            writable: !0
          };
          Object.defineProperties(console, {
            info: w,
            log: w,
            warn: w,
            error: w,
            group: w,
            groupCollapsed: w,
            groupEnd: w
          });
        }
        X++;
      }
    }
    function O() {
      {
        if (X--, X === 0) {
          var w = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, w, {
              value: ne
            }),
            info: Y({}, w, {
              value: U
            }),
            warn: Y({}, w, {
              value: de
            }),
            error: Y({}, w, {
              value: Z
            }),
            group: Y({}, w, {
              value: S
            }),
            groupCollapsed: Y({}, w, {
              value: R
            }),
            groupEnd: Y({}, w, {
              value: ae
            })
          });
        }
        X < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var A = j.ReactCurrentDispatcher,
      E;
    function G(w, W, re) {
      {
        if (E === void 0) try {
          throw Error();
        } catch (Ie) {
          var ve = Ie.stack.trim().match(/\n( *(at )?)/);
          E = ve && ve[1] || "";
        }
        return `
` + E + w;
      }
    }
    var B = !1,
      Q;
    {
      var ie = typeof WeakMap == "function" ? WeakMap : Map;
      Q = new ie();
    }
    function $(w, W) {
      if (!w || B) return "";
      {
        var re = Q.get(w);
        if (re !== void 0) return re;
      }
      var ve;
      B = !0;
      var Ie = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ae;
      Ae = A.current, A.current = null, D();
      try {
        if (W) {
          var be = function () {
            throw Error();
          };
          if (Object.defineProperty(be.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(be, []);
            } catch (Xe) {
              ve = Xe;
            }
            Reflect.construct(w, [], be);
          } else {
            try {
              be.call();
            } catch (Xe) {
              ve = Xe;
            }
            w.call(be.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xe) {
            ve = Xe;
          }
          w();
        }
      } catch (Xe) {
        if (Xe && ve && typeof Xe.stack == "string") {
          for (var Me = Xe.stack.split(`
`), qe = ve.stack.split(`
`), ze = Me.length - 1, Re = qe.length - 1; ze >= 1 && Re >= 0 && Me[ze] !== qe[Re];) Re--;
          for (; ze >= 1 && Re >= 0; ze--, Re--) if (Me[ze] !== qe[Re]) {
            if (ze !== 1 || Re !== 1) do if (ze--, Re--, Re < 0 || Me[ze] !== qe[Re]) {
              var ct = `
` + Me[ze].replace(" at new ", " at ");
              return w.displayName && ct.includes("<anonymous>") && (ct = ct.replace("<anonymous>", w.displayName)), typeof w == "function" && Q.set(w, ct), ct;
            } while (ze >= 1 && Re >= 0);
            break;
          }
        }
      } finally {
        B = !1, A.current = Ae, O(), Error.prepareStackTrace = Ie;
      }
      var Tn = w ? w.displayName || w.name : "",
        gn = Tn ? G(Tn) : "";
      return typeof w == "function" && Q.set(w, gn), gn;
    }
    function je(w, W, re) {
      return $(w, !1);
    }
    function J(w) {
      var W = w.prototype;
      return !!(W && W.isReactComponent);
    }
    function Ce(w, W, re) {
      if (w == null) return "";
      if (typeof w == "function") return $(w, J(w));
      if (typeof w == "string") return G(w);
      switch (w) {
        case c:
          return G("Suspense");
        case d:
          return G("SuspenseList");
      }
      if (typeof w == "object") switch (w.$$typeof) {
        case l:
          return je(w.render);
        case f:
          return Ce(w.type, W, re);
        case g:
          {
            var ve = w,
              Ie = ve._payload,
              Ae = ve._init;
            try {
              return Ce(Ae(Ie), W, re);
            } catch {}
          }
      }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty,
      Ye = {},
      lt = j.ReactDebugCurrentFrame;
    function Be(w) {
      if (w) {
        var W = w._owner,
          re = Ce(w.type, w._source, W ? W.type : null);
        lt.setExtraStackFrame(re);
      } else lt.setExtraStackFrame(null);
    }
    function et(w, W, re, ve, Ie) {
      {
        var Ae = Function.call.bind(Ne);
        for (var be in w) if (Ae(w, be)) {
          var Me = void 0;
          try {
            if (typeof w[be] != "function") {
              var qe = Error((ve || "React class") + ": " + re + " type `" + be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof w[be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw qe.name = "Invariant Violation", qe;
            }
            Me = w[be](W, be, ve, re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (ze) {
            Me = ze;
          }
          Me && !(Me instanceof Error) && (Be(Ie), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ve || "React class", re, be, typeof Me), Be(null)), Me instanceof Error && !(Me.message in Ye) && (Ye[Me.message] = !0, Be(Ie), v("Failed %s type: %s", re, Me.message), Be(null));
        }
      }
    }
    var dt = Array.isArray;
    function fn(w) {
      return dt(w);
    }
    function ft(w) {
      {
        var W = typeof Symbol == "function" && Symbol.toStringTag,
          re = W && w[Symbol.toStringTag] || w.constructor.name || "Object";
        return re;
      }
    }
    function pn(w) {
      try {
        return En(w), !1;
      } catch {
        return !0;
      }
    }
    function En(w) {
      return "" + w;
    }
    function mn(w) {
      if (pn(w)) return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ft(w)), En(w);
    }
    var Ge = j.ReactCurrentOwner,
      St = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      pt,
      Je,
      ar;
    ar = {};
    function Cm(w) {
      if (Ne.call(w, "ref")) {
        var W = Object.getOwnPropertyDescriptor(w, "ref").get;
        if (W && W.isReactWarning) return !1;
      }
      return w.ref !== void 0;
    }
    function Nm(w) {
      if (Ne.call(w, "key")) {
        var W = Object.getOwnPropertyDescriptor(w, "key").get;
        if (W && W.isReactWarning) return !1;
      }
      return w.key !== void 0;
    }
    function Im(w, W) {
      if (typeof w.ref == "string" && Ge.current && W && Ge.current.stateNode !== W) {
        var re = H(Ge.current.type);
        ar[re] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(Ge.current.type), w.ref), ar[re] = !0);
      }
    }
    function Em(w, W) {
      {
        var re = function () {
          pt || (pt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        re.isReactWarning = !0, Object.defineProperty(w, "key", {
          get: re,
          configurable: !0
        });
      }
    }
    function Sm(w, W) {
      {
        var re = function () {
          Je || (Je = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        re.isReactWarning = !0, Object.defineProperty(w, "ref", {
          get: re,
          configurable: !0
        });
      }
    }
    var Tm = function (w, W, re, ve, Ie, Ae, be) {
      var Me = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: w,
        key: W,
        ref: re,
        props: be,
        // Record the component responsible for creating this element.
        _owner: Ae
      };
      return Me._store = {}, Object.defineProperty(Me._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Me, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ve
      }), Object.defineProperty(Me, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.freeze && (Object.freeze(Me.props), Object.freeze(Me)), Me;
    };
    function Dm(w, W, re, ve, Ie) {
      {
        var Ae,
          be = {},
          Me = null,
          qe = null;
        re !== void 0 && (mn(re), Me = "" + re), Nm(W) && (mn(W.key), Me = "" + W.key), Cm(W) && (qe = W.ref, Im(W, Ie));
        for (Ae in W) Ne.call(W, Ae) && !St.hasOwnProperty(Ae) && (be[Ae] = W[Ae]);
        if (w && w.defaultProps) {
          var ze = w.defaultProps;
          for (Ae in ze) be[Ae] === void 0 && (be[Ae] = ze[Ae]);
        }
        if (Me || qe) {
          var Re = typeof w == "function" ? w.displayName || w.name || "Unknown" : w;
          Me && Em(be, Re), qe && Sm(be, Re);
        }
        return Tm(w, Me, qe, Ie, ve, Ge.current, be);
      }
    }
    var io = j.ReactCurrentOwner,
      zi = j.ReactDebugCurrentFrame;
    function Sn(w) {
      if (w) {
        var W = w._owner,
          re = Ce(w.type, w._source, W ? W.type : null);
        zi.setExtraStackFrame(re);
      } else zi.setExtraStackFrame(null);
    }
    var lo;
    lo = !1;
    function co(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }
    function Ri() {
      {
        if (io.current) {
          var w = H(io.current.type);
          if (w) return `

Check the render method of \`` + w + "`.";
        }
        return "";
      }
    }
    function Om(w) {
      {
        if (w !== void 0) {
          var W = w.fileName.replace(/^.*[\\\/]/, ""),
            re = w.lineNumber;
          return `

Check your code at ` + W + ":" + re + ".";
        }
        return "";
      }
    }
    var Pi = {};
    function Am(w) {
      {
        var W = Ri();
        if (!W) {
          var re = typeof w == "string" ? w : w.displayName || w.name;
          re && (W = `

Check the top-level render call using <` + re + ">.");
        }
        return W;
      }
    }
    function Vi(w, W) {
      {
        if (!w._store || w._store.validated || w.key != null) return;
        w._store.validated = !0;
        var re = Am(W);
        if (Pi[re]) return;
        Pi[re] = !0;
        var ve = "";
        w && w._owner && w._owner !== io.current && (ve = " It was passed a child from " + H(w._owner.type) + "."), Sn(w), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', re, ve), Sn(null);
      }
    }
    function Fi(w, W) {
      {
        if (typeof w != "object") return;
        if (fn(w)) for (var re = 0; re < w.length; re++) {
          var ve = w[re];
          co(ve) && Vi(ve, W);
        } else if (co(w)) w._store && (w._store.validated = !0);else if (w) {
          var Ie = h(w);
          if (typeof Ie == "function" && Ie !== w.entries) for (var Ae = Ie.call(w), be; !(be = Ae.next()).done;) co(be.value) && Vi(be.value, W);
        }
      }
    }
    function $m(w) {
      {
        var W = w.type;
        if (W == null || typeof W == "string") return;
        var re;
        if (typeof W == "function") re = W.propTypes;else if (typeof W == "object" && (W.$$typeof === l ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        W.$$typeof === f)) re = W.propTypes;else return;
        if (re) {
          var ve = H(W);
          et(re, w.props, "prop", ve, w);
        } else if (W.PropTypes !== void 0 && !lo) {
          lo = !0;
          var Ie = H(W);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ie || "Unknown");
        }
        typeof W.getDefaultProps == "function" && !W.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Lm(w) {
      {
        for (var W = Object.keys(w.props), re = 0; re < W.length; re++) {
          var ve = W[re];
          if (ve !== "children" && ve !== "key") {
            Sn(w), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ve), Sn(null);
            break;
          }
        }
        w.ref !== null && (Sn(w), v("Invalid attribute `ref` supplied to `React.Fragment`."), Sn(null));
      }
    }
    var Ui = {};
    function Yi(w, W, re, ve, Ie, Ae) {
      {
        var be = z(w);
        if (!be) {
          var Me = "";
          (w === void 0 || typeof w == "object" && w !== null && Object.keys(w).length === 0) && (Me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var qe = Om(Ie);
          qe ? Me += qe : Me += Ri();
          var ze;
          w === null ? ze = "null" : fn(w) ? ze = "array" : w !== void 0 && w.$$typeof === t ? (ze = "<" + (H(w.type) || "Unknown") + " />", Me = " Did you accidentally export a JSX literal instead of a component?") : ze = typeof w, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ze, Me);
        }
        var Re = Dm(w, W, re, Ie, Ae);
        if (Re == null) return Re;
        if (be) {
          var ct = W.children;
          if (ct !== void 0) if (ve) {
            if (fn(ct)) {
              for (var Tn = 0; Tn < ct.length; Tn++) Fi(ct[Tn], w);
              Object.freeze && Object.freeze(ct);
            } else v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else Fi(ct, w);
        }
        if (Ne.call(W, "key")) {
          var gn = H(w),
            Xe = Object.keys(W).filter(function (Um) {
              return Um !== "key";
            }),
            uo = Xe.length > 0 ? "{key: someKey, " + Xe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ui[gn + uo]) {
            var Fm = Xe.length > 0 ? "{" + Xe.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, uo, gn, Fm, gn), Ui[gn + uo] = !0;
          }
        }
        return w === r ? Lm(Re) : $m(Re), Re;
      }
    }
    function zm(w, W, re) {
      return Yi(w, W, re, !0);
    }
    function Rm(w, W, re) {
      return Yi(w, W, re, !1);
    }
    var Pm = Rm,
      Vm = zm;
    lr.Fragment = r, lr.jsx = Pm, lr.jsxs = Vm;
  }()), lr;
}
process.env.NODE_ENV === "production" ? Ho.exports = qm() : Ho.exports = Km();
var u = Ho.exports;
function Zm(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gm(e) {
  var t = Zm(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Jm(e, t, n) {
  return t = Gm(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Hi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hi(Object(n), !0).forEach(function (r) {
      Jm(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hi(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Xm = e => function () {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    var o = Object.assign({}, ...n.map(l => l.styles)),
      s = Object.keys(o),
      a = s.filter(l => "mappings" in o[l]),
      i = l => {
        var c = [],
          d = {},
          f = fo({}, l),
          g = !1;
        for (var p of a) {
          var x = l[p];
          if (x != null) {
            var m = o[p];
            g = !0;
            for (var h of m.mappings) d[h] = x, f[h] == null && delete f[h];
          }
        }
        var j = g ? fo(fo({}, d), f) : l,
          v = function () {
            var y = j[_],
              b = o[_];
            try {
              if (b.mappings) return 1;
              if (typeof y == "string" || typeof y == "number") {
                if (process.env.NODE_ENV !== "production" && !b.values[y].defaultClass) throw new Error();
                c.push(b.values[y].defaultClass);
              } else if (Array.isArray(y)) for (var C = 0; C < y.length; C++) {
                var N = y[C];
                if (N != null) {
                  var T = b.responsiveArray[C];
                  if (process.env.NODE_ENV !== "production" && !b.values[N].conditions[T]) throw new Error();
                  c.push(b.values[N].conditions[T]);
                }
              } else for (var z in y) {
                var K = y[z];
                if (K != null) {
                  if (process.env.NODE_ENV !== "production" && !b.values[K].conditions[z]) throw new Error();
                  c.push(b.values[K].conditions[z]);
                }
              }
            } catch (de) {
              if (process.env.NODE_ENV !== "production") {
                class Z extends Error {
                  constructor(R) {
                    super(R), this.name = "SprinklesError";
                  }
                }
                var L = S => typeof S == "string" ? '"'.concat(S, '"') : S,
                  H = (S, R, ae) => {
                    throw new Z('"'.concat(S, '" has no value ').concat(L(R), ". Possible values are ").concat(Object.keys(ae).map(L).join(", ")));
                  };
                if (!b) throw new Z('"'.concat(_, '" is not a valid sprinkle'));
                if ((typeof y == "string" || typeof y == "number") && (y in b.values || H(_, y, b.values), !b.values[y].defaultClass)) throw new Z('"'.concat(_, '" has no default condition. You must specify which conditions to target explicitly. Possible options are ').concat(Object.keys(b.values[y].conditions).map(L).join(", ")));
                if (typeof y == "object") {
                  if (!("conditions" in b.values[Object.keys(b.values)[0]])) throw new Z('"'.concat(_, '" is not a conditional property'));
                  if (Array.isArray(y)) {
                    if (!("responsiveArray" in b)) throw new Z('"'.concat(_, '" does not support responsive arrays'));
                    var Y = b.responsiveArray.length;
                    if (Y < y.length) throw new Z('"'.concat(_, '" only supports up to ').concat(Y, " breakpoints. You passed ").concat(y.length));
                    for (var X of y) b.values[X] || H(_, X, b.values);
                  } else for (var ne in y) {
                    var U = y[ne];
                    if (U != null && (b.values[U] || H(_, U, b.values), !b.values[U].conditions[ne])) throw new Z('"'.concat(_, '" has no condition named ').concat(L(ne), ". Possible values are ").concat(Object.keys(b.values[U].conditions).map(L).join(", ")));
                  }
                }
              }
              throw de;
            }
          };
        for (var _ in j) v();
        return e(c.join(" "));
      };
    return Object.assign(i, {
      properties: new Set(s)
    });
  },
  eg = e => e,
  tg = function () {
    return Xm(eg)(...arguments);
  },
  hs = tg({
    conditions: {
      defaultCondition: "_",
      conditionNames: ["_", "sm", "md", "lg", "xl"],
      responsiveArray: void 0
    },
    styles: {
      padding: {
        mappings: ["paddingBlockStart", "paddingInlineEnd", "paddingBlockEnd", "paddingInlineStart"]
      },
      paddingX: {
        mappings: ["paddingInlineStart", "paddingInlineEnd"]
      },
      paddingInline: {
        mappings: ["paddingInlineStart", "paddingInlineEnd"]
      },
      paddingY: {
        mappings: ["paddingBlockStart", "paddingInlineEnd"]
      },
      paddingBlock: {
        mappings: ["paddingBlockStart", "paddingBlockEnd"]
      },
      margin: {
        mappings: ["marginBlockStart", "marginInlineEnd", "marginBlockEnd", "marginInlineStart"]
      },
      marginX: {
        mappings: ["marginInlineStart", "marginInlineEnd"]
      },
      marginInline: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8pf",
              sm: "_1j2kes8pg",
              md: "_1j2kes8ph",
              lg: "_1j2kes8pi",
              xl: "_1j2kes8pj"
            },
            defaultClass: "_1j2kes8pf"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8pk",
              sm: "_1j2kes8pl",
              md: "_1j2kes8pm",
              lg: "_1j2kes8pn",
              xl: "_1j2kes8po"
            },
            defaultClass: "_1j2kes8pk"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8pp",
              sm: "_1j2kes8pq",
              md: "_1j2kes8pr",
              lg: "_1j2kes8ps",
              xl: "_1j2kes8pt"
            },
            defaultClass: "_1j2kes8pp"
          },
          xs: {
            conditions: {
              _: "_1j2kes8pu",
              sm: "_1j2kes8pv",
              md: "_1j2kes8pw",
              lg: "_1j2kes8px",
              xl: "_1j2kes8py"
            },
            defaultClass: "_1j2kes8pu"
          },
          sm: {
            conditions: {
              _: "_1j2kes8pz",
              sm: "_1j2kes8q0",
              md: "_1j2kes8q1",
              lg: "_1j2kes8q2",
              xl: "_1j2kes8q3"
            },
            defaultClass: "_1j2kes8pz"
          },
          md: {
            conditions: {
              _: "_1j2kes8q4",
              sm: "_1j2kes8q5",
              md: "_1j2kes8q6",
              lg: "_1j2kes8q7",
              xl: "_1j2kes8q8"
            },
            defaultClass: "_1j2kes8q4"
          },
          lg: {
            conditions: {
              _: "_1j2kes8q9",
              sm: "_1j2kes8qa",
              md: "_1j2kes8qb",
              lg: "_1j2kes8qc",
              xl: "_1j2kes8qd"
            },
            defaultClass: "_1j2kes8q9"
          },
          xl: {
            conditions: {
              _: "_1j2kes8qe",
              sm: "_1j2kes8qf",
              md: "_1j2kes8qg",
              lg: "_1j2kes8qh",
              xl: "_1j2kes8qi"
            },
            defaultClass: "_1j2kes8qe"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8qj",
              sm: "_1j2kes8qk",
              md: "_1j2kes8ql",
              lg: "_1j2kes8qm",
              xl: "_1j2kes8qn"
            },
            defaultClass: "_1j2kes8qj"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8qo",
              sm: "_1j2kes8qp",
              md: "_1j2kes8qq",
              lg: "_1j2kes8qr",
              xl: "_1j2kes8qs"
            },
            defaultClass: "_1j2kes8qo"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8qt",
              sm: "_1j2kes8qu",
              md: "_1j2kes8qv",
              lg: "_1j2kes8qw",
              xl: "_1j2kes8qx"
            },
            defaultClass: "_1j2kes8qt"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8qy",
              sm: "_1j2kes8qz",
              md: "_1j2kes8r0",
              lg: "_1j2kes8r1",
              xl: "_1j2kes8r2"
            },
            defaultClass: "_1j2kes8qy"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8r3",
              sm: "_1j2kes8r4",
              md: "_1j2kes8r5",
              lg: "_1j2kes8r6",
              xl: "_1j2kes8r7"
            },
            defaultClass: "_1j2kes8r3"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8r8",
              sm: "_1j2kes8r9",
              md: "_1j2kes8ra",
              lg: "_1j2kes8rb",
              xl: "_1j2kes8rc"
            },
            defaultClass: "_1j2kes8r8"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8rd",
              sm: "_1j2kes8re",
              md: "_1j2kes8rf",
              lg: "_1j2kes8rg",
              xl: "_1j2kes8rh"
            },
            defaultClass: "_1j2kes8rd"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8ri",
              sm: "_1j2kes8rj",
              md: "_1j2kes8rk",
              lg: "_1j2kes8rl",
              xl: "_1j2kes8rm"
            },
            defaultClass: "_1j2kes8ri"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8rn",
              sm: "_1j2kes8ro",
              md: "_1j2kes8rp",
              lg: "_1j2kes8rq",
              xl: "_1j2kes8rr"
            },
            defaultClass: "_1j2kes8rn"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8rs",
              sm: "_1j2kes8rt",
              md: "_1j2kes8ru",
              lg: "_1j2kes8rv",
              xl: "_1j2kes8rw"
            },
            defaultClass: "_1j2kes8rs"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8rx",
              sm: "_1j2kes8ry",
              md: "_1j2kes8rz",
              lg: "_1j2kes8s0",
              xl: "_1j2kes8s1"
            },
            defaultClass: "_1j2kes8rx"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8s2",
              sm: "_1j2kes8s3",
              md: "_1j2kes8s4",
              lg: "_1j2kes8s5",
              xl: "_1j2kes8s6"
            },
            defaultClass: "_1j2kes8s2"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8s7",
              sm: "_1j2kes8s8",
              md: "_1j2kes8s9",
              lg: "_1j2kes8sa",
              xl: "_1j2kes8sb"
            },
            defaultClass: "_1j2kes8s7"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8sc",
              sm: "_1j2kes8sd",
              md: "_1j2kes8se",
              lg: "_1j2kes8sf",
              xl: "_1j2kes8sg"
            },
            defaultClass: "_1j2kes8sc"
          },
          auto: {
            conditions: {
              _: "_1j2kes8sh",
              sm: "_1j2kes8si",
              md: "_1j2kes8sj",
              lg: "_1j2kes8sk",
              xl: "_1j2kes8sl"
            },
            defaultClass: "_1j2kes8sh"
          }
        }
      },
      marginY: {
        mappings: ["marginBlockStart", "marginInlineEnd"]
      },
      marginBlock: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8m8",
              sm: "_1j2kes8m9",
              md: "_1j2kes8ma",
              lg: "_1j2kes8mb",
              xl: "_1j2kes8mc"
            },
            defaultClass: "_1j2kes8m8"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8md",
              sm: "_1j2kes8me",
              md: "_1j2kes8mf",
              lg: "_1j2kes8mg",
              xl: "_1j2kes8mh"
            },
            defaultClass: "_1j2kes8md"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8mi",
              sm: "_1j2kes8mj",
              md: "_1j2kes8mk",
              lg: "_1j2kes8ml",
              xl: "_1j2kes8mm"
            },
            defaultClass: "_1j2kes8mi"
          },
          xs: {
            conditions: {
              _: "_1j2kes8mn",
              sm: "_1j2kes8mo",
              md: "_1j2kes8mp",
              lg: "_1j2kes8mq",
              xl: "_1j2kes8mr"
            },
            defaultClass: "_1j2kes8mn"
          },
          sm: {
            conditions: {
              _: "_1j2kes8ms",
              sm: "_1j2kes8mt",
              md: "_1j2kes8mu",
              lg: "_1j2kes8mv",
              xl: "_1j2kes8mw"
            },
            defaultClass: "_1j2kes8ms"
          },
          md: {
            conditions: {
              _: "_1j2kes8mx",
              sm: "_1j2kes8my",
              md: "_1j2kes8mz",
              lg: "_1j2kes8n0",
              xl: "_1j2kes8n1"
            },
            defaultClass: "_1j2kes8mx"
          },
          lg: {
            conditions: {
              _: "_1j2kes8n2",
              sm: "_1j2kes8n3",
              md: "_1j2kes8n4",
              lg: "_1j2kes8n5",
              xl: "_1j2kes8n6"
            },
            defaultClass: "_1j2kes8n2"
          },
          xl: {
            conditions: {
              _: "_1j2kes8n7",
              sm: "_1j2kes8n8",
              md: "_1j2kes8n9",
              lg: "_1j2kes8na",
              xl: "_1j2kes8nb"
            },
            defaultClass: "_1j2kes8n7"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8nc",
              sm: "_1j2kes8nd",
              md: "_1j2kes8ne",
              lg: "_1j2kes8nf",
              xl: "_1j2kes8ng"
            },
            defaultClass: "_1j2kes8nc"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8nh",
              sm: "_1j2kes8ni",
              md: "_1j2kes8nj",
              lg: "_1j2kes8nk",
              xl: "_1j2kes8nl"
            },
            defaultClass: "_1j2kes8nh"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8nm",
              sm: "_1j2kes8nn",
              md: "_1j2kes8no",
              lg: "_1j2kes8np",
              xl: "_1j2kes8nq"
            },
            defaultClass: "_1j2kes8nm"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8nr",
              sm: "_1j2kes8ns",
              md: "_1j2kes8nt",
              lg: "_1j2kes8nu",
              xl: "_1j2kes8nv"
            },
            defaultClass: "_1j2kes8nr"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8nw",
              sm: "_1j2kes8nx",
              md: "_1j2kes8ny",
              lg: "_1j2kes8nz",
              xl: "_1j2kes8o0"
            },
            defaultClass: "_1j2kes8nw"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8o1",
              sm: "_1j2kes8o2",
              md: "_1j2kes8o3",
              lg: "_1j2kes8o4",
              xl: "_1j2kes8o5"
            },
            defaultClass: "_1j2kes8o1"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8o6",
              sm: "_1j2kes8o7",
              md: "_1j2kes8o8",
              lg: "_1j2kes8o9",
              xl: "_1j2kes8oa"
            },
            defaultClass: "_1j2kes8o6"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8ob",
              sm: "_1j2kes8oc",
              md: "_1j2kes8od",
              lg: "_1j2kes8oe",
              xl: "_1j2kes8of"
            },
            defaultClass: "_1j2kes8ob"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8og",
              sm: "_1j2kes8oh",
              md: "_1j2kes8oi",
              lg: "_1j2kes8oj",
              xl: "_1j2kes8ok"
            },
            defaultClass: "_1j2kes8og"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8ol",
              sm: "_1j2kes8om",
              md: "_1j2kes8on",
              lg: "_1j2kes8oo",
              xl: "_1j2kes8op"
            },
            defaultClass: "_1j2kes8ol"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8oq",
              sm: "_1j2kes8or",
              md: "_1j2kes8os",
              lg: "_1j2kes8ot",
              xl: "_1j2kes8ou"
            },
            defaultClass: "_1j2kes8oq"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8ov",
              sm: "_1j2kes8ow",
              md: "_1j2kes8ox",
              lg: "_1j2kes8oy",
              xl: "_1j2kes8oz"
            },
            defaultClass: "_1j2kes8ov"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8p0",
              sm: "_1j2kes8p1",
              md: "_1j2kes8p2",
              lg: "_1j2kes8p3",
              xl: "_1j2kes8p4"
            },
            defaultClass: "_1j2kes8p0"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8p5",
              sm: "_1j2kes8p6",
              md: "_1j2kes8p7",
              lg: "_1j2kes8p8",
              xl: "_1j2kes8p9"
            },
            defaultClass: "_1j2kes8p5"
          },
          auto: {
            conditions: {
              _: "_1j2kes8pa",
              sm: "_1j2kes8pb",
              md: "_1j2kes8pc",
              lg: "_1j2kes8pd",
              xl: "_1j2kes8pe"
            },
            defaultClass: "_1j2kes8pa"
          }
        }
      },
      position: {
        values: {
          absolute: {
            conditions: {
              _: "_1j2kes80",
              sm: "_1j2kes81",
              md: "_1j2kes82",
              lg: "_1j2kes83",
              xl: "_1j2kes84"
            },
            defaultClass: "_1j2kes80"
          },
          relative: {
            conditions: {
              _: "_1j2kes85",
              sm: "_1j2kes86",
              md: "_1j2kes87",
              lg: "_1j2kes88",
              xl: "_1j2kes89"
            },
            defaultClass: "_1j2kes85"
          },
          fixed: {
            conditions: {
              _: "_1j2kes8a",
              sm: "_1j2kes8b",
              md: "_1j2kes8c",
              lg: "_1j2kes8d",
              xl: "_1j2kes8e"
            },
            defaultClass: "_1j2kes8a"
          }
        }
      },
      display: {
        values: {
          block: {
            conditions: {
              _: "_1j2kes8f",
              sm: "_1j2kes8g",
              md: "_1j2kes8h",
              lg: "_1j2kes8i",
              xl: "_1j2kes8j"
            },
            defaultClass: "_1j2kes8f"
          },
          flex: {
            conditions: {
              _: "_1j2kes8k",
              sm: "_1j2kes8l",
              md: "_1j2kes8m",
              lg: "_1j2kes8n",
              xl: "_1j2kes8o"
            },
            defaultClass: "_1j2kes8k"
          },
          inline: {
            conditions: {
              _: "_1j2kes8p",
              sm: "_1j2kes8q",
              md: "_1j2kes8r",
              lg: "_1j2kes8s",
              xl: "_1j2kes8t"
            },
            defaultClass: "_1j2kes8p"
          },
          "inline-flex": {
            conditions: {
              _: "_1j2kes8u",
              sm: "_1j2kes8v",
              md: "_1j2kes8w",
              lg: "_1j2kes8x",
              xl: "_1j2kes8y"
            },
            defaultClass: "_1j2kes8u"
          },
          "inline-block": {
            conditions: {
              _: "_1j2kes8z",
              sm: "_1j2kes810",
              md: "_1j2kes811",
              lg: "_1j2kes812",
              xl: "_1j2kes813"
            },
            defaultClass: "_1j2kes8z"
          },
          grid: {
            conditions: {
              _: "_1j2kes814",
              sm: "_1j2kes815",
              md: "_1j2kes816",
              lg: "_1j2kes817",
              xl: "_1j2kes818"
            },
            defaultClass: "_1j2kes814"
          },
          "inline-grid": {
            conditions: {
              _: "_1j2kes819",
              sm: "_1j2kes81a",
              md: "_1j2kes81b",
              lg: "_1j2kes81c",
              xl: "_1j2kes81d"
            },
            defaultClass: "_1j2kes819"
          },
          none: {
            conditions: {
              _: "_1j2kes81e",
              sm: "_1j2kes81f",
              md: "_1j2kes81g",
              lg: "_1j2kes81h",
              xl: "_1j2kes81i"
            },
            defaultClass: "_1j2kes81e"
          }
        }
      },
      alignSelf: {
        values: {
          "flex-start": {
            conditions: {
              _: "_1j2kes81j",
              sm: "_1j2kes81k",
              md: "_1j2kes81l",
              lg: "_1j2kes81m",
              xl: "_1j2kes81n"
            },
            defaultClass: "_1j2kes81j"
          },
          "flex-end": {
            conditions: {
              _: "_1j2kes81o",
              sm: "_1j2kes81p",
              md: "_1j2kes81q",
              lg: "_1j2kes81r",
              xl: "_1j2kes81s"
            },
            defaultClass: "_1j2kes81o"
          },
          center: {
            conditions: {
              _: "_1j2kes81t",
              sm: "_1j2kes81u",
              md: "_1j2kes81v",
              lg: "_1j2kes81w",
              xl: "_1j2kes81x"
            },
            defaultClass: "_1j2kes81t"
          },
          stretch: {
            conditions: {
              _: "_1j2kes81y",
              sm: "_1j2kes81z",
              md: "_1j2kes820",
              lg: "_1j2kes821",
              xl: "_1j2kes822"
            },
            defaultClass: "_1j2kes81y"
          }
        }
      },
      alignItems: {
        values: {
          "flex-start": {
            conditions: {
              _: "_1j2kes823",
              sm: "_1j2kes824",
              md: "_1j2kes825",
              lg: "_1j2kes826",
              xl: "_1j2kes827"
            },
            defaultClass: "_1j2kes823"
          },
          "flex-end": {
            conditions: {
              _: "_1j2kes828",
              sm: "_1j2kes829",
              md: "_1j2kes82a",
              lg: "_1j2kes82b",
              xl: "_1j2kes82c"
            },
            defaultClass: "_1j2kes828"
          },
          center: {
            conditions: {
              _: "_1j2kes82d",
              sm: "_1j2kes82e",
              md: "_1j2kes82f",
              lg: "_1j2kes82g",
              xl: "_1j2kes82h"
            },
            defaultClass: "_1j2kes82d"
          },
          stretch: {
            conditions: {
              _: "_1j2kes82i",
              sm: "_1j2kes82j",
              md: "_1j2kes82k",
              lg: "_1j2kes82l",
              xl: "_1j2kes82m"
            },
            defaultClass: "_1j2kes82i"
          }
        }
      },
      justifyContent: {
        values: {
          "flex-start": {
            conditions: {
              _: "_1j2kes82n",
              sm: "_1j2kes82o",
              md: "_1j2kes82p",
              lg: "_1j2kes82q",
              xl: "_1j2kes82r"
            },
            defaultClass: "_1j2kes82n"
          },
          center: {
            conditions: {
              _: "_1j2kes82s",
              sm: "_1j2kes82t",
              md: "_1j2kes82u",
              lg: "_1j2kes82v",
              xl: "_1j2kes82w"
            },
            defaultClass: "_1j2kes82s"
          },
          "flex-end": {
            conditions: {
              _: "_1j2kes82x",
              sm: "_1j2kes82y",
              md: "_1j2kes82z",
              lg: "_1j2kes830",
              xl: "_1j2kes831"
            },
            defaultClass: "_1j2kes82x"
          },
          "space-between": {
            conditions: {
              _: "_1j2kes832",
              sm: "_1j2kes833",
              md: "_1j2kes834",
              lg: "_1j2kes835",
              xl: "_1j2kes836"
            },
            defaultClass: "_1j2kes832"
          }
        }
      },
      flexDirection: {
        values: {
          row: {
            conditions: {
              _: "_1j2kes837",
              sm: "_1j2kes838",
              md: "_1j2kes839",
              lg: "_1j2kes83a",
              xl: "_1j2kes83b"
            },
            defaultClass: "_1j2kes837"
          },
          "row-reverse": {
            conditions: {
              _: "_1j2kes83c",
              sm: "_1j2kes83d",
              md: "_1j2kes83e",
              lg: "_1j2kes83f",
              xl: "_1j2kes83g"
            },
            defaultClass: "_1j2kes83c"
          },
          column: {
            conditions: {
              _: "_1j2kes83h",
              sm: "_1j2kes83i",
              md: "_1j2kes83j",
              lg: "_1j2kes83k",
              xl: "_1j2kes83l"
            },
            defaultClass: "_1j2kes83h"
          },
          "column-reverse": {
            conditions: {
              _: "_1j2kes83m",
              sm: "_1j2kes83n",
              md: "_1j2kes83o",
              lg: "_1j2kes83p",
              xl: "_1j2kes83q"
            },
            defaultClass: "_1j2kes83m"
          }
        }
      },
      flexWrap: {
        values: {
          wrap: {
            conditions: {
              _: "_1j2kes83r",
              sm: "_1j2kes83s",
              md: "_1j2kes83t",
              lg: "_1j2kes83u",
              xl: "_1j2kes83v"
            },
            defaultClass: "_1j2kes83r"
          },
          nowrap: {
            conditions: {
              _: "_1j2kes83w",
              sm: "_1j2kes83x",
              md: "_1j2kes83y",
              lg: "_1j2kes83z",
              xl: "_1j2kes840"
            },
            defaultClass: "_1j2kes83w"
          }
        }
      },
      flexShrink: {
        values: {
          0: {
            conditions: {
              _: "_1j2kes841",
              sm: "_1j2kes842",
              md: "_1j2kes843",
              lg: "_1j2kes844",
              xl: "_1j2kes845"
            },
            defaultClass: "_1j2kes841"
          },
          1: {
            conditions: {
              _: "_1j2kes846",
              sm: "_1j2kes847",
              md: "_1j2kes848",
              lg: "_1j2kes849",
              xl: "_1j2kes84a"
            },
            defaultClass: "_1j2kes846"
          }
        }
      },
      flexGrow: {
        values: {
          0: {
            conditions: {
              _: "_1j2kes84b",
              sm: "_1j2kes84c",
              md: "_1j2kes84d",
              lg: "_1j2kes84e",
              xl: "_1j2kes84f"
            },
            defaultClass: "_1j2kes84b"
          },
          1: {
            conditions: {
              _: "_1j2kes84g",
              sm: "_1j2kes84h",
              md: "_1j2kes84i",
              lg: "_1j2kes84j",
              xl: "_1j2kes84k"
            },
            defaultClass: "_1j2kes84g"
          }
        }
      },
      gap: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes84l",
              sm: "_1j2kes84m",
              md: "_1j2kes84n",
              lg: "_1j2kes84o",
              xl: "_1j2kes84p"
            },
            defaultClass: "_1j2kes84l"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes84q",
              sm: "_1j2kes84r",
              md: "_1j2kes84s",
              lg: "_1j2kes84t",
              xl: "_1j2kes84u"
            },
            defaultClass: "_1j2kes84q"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes84v",
              sm: "_1j2kes84w",
              md: "_1j2kes84x",
              lg: "_1j2kes84y",
              xl: "_1j2kes84z"
            },
            defaultClass: "_1j2kes84v"
          },
          xs: {
            conditions: {
              _: "_1j2kes850",
              sm: "_1j2kes851",
              md: "_1j2kes852",
              lg: "_1j2kes853",
              xl: "_1j2kes854"
            },
            defaultClass: "_1j2kes850"
          },
          sm: {
            conditions: {
              _: "_1j2kes855",
              sm: "_1j2kes856",
              md: "_1j2kes857",
              lg: "_1j2kes858",
              xl: "_1j2kes859"
            },
            defaultClass: "_1j2kes855"
          },
          md: {
            conditions: {
              _: "_1j2kes85a",
              sm: "_1j2kes85b",
              md: "_1j2kes85c",
              lg: "_1j2kes85d",
              xl: "_1j2kes85e"
            },
            defaultClass: "_1j2kes85a"
          },
          lg: {
            conditions: {
              _: "_1j2kes85f",
              sm: "_1j2kes85g",
              md: "_1j2kes85h",
              lg: "_1j2kes85i",
              xl: "_1j2kes85j"
            },
            defaultClass: "_1j2kes85f"
          },
          xl: {
            conditions: {
              _: "_1j2kes85k",
              sm: "_1j2kes85l",
              md: "_1j2kes85m",
              lg: "_1j2kes85n",
              xl: "_1j2kes85o"
            },
            defaultClass: "_1j2kes85k"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes85p",
              sm: "_1j2kes85q",
              md: "_1j2kes85r",
              lg: "_1j2kes85s",
              xl: "_1j2kes85t"
            },
            defaultClass: "_1j2kes85p"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes85u",
              sm: "_1j2kes85v",
              md: "_1j2kes85w",
              lg: "_1j2kes85x",
              xl: "_1j2kes85y"
            },
            defaultClass: "_1j2kes85u"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes85z",
              sm: "_1j2kes860",
              md: "_1j2kes861",
              lg: "_1j2kes862",
              xl: "_1j2kes863"
            },
            defaultClass: "_1j2kes85z"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes864",
              sm: "_1j2kes865",
              md: "_1j2kes866",
              lg: "_1j2kes867",
              xl: "_1j2kes868"
            },
            defaultClass: "_1j2kes864"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes869",
              sm: "_1j2kes86a",
              md: "_1j2kes86b",
              lg: "_1j2kes86c",
              xl: "_1j2kes86d"
            },
            defaultClass: "_1j2kes869"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes86e",
              sm: "_1j2kes86f",
              md: "_1j2kes86g",
              lg: "_1j2kes86h",
              xl: "_1j2kes86i"
            },
            defaultClass: "_1j2kes86e"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes86j",
              sm: "_1j2kes86k",
              md: "_1j2kes86l",
              lg: "_1j2kes86m",
              xl: "_1j2kes86n"
            },
            defaultClass: "_1j2kes86j"
          }
        }
      },
      gridTemplateColumns: {
        values: {
          1: {
            conditions: {
              _: "_1j2kes86o",
              sm: "_1j2kes86p",
              md: "_1j2kes86q",
              lg: "_1j2kes86r",
              xl: "_1j2kes86s"
            },
            defaultClass: "_1j2kes86o"
          },
          2: {
            conditions: {
              _: "_1j2kes86t",
              sm: "_1j2kes86u",
              md: "_1j2kes86v",
              lg: "_1j2kes86w",
              xl: "_1j2kes86x"
            },
            defaultClass: "_1j2kes86t"
          },
          3: {
            conditions: {
              _: "_1j2kes86y",
              sm: "_1j2kes86z",
              md: "_1j2kes870",
              lg: "_1j2kes871",
              xl: "_1j2kes872"
            },
            defaultClass: "_1j2kes86y"
          },
          4: {
            conditions: {
              _: "_1j2kes873",
              sm: "_1j2kes874",
              md: "_1j2kes875",
              lg: "_1j2kes876",
              xl: "_1j2kes877"
            },
            defaultClass: "_1j2kes873"
          },
          5: {
            conditions: {
              _: "_1j2kes878",
              sm: "_1j2kes879",
              md: "_1j2kes87a",
              lg: "_1j2kes87b",
              xl: "_1j2kes87c"
            },
            defaultClass: "_1j2kes878"
          },
          6: {
            conditions: {
              _: "_1j2kes87d",
              sm: "_1j2kes87e",
              md: "_1j2kes87f",
              lg: "_1j2kes87g",
              xl: "_1j2kes87h"
            },
            defaultClass: "_1j2kes87d"
          }
        }
      },
      paddingBlockStart: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes87i",
              sm: "_1j2kes87j",
              md: "_1j2kes87k",
              lg: "_1j2kes87l",
              xl: "_1j2kes87m"
            },
            defaultClass: "_1j2kes87i"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes87n",
              sm: "_1j2kes87o",
              md: "_1j2kes87p",
              lg: "_1j2kes87q",
              xl: "_1j2kes87r"
            },
            defaultClass: "_1j2kes87n"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes87s",
              sm: "_1j2kes87t",
              md: "_1j2kes87u",
              lg: "_1j2kes87v",
              xl: "_1j2kes87w"
            },
            defaultClass: "_1j2kes87s"
          },
          xs: {
            conditions: {
              _: "_1j2kes87x",
              sm: "_1j2kes87y",
              md: "_1j2kes87z",
              lg: "_1j2kes880",
              xl: "_1j2kes881"
            },
            defaultClass: "_1j2kes87x"
          },
          sm: {
            conditions: {
              _: "_1j2kes882",
              sm: "_1j2kes883",
              md: "_1j2kes884",
              lg: "_1j2kes885",
              xl: "_1j2kes886"
            },
            defaultClass: "_1j2kes882"
          },
          md: {
            conditions: {
              _: "_1j2kes887",
              sm: "_1j2kes888",
              md: "_1j2kes889",
              lg: "_1j2kes88a",
              xl: "_1j2kes88b"
            },
            defaultClass: "_1j2kes887"
          },
          lg: {
            conditions: {
              _: "_1j2kes88c",
              sm: "_1j2kes88d",
              md: "_1j2kes88e",
              lg: "_1j2kes88f",
              xl: "_1j2kes88g"
            },
            defaultClass: "_1j2kes88c"
          },
          xl: {
            conditions: {
              _: "_1j2kes88h",
              sm: "_1j2kes88i",
              md: "_1j2kes88j",
              lg: "_1j2kes88k",
              xl: "_1j2kes88l"
            },
            defaultClass: "_1j2kes88h"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes88m",
              sm: "_1j2kes88n",
              md: "_1j2kes88o",
              lg: "_1j2kes88p",
              xl: "_1j2kes88q"
            },
            defaultClass: "_1j2kes88m"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes88r",
              sm: "_1j2kes88s",
              md: "_1j2kes88t",
              lg: "_1j2kes88u",
              xl: "_1j2kes88v"
            },
            defaultClass: "_1j2kes88r"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes88w",
              sm: "_1j2kes88x",
              md: "_1j2kes88y",
              lg: "_1j2kes88z",
              xl: "_1j2kes890"
            },
            defaultClass: "_1j2kes88w"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes891",
              sm: "_1j2kes892",
              md: "_1j2kes893",
              lg: "_1j2kes894",
              xl: "_1j2kes895"
            },
            defaultClass: "_1j2kes891"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes896",
              sm: "_1j2kes897",
              md: "_1j2kes898",
              lg: "_1j2kes899",
              xl: "_1j2kes89a"
            },
            defaultClass: "_1j2kes896"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes89b",
              sm: "_1j2kes89c",
              md: "_1j2kes89d",
              lg: "_1j2kes89e",
              xl: "_1j2kes89f"
            },
            defaultClass: "_1j2kes89b"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes89g",
              sm: "_1j2kes89h",
              md: "_1j2kes89i",
              lg: "_1j2kes89j",
              xl: "_1j2kes89k"
            },
            defaultClass: "_1j2kes89g"
          }
        }
      },
      paddingBlockEnd: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes89l",
              sm: "_1j2kes89m",
              md: "_1j2kes89n",
              lg: "_1j2kes89o",
              xl: "_1j2kes89p"
            },
            defaultClass: "_1j2kes89l"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes89q",
              sm: "_1j2kes89r",
              md: "_1j2kes89s",
              lg: "_1j2kes89t",
              xl: "_1j2kes89u"
            },
            defaultClass: "_1j2kes89q"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes89v",
              sm: "_1j2kes89w",
              md: "_1j2kes89x",
              lg: "_1j2kes89y",
              xl: "_1j2kes89z"
            },
            defaultClass: "_1j2kes89v"
          },
          xs: {
            conditions: {
              _: "_1j2kes8a0",
              sm: "_1j2kes8a1",
              md: "_1j2kes8a2",
              lg: "_1j2kes8a3",
              xl: "_1j2kes8a4"
            },
            defaultClass: "_1j2kes8a0"
          },
          sm: {
            conditions: {
              _: "_1j2kes8a5",
              sm: "_1j2kes8a6",
              md: "_1j2kes8a7",
              lg: "_1j2kes8a8",
              xl: "_1j2kes8a9"
            },
            defaultClass: "_1j2kes8a5"
          },
          md: {
            conditions: {
              _: "_1j2kes8aa",
              sm: "_1j2kes8ab",
              md: "_1j2kes8ac",
              lg: "_1j2kes8ad",
              xl: "_1j2kes8ae"
            },
            defaultClass: "_1j2kes8aa"
          },
          lg: {
            conditions: {
              _: "_1j2kes8af",
              sm: "_1j2kes8ag",
              md: "_1j2kes8ah",
              lg: "_1j2kes8ai",
              xl: "_1j2kes8aj"
            },
            defaultClass: "_1j2kes8af"
          },
          xl: {
            conditions: {
              _: "_1j2kes8ak",
              sm: "_1j2kes8al",
              md: "_1j2kes8am",
              lg: "_1j2kes8an",
              xl: "_1j2kes8ao"
            },
            defaultClass: "_1j2kes8ak"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8ap",
              sm: "_1j2kes8aq",
              md: "_1j2kes8ar",
              lg: "_1j2kes8as",
              xl: "_1j2kes8at"
            },
            defaultClass: "_1j2kes8ap"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8au",
              sm: "_1j2kes8av",
              md: "_1j2kes8aw",
              lg: "_1j2kes8ax",
              xl: "_1j2kes8ay"
            },
            defaultClass: "_1j2kes8au"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8az",
              sm: "_1j2kes8b0",
              md: "_1j2kes8b1",
              lg: "_1j2kes8b2",
              xl: "_1j2kes8b3"
            },
            defaultClass: "_1j2kes8az"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8b4",
              sm: "_1j2kes8b5",
              md: "_1j2kes8b6",
              lg: "_1j2kes8b7",
              xl: "_1j2kes8b8"
            },
            defaultClass: "_1j2kes8b4"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8b9",
              sm: "_1j2kes8ba",
              md: "_1j2kes8bb",
              lg: "_1j2kes8bc",
              xl: "_1j2kes8bd"
            },
            defaultClass: "_1j2kes8b9"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8be",
              sm: "_1j2kes8bf",
              md: "_1j2kes8bg",
              lg: "_1j2kes8bh",
              xl: "_1j2kes8bi"
            },
            defaultClass: "_1j2kes8be"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8bj",
              sm: "_1j2kes8bk",
              md: "_1j2kes8bl",
              lg: "_1j2kes8bm",
              xl: "_1j2kes8bn"
            },
            defaultClass: "_1j2kes8bj"
          }
        }
      },
      paddingInlineStart: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8bo",
              sm: "_1j2kes8bp",
              md: "_1j2kes8bq",
              lg: "_1j2kes8br",
              xl: "_1j2kes8bs"
            },
            defaultClass: "_1j2kes8bo"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8bt",
              sm: "_1j2kes8bu",
              md: "_1j2kes8bv",
              lg: "_1j2kes8bw",
              xl: "_1j2kes8bx"
            },
            defaultClass: "_1j2kes8bt"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8by",
              sm: "_1j2kes8bz",
              md: "_1j2kes8c0",
              lg: "_1j2kes8c1",
              xl: "_1j2kes8c2"
            },
            defaultClass: "_1j2kes8by"
          },
          xs: {
            conditions: {
              _: "_1j2kes8c3",
              sm: "_1j2kes8c4",
              md: "_1j2kes8c5",
              lg: "_1j2kes8c6",
              xl: "_1j2kes8c7"
            },
            defaultClass: "_1j2kes8c3"
          },
          sm: {
            conditions: {
              _: "_1j2kes8c8",
              sm: "_1j2kes8c9",
              md: "_1j2kes8ca",
              lg: "_1j2kes8cb",
              xl: "_1j2kes8cc"
            },
            defaultClass: "_1j2kes8c8"
          },
          md: {
            conditions: {
              _: "_1j2kes8cd",
              sm: "_1j2kes8ce",
              md: "_1j2kes8cf",
              lg: "_1j2kes8cg",
              xl: "_1j2kes8ch"
            },
            defaultClass: "_1j2kes8cd"
          },
          lg: {
            conditions: {
              _: "_1j2kes8ci",
              sm: "_1j2kes8cj",
              md: "_1j2kes8ck",
              lg: "_1j2kes8cl",
              xl: "_1j2kes8cm"
            },
            defaultClass: "_1j2kes8ci"
          },
          xl: {
            conditions: {
              _: "_1j2kes8cn",
              sm: "_1j2kes8co",
              md: "_1j2kes8cp",
              lg: "_1j2kes8cq",
              xl: "_1j2kes8cr"
            },
            defaultClass: "_1j2kes8cn"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8cs",
              sm: "_1j2kes8ct",
              md: "_1j2kes8cu",
              lg: "_1j2kes8cv",
              xl: "_1j2kes8cw"
            },
            defaultClass: "_1j2kes8cs"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8cx",
              sm: "_1j2kes8cy",
              md: "_1j2kes8cz",
              lg: "_1j2kes8d0",
              xl: "_1j2kes8d1"
            },
            defaultClass: "_1j2kes8cx"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8d2",
              sm: "_1j2kes8d3",
              md: "_1j2kes8d4",
              lg: "_1j2kes8d5",
              xl: "_1j2kes8d6"
            },
            defaultClass: "_1j2kes8d2"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8d7",
              sm: "_1j2kes8d8",
              md: "_1j2kes8d9",
              lg: "_1j2kes8da",
              xl: "_1j2kes8db"
            },
            defaultClass: "_1j2kes8d7"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8dc",
              sm: "_1j2kes8dd",
              md: "_1j2kes8de",
              lg: "_1j2kes8df",
              xl: "_1j2kes8dg"
            },
            defaultClass: "_1j2kes8dc"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8dh",
              sm: "_1j2kes8di",
              md: "_1j2kes8dj",
              lg: "_1j2kes8dk",
              xl: "_1j2kes8dl"
            },
            defaultClass: "_1j2kes8dh"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8dm",
              sm: "_1j2kes8dn",
              md: "_1j2kes8do",
              lg: "_1j2kes8dp",
              xl: "_1j2kes8dq"
            },
            defaultClass: "_1j2kes8dm"
          }
        }
      },
      paddingInlineEnd: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8dr",
              sm: "_1j2kes8ds",
              md: "_1j2kes8dt",
              lg: "_1j2kes8du",
              xl: "_1j2kes8dv"
            },
            defaultClass: "_1j2kes8dr"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8dw",
              sm: "_1j2kes8dx",
              md: "_1j2kes8dy",
              lg: "_1j2kes8dz",
              xl: "_1j2kes8e0"
            },
            defaultClass: "_1j2kes8dw"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8e1",
              sm: "_1j2kes8e2",
              md: "_1j2kes8e3",
              lg: "_1j2kes8e4",
              xl: "_1j2kes8e5"
            },
            defaultClass: "_1j2kes8e1"
          },
          xs: {
            conditions: {
              _: "_1j2kes8e6",
              sm: "_1j2kes8e7",
              md: "_1j2kes8e8",
              lg: "_1j2kes8e9",
              xl: "_1j2kes8ea"
            },
            defaultClass: "_1j2kes8e6"
          },
          sm: {
            conditions: {
              _: "_1j2kes8eb",
              sm: "_1j2kes8ec",
              md: "_1j2kes8ed",
              lg: "_1j2kes8ee",
              xl: "_1j2kes8ef"
            },
            defaultClass: "_1j2kes8eb"
          },
          md: {
            conditions: {
              _: "_1j2kes8eg",
              sm: "_1j2kes8eh",
              md: "_1j2kes8ei",
              lg: "_1j2kes8ej",
              xl: "_1j2kes8ek"
            },
            defaultClass: "_1j2kes8eg"
          },
          lg: {
            conditions: {
              _: "_1j2kes8el",
              sm: "_1j2kes8em",
              md: "_1j2kes8en",
              lg: "_1j2kes8eo",
              xl: "_1j2kes8ep"
            },
            defaultClass: "_1j2kes8el"
          },
          xl: {
            conditions: {
              _: "_1j2kes8eq",
              sm: "_1j2kes8er",
              md: "_1j2kes8es",
              lg: "_1j2kes8et",
              xl: "_1j2kes8eu"
            },
            defaultClass: "_1j2kes8eq"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8ev",
              sm: "_1j2kes8ew",
              md: "_1j2kes8ex",
              lg: "_1j2kes8ey",
              xl: "_1j2kes8ez"
            },
            defaultClass: "_1j2kes8ev"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8f0",
              sm: "_1j2kes8f1",
              md: "_1j2kes8f2",
              lg: "_1j2kes8f3",
              xl: "_1j2kes8f4"
            },
            defaultClass: "_1j2kes8f0"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8f5",
              sm: "_1j2kes8f6",
              md: "_1j2kes8f7",
              lg: "_1j2kes8f8",
              xl: "_1j2kes8f9"
            },
            defaultClass: "_1j2kes8f5"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8fa",
              sm: "_1j2kes8fb",
              md: "_1j2kes8fc",
              lg: "_1j2kes8fd",
              xl: "_1j2kes8fe"
            },
            defaultClass: "_1j2kes8fa"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8ff",
              sm: "_1j2kes8fg",
              md: "_1j2kes8fh",
              lg: "_1j2kes8fi",
              xl: "_1j2kes8fj"
            },
            defaultClass: "_1j2kes8ff"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8fk",
              sm: "_1j2kes8fl",
              md: "_1j2kes8fm",
              lg: "_1j2kes8fn",
              xl: "_1j2kes8fo"
            },
            defaultClass: "_1j2kes8fk"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8fp",
              sm: "_1j2kes8fq",
              md: "_1j2kes8fr",
              lg: "_1j2kes8fs",
              xl: "_1j2kes8ft"
            },
            defaultClass: "_1j2kes8fp"
          }
        }
      },
      marginBlockStart: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8fu",
              sm: "_1j2kes8fv",
              md: "_1j2kes8fw",
              lg: "_1j2kes8fx",
              xl: "_1j2kes8fy"
            },
            defaultClass: "_1j2kes8fu"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8fz",
              sm: "_1j2kes8g0",
              md: "_1j2kes8g1",
              lg: "_1j2kes8g2",
              xl: "_1j2kes8g3"
            },
            defaultClass: "_1j2kes8fz"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8g4",
              sm: "_1j2kes8g5",
              md: "_1j2kes8g6",
              lg: "_1j2kes8g7",
              xl: "_1j2kes8g8"
            },
            defaultClass: "_1j2kes8g4"
          },
          xs: {
            conditions: {
              _: "_1j2kes8g9",
              sm: "_1j2kes8ga",
              md: "_1j2kes8gb",
              lg: "_1j2kes8gc",
              xl: "_1j2kes8gd"
            },
            defaultClass: "_1j2kes8g9"
          },
          sm: {
            conditions: {
              _: "_1j2kes8ge",
              sm: "_1j2kes8gf",
              md: "_1j2kes8gg",
              lg: "_1j2kes8gh",
              xl: "_1j2kes8gi"
            },
            defaultClass: "_1j2kes8ge"
          },
          md: {
            conditions: {
              _: "_1j2kes8gj",
              sm: "_1j2kes8gk",
              md: "_1j2kes8gl",
              lg: "_1j2kes8gm",
              xl: "_1j2kes8gn"
            },
            defaultClass: "_1j2kes8gj"
          },
          lg: {
            conditions: {
              _: "_1j2kes8go",
              sm: "_1j2kes8gp",
              md: "_1j2kes8gq",
              lg: "_1j2kes8gr",
              xl: "_1j2kes8gs"
            },
            defaultClass: "_1j2kes8go"
          },
          xl: {
            conditions: {
              _: "_1j2kes8gt",
              sm: "_1j2kes8gu",
              md: "_1j2kes8gv",
              lg: "_1j2kes8gw",
              xl: "_1j2kes8gx"
            },
            defaultClass: "_1j2kes8gt"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8gy",
              sm: "_1j2kes8gz",
              md: "_1j2kes8h0",
              lg: "_1j2kes8h1",
              xl: "_1j2kes8h2"
            },
            defaultClass: "_1j2kes8gy"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8h3",
              sm: "_1j2kes8h4",
              md: "_1j2kes8h5",
              lg: "_1j2kes8h6",
              xl: "_1j2kes8h7"
            },
            defaultClass: "_1j2kes8h3"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8h8",
              sm: "_1j2kes8h9",
              md: "_1j2kes8ha",
              lg: "_1j2kes8hb",
              xl: "_1j2kes8hc"
            },
            defaultClass: "_1j2kes8h8"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8hd",
              sm: "_1j2kes8he",
              md: "_1j2kes8hf",
              lg: "_1j2kes8hg",
              xl: "_1j2kes8hh"
            },
            defaultClass: "_1j2kes8hd"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8hi",
              sm: "_1j2kes8hj",
              md: "_1j2kes8hk",
              lg: "_1j2kes8hl",
              xl: "_1j2kes8hm"
            },
            defaultClass: "_1j2kes8hi"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8hn",
              sm: "_1j2kes8ho",
              md: "_1j2kes8hp",
              lg: "_1j2kes8hq",
              xl: "_1j2kes8hr"
            },
            defaultClass: "_1j2kes8hn"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8hs",
              sm: "_1j2kes8ht",
              md: "_1j2kes8hu",
              lg: "_1j2kes8hv",
              xl: "_1j2kes8hw"
            },
            defaultClass: "_1j2kes8hs"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8hx",
              sm: "_1j2kes8hy",
              md: "_1j2kes8hz",
              lg: "_1j2kes8i0",
              xl: "_1j2kes8i1"
            },
            defaultClass: "_1j2kes8hx"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8i2",
              sm: "_1j2kes8i3",
              md: "_1j2kes8i4",
              lg: "_1j2kes8i5",
              xl: "_1j2kes8i6"
            },
            defaultClass: "_1j2kes8i2"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8i7",
              sm: "_1j2kes8i8",
              md: "_1j2kes8i9",
              lg: "_1j2kes8ia",
              xl: "_1j2kes8ib"
            },
            defaultClass: "_1j2kes8i7"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8ic",
              sm: "_1j2kes8id",
              md: "_1j2kes8ie",
              lg: "_1j2kes8if",
              xl: "_1j2kes8ig"
            },
            defaultClass: "_1j2kes8ic"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8ih",
              sm: "_1j2kes8ii",
              md: "_1j2kes8ij",
              lg: "_1j2kes8ik",
              xl: "_1j2kes8il"
            },
            defaultClass: "_1j2kes8ih"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8im",
              sm: "_1j2kes8in",
              md: "_1j2kes8io",
              lg: "_1j2kes8ip",
              xl: "_1j2kes8iq"
            },
            defaultClass: "_1j2kes8im"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8ir",
              sm: "_1j2kes8is",
              md: "_1j2kes8it",
              lg: "_1j2kes8iu",
              xl: "_1j2kes8iv"
            },
            defaultClass: "_1j2kes8ir"
          },
          auto: {
            conditions: {
              _: "_1j2kes8iw",
              sm: "_1j2kes8ix",
              md: "_1j2kes8iy",
              lg: "_1j2kes8iz",
              xl: "_1j2kes8j0"
            },
            defaultClass: "_1j2kes8iw"
          }
        }
      },
      marginBlockEnd: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8j1",
              sm: "_1j2kes8j2",
              md: "_1j2kes8j3",
              lg: "_1j2kes8j4",
              xl: "_1j2kes8j5"
            },
            defaultClass: "_1j2kes8j1"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8j6",
              sm: "_1j2kes8j7",
              md: "_1j2kes8j8",
              lg: "_1j2kes8j9",
              xl: "_1j2kes8ja"
            },
            defaultClass: "_1j2kes8j6"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8jb",
              sm: "_1j2kes8jc",
              md: "_1j2kes8jd",
              lg: "_1j2kes8je",
              xl: "_1j2kes8jf"
            },
            defaultClass: "_1j2kes8jb"
          },
          xs: {
            conditions: {
              _: "_1j2kes8jg",
              sm: "_1j2kes8jh",
              md: "_1j2kes8ji",
              lg: "_1j2kes8jj",
              xl: "_1j2kes8jk"
            },
            defaultClass: "_1j2kes8jg"
          },
          sm: {
            conditions: {
              _: "_1j2kes8jl",
              sm: "_1j2kes8jm",
              md: "_1j2kes8jn",
              lg: "_1j2kes8jo",
              xl: "_1j2kes8jp"
            },
            defaultClass: "_1j2kes8jl"
          },
          md: {
            conditions: {
              _: "_1j2kes8jq",
              sm: "_1j2kes8jr",
              md: "_1j2kes8js",
              lg: "_1j2kes8jt",
              xl: "_1j2kes8ju"
            },
            defaultClass: "_1j2kes8jq"
          },
          lg: {
            conditions: {
              _: "_1j2kes8jv",
              sm: "_1j2kes8jw",
              md: "_1j2kes8jx",
              lg: "_1j2kes8jy",
              xl: "_1j2kes8jz"
            },
            defaultClass: "_1j2kes8jv"
          },
          xl: {
            conditions: {
              _: "_1j2kes8k0",
              sm: "_1j2kes8k1",
              md: "_1j2kes8k2",
              lg: "_1j2kes8k3",
              xl: "_1j2kes8k4"
            },
            defaultClass: "_1j2kes8k0"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8k5",
              sm: "_1j2kes8k6",
              md: "_1j2kes8k7",
              lg: "_1j2kes8k8",
              xl: "_1j2kes8k9"
            },
            defaultClass: "_1j2kes8k5"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8ka",
              sm: "_1j2kes8kb",
              md: "_1j2kes8kc",
              lg: "_1j2kes8kd",
              xl: "_1j2kes8ke"
            },
            defaultClass: "_1j2kes8ka"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8kf",
              sm: "_1j2kes8kg",
              md: "_1j2kes8kh",
              lg: "_1j2kes8ki",
              xl: "_1j2kes8kj"
            },
            defaultClass: "_1j2kes8kf"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8kk",
              sm: "_1j2kes8kl",
              md: "_1j2kes8km",
              lg: "_1j2kes8kn",
              xl: "_1j2kes8ko"
            },
            defaultClass: "_1j2kes8kk"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8kp",
              sm: "_1j2kes8kq",
              md: "_1j2kes8kr",
              lg: "_1j2kes8ks",
              xl: "_1j2kes8kt"
            },
            defaultClass: "_1j2kes8kp"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8ku",
              sm: "_1j2kes8kv",
              md: "_1j2kes8kw",
              lg: "_1j2kes8kx",
              xl: "_1j2kes8ky"
            },
            defaultClass: "_1j2kes8ku"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8kz",
              sm: "_1j2kes8l0",
              md: "_1j2kes8l1",
              lg: "_1j2kes8l2",
              xl: "_1j2kes8l3"
            },
            defaultClass: "_1j2kes8kz"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8l4",
              sm: "_1j2kes8l5",
              md: "_1j2kes8l6",
              lg: "_1j2kes8l7",
              xl: "_1j2kes8l8"
            },
            defaultClass: "_1j2kes8l4"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8l9",
              sm: "_1j2kes8la",
              md: "_1j2kes8lb",
              lg: "_1j2kes8lc",
              xl: "_1j2kes8ld"
            },
            defaultClass: "_1j2kes8l9"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8le",
              sm: "_1j2kes8lf",
              md: "_1j2kes8lg",
              lg: "_1j2kes8lh",
              xl: "_1j2kes8li"
            },
            defaultClass: "_1j2kes8le"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8lj",
              sm: "_1j2kes8lk",
              md: "_1j2kes8ll",
              lg: "_1j2kes8lm",
              xl: "_1j2kes8ln"
            },
            defaultClass: "_1j2kes8lj"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8lo",
              sm: "_1j2kes8lp",
              md: "_1j2kes8lq",
              lg: "_1j2kes8lr",
              xl: "_1j2kes8ls"
            },
            defaultClass: "_1j2kes8lo"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8lt",
              sm: "_1j2kes8lu",
              md: "_1j2kes8lv",
              lg: "_1j2kes8lw",
              xl: "_1j2kes8lx"
            },
            defaultClass: "_1j2kes8lt"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8ly",
              sm: "_1j2kes8lz",
              md: "_1j2kes8m0",
              lg: "_1j2kes8m1",
              xl: "_1j2kes8m2"
            },
            defaultClass: "_1j2kes8ly"
          },
          auto: {
            conditions: {
              _: "_1j2kes8m3",
              sm: "_1j2kes8m4",
              md: "_1j2kes8m5",
              lg: "_1j2kes8m6",
              xl: "_1j2kes8m7"
            },
            defaultClass: "_1j2kes8m3"
          }
        }
      },
      marginInlineStart: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8sm",
              sm: "_1j2kes8sn",
              md: "_1j2kes8so",
              lg: "_1j2kes8sp",
              xl: "_1j2kes8sq"
            },
            defaultClass: "_1j2kes8sm"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8sr",
              sm: "_1j2kes8ss",
              md: "_1j2kes8st",
              lg: "_1j2kes8su",
              xl: "_1j2kes8sv"
            },
            defaultClass: "_1j2kes8sr"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8sw",
              sm: "_1j2kes8sx",
              md: "_1j2kes8sy",
              lg: "_1j2kes8sz",
              xl: "_1j2kes8t0"
            },
            defaultClass: "_1j2kes8sw"
          },
          xs: {
            conditions: {
              _: "_1j2kes8t1",
              sm: "_1j2kes8t2",
              md: "_1j2kes8t3",
              lg: "_1j2kes8t4",
              xl: "_1j2kes8t5"
            },
            defaultClass: "_1j2kes8t1"
          },
          sm: {
            conditions: {
              _: "_1j2kes8t6",
              sm: "_1j2kes8t7",
              md: "_1j2kes8t8",
              lg: "_1j2kes8t9",
              xl: "_1j2kes8ta"
            },
            defaultClass: "_1j2kes8t6"
          },
          md: {
            conditions: {
              _: "_1j2kes8tb",
              sm: "_1j2kes8tc",
              md: "_1j2kes8td",
              lg: "_1j2kes8te",
              xl: "_1j2kes8tf"
            },
            defaultClass: "_1j2kes8tb"
          },
          lg: {
            conditions: {
              _: "_1j2kes8tg",
              sm: "_1j2kes8th",
              md: "_1j2kes8ti",
              lg: "_1j2kes8tj",
              xl: "_1j2kes8tk"
            },
            defaultClass: "_1j2kes8tg"
          },
          xl: {
            conditions: {
              _: "_1j2kes8tl",
              sm: "_1j2kes8tm",
              md: "_1j2kes8tn",
              lg: "_1j2kes8to",
              xl: "_1j2kes8tp"
            },
            defaultClass: "_1j2kes8tl"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8tq",
              sm: "_1j2kes8tr",
              md: "_1j2kes8ts",
              lg: "_1j2kes8tt",
              xl: "_1j2kes8tu"
            },
            defaultClass: "_1j2kes8tq"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8tv",
              sm: "_1j2kes8tw",
              md: "_1j2kes8tx",
              lg: "_1j2kes8ty",
              xl: "_1j2kes8tz"
            },
            defaultClass: "_1j2kes8tv"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8u0",
              sm: "_1j2kes8u1",
              md: "_1j2kes8u2",
              lg: "_1j2kes8u3",
              xl: "_1j2kes8u4"
            },
            defaultClass: "_1j2kes8u0"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8u5",
              sm: "_1j2kes8u6",
              md: "_1j2kes8u7",
              lg: "_1j2kes8u8",
              xl: "_1j2kes8u9"
            },
            defaultClass: "_1j2kes8u5"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8ua",
              sm: "_1j2kes8ub",
              md: "_1j2kes8uc",
              lg: "_1j2kes8ud",
              xl: "_1j2kes8ue"
            },
            defaultClass: "_1j2kes8ua"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8uf",
              sm: "_1j2kes8ug",
              md: "_1j2kes8uh",
              lg: "_1j2kes8ui",
              xl: "_1j2kes8uj"
            },
            defaultClass: "_1j2kes8uf"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8uk",
              sm: "_1j2kes8ul",
              md: "_1j2kes8um",
              lg: "_1j2kes8un",
              xl: "_1j2kes8uo"
            },
            defaultClass: "_1j2kes8uk"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8up",
              sm: "_1j2kes8uq",
              md: "_1j2kes8ur",
              lg: "_1j2kes8us",
              xl: "_1j2kes8ut"
            },
            defaultClass: "_1j2kes8up"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8uu",
              sm: "_1j2kes8uv",
              md: "_1j2kes8uw",
              lg: "_1j2kes8ux",
              xl: "_1j2kes8uy"
            },
            defaultClass: "_1j2kes8uu"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8uz",
              sm: "_1j2kes8v0",
              md: "_1j2kes8v1",
              lg: "_1j2kes8v2",
              xl: "_1j2kes8v3"
            },
            defaultClass: "_1j2kes8uz"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8v4",
              sm: "_1j2kes8v5",
              md: "_1j2kes8v6",
              lg: "_1j2kes8v7",
              xl: "_1j2kes8v8"
            },
            defaultClass: "_1j2kes8v4"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8v9",
              sm: "_1j2kes8va",
              md: "_1j2kes8vb",
              lg: "_1j2kes8vc",
              xl: "_1j2kes8vd"
            },
            defaultClass: "_1j2kes8v9"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8ve",
              sm: "_1j2kes8vf",
              md: "_1j2kes8vg",
              lg: "_1j2kes8vh",
              xl: "_1j2kes8vi"
            },
            defaultClass: "_1j2kes8ve"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8vj",
              sm: "_1j2kes8vk",
              md: "_1j2kes8vl",
              lg: "_1j2kes8vm",
              xl: "_1j2kes8vn"
            },
            defaultClass: "_1j2kes8vj"
          },
          auto: {
            conditions: {
              _: "_1j2kes8vo",
              sm: "_1j2kes8vp",
              md: "_1j2kes8vq",
              lg: "_1j2kes8vr",
              xl: "_1j2kes8vs"
            },
            defaultClass: "_1j2kes8vo"
          }
        }
      },
      marginInlineEnd: {
        values: {
          none: {
            conditions: {
              _: "_1j2kes8vt",
              sm: "_1j2kes8vu",
              md: "_1j2kes8vv",
              lg: "_1j2kes8vw",
              xl: "_1j2kes8vx"
            },
            defaultClass: "_1j2kes8vt"
          },
          "3xs": {
            conditions: {
              _: "_1j2kes8vy",
              sm: "_1j2kes8vz",
              md: "_1j2kes8w0",
              lg: "_1j2kes8w1",
              xl: "_1j2kes8w2"
            },
            defaultClass: "_1j2kes8vy"
          },
          "2xs": {
            conditions: {
              _: "_1j2kes8w3",
              sm: "_1j2kes8w4",
              md: "_1j2kes8w5",
              lg: "_1j2kes8w6",
              xl: "_1j2kes8w7"
            },
            defaultClass: "_1j2kes8w3"
          },
          xs: {
            conditions: {
              _: "_1j2kes8w8",
              sm: "_1j2kes8w9",
              md: "_1j2kes8wa",
              lg: "_1j2kes8wb",
              xl: "_1j2kes8wc"
            },
            defaultClass: "_1j2kes8w8"
          },
          sm: {
            conditions: {
              _: "_1j2kes8wd",
              sm: "_1j2kes8we",
              md: "_1j2kes8wf",
              lg: "_1j2kes8wg",
              xl: "_1j2kes8wh"
            },
            defaultClass: "_1j2kes8wd"
          },
          md: {
            conditions: {
              _: "_1j2kes8wi",
              sm: "_1j2kes8wj",
              md: "_1j2kes8wk",
              lg: "_1j2kes8wl",
              xl: "_1j2kes8wm"
            },
            defaultClass: "_1j2kes8wi"
          },
          lg: {
            conditions: {
              _: "_1j2kes8wn",
              sm: "_1j2kes8wo",
              md: "_1j2kes8wp",
              lg: "_1j2kes8wq",
              xl: "_1j2kes8wr"
            },
            defaultClass: "_1j2kes8wn"
          },
          xl: {
            conditions: {
              _: "_1j2kes8ws",
              sm: "_1j2kes8wt",
              md: "_1j2kes8wu",
              lg: "_1j2kes8wv",
              xl: "_1j2kes8ww"
            },
            defaultClass: "_1j2kes8ws"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8wx",
              sm: "_1j2kes8wy",
              md: "_1j2kes8wz",
              lg: "_1j2kes8x0",
              xl: "_1j2kes8x1"
            },
            defaultClass: "_1j2kes8wx"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes8x2",
              sm: "_1j2kes8x3",
              md: "_1j2kes8x4",
              lg: "_1j2kes8x5",
              xl: "_1j2kes8x6"
            },
            defaultClass: "_1j2kes8x2"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes8x7",
              sm: "_1j2kes8x8",
              md: "_1j2kes8x9",
              lg: "_1j2kes8xa",
              xl: "_1j2kes8xb"
            },
            defaultClass: "_1j2kes8x7"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes8xc",
              sm: "_1j2kes8xd",
              md: "_1j2kes8xe",
              lg: "_1j2kes8xf",
              xl: "_1j2kes8xg"
            },
            defaultClass: "_1j2kes8xc"
          },
          "6xl": {
            conditions: {
              _: "_1j2kes8xh",
              sm: "_1j2kes8xi",
              md: "_1j2kes8xj",
              lg: "_1j2kes8xk",
              xl: "_1j2kes8xl"
            },
            defaultClass: "_1j2kes8xh"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes8xm",
              sm: "_1j2kes8xn",
              md: "_1j2kes8xo",
              lg: "_1j2kes8xp",
              xl: "_1j2kes8xq"
            },
            defaultClass: "_1j2kes8xm"
          },
          "8xl": {
            conditions: {
              _: "_1j2kes8xr",
              sm: "_1j2kes8xs",
              md: "_1j2kes8xt",
              lg: "_1j2kes8xu",
              xl: "_1j2kes8xv"
            },
            defaultClass: "_1j2kes8xr"
          },
          "-2xs": {
            conditions: {
              _: "_1j2kes8xw",
              sm: "_1j2kes8xx",
              md: "_1j2kes8xy",
              lg: "_1j2kes8xz",
              xl: "_1j2kes8y0"
            },
            defaultClass: "_1j2kes8xw"
          },
          "-xs": {
            conditions: {
              _: "_1j2kes8y1",
              sm: "_1j2kes8y2",
              md: "_1j2kes8y3",
              lg: "_1j2kes8y4",
              xl: "_1j2kes8y5"
            },
            defaultClass: "_1j2kes8y1"
          },
          "-sm": {
            conditions: {
              _: "_1j2kes8y6",
              sm: "_1j2kes8y7",
              md: "_1j2kes8y8",
              lg: "_1j2kes8y9",
              xl: "_1j2kes8ya"
            },
            defaultClass: "_1j2kes8y6"
          },
          "-md": {
            conditions: {
              _: "_1j2kes8yb",
              sm: "_1j2kes8yc",
              md: "_1j2kes8yd",
              lg: "_1j2kes8ye",
              xl: "_1j2kes8yf"
            },
            defaultClass: "_1j2kes8yb"
          },
          "-lg": {
            conditions: {
              _: "_1j2kes8yg",
              sm: "_1j2kes8yh",
              md: "_1j2kes8yi",
              lg: "_1j2kes8yj",
              xl: "_1j2kes8yk"
            },
            defaultClass: "_1j2kes8yg"
          },
          "-xl": {
            conditions: {
              _: "_1j2kes8yl",
              sm: "_1j2kes8ym",
              md: "_1j2kes8yn",
              lg: "_1j2kes8yo",
              xl: "_1j2kes8yp"
            },
            defaultClass: "_1j2kes8yl"
          },
          "-2xl": {
            conditions: {
              _: "_1j2kes8yq",
              sm: "_1j2kes8yr",
              md: "_1j2kes8ys",
              lg: "_1j2kes8yt",
              xl: "_1j2kes8yu"
            },
            defaultClass: "_1j2kes8yq"
          },
          auto: {
            conditions: {
              _: "_1j2kes8yv",
              sm: "_1j2kes8yw",
              md: "_1j2kes8yx",
              lg: "_1j2kes8yy",
              xl: "_1j2kes8yz"
            },
            defaultClass: "_1j2kes8yv"
          }
        }
      },
      textAlign: {
        values: {
          start: {
            conditions: {
              _: "_1j2kes8z0",
              sm: "_1j2kes8z1",
              md: "_1j2kes8z2",
              lg: "_1j2kes8z3",
              xl: "_1j2kes8z4"
            },
            defaultClass: "_1j2kes8z0"
          },
          center: {
            conditions: {
              _: "_1j2kes8z5",
              sm: "_1j2kes8z6",
              md: "_1j2kes8z7",
              lg: "_1j2kes8z8",
              xl: "_1j2kes8z9"
            },
            defaultClass: "_1j2kes8z5"
          },
          end: {
            conditions: {
              _: "_1j2kes8za",
              sm: "_1j2kes8zb",
              md: "_1j2kes8zc",
              lg: "_1j2kes8zd",
              xl: "_1j2kes8ze"
            },
            defaultClass: "_1j2kes8za"
          }
        }
      },
      fontSize: {
        values: {
          "2xs": {
            conditions: {
              _: "_1j2kes8zf",
              sm: "_1j2kes8zg",
              md: "_1j2kes8zh",
              lg: "_1j2kes8zi",
              xl: "_1j2kes8zj"
            },
            defaultClass: "_1j2kes8zf"
          },
          xs: {
            conditions: {
              _: "_1j2kes8zk",
              sm: "_1j2kes8zl",
              md: "_1j2kes8zm",
              lg: "_1j2kes8zn",
              xl: "_1j2kes8zo"
            },
            defaultClass: "_1j2kes8zk"
          },
          sm: {
            conditions: {
              _: "_1j2kes8zp",
              sm: "_1j2kes8zq",
              md: "_1j2kes8zr",
              lg: "_1j2kes8zs",
              xl: "_1j2kes8zt"
            },
            defaultClass: "_1j2kes8zp"
          },
          md: {
            conditions: {
              _: "_1j2kes8zu",
              sm: "_1j2kes8zv",
              md: "_1j2kes8zw",
              lg: "_1j2kes8zx",
              xl: "_1j2kes8zy"
            },
            defaultClass: "_1j2kes8zu"
          },
          lg: {
            conditions: {
              _: "_1j2kes8zz",
              sm: "_1j2kes8100",
              md: "_1j2kes8101",
              lg: "_1j2kes8102",
              xl: "_1j2kes8103"
            },
            defaultClass: "_1j2kes8zz"
          },
          xl: {
            conditions: {
              _: "_1j2kes8104",
              sm: "_1j2kes8105",
              md: "_1j2kes8106",
              lg: "_1j2kes8107",
              xl: "_1j2kes8108"
            },
            defaultClass: "_1j2kes8104"
          },
          "2xl": {
            conditions: {
              _: "_1j2kes8109",
              sm: "_1j2kes810a",
              md: "_1j2kes810b",
              lg: "_1j2kes810c",
              xl: "_1j2kes810d"
            },
            defaultClass: "_1j2kes8109"
          },
          "3xl": {
            conditions: {
              _: "_1j2kes810e",
              sm: "_1j2kes810f",
              md: "_1j2kes810g",
              lg: "_1j2kes810h",
              xl: "_1j2kes810i"
            },
            defaultClass: "_1j2kes810e"
          },
          "4xl": {
            conditions: {
              _: "_1j2kes810j",
              sm: "_1j2kes810k",
              md: "_1j2kes810l",
              lg: "_1j2kes810m",
              xl: "_1j2kes810n"
            },
            defaultClass: "_1j2kes810j"
          },
          "5xl": {
            conditions: {
              _: "_1j2kes810o",
              sm: "_1j2kes810p",
              md: "_1j2kes810q",
              lg: "_1j2kes810r",
              xl: "_1j2kes810s"
            },
            defaultClass: "_1j2kes810o"
          },
          "7xl": {
            conditions: {
              _: "_1j2kes810t",
              sm: "_1j2kes810u",
              md: "_1j2kes810v",
              lg: "_1j2kes810w",
              xl: "_1j2kes810x"
            },
            defaultClass: "_1j2kes810t"
          }
        }
      },
      fontWeight: {
        values: {
          400: {
            conditions: {
              _: "_1j2kes810y",
              sm: "_1j2kes810z",
              md: "_1j2kes8110",
              lg: "_1j2kes8111",
              xl: "_1j2kes8112"
            },
            defaultClass: "_1j2kes810y"
          },
          500: {
            conditions: {
              _: "_1j2kes8113",
              sm: "_1j2kes8114",
              md: "_1j2kes8115",
              lg: "_1j2kes8116",
              xl: "_1j2kes8117"
            },
            defaultClass: "_1j2kes8113"
          },
          600: {
            conditions: {
              _: "_1j2kes8118",
              sm: "_1j2kes8119",
              md: "_1j2kes811a",
              lg: "_1j2kes811b",
              xl: "_1j2kes811c"
            },
            defaultClass: "_1j2kes8118"
          },
          700: {
            conditions: {
              _: "_1j2kes811d",
              sm: "_1j2kes811e",
              md: "_1j2kes811f",
              lg: "_1j2kes811g",
              xl: "_1j2kes811h"
            },
            defaultClass: "_1j2kes811d"
          }
        }
      },
      lineHeight: {
        values: {
          xs: {
            conditions: {
              _: "_1j2kes811i",
              sm: "_1j2kes811j",
              md: "_1j2kes811k",
              lg: "_1j2kes811l",
              xl: "_1j2kes811m"
            },
            defaultClass: "_1j2kes811i"
          },
          sm: {
            conditions: {
              _: "_1j2kes811n",
              sm: "_1j2kes811o",
              md: "_1j2kes811p",
              lg: "_1j2kes811q",
              xl: "_1j2kes811r"
            },
            defaultClass: "_1j2kes811n"
          },
          md: {
            conditions: {
              _: "_1j2kes811s",
              sm: "_1j2kes811t",
              md: "_1j2kes811u",
              lg: "_1j2kes811v",
              xl: "_1j2kes811w"
            },
            defaultClass: "_1j2kes811s"
          },
          lg: {
            conditions: {
              _: "_1j2kes811x",
              sm: "_1j2kes811y",
              md: "_1j2kes811z",
              lg: "_1j2kes8120",
              xl: "_1j2kes8121"
            },
            defaultClass: "_1j2kes811x"
          },
          xl: {
            conditions: {
              _: "_1j2kes8122",
              sm: "_1j2kes8123",
              md: "_1j2kes8124",
              lg: "_1j2kes8125",
              xl: "_1j2kes8126"
            },
            defaultClass: "_1j2kes8122"
          }
        }
      }
    }
  }, {
    conditions: void 0,
    styles: {
      inset: {
        mappings: ["top", "bottom", "left", "right"]
      },
      borderRadius: {
        values: {
          none: {
            defaultClass: "_1j2kes8127"
          },
          xs: {
            defaultClass: "_1j2kes8128"
          },
          sm: {
            defaultClass: "_1j2kes8129"
          },
          md: {
            defaultClass: "_1j2kes812a"
          },
          lg: {
            defaultClass: "_1j2kes812b"
          },
          xl: {
            defaultClass: "_1j2kes812c"
          },
          "2xl": {
            defaultClass: "_1j2kes812d"
          },
          "6xl": {
            defaultClass: "_1j2kes812e"
          },
          full: {
            defaultClass: "_1j2kes812f"
          }
        }
      },
      width: {
        values: {
          full: {
            defaultClass: "_1j2kes812g"
          },
          fitContent: {
            defaultClass: "_1j2kes812h"
          }
        }
      },
      zIndex: {
        values: {
          0: {
            defaultClass: "_1j2kes812i"
          },
          1: {
            defaultClass: "_1j2kes812j"
          },
          10: {
            defaultClass: "_1j2kes812k"
          },
          20: {
            defaultClass: "_1j2kes812l"
          },
          30: {
            defaultClass: "_1j2kes812m"
          },
          "-1": {
            defaultClass: "_1j2kes812n"
          }
        }
      },
      top: {
        values: {
          none: {
            defaultClass: "_1j2kes812o"
          },
          "3xs": {
            defaultClass: "_1j2kes812p"
          },
          "2xs": {
            defaultClass: "_1j2kes812q"
          },
          xs: {
            defaultClass: "_1j2kes812r"
          },
          sm: {
            defaultClass: "_1j2kes812s"
          },
          md: {
            defaultClass: "_1j2kes812t"
          },
          lg: {
            defaultClass: "_1j2kes812u"
          },
          xl: {
            defaultClass: "_1j2kes812v"
          },
          "2xl": {
            defaultClass: "_1j2kes812w"
          },
          "3xl": {
            defaultClass: "_1j2kes812x"
          },
          "4xl": {
            defaultClass: "_1j2kes812y"
          },
          "5xl": {
            defaultClass: "_1j2kes812z"
          },
          "6xl": {
            defaultClass: "_1j2kes8130"
          },
          "7xl": {
            defaultClass: "_1j2kes8131"
          },
          "8xl": {
            defaultClass: "_1j2kes8132"
          }
        }
      },
      bottom: {
        values: {
          none: {
            defaultClass: "_1j2kes8133"
          },
          "3xs": {
            defaultClass: "_1j2kes8134"
          },
          "2xs": {
            defaultClass: "_1j2kes8135"
          },
          xs: {
            defaultClass: "_1j2kes8136"
          },
          sm: {
            defaultClass: "_1j2kes8137"
          },
          md: {
            defaultClass: "_1j2kes8138"
          },
          lg: {
            defaultClass: "_1j2kes8139"
          },
          xl: {
            defaultClass: "_1j2kes813a"
          },
          "2xl": {
            defaultClass: "_1j2kes813b"
          },
          "3xl": {
            defaultClass: "_1j2kes813c"
          },
          "4xl": {
            defaultClass: "_1j2kes813d"
          },
          "5xl": {
            defaultClass: "_1j2kes813e"
          },
          "6xl": {
            defaultClass: "_1j2kes813f"
          },
          "7xl": {
            defaultClass: "_1j2kes813g"
          },
          "8xl": {
            defaultClass: "_1j2kes813h"
          }
        }
      },
      left: {
        values: {
          none: {
            defaultClass: "_1j2kes813i"
          },
          "3xs": {
            defaultClass: "_1j2kes813j"
          },
          "2xs": {
            defaultClass: "_1j2kes813k"
          },
          xs: {
            defaultClass: "_1j2kes813l"
          },
          sm: {
            defaultClass: "_1j2kes813m"
          },
          md: {
            defaultClass: "_1j2kes813n"
          },
          lg: {
            defaultClass: "_1j2kes813o"
          },
          xl: {
            defaultClass: "_1j2kes813p"
          },
          "2xl": {
            defaultClass: "_1j2kes813q"
          },
          "3xl": {
            defaultClass: "_1j2kes813r"
          },
          "4xl": {
            defaultClass: "_1j2kes813s"
          },
          "5xl": {
            defaultClass: "_1j2kes813t"
          },
          "6xl": {
            defaultClass: "_1j2kes813u"
          },
          "7xl": {
            defaultClass: "_1j2kes813v"
          },
          "8xl": {
            defaultClass: "_1j2kes813w"
          }
        }
      },
      right: {
        values: {
          none: {
            defaultClass: "_1j2kes813x"
          },
          "3xs": {
            defaultClass: "_1j2kes813y"
          },
          "2xs": {
            defaultClass: "_1j2kes813z"
          },
          xs: {
            defaultClass: "_1j2kes8140"
          },
          sm: {
            defaultClass: "_1j2kes8141"
          },
          md: {
            defaultClass: "_1j2kes8142"
          },
          lg: {
            defaultClass: "_1j2kes8143"
          },
          xl: {
            defaultClass: "_1j2kes8144"
          },
          "2xl": {
            defaultClass: "_1j2kes8145"
          },
          "3xl": {
            defaultClass: "_1j2kes8146"
          },
          "4xl": {
            defaultClass: "_1j2kes8147"
          },
          "5xl": {
            defaultClass: "_1j2kes8148"
          },
          "6xl": {
            defaultClass: "_1j2kes8149"
          },
          "7xl": {
            defaultClass: "_1j2kes814a"
          },
          "8xl": {
            defaultClass: "_1j2kes814b"
          }
        }
      }
    }
  }, {
    conditions: void 0,
    styles: {
      background: {
        values: {
          "blue.5": {
            defaultClass: "_1j2kes814c"
          },
          "blue.10": {
            defaultClass: "_1j2kes814d"
          },
          "blue.20": {
            defaultClass: "_1j2kes814e"
          },
          "blue.30": {
            defaultClass: "_1j2kes814f"
          },
          "blue.40": {
            defaultClass: "_1j2kes814g"
          },
          "blue.50": {
            defaultClass: "_1j2kes814h"
          },
          "blue.60": {
            defaultClass: "_1j2kes814i"
          },
          "blue.70": {
            defaultClass: "_1j2kes814j"
          },
          "blue.80": {
            defaultClass: "_1j2kes814k"
          },
          "blue.90": {
            defaultClass: "_1j2kes814l"
          },
          "blue.95": {
            defaultClass: "_1j2kes814m"
          },
          "green.5": {
            defaultClass: "_1j2kes814n"
          },
          "green.10": {
            defaultClass: "_1j2kes814o"
          },
          "green.20": {
            defaultClass: "_1j2kes814p"
          },
          "green.30": {
            defaultClass: "_1j2kes814q"
          },
          "green.40": {
            defaultClass: "_1j2kes814r"
          },
          "green.50": {
            defaultClass: "_1j2kes814s"
          },
          "green.60": {
            defaultClass: "_1j2kes814t"
          },
          "green.70": {
            defaultClass: "_1j2kes814u"
          },
          "green.80": {
            defaultClass: "_1j2kes814v"
          },
          "green.90": {
            defaultClass: "_1j2kes814w"
          },
          "green.95": {
            defaultClass: "_1j2kes814x"
          },
          "grey.5": {
            defaultClass: "_1j2kes814y"
          },
          "grey.10": {
            defaultClass: "_1j2kes814z"
          },
          "grey.20": {
            defaultClass: "_1j2kes8150"
          },
          "grey.30": {
            defaultClass: "_1j2kes8151"
          },
          "grey.40": {
            defaultClass: "_1j2kes8152"
          },
          "grey.50": {
            defaultClass: "_1j2kes8153"
          },
          "grey.60": {
            defaultClass: "_1j2kes8154"
          },
          "grey.70": {
            defaultClass: "_1j2kes8155"
          },
          "grey.80": {
            defaultClass: "_1j2kes8156"
          },
          "grey.90": {
            defaultClass: "_1j2kes8157"
          },
          "grey.95": {
            defaultClass: "_1j2kes8158"
          },
          "purple.5": {
            defaultClass: "_1j2kes8159"
          },
          "purple.10": {
            defaultClass: "_1j2kes815a"
          },
          "purple.20": {
            defaultClass: "_1j2kes815b"
          },
          "purple.30": {
            defaultClass: "_1j2kes815c"
          },
          "purple.40": {
            defaultClass: "_1j2kes815d"
          },
          "purple.50": {
            defaultClass: "_1j2kes815e"
          },
          "purple.60": {
            defaultClass: "_1j2kes815f"
          },
          "purple.70": {
            defaultClass: "_1j2kes815g"
          },
          "purple.80": {
            defaultClass: "_1j2kes815h"
          },
          "purple.90": {
            defaultClass: "_1j2kes815i"
          },
          "purple.95": {
            defaultClass: "_1j2kes815j"
          },
          "red.5": {
            defaultClass: "_1j2kes815k"
          },
          "red.10": {
            defaultClass: "_1j2kes815l"
          },
          "red.20": {
            defaultClass: "_1j2kes815m"
          },
          "red.30": {
            defaultClass: "_1j2kes815n"
          },
          "red.40": {
            defaultClass: "_1j2kes815o"
          },
          "red.50": {
            defaultClass: "_1j2kes815p"
          },
          "red.60": {
            defaultClass: "_1j2kes815q"
          },
          "red.70": {
            defaultClass: "_1j2kes815r"
          },
          "red.80": {
            defaultClass: "_1j2kes815s"
          },
          "red.90": {
            defaultClass: "_1j2kes815t"
          },
          "red.95": {
            defaultClass: "_1j2kes815u"
          },
          "yellow.5": {
            defaultClass: "_1j2kes815v"
          },
          "yellow.10": {
            defaultClass: "_1j2kes815w"
          },
          "yellow.20": {
            defaultClass: "_1j2kes815x"
          },
          "yellow.30": {
            defaultClass: "_1j2kes815y"
          },
          "yellow.40": {
            defaultClass: "_1j2kes815z"
          },
          "yellow.50": {
            defaultClass: "_1j2kes8160"
          },
          "yellow.60": {
            defaultClass: "_1j2kes8161"
          },
          "yellow.70": {
            defaultClass: "_1j2kes8162"
          },
          "yellow.80": {
            defaultClass: "_1j2kes8163"
          },
          "yellow.90": {
            defaultClass: "_1j2kes8164"
          },
          "yellow.95": {
            defaultClass: "_1j2kes8165"
          },
          black: {
            defaultClass: "_1j2kes8166"
          },
          white: {
            defaultClass: "_1j2kes8167"
          }
        }
      },
      color: {
        values: {
          "blue.5": {
            defaultClass: "_1j2kes8168"
          },
          "blue.10": {
            defaultClass: "_1j2kes8169"
          },
          "blue.20": {
            defaultClass: "_1j2kes816a"
          },
          "blue.30": {
            defaultClass: "_1j2kes816b"
          },
          "blue.40": {
            defaultClass: "_1j2kes816c"
          },
          "blue.50": {
            defaultClass: "_1j2kes816d"
          },
          "blue.60": {
            defaultClass: "_1j2kes816e"
          },
          "blue.70": {
            defaultClass: "_1j2kes816f"
          },
          "blue.80": {
            defaultClass: "_1j2kes816g"
          },
          "blue.90": {
            defaultClass: "_1j2kes816h"
          },
          "blue.95": {
            defaultClass: "_1j2kes816i"
          },
          "green.5": {
            defaultClass: "_1j2kes816j"
          },
          "green.10": {
            defaultClass: "_1j2kes816k"
          },
          "green.20": {
            defaultClass: "_1j2kes816l"
          },
          "green.30": {
            defaultClass: "_1j2kes816m"
          },
          "green.40": {
            defaultClass: "_1j2kes816n"
          },
          "green.50": {
            defaultClass: "_1j2kes816o"
          },
          "green.60": {
            defaultClass: "_1j2kes816p"
          },
          "green.70": {
            defaultClass: "_1j2kes816q"
          },
          "green.80": {
            defaultClass: "_1j2kes816r"
          },
          "green.90": {
            defaultClass: "_1j2kes816s"
          },
          "green.95": {
            defaultClass: "_1j2kes816t"
          },
          "grey.5": {
            defaultClass: "_1j2kes816u"
          },
          "grey.10": {
            defaultClass: "_1j2kes816v"
          },
          "grey.20": {
            defaultClass: "_1j2kes816w"
          },
          "grey.30": {
            defaultClass: "_1j2kes816x"
          },
          "grey.40": {
            defaultClass: "_1j2kes816y"
          },
          "grey.50": {
            defaultClass: "_1j2kes816z"
          },
          "grey.60": {
            defaultClass: "_1j2kes8170"
          },
          "grey.70": {
            defaultClass: "_1j2kes8171"
          },
          "grey.80": {
            defaultClass: "_1j2kes8172"
          },
          "grey.90": {
            defaultClass: "_1j2kes8173"
          },
          "grey.95": {
            defaultClass: "_1j2kes8174"
          },
          "purple.5": {
            defaultClass: "_1j2kes8175"
          },
          "purple.10": {
            defaultClass: "_1j2kes8176"
          },
          "purple.20": {
            defaultClass: "_1j2kes8177"
          },
          "purple.30": {
            defaultClass: "_1j2kes8178"
          },
          "purple.40": {
            defaultClass: "_1j2kes8179"
          },
          "purple.50": {
            defaultClass: "_1j2kes817a"
          },
          "purple.60": {
            defaultClass: "_1j2kes817b"
          },
          "purple.70": {
            defaultClass: "_1j2kes817c"
          },
          "purple.80": {
            defaultClass: "_1j2kes817d"
          },
          "purple.90": {
            defaultClass: "_1j2kes817e"
          },
          "purple.95": {
            defaultClass: "_1j2kes817f"
          },
          "red.5": {
            defaultClass: "_1j2kes817g"
          },
          "red.10": {
            defaultClass: "_1j2kes817h"
          },
          "red.20": {
            defaultClass: "_1j2kes817i"
          },
          "red.30": {
            defaultClass: "_1j2kes817j"
          },
          "red.40": {
            defaultClass: "_1j2kes817k"
          },
          "red.50": {
            defaultClass: "_1j2kes817l"
          },
          "red.60": {
            defaultClass: "_1j2kes817m"
          },
          "red.70": {
            defaultClass: "_1j2kes817n"
          },
          "red.80": {
            defaultClass: "_1j2kes817o"
          },
          "red.90": {
            defaultClass: "_1j2kes817p"
          },
          "red.95": {
            defaultClass: "_1j2kes817q"
          },
          "yellow.5": {
            defaultClass: "_1j2kes817r"
          },
          "yellow.10": {
            defaultClass: "_1j2kes817s"
          },
          "yellow.20": {
            defaultClass: "_1j2kes817t"
          },
          "yellow.30": {
            defaultClass: "_1j2kes817u"
          },
          "yellow.40": {
            defaultClass: "_1j2kes817v"
          },
          "yellow.50": {
            defaultClass: "_1j2kes817w"
          },
          "yellow.60": {
            defaultClass: "_1j2kes817x"
          },
          "yellow.70": {
            defaultClass: "_1j2kes817y"
          },
          "yellow.80": {
            defaultClass: "_1j2kes817z"
          },
          "yellow.90": {
            defaultClass: "_1j2kes8180"
          },
          "yellow.95": {
            defaultClass: "_1j2kes8181"
          },
          black: {
            defaultClass: "_1j2kes8182"
          },
          white: {
            defaultClass: "_1j2kes8183"
          }
        }
      }
    }
  });
function pe(_ref) {
  let {
    as: e,
    className: t,
    innerRef: n,
    padding: r,
    paddingX: o,
    paddingY: s,
    paddingInline: a,
    paddingInlineStart: i,
    paddingInlineEnd: l,
    paddingBlock: c,
    paddingBlockStart: d,
    paddingBlockEnd: f,
    margin: g,
    marginX: p,
    marginY: x,
    marginInline: m,
    marginInlineStart: h,
    marginInlineEnd: j,
    marginBlock: v,
    marginBlockStart: _,
    marginBlockEnd: k,
    gap: y,
    gridTemplateColumns: b,
    display: C,
    alignItems: N,
    alignSelf: T,
    justifyContent: z,
    flexDirection: K,
    flexWrap: L,
    flexGrow: H,
    flexShrink: Y,
    borderRadius: X,
    position: ne,
    top: U,
    bottom: de,
    left: Z,
    right: S,
    inset: R,
    background: ae,
    color: P,
    width: D,
    zIndex: O,
    textAlign: A,
    fontWeight: E,
    fontSize: G,
    lineHeight: B,
    ...Q
  } = _ref;
  const ie = ye([hs({
    padding: r,
    paddingX: o,
    paddingY: s,
    paddingInline: a,
    paddingInlineStart: i,
    paddingInlineEnd: l,
    paddingBlock: c,
    paddingBlockStart: d,
    paddingBlockEnd: f,
    margin: g,
    marginX: p,
    marginY: x,
    marginInline: m,
    marginInlineStart: h,
    marginInlineEnd: j,
    marginBlock: v,
    marginBlockStart: _,
    marginBlockEnd: k,
    gridTemplateColumns: b,
    gap: y,
    display: C,
    alignItems: N,
    alignSelf: T,
    justifyContent: z,
    flexDirection: K,
    flexWrap: L,
    flexGrow: H,
    flexShrink: Y,
    borderRadius: X,
    position: ne,
    top: U,
    bottom: de,
    left: Z,
    right: S,
    inset: R,
    background: ae,
    color: P,
    width: D,
    zIndex: O,
    textAlign: A,
    fontWeight: E,
    fontSize: G,
    lineHeight: B
  }), t]);
  return F(e || "div", {
    ref: je => {
      n && typeof n == "object" && (n.current = je);
    },
    className: ie,
    ...Q
  });
}
function ng(_ref2) {
  let {
    gap: e = "lg",
    direction: t = "column",
    ...n
  } = _ref2;
  return /* @__PURE__ */u.jsx(pe, {
    display: "flex",
    flexDirection: t,
    gap: e,
    ...n
  });
}
function _N(_ref3) {
  let {
    children: e,
    theme: t,
    reset: n
  } = _ref3;
  const r = ye([n ? Hm : "", t, Bc.md]);
  return /* @__PURE__ */u.jsx("div", {
    className: r,
    children: e
  });
}
function ut(_ref4) {
  let {
    as: e,
    type: t,
    size: n,
    weight: r,
    className: o,
    children: s,
    ...a
  } = _ref4;
  const i = e || "span",
    l = t || n,
    c = ye([l && Bc[l], o]);
  return /* @__PURE__ */u.jsx(pe, {
    as: i,
    className: c,
    fontWeight: r,
    ...a,
    children: s
  });
}
function jN(e) {
  return /* @__PURE__ */u.jsx(ut, {
    as: "div",
    type: "md",
    weight: 400,
    ...e
  });
}
function Cn(_ref5) {
  let {
    as: e,
    type: t = 1,
    level: n,
    children: r,
    className: o,
    ...s
  } = _ref5;
  const i = ye([Wm[n || t], o]);
  return /* @__PURE__ */u.jsx(pe, {
    as: e,
    className: i,
    ...s,
    children: r
  });
}
function yN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h1",
    type: 1,
    ...e
  });
}
function xN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h2",
    type: 2,
    ...e
  });
}
function kN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h3",
    type: 3,
    ...e
  });
}
function MN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h4",
    type: 4,
    ...e
  });
}
function bN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h5",
    type: 5,
    ...e
  });
}
function wN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "h6",
    type: 6,
    ...e
  });
}
function CN(e) {
  return /* @__PURE__ */u.jsx(Cn, {
    as: "div",
    type: "eyebrow",
    ...e
  });
}
var Qc = {
    color: void 0,
    size: void 0,
    className: void 0,
    style: void 0,
    attr: void 0
  },
  Qi = te.createContext && te.createContext(Qc),
  Qt = globalThis && globalThis.__assign || function () {
    return Qt = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        t = arguments[n];
        for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
      return e;
    }, Qt.apply(this, arguments);
  },
  rg = globalThis && globalThis.__rest || function (e, t) {
    var n = {};
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
    return n;
  };
function qc(e) {
  return e && e.map(function (t, n) {
    return te.createElement(t.tag, Qt({
      key: n
    }, t.attr), qc(t.child));
  });
}
function on(e) {
  return function (t) {
    return te.createElement(sg, Qt({
      attr: Qt({}, e.attr)
    }, t), qc(e.child));
  };
}
function sg(e) {
  var t = function (n) {
    var r = e.attr,
      o = e.size,
      s = e.title,
      a = rg(e, ["attr", "size", "title"]),
      i = o || n.size || "1em",
      l;
    return n.className && (l = n.className), e.className && (l = (l ? l + " " : "") + e.className), te.createElement("svg", Qt({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, a, {
      className: l,
      style: Qt(Qt({
        color: e.color || n.color
      }, n.style), e.style),
      height: i,
      width: i,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && te.createElement("title", null, s), e.children);
  };
  return Qi !== void 0 ? te.createElement(Qi.Consumer, null, function (n) {
    return t(n);
  }) : t(Qc);
}
function og(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
      }
    }]
  })(e);
}
function Kc(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M7 10l5 5 5-5z"
      }
    }]
  })(e);
}
function zr(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
      }
    }]
  })(e);
}
function ag(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      }
    }]
  })(e);
}
function Zc(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      }
    }]
  })(e);
}
function ig(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }
    }]
  })(e);
}
function lg(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      }
    }]
  })(e);
}
function qi(e) {
  return on({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }
    }, {
      tag: "path",
      attr: {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      }
    }]
  })(e);
}
function cg(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ki(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ki(Object(n), !0).forEach(function (r) {
      cg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ki(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ug = (e, t, n) => {
    for (var r of Object.keys(e)) {
      var o;
      if (e[r] !== ((o = t[r]) !== null && o !== void 0 ? o : n[r])) return !1;
    }
    return !0;
  },
  Ue = e => t => {
    var n = e.defaultClassName,
      r = Zi(Zi({}, e.defaultVariants), t);
    for (var o in r) {
      var s,
        a = (s = r[o]) !== null && s !== void 0 ? s : e.defaultVariants[o];
      if (a != null) {
        var i = a;
        typeof i == "boolean" && (i = i === !0 ? "true" : "false");
        var l =
        // @ts-expect-error
        e.variantClassNames[o][i];
        l && (n += " " + l);
      }
    }
    for (var [c, d] of e.compoundVariants) ug(c, r, e.defaultVariants) && (n += " " + d);
    return n;
  },
  dg = {
    display: "var(--jxvquf0)",
    color: {
      background: "var(--jxvquf1)",
      text: "var(--jxvquf2)",
      backgroundHover: "var(--jxvquf3)",
      backgroundActive: "var(--jxvquf4)",
      textHover: "var(--jxvquf5)",
      textActive: "var(--jxvquf6)",
      borderColor: "var(--jxvquf7)",
      borderColorHover: "var(--jxvquf8)",
      borderColorActive: "var(--jxvquf9)",
      focusRing: "var(--jxvqufa)",
      visited: "var(--jxvqufb)"
    },
    size: {
      border: "var(--jxvqufc)",
      block: "var(--jxvqufd)",
      inline: "var(--jxvqufe)"
    },
    fontSize: "var(--jxvquff)",
    textDecoration: "var(--jxvqufg)",
    textDecorationHover: "var(--jxvqufh)"
  },
  Gc = "jxvqufi",
  Jc = Ue({
    defaultClassName: "jxvqufj",
    variantClassNames: {
      variant: {
        solid: "jxvqufk",
        outline: "jxvqufl",
        transparent: "jxvqufm",
        text: "jxvqufn"
      },
      colorModes: {
        light: "jxvqufo",
        dark: "jxvqufp"
      },
      size: {
        compact: "jxvqufq",
        form: "jxvqufr",
        normal: "jxvqufs",
        oversized: "jxvquft"
      },
      width: {
        full: "jxvqufu"
      },
      icon: {
        before: "jxvqufv",
        after: "jxvqufw"
      },
      disabled: {
        true: "jxvqufx"
      }
    },
    defaultVariants: {},
    compoundVariants: [[{
      variant: "solid",
      colorModes: "light"
    }, "jxvqufy"], [{
      variant: "solid",
      colorModes: "dark"
    }, "jxvqufz"], [{
      variant: "solid",
      disabled: !0
    }, "jxvquf10"], [{
      variant: "outline",
      colorModes: "dark"
    }, "jxvquf11"], [{
      variant: "outline",
      disabled: !0
    }, "jxvquf12"], [{
      variant: "text",
      size: "compact"
    }, "jxvquf13"], [{
      variant: "text",
      colorModes: "dark"
    }, "jxvquf14"], [{
      variant: "transparent",
      disabled: !0
    }, "jxvquf15"], [{
      width: "full",
      icon: "before"
    }, "jxvquf16"], [{
      width: "full",
      icon: "after"
    }, "jxvquf17"]]
  }),
  fg = "jxvquf18";
const NN = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
  __proto__: null,
  base: Gc,
  bleed: fg,
  button: Jc,
  buttonVars: dg
}, Symbol.toStringTag, {
  value: "Module"
}));
var pg = "q8x3853",
  mg = {
    md: "q8x3854",
    sm: "q8x3855"
  },
  gg = "q8x3856",
  hg = "q8x3857";
function Oa(_ref6) {
  let {
    size: e = "md"
  } = _ref6;
  return /* @__PURE__ */u.jsx("div", {
    className: ye([mg[e], pg]),
    children: /* @__PURE__ */u.jsx("svg", {
      className: gg,
      viewBox: "25 25 50 50",
      children: /* @__PURE__ */u.jsx("circle", {
        className: hg,
        cx: "50",
        cy: "50",
        fill: "none",
        r: "20"
      })
    })
  });
}
const Gi = {
    width: "1.25em",
    height: "1.25em",
    color: "currentColor"
  },
  Zt = ce((_ref7, m) => {
    let {
      url: e,
      onClick: t,
      children: n,
      variant: r = "solid",
      colorModes: o = "light",
      size: s = "normal",
      renderIconBefore: a,
      renderIconAfter: i,
      loading: l,
      disabled: c = !1,
      full: d,
      className: f,
      id: g,
      target: p = void 0,
      ...x
    } = _ref7;
    const h = e ? "a" : "button",
      j = l && h === "button",
      v = d ? "full" : void 0,
      _ = !!a || !!i,
      y = Jc({
        variant: r,
        colorModes: o,
        size: s,
        width: v,
        icon: _ ? _ && a ? "before" : "after" : void 0,
        disabled: c
      }),
      b = ye([Gc, y, f]);
    return /* @__PURE__ */u.jsx(h, {
      ref: m,
      className: b,
      disabled: c,
      href: e || void 0,
      id: g,
      onClick: t || void 0,
      ...(h === "a" ? {
        target: p
      } : {}),
      ...x,
      children: j ? /* @__PURE__ */u.jsx(Oa, {}) : /* @__PURE__ */u.jsxs(u.Fragment, {
        children: [a ? a(Gi) : null, n, i ? i(Gi) : null]
      })
    });
  });
var vg = {
    clickable: "ngvwz14 ngvwz13",
    static: "ngvwz15 ngvwz13"
  },
  _g = "ngvwz16",
  jg = "ngvwz17",
  yg = "ngvwz18",
  xg = "ngvwz19",
  kg = "ngvwz1c",
  Mg = "ngvwz1d",
  bg = "ngvwz1e";
const wg = (e, t) => {
    !(e.target === (t == null ? void 0 : t.current)) && t != null && t.current && t.current.click();
  },
  IN = _ref8 => {
    let {
      children: e,
      meta: t,
      title: n = "",
      url: r = "#",
      image: o,
      badge: s,
      actionText: a = "",
      altText: i,
      cardIsClickable: l = !0,
      id: c
    } = _ref8;
    const d = ee(null),
      f = l ? "clickable" : "static",
      g = `link-text-${c}`,
      p = l ? {
        role: "button",
        "aria-labelledby": g
      } : {};
    return /* @__PURE__ */u.jsxs(pe, {
      className: vg[f],
      onClick: x => l && wg(x, d),
      ...p,
      children: [/* @__PURE__ */u.jsxs(pe, {
        className: _g,
        children: [s && /* @__PURE__ */u.jsx("span", {
          className: bg,
          children: s
        }), /* @__PURE__ */u.jsx("img", {
          alt: i,
          className: kg,
          src: o
        })]
      }), /* @__PURE__ */u.jsxs(pe, {
        className: jg,
        children: [/* @__PURE__ */u.jsxs(pe, {
          className: yg,
          children: [t && /* @__PURE__ */u.jsx(pe, {
            className: Mg,
            children: t
          }), /* @__PURE__ */u.jsx(pe, {
            className: xg,
            children: n
          }), e]
        }), /* @__PURE__ */u.jsx(Zt, {
          ref: d,
          id: g,
          renderIconAfter: () => /* @__PURE__ */u.jsx(zr, {}),
          size: "compact",
          url: r,
          variant: "text",
          children: a
        })]
      })]
    });
  };
var Cg = Ue({
    defaultClassName: "l0ap553",
    variantClassNames: {
      isLink: {
        true: "l0ap554"
      },
      noShadow: {
        true: "l0ap555"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  Ng = "l0ap556",
  Ig = "l0ap557",
  Eg = "l0ap558",
  Sg = Ue({
    defaultClassName: "l0ap559",
    variantClassNames: {
      truncate: {
        true: "l0ap55a"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  Tg = "l0ap55b";
const EN = _ref9 => {
  let {
    children: e,
    meta: t,
    title: n,
    link: r,
    image: o,
    altText: s = "",
    truncate: a = !1,
    noShadow: i = !1,
    ...l
  } = _ref9;
  const c = r ? "a" : "div";
  return /* @__PURE__ */u.jsxs(pe, {
    as: c,
    className: Cg({
      isLink: !!r,
      noShadow: i
    }),
    href: r,
    ...l,
    children: [t ? /* @__PURE__ */u.jsx(pe, {
      className: Tg,
      children: t
    }) : null, o && /* @__PURE__ */u.jsx("img", {
      alt: s,
      className: Eg,
      src: o
    }), /* @__PURE__ */u.jsxs(pe, {
      className: Ng,
      children: [n && /* @__PURE__ */u.jsx(pe, {
        className: Ig,
        children: n
      }), e && /* @__PURE__ */u.jsx(pe, {
        className: Sg({
          truncate: a
        }),
        children: e
      })]
    })]
  });
};
function V() {
  return V = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V.apply(null, arguments);
}
function st(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function Qo(e, t) {
  return Qo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (n, r) {
    return n.__proto__ = r, n;
  }, Qo(e, t);
}
function Ws(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Qo(e, t);
}
var qo = {
    exports: {}
  },
  Qr = {
    exports: {}
  },
  Ee = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ji;
function Dg() {
  if (Ji) return Ee;
  Ji = 1;
  var e = typeof Symbol == "function" && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    s = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    i = e ? Symbol.for("react.context") : 60110,
    l = e ? Symbol.for("react.async_mode") : 60111,
    c = e ? Symbol.for("react.concurrent_mode") : 60111,
    d = e ? Symbol.for("react.forward_ref") : 60112,
    f = e ? Symbol.for("react.suspense") : 60113,
    g = e ? Symbol.for("react.suspense_list") : 60120,
    p = e ? Symbol.for("react.memo") : 60115,
    x = e ? Symbol.for("react.lazy") : 60116,
    m = e ? Symbol.for("react.block") : 60121,
    h = e ? Symbol.for("react.fundamental") : 60117,
    j = e ? Symbol.for("react.responder") : 60118,
    v = e ? Symbol.for("react.scope") : 60119;
  function _(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case t:
          switch (y = y.type, y) {
            case l:
            case c:
            case r:
            case s:
            case o:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case i:
                case d:
                case x:
                case p:
                case a:
                  return y;
                default:
                  return b;
              }
          }
        case n:
          return b;
      }
    }
  }
  function k(y) {
    return _(y) === c;
  }
  return Ee.AsyncMode = l, Ee.ConcurrentMode = c, Ee.ContextConsumer = i, Ee.ContextProvider = a, Ee.Element = t, Ee.ForwardRef = d, Ee.Fragment = r, Ee.Lazy = x, Ee.Memo = p, Ee.Portal = n, Ee.Profiler = s, Ee.StrictMode = o, Ee.Suspense = f, Ee.isAsyncMode = function (y) {
    return k(y) || _(y) === l;
  }, Ee.isConcurrentMode = k, Ee.isContextConsumer = function (y) {
    return _(y) === i;
  }, Ee.isContextProvider = function (y) {
    return _(y) === a;
  }, Ee.isElement = function (y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Ee.isForwardRef = function (y) {
    return _(y) === d;
  }, Ee.isFragment = function (y) {
    return _(y) === r;
  }, Ee.isLazy = function (y) {
    return _(y) === x;
  }, Ee.isMemo = function (y) {
    return _(y) === p;
  }, Ee.isPortal = function (y) {
    return _(y) === n;
  }, Ee.isProfiler = function (y) {
    return _(y) === s;
  }, Ee.isStrictMode = function (y) {
    return _(y) === o;
  }, Ee.isSuspense = function (y) {
    return _(y) === f;
  }, Ee.isValidElementType = function (y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === c || y === s || y === o || y === f || y === g || typeof y == "object" && y !== null && (y.$$typeof === x || y.$$typeof === p || y.$$typeof === a || y.$$typeof === i || y.$$typeof === d || y.$$typeof === h || y.$$typeof === j || y.$$typeof === v || y.$$typeof === m);
  }, Ee.typeOf = _, Ee;
}
var Se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xi;
function Og() {
  return Xi || (Xi = 1, process.env.NODE_ENV !== "production" && function () {
    var e = typeof Symbol == "function" && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      s = e ? Symbol.for("react.profiler") : 60114,
      a = e ? Symbol.for("react.provider") : 60109,
      i = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      d = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      g = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      x = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      j = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function _($) {
      return typeof $ == "string" || typeof $ == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === r || $ === c || $ === s || $ === o || $ === f || $ === g || typeof $ == "object" && $ !== null && ($.$$typeof === x || $.$$typeof === p || $.$$typeof === a || $.$$typeof === i || $.$$typeof === d || $.$$typeof === h || $.$$typeof === j || $.$$typeof === v || $.$$typeof === m);
    }
    function k($) {
      if (typeof $ == "object" && $ !== null) {
        var je = $.$$typeof;
        switch (je) {
          case t:
            var J = $.type;
            switch (J) {
              case l:
              case c:
              case r:
              case s:
              case o:
              case f:
                return J;
              default:
                var Ce = J && J.$$typeof;
                switch (Ce) {
                  case i:
                  case d:
                  case x:
                  case p:
                  case a:
                    return Ce;
                  default:
                    return je;
                }
            }
          case n:
            return je;
        }
      }
    }
    var y = l,
      b = c,
      C = i,
      N = a,
      T = t,
      z = d,
      K = r,
      L = x,
      H = p,
      Y = n,
      X = s,
      ne = o,
      U = f,
      de = !1;
    function Z($) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), S($) || k($) === l;
    }
    function S($) {
      return k($) === c;
    }
    function R($) {
      return k($) === i;
    }
    function ae($) {
      return k($) === a;
    }
    function P($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function D($) {
      return k($) === d;
    }
    function O($) {
      return k($) === r;
    }
    function A($) {
      return k($) === x;
    }
    function E($) {
      return k($) === p;
    }
    function G($) {
      return k($) === n;
    }
    function B($) {
      return k($) === s;
    }
    function Q($) {
      return k($) === o;
    }
    function ie($) {
      return k($) === f;
    }
    Se.AsyncMode = y, Se.ConcurrentMode = b, Se.ContextConsumer = C, Se.ContextProvider = N, Se.Element = T, Se.ForwardRef = z, Se.Fragment = K, Se.Lazy = L, Se.Memo = H, Se.Portal = Y, Se.Profiler = X, Se.StrictMode = ne, Se.Suspense = U, Se.isAsyncMode = Z, Se.isConcurrentMode = S, Se.isContextConsumer = R, Se.isContextProvider = ae, Se.isElement = P, Se.isForwardRef = D, Se.isFragment = O, Se.isLazy = A, Se.isMemo = E, Se.isPortal = G, Se.isProfiler = B, Se.isStrictMode = Q, Se.isSuspense = ie, Se.isValidElementType = _, Se.typeOf = k;
  }()), Se;
}
var el;
function Xc() {
  return el || (el = 1, process.env.NODE_ENV === "production" ? Qr.exports = Dg() : Qr.exports = Og()), Qr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var po, tl;
function Ag() {
  if (tl) return po;
  tl = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign) return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5") return !1;
      for (var a = {}, i = 0; i < 10; i++) a["_" + String.fromCharCode(i)] = i;
      var l = Object.getOwnPropertyNames(a).map(function (d) {
        return a[d];
      });
      if (l.join("") !== "0123456789") return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return po = o() ? Object.assign : function (s, a) {
    for (var i, l = r(s), c, d = 1; d < arguments.length; d++) {
      i = Object(arguments[d]);
      for (var f in i) t.call(i, f) && (l[f] = i[f]);
      if (e) {
        c = e(i);
        for (var g = 0; g < c.length; g++) n.call(i, c[g]) && (l[c[g]] = i[c[g]]);
      }
    }
    return l;
  }, po;
}
var mo, nl;
function Aa() {
  if (nl) return mo;
  nl = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return mo = e, mo;
}
var go, rl;
function eu() {
  return rl || (rl = 1, go = Function.call.bind(Object.prototype.hasOwnProperty)), go;
}
var ho, sl;
function $g() {
  if (sl) return ho;
  sl = 1;
  var e = function () {};
  if (process.env.NODE_ENV !== "production") {
    var t = Aa(),
      n = {},
      r = eu();
    e = function (s) {
      var a = "Warning: " + s;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {}
    };
  }
  function o(s, a, i, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in s) if (r(s, d)) {
        var f;
        try {
          if (typeof s[d] != "function") {
            var g = Error((l || "React class") + ": " + i + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw g.name = "Invariant Violation", g;
          }
          f = s[d](a, d, l, i, null, t);
        } catch (x) {
          f = x;
        }
        if (f && !(f instanceof Error) && e((l || "React class") + ": type specification of " + i + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), f instanceof Error && !(f.message in n)) {
          n[f.message] = !0;
          var p = c ? c() : "";
          e("Failed " + i + " type: " + f.message + (p ?? ""));
        }
      }
    }
  }
  return o.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ho = o, ho;
}
var vo, ol;
function Lg() {
  if (ol) return vo;
  ol = 1;
  var e = Xc(),
    t = Ag(),
    n = Aa(),
    r = eu(),
    o = $g(),
    s = function () {};
  process.env.NODE_ENV !== "production" && (s = function (i) {
    var l = "Warning: " + i;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {}
  });
  function a() {
    return null;
  }
  return vo = function (i, l) {
    var c = typeof Symbol == "function" && Symbol.iterator,
      d = "@@iterator";
    function f(S) {
      var R = S && (c && S[c] || S[d]);
      if (typeof R == "function") return R;
    }
    var g = "<<anonymous>>",
      p = {
        array: j("array"),
        bigint: j("bigint"),
        bool: j("boolean"),
        func: j("function"),
        number: j("number"),
        object: j("object"),
        string: j("string"),
        symbol: j("symbol"),
        any: v(),
        arrayOf: _,
        element: k(),
        elementType: y(),
        instanceOf: b,
        node: z(),
        objectOf: N,
        oneOf: C,
        oneOfType: T,
        shape: L,
        exact: H
      };
    function x(S, R) {
      return S === R ? S !== 0 || 1 / S === 1 / R : S !== S && R !== R;
    }
    function m(S, R) {
      this.message = S, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function h(S) {
      if (process.env.NODE_ENV !== "production") var R = {},
        ae = 0;
      function P(O, A, E, G, B, Q, ie) {
        if (G = G || g, Q = Q || E, ie !== n) {
          if (l) {
            var $ = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw $.name = "Invariant Violation", $;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var je = G + ":" + E;
            !R[je] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            ae < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), R[je] = !0, ae++);
          }
        }
        return A[E] == null ? O ? A[E] === null ? new m("The " + B + " `" + Q + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new m("The " + B + " `" + Q + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : S(A, E, G, B, Q);
      }
      var D = P.bind(null, !1);
      return D.isRequired = P.bind(null, !0), D;
    }
    function j(S) {
      function R(ae, P, D, O, A, E) {
        var G = ae[P],
          B = ne(G);
        if (B !== S) {
          var Q = U(G);
          return new m("Invalid " + O + " `" + A + "` of type " + ("`" + Q + "` supplied to `" + D + "`, expected ") + ("`" + S + "`."), {
            expectedType: S
          });
        }
        return null;
      }
      return h(R);
    }
    function v() {
      return h(a);
    }
    function _(S) {
      function R(ae, P, D, O, A) {
        if (typeof S != "function") return new m("Property `" + A + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
        var E = ae[P];
        if (!Array.isArray(E)) {
          var G = ne(E);
          return new m("Invalid " + O + " `" + A + "` of type " + ("`" + G + "` supplied to `" + D + "`, expected an array."));
        }
        for (var B = 0; B < E.length; B++) {
          var Q = S(E, B, D, O, A + "[" + B + "]", n);
          if (Q instanceof Error) return Q;
        }
        return null;
      }
      return h(R);
    }
    function k() {
      function S(R, ae, P, D, O) {
        var A = R[ae];
        if (!i(A)) {
          var E = ne(A);
          return new m("Invalid " + D + " `" + O + "` of type " + ("`" + E + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(S);
    }
    function y() {
      function S(R, ae, P, D, O) {
        var A = R[ae];
        if (!e.isValidElementType(A)) {
          var E = ne(A);
          return new m("Invalid " + D + " `" + O + "` of type " + ("`" + E + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(S);
    }
    function b(S) {
      function R(ae, P, D, O, A) {
        if (!(ae[P] instanceof S)) {
          var E = S.name || g,
            G = Z(ae[P]);
          return new m("Invalid " + O + " `" + A + "` of type " + ("`" + G + "` supplied to `" + D + "`, expected ") + ("instance of `" + E + "`."));
        }
        return null;
      }
      return h(R);
    }
    function C(S) {
      if (!Array.isArray(S)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), a;
      function R(ae, P, D, O, A) {
        for (var E = ae[P], G = 0; G < S.length; G++) if (x(E, S[G])) return null;
        var B = JSON.stringify(S, function (ie, $) {
          var je = U($);
          return je === "symbol" ? String($) : $;
        });
        return new m("Invalid " + O + " `" + A + "` of value `" + String(E) + "` " + ("supplied to `" + D + "`, expected one of " + B + "."));
      }
      return h(R);
    }
    function N(S) {
      function R(ae, P, D, O, A) {
        if (typeof S != "function") return new m("Property `" + A + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
        var E = ae[P],
          G = ne(E);
        if (G !== "object") return new m("Invalid " + O + " `" + A + "` of type " + ("`" + G + "` supplied to `" + D + "`, expected an object."));
        for (var B in E) if (r(E, B)) {
          var Q = S(E, B, D, O, A + "." + B, n);
          if (Q instanceof Error) return Q;
        }
        return null;
      }
      return h(R);
    }
    function T(S) {
      if (!Array.isArray(S)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var R = 0; R < S.length; R++) {
        var ae = S[R];
        if (typeof ae != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + de(ae) + " at index " + R + "."), a;
      }
      function P(D, O, A, E, G) {
        for (var B = [], Q = 0; Q < S.length; Q++) {
          var ie = S[Q],
            $ = ie(D, O, A, E, G, n);
          if ($ == null) return null;
          $.data && r($.data, "expectedType") && B.push($.data.expectedType);
        }
        var je = B.length > 0 ? ", expected one of type [" + B.join(", ") + "]" : "";
        return new m("Invalid " + E + " `" + G + "` supplied to " + ("`" + A + "`" + je + "."));
      }
      return h(P);
    }
    function z() {
      function S(R, ae, P, D, O) {
        return Y(R[ae]) ? null : new m("Invalid " + D + " `" + O + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return h(S);
    }
    function K(S, R, ae, P, D) {
      return new m((S || "React class") + ": " + R + " type `" + ae + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`.");
    }
    function L(S) {
      function R(ae, P, D, O, A) {
        var E = ae[P],
          G = ne(E);
        if (G !== "object") return new m("Invalid " + O + " `" + A + "` of type `" + G + "` " + ("supplied to `" + D + "`, expected `object`."));
        for (var B in S) {
          var Q = S[B];
          if (typeof Q != "function") return K(D, O, A, B, U(Q));
          var ie = Q(E, B, D, O, A + "." + B, n);
          if (ie) return ie;
        }
        return null;
      }
      return h(R);
    }
    function H(S) {
      function R(ae, P, D, O, A) {
        var E = ae[P],
          G = ne(E);
        if (G !== "object") return new m("Invalid " + O + " `" + A + "` of type `" + G + "` " + ("supplied to `" + D + "`, expected `object`."));
        var B = t({}, ae[P], S);
        for (var Q in B) {
          var ie = S[Q];
          if (r(S, Q) && typeof ie != "function") return K(D, O, A, Q, U(ie));
          if (!ie) return new m("Invalid " + O + " `" + A + "` key `" + Q + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(ae[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(S), null, "  "));
          var $ = ie(E, Q, D, O, A + "." + Q, n);
          if ($) return $;
        }
        return null;
      }
      return h(R);
    }
    function Y(S) {
      switch (typeof S) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !S;
        case "object":
          if (Array.isArray(S)) return S.every(Y);
          if (S === null || i(S)) return !0;
          var R = f(S);
          if (R) {
            var ae = R.call(S),
              P;
            if (R !== S.entries) {
              for (; !(P = ae.next()).done;) if (!Y(P.value)) return !1;
            } else for (; !(P = ae.next()).done;) {
              var D = P.value;
              if (D && !Y(D[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(S, R) {
      return S === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function ne(S) {
      var R = typeof S;
      return Array.isArray(S) ? "array" : S instanceof RegExp ? "object" : X(R, S) ? "symbol" : R;
    }
    function U(S) {
      if (typeof S > "u" || S === null) return "" + S;
      var R = ne(S);
      if (R === "object") {
        if (S instanceof Date) return "date";
        if (S instanceof RegExp) return "regexp";
      }
      return R;
    }
    function de(S) {
      var R = U(S);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function Z(S) {
      return !S.constructor || !S.constructor.name ? g : S.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, vo;
}
var _o, al;
function zg() {
  if (al) return _o;
  al = 1;
  var e = Aa();
  function t() {}
  function n() {}
  return n.resetWarningCache = t, _o = function () {
    function r(a, i, l, c, d, f) {
      if (f !== e) {
        var g = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, _o;
}
if (process.env.NODE_ENV !== "production") {
  var Rg = Xc(),
    Pg = !0;
  qo.exports = Lg()(Rg.isElement, Pg);
} else qo.exports = zg()();
var Vg = qo.exports;
const I = /* @__PURE__ */Ys(Vg);
function Fg(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function Ug(e, t) {
  e.classList ? e.classList.add(t) : Fg(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function il(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Yg(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = il(e.className, t) : e.setAttribute("class", il(e.className && e.className.baseVal || "", t));
}
const ll = {
  disabled: !1
};
var Wg = process.env.NODE_ENV !== "production" ? I.oneOfType([I.number, I.shape({
    enter: I.number,
    exit: I.number,
    appear: I.number
  }).isRequired]) : null,
  Bg = process.env.NODE_ENV !== "production" ? I.oneOfType([I.string, I.shape({
    enter: I.string,
    exit: I.string,
    active: I.string
  }), I.shape({
    enter: I.string,
    enterDone: I.string,
    enterActive: I.string,
    exit: I.string,
    exitDone: I.string,
    exitActive: I.string
  })]) : null;
const vs = te.createContext(null);
var tu = function (t) {
    return t.scrollTop;
  },
  ur = "unmounted",
  hn = "exited",
  vn = "entering",
  Rn = "entered",
  Ko = "exiting",
  Rt = /* @__PURE__ */function (e) {
    Ws(t, e);
    function t(r, o) {
      var s;
      s = e.call(this, r, o) || this;
      var a = o,
        i = a && !a.isMounting ? r.enter : r.appear,
        l;
      return s.appearStatus = null, r.in ? i ? (l = hn, s.appearStatus = vn) : l = Rn : r.unmountOnExit || r.mountOnEnter ? l = ur : l = hn, s.state = {
        status: l
      }, s.nextCallback = null, s;
    }
    t.getDerivedStateFromProps = function (o, s) {
      var a = o.in;
      return a && s.status === ur ? {
        status: hn
      } : null;
    };
    var n = t.prototype;
    return n.componentDidMount = function () {
      this.updateStatus(!0, this.appearStatus);
    }, n.componentDidUpdate = function (o) {
      var s = null;
      if (o !== this.props) {
        var a = this.state.status;
        this.props.in ? a !== vn && a !== Rn && (s = vn) : (a === vn || a === Rn) && (s = Ko);
      }
      this.updateStatus(!1, s);
    }, n.componentWillUnmount = function () {
      this.cancelNextCallback();
    }, n.getTimeouts = function () {
      var o = this.props.timeout,
        s,
        a,
        i;
      return s = a = i = o, o != null && typeof o != "number" && (s = o.exit, a = o.enter, i = o.appear !== void 0 ? o.appear : a), {
        exit: s,
        enter: a,
        appear: i
      };
    }, n.updateStatus = function (o, s) {
      if (o === void 0 && (o = !1), s !== null) {
        if (this.cancelNextCallback(), s === vn) {
          if (this.props.unmountOnExit || this.props.mountOnEnter) {
            var a = this.props.nodeRef ? this.props.nodeRef.current : cr.findDOMNode(this);
            a && tu(a);
          }
          this.performEnter(o);
        } else this.performExit();
      } else this.props.unmountOnExit && this.state.status === hn && this.setState({
        status: ur
      });
    }, n.performEnter = function (o) {
      var s = this,
        a = this.props.enter,
        i = this.context ? this.context.isMounting : o,
        l = this.props.nodeRef ? [i] : [cr.findDOMNode(this), i],
        c = l[0],
        d = l[1],
        f = this.getTimeouts(),
        g = i ? f.appear : f.enter;
      if (!o && !a || ll.disabled) {
        this.safeSetState({
          status: Rn
        }, function () {
          s.props.onEntered(c);
        });
        return;
      }
      this.props.onEnter(c, d), this.safeSetState({
        status: vn
      }, function () {
        s.props.onEntering(c, d), s.onTransitionEnd(g, function () {
          s.safeSetState({
            status: Rn
          }, function () {
            s.props.onEntered(c, d);
          });
        });
      });
    }, n.performExit = function () {
      var o = this,
        s = this.props.exit,
        a = this.getTimeouts(),
        i = this.props.nodeRef ? void 0 : cr.findDOMNode(this);
      if (!s || ll.disabled) {
        this.safeSetState({
          status: hn
        }, function () {
          o.props.onExited(i);
        });
        return;
      }
      this.props.onExit(i), this.safeSetState({
        status: Ko
      }, function () {
        o.props.onExiting(i), o.onTransitionEnd(a.exit, function () {
          o.safeSetState({
            status: hn
          }, function () {
            o.props.onExited(i);
          });
        });
      });
    }, n.cancelNextCallback = function () {
      this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
    }, n.safeSetState = function (o, s) {
      s = this.setNextCallback(s), this.setState(o, s);
    }, n.setNextCallback = function (o) {
      var s = this,
        a = !0;
      return this.nextCallback = function (i) {
        a && (a = !1, s.nextCallback = null, o(i));
      }, this.nextCallback.cancel = function () {
        a = !1;
      }, this.nextCallback;
    }, n.onTransitionEnd = function (o, s) {
      this.setNextCallback(s);
      var a = this.props.nodeRef ? this.props.nodeRef.current : cr.findDOMNode(this),
        i = o == null && !this.props.addEndListener;
      if (!a || i) {
        setTimeout(this.nextCallback, 0);
        return;
      }
      if (this.props.addEndListener) {
        var l = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback],
          c = l[0],
          d = l[1];
        this.props.addEndListener(c, d);
      }
      o != null && setTimeout(this.nextCallback, o);
    }, n.render = function () {
      var o = this.state.status;
      if (o === ur) return null;
      var s = this.props,
        a = s.children;
      s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
      var i = st(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
      return (
        // allows for nested Transitions
        /* @__PURE__ */
        te.createElement(vs.Provider, {
          value: null
        }, typeof a == "function" ? a(o, i) : te.cloneElement(te.Children.only(a), i))
      );
    }, t;
  }(te.Component);
Rt.contextType = vs;
Rt.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: I.shape({
    current: typeof Element > "u" ? I.any : function (e, t, n, r, o, s) {
      var a = e[t];
      return I.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, s);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: I.oneOfType([I.func.isRequired, I.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: I.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: I.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: I.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: I.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: I.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: I.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function (t) {
    var n = Wg;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) o[s - 1] = arguments[s];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: I.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: I.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: I.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: I.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: I.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: I.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: I.func
} : {};
function Dn() {}
Rt.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Dn,
  onEntering: Dn,
  onEntered: Dn,
  onExit: Dn,
  onExiting: Dn,
  onExited: Dn
};
Rt.UNMOUNTED = ur;
Rt.EXITED = hn;
Rt.ENTERING = vn;
Rt.ENTERED = Rn;
Rt.EXITING = Ko;
const nu = Rt;
var Hg = function (t, n) {
    return t && n && n.split(" ").forEach(function (r) {
      return Ug(t, r);
    });
  },
  jo = function (t, n) {
    return t && n && n.split(" ").forEach(function (r) {
      return Yg(t, r);
    });
  },
  $a = /* @__PURE__ */function (e) {
    Ws(t, e);
    function t() {
      for (var r, o = arguments.length, s = new Array(o), a = 0; a < o; a++) s[a] = arguments[a];
      return r = e.call.apply(e, [this].concat(s)) || this, r.appliedClasses = {
        appear: {},
        enter: {},
        exit: {}
      }, r.onEnter = function (i, l) {
        var c = r.resolveArguments(i, l),
          d = c[0],
          f = c[1];
        r.removeClasses(d, "exit"), r.addClass(d, f ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(i, l);
      }, r.onEntering = function (i, l) {
        var c = r.resolveArguments(i, l),
          d = c[0],
          f = c[1],
          g = f ? "appear" : "enter";
        r.addClass(d, g, "active"), r.props.onEntering && r.props.onEntering(i, l);
      }, r.onEntered = function (i, l) {
        var c = r.resolveArguments(i, l),
          d = c[0],
          f = c[1],
          g = f ? "appear" : "enter";
        r.removeClasses(d, g), r.addClass(d, g, "done"), r.props.onEntered && r.props.onEntered(i, l);
      }, r.onExit = function (i) {
        var l = r.resolveArguments(i),
          c = l[0];
        r.removeClasses(c, "appear"), r.removeClasses(c, "enter"), r.addClass(c, "exit", "base"), r.props.onExit && r.props.onExit(i);
      }, r.onExiting = function (i) {
        var l = r.resolveArguments(i),
          c = l[0];
        r.addClass(c, "exit", "active"), r.props.onExiting && r.props.onExiting(i);
      }, r.onExited = function (i) {
        var l = r.resolveArguments(i),
          c = l[0];
        r.removeClasses(c, "exit"), r.addClass(c, "exit", "done"), r.props.onExited && r.props.onExited(i);
      }, r.resolveArguments = function (i, l) {
        return r.props.nodeRef ? [r.props.nodeRef.current, i] : [i, l];
      }, r.getClassNames = function (i) {
        var l = r.props.classNames,
          c = typeof l == "string",
          d = c && l ? l + "-" : "",
          f = c ? "" + d + i : l[i],
          g = c ? f + "-active" : l[i + "Active"],
          p = c ? f + "-done" : l[i + "Done"];
        return {
          baseClassName: f,
          activeClassName: g,
          doneClassName: p
        };
      }, r;
    }
    var n = t.prototype;
    return n.addClass = function (o, s, a) {
      var i = this.getClassNames(s)[a + "ClassName"],
        l = this.getClassNames("enter"),
        c = l.doneClassName;
      s === "appear" && a === "done" && c && (i += " " + c), a === "active" && o && tu(o), i && (this.appliedClasses[s][a] = i, Hg(o, i));
    }, n.removeClasses = function (o, s) {
      var a = this.appliedClasses[s],
        i = a.base,
        l = a.active,
        c = a.done;
      this.appliedClasses[s] = {}, i && jo(o, i), l && jo(o, l), c && jo(o, c);
    }, n.render = function () {
      var o = this.props;
      o.classNames;
      var s = st(o, ["classNames"]);
      return /* @__PURE__ */te.createElement(nu, V({}, s, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    }, t;
  }(te.Component);
$a.defaultProps = {
  classNames: ""
};
$a.propTypes = process.env.NODE_ENV !== "production" ? V({}, nu.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: Bg,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: I.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: I.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: I.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: I.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: I.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: I.func
}) : {};
const Qg = $a;
function Zo(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function La(e, t) {
  var n = function (s) {
      return t && kt(s) ? t(s) : s;
    },
    r = /* @__PURE__ */Object.create(null);
  return e && ht.map(e, function (o) {
    return o;
  }).forEach(function (o) {
    r[o.key] = n(o);
  }), r;
}
function qg(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */Object.create(null),
    o = [];
  for (var s in e) s in t ? o.length && (r[s] = o, o = []) : o.push(s);
  var a,
    i = {};
  for (var l in t) {
    if (r[l]) for (a = 0; a < r[l].length; a++) {
      var c = r[l][a];
      i[r[l][a]] = n(c);
    }
    i[l] = n(l);
  }
  for (a = 0; a < o.length; a++) i[o[a]] = n(o[a]);
  return i;
}
function _n(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function Kg(e, t) {
  return La(e.children, function (n) {
    return Ot(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: _n(n, "appear", e),
      enter: _n(n, "enter", e),
      exit: _n(n, "exit", e)
    });
  });
}
function Zg(e, t, n) {
  var r = La(e.children),
    o = qg(t, r);
  return Object.keys(o).forEach(function (s) {
    var a = o[s];
    if (kt(a)) {
      var i = s in t,
        l = s in r,
        c = t[s],
        d = kt(c) && !c.props.in;
      l && (!i || d) ? o[s] = Ot(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: _n(a, "exit", e),
        enter: _n(a, "enter", e)
      }) : !l && i && !d ? o[s] = Ot(a, {
        in: !1
      }) : l && i && kt(c) && (o[s] = Ot(a, {
        onExited: n.bind(null, a),
        in: c.props.in,
        exit: _n(a, "exit", e),
        enter: _n(a, "enter", e)
      }));
    }
  }), o;
}
var Gg = Object.values || function (e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  },
  Jg = {
    component: "div",
    childFactory: function (t) {
      return t;
    }
  },
  za = /* @__PURE__ */function (e) {
    Ws(t, e);
    function t(r, o) {
      var s;
      s = e.call(this, r, o) || this;
      var a = s.handleExited.bind(Zo(s));
      return s.state = {
        contextValue: {
          isMounting: !0
        },
        handleExited: a,
        firstRender: !0
      }, s;
    }
    var n = t.prototype;
    return n.componentDidMount = function () {
      this.mounted = !0, this.setState({
        contextValue: {
          isMounting: !1
        }
      });
    }, n.componentWillUnmount = function () {
      this.mounted = !1;
    }, t.getDerivedStateFromProps = function (o, s) {
      var a = s.children,
        i = s.handleExited,
        l = s.firstRender;
      return {
        children: l ? Kg(o, i) : Zg(o, a, i),
        firstRender: !1
      };
    }, n.handleExited = function (o, s) {
      var a = La(this.props.children);
      o.key in a || (o.props.onExited && o.props.onExited(s), this.mounted && this.setState(function (i) {
        var l = V({}, i.children);
        return delete l[o.key], {
          children: l
        };
      }));
    }, n.render = function () {
      var o = this.props,
        s = o.component,
        a = o.childFactory,
        i = st(o, ["component", "childFactory"]),
        l = this.state.contextValue,
        c = Gg(this.state.children).map(a);
      return delete i.appear, delete i.enter, delete i.exit, s === null ? /* @__PURE__ */te.createElement(vs.Provider, {
        value: l
      }, c) : /* @__PURE__ */te.createElement(vs.Provider, {
        value: l
      }, /* @__PURE__ */te.createElement(s, i, c));
    }, t;
  }(te.Component);
za.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: I.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: I.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: I.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: I.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: I.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: I.func
} : {};
za.defaultProps = Jg;
const cl = za;
var Xg = "jjcfm4",
  ul = "jjcfm5",
  eh = "jjcfm6",
  th = "jjcfm7",
  nh = "jjcfm8";
const rh = (e, t, n) => {
    const r = t.findIndex(o => o === e);
    n(r === 0 ? t[t.length - 1] : t[r - 1]);
  },
  sh = (e, t, n) => {
    const r = t.findIndex(o => o === e);
    r === t.length - 1 ? n(t[0]) : n(t[r + 1]);
  },
  ru = _ref10 => {
    let {
      slidesIds: e,
      activeSlide: t,
      progressRef: n,
      onClick: r
    } = _ref10;
    const o = (n == null ? void 0 : n.current) ?? 0;
    return /* @__PURE__ */u.jsxs("div", {
      className: Xg,
      onClick: s => s.stopPropagation(),
      children: [/* @__PURE__ */u.jsx("button", {
        className: ul,
        onClick: () => {
          rh(t, e, r);
        },
        children: /* @__PURE__ */u.jsx(ag, {
          size: 16
        })
      }), e.map(s => /* @__PURE__ */u.jsxs("button", {
        className: ye([eh, t === s && "active"]),
        disabled: t === s,
        title: `Slide ${s}`,
        type: "button",
        onClick: () => r(s),
        children: [/* @__PURE__ */u.jsx("div", {
          className: th
        }), /* @__PURE__ */u.jsx("div", {
          className: nh,
          style: {
            transform: t === s ? `translateX(${o * 100 - 100}%)` : "translateX(-100%)",
            transition: t === s ? "ease-in-out transform" : "0.3s ease-in-out transform"
          }
        })]
      }, s)), /* @__PURE__ */u.jsx("button", {
        className: ul,
        onClick: () => {
          sh(t, e, r);
        },
        children: /* @__PURE__ */u.jsx(Zc, {
          size: 16
        })
      })]
    });
  };
function dl(_ref11) {
  let {
    slidesIds: e,
    selectedSlide: t
  } = _ref11;
  const r = e.indexOf(t) + 1;
  return r === e.length ? e[0] : e[r];
}
const su = _ref12 => {
  let {
    autoplay: e,
    autoplayTime: t,
    slidesIds: n,
    selectedSlide: r,
    setSelectedSlide: o
  } = _ref12;
  const [s, a] = le(""),
    i = ee(0),
    l = ee(0),
    c = ee(void 0),
    d = ge(f => {
      c.current || (c.current = f);
      const g = f - c.current;
      i.current = g / t, g < t ? l.current = window.requestAnimationFrame(d) : o(dl({
        slidesIds: n,
        selectedSlide: r
      }));
    }, [t, n, r]);
  return fe(() => !e || !t || t < 0 ? () => {
    window.cancelAnimationFrame(l.current);
  } : (a(dl({
    slidesIds: n,
    selectedSlide: r
  })), window.cancelAnimationFrame(l.current), c.current = void 0, l.current = window.requestAnimationFrame(d), () => {
    window.cancelAnimationFrame(l.current);
  }), [e, d]), e ? {
    nextSlide: s,
    progressRef: i
  } : (i.current = 0, {
    nextSlide: "",
    progressRef: i
  });
};
var oh = "_7hwotr2",
  ah = "_7hwotr3",
  ih = "_7hwotr4",
  lh = "_7hwotr5";
var ch = "mk86421",
  ou = "mk86422";
function uh(_ref13) {
  let {
    children: e,
    direction: t
  } = _ref13;
  return /* @__PURE__ */u.jsx("div", {
    className: ye([ou, t]),
    children: e
  });
}
function dh(_ref14) {
  let {
    children: e,
    direction: t
  } = _ref14;
  return /* @__PURE__ */u.jsx("div", {
    className: ye([ou, t]),
    children: e
  });
}
function SN(_ref15) {
  let {
    children: e,
    id: t
  } = _ref15;
  return /* @__PURE__ */u.jsx("div", {
    className: ch,
    id: t,
    children: e
  });
}
var _s = /* @__PURE__ */(e => (e.forward = "forward", e.backward = "backward", e))(_s || {});
const fh = "slide",
  ph = 400,
  fl = (e, t, n, r) => {
    if (!r) return /* @__PURE__ */u.jsx(u.Fragment, {});
    const o = ht.toArray(e).filter(a => kt(a) && r === a.props.id)[0],
      s = ht.toArray(o.props.children).filter(_ref16 => {
        let {
          type: a
        } = _ref16;
        return a === t;
      });
    return /* @__PURE__ */u.jsx(Qg, {
      classNames: `${fh}-${n || _s.forward}`,
      timeout: ph,
      children: Ot(s[0], {
        direction: n
      })
    }, o.props.id);
  };
function TN(_ref17) {
  let {
    children: e,
    autoplay: t = !0,
    autoplayTime: n = 1e4
  } = _ref17;
  const [r, o] = le(""),
    [s, a] = le(void 0),
    i = it(() => {
      var g;
      return ((g = ht.map(e, p => kt(p) && p.props.id)) == null ? void 0 : g.filter(Boolean)) || [];
    }, [e]);
  fe(() => {
    (!r || !i.includes(r)) && o(i[0]);
  }, [e, i]);
  const {
      nextSlide: l,
      progressRef: c
    } = su({
      autoplay: t,
      autoplayTime: n,
      slidesIds: i,
      selectedSlide: r,
      setSelectedSlide: o
    }),
    d = g => {
      const p = i.indexOf(r),
        x = i.indexOf(g);
      o(g), a(p < x ? _s.forward : _s.backward);
    },
    f = () => /* @__PURE__ */u.jsxs("div", {
      className: lh,
      children: [/* @__PURE__ */u.jsx("div", {
        className: ah,
        children: /* @__PURE__ */u.jsx(cl, {
          children: fl(e, uh, s, r)
        })
      }), /* @__PURE__ */u.jsx("div", {
        className: ih,
        children: /* @__PURE__ */u.jsx(cl, {
          children: fl(e, dh, s, r)
        })
      })]
    });
  return r === "" ? /* @__PURE__ */u.jsx(u.Fragment, {}) : ht.count(e) ? /* @__PURE__ */u.jsxs("div", {
    className: oh,
    role: "tablist",
    children: [f(), i.length > 1 ? /* @__PURE__ */u.jsx(ru, {
      activeSlide: r,
      nextSlide: l,
      progressRef: c,
      slidesIds: i,
      onClick: d
    }) : null]
  }) : /* @__PURE__ */u.jsx(u.Fragment, {});
}
var mh = "_8fzk1pg",
  gh = "_8fzk1ph",
  hh = "_8fzk1pi",
  vh = "_8fzk1pj",
  _h = "_8fzk1pk",
  jh = "_8fzk1pl",
  yh = "_8fzk1pm",
  pl = "_8fzk1pn",
  ml = "_8fzk1po",
  xh = "_8fzk1pp",
  kh = "_8fzk1pq",
  Mh = "_8fzk1pr",
  bh = "_8fzk1ps",
  wh = "_8fzk1pt",
  Ch = "_8fzk1pu",
  Nh = "_8fzk1pv",
  Ih = "_8fzk1pw",
  Eh = "_8fzk1px",
  gl = "_8fzk1py",
  qr = "_8fzk1pz",
  Kr = "_8fzk1p10";
const yo = _ref18 => {
    let {
      title: e,
      rightElement: t,
      body: n,
      active: r,
      activate: o
    } = _ref18;
    return /* @__PURE__ */u.jsxs("div", {
      role: "button",
      onClick: o,
      className: r ? Mh : kh,
      children: [/* @__PURE__ */u.jsxs("div", {
        className: bh,
        children: [/* @__PURE__ */u.jsx("span", {
          className: Ih,
          children: r ? "▾" : "▸"
        }), /* @__PURE__ */u.jsxs("h3", {
          className: r ? Ch : wh,
          children: [" ", e]
        }), /* @__PURE__ */u.jsx("div", {
          style: {
            flex: 1,
            minWidth: 16
          }
        }), t]
      }), r && /* @__PURE__ */u.jsx(u.Fragment, {
        children: /* @__PURE__ */u.jsx("p", {
          className: Nh,
          children: n
        })
      })]
    });
  },
  DN = () => {
    const [e, t] = le(window.__STORYBOOKAPI__ ? !0 : !document.cookie.includes("OptanonConsent=groups")),
      [n, r] = le(!1),
      [o, s] = le(!0),
      [a, i] = le(!0),
      [l, c] = le(""),
      d = (p, x) => {
        p.stopPropagation(), s(x);
      },
      f = (p, x) => {
        p.stopPropagation(), i(x);
      },
      g = (p, x, m) => {
        const h = j => j ? "1" : "0";
        if (!window.OneTrust) {
          (window.__STORYBOOKAPI__ ? alert : console.error)("OneTrust not available on window object"), t(!1);
          return;
        }
        document.cookie = `OptanonConsent=groups:"req:${h(p)},funcs:${h(x)},adv:${h(m)}"`, t(!1);
      };
    return e ? /* @__PURE__ */u.jsxs("div", {
      className: n ? gh : mh,
      children: [/* @__PURE__ */u.jsxs("div", {
        children: [/* @__PURE__ */u.jsx("h1", {
          className: hh,
          children: "Cookie Policy"
        }), /* @__PURE__ */u.jsxs("p", {
          className: _h,
          children: ["Will you accept our ", /* @__PURE__ */u.jsx("a", {
            href: "https://fastly.com",
            target: "_blank",
            className: jh,
            children: "Cookie Policy"
          }), "? We use cookies to give you a better, more personalized experience, and to give us important performance and analytics data to keep things running smoothly."]
        })]
      }), n && /* @__PURE__ */u.jsxs("div", {
        className: xh,
        children: [/* @__PURE__ */u.jsx("h1", {
          className: vh,
          children: "Manage consent preferences"
        }), /* @__PURE__ */u.jsx(yo, {
          active: l === "nec",
          activate: () => c(l === "nec" ? "" : "nec"),
          title: "Necessary",
          rightElement: /* @__PURE__ */u.jsx("button", {
            disabled: !0,
            className: Eh,
            children: "Always active"
          }),
          body: "Functionality and performance cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on our websites. Functionality and performance cookies are also used to collect information about how you and other visitors use and interact with our websites."
        }), /* @__PURE__ */u.jsx(yo, {
          active: l === "perf",
          activate: () => c(l === "perf" ? "" : "perf"),
          title: "Performance and functionality",
          rightElement: /* @__PURE__ */u.jsxs("div", {
            className: gl,
            children: [/* @__PURE__ */u.jsx("button", {
              className: o ? qr : Kr,
              onClick: p => d(p, !1),
              children: "No"
            }), /* @__PURE__ */u.jsx("button", {
              className: o ? Kr : qr,
              onClick: p => d(p, !0),
              children: "Yes"
            })]
          }),
          body: "Functionality and performance cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on our websites. Functionality and performance cookies are also used to collect information about how you and other visitors use and interact with our websites."
        }), /* @__PURE__ */u.jsx(yo, {
          active: l === "ad",
          activate: () => c(l === "ad" ? "" : "ad"),
          title: "Advertising",
          rightElement: /* @__PURE__ */u.jsxs("div", {
            className: gl,
            children: [/* @__PURE__ */u.jsx("button", {
              className: a ? qr : Kr,
              onClick: p => f(p, !1),
              children: "No"
            }), /* @__PURE__ */u.jsx("button", {
              className: a ? Kr : qr,
              onClick: p => f(p, !0),
              children: "Yes"
            })]
          }),
          body: "Functionality and performance cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on our websites. Functionality and performance cookies are also used to collect information about how you and other visitors use and interact with our websites."
        })]
      }), /* @__PURE__ */u.jsx("div", {
        className: yh,
        children: n ? /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("button", {
            className: ml,
            onClick: () => {
              g(!0, o, a);
            },
            children: "Submit Preferences"
          }), /* @__PURE__ */u.jsx("button", {
            className: pl,
            onClick: () => {
              g(!1, !1, !1);
            },
            children: "Decline All"
          })]
        }) : /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("button", {
            className: ml,
            onClick: () => {
              g(!0, !0, !0);
            },
            children: "Accept Default Settings"
          }), /* @__PURE__ */u.jsx("button", {
            className: pl,
            onClick: () => {
              r(!0);
            },
            children: "Manage Preferences"
          })]
        })
      })]
    }) : /* @__PURE__ */u.jsx(u.Fragment, {});
  };
var Sh = "_1uhd5ey7",
  Th = "_1uhd5ey8",
  Dh = "_1uhd5ey9",
  Oh = "_1uhd5eya",
  Ah = "_1uhd5eyb",
  $h = "_1uhd5eyc",
  Lh = Ue({
    defaultClassName: "_1uhd5eyd _1uhd5eyc",
    variantClassNames: {
      underlined: {
        true: "_1uhd5eye"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  zh = "_1uhd5eyf _1uhd5eyc",
  Rh = "_1uhd5eyg";
function Ph(_ref19) {
  let {
    children: e,
    ...t
  } = _ref19;
  return /* @__PURE__ */u.jsx(pe, {
    ...t,
    className: ye([Sh, t.className]),
    children: /* @__PURE__ */u.jsx("div", {
      className: Th,
      children: e
    })
  });
}
function Vh(_ref20) {
  let {
    children: e,
    ...t
  } = _ref20;
  return /* @__PURE__ */u.jsx(pe, {
    ...t,
    className: ye([Dh, t.className]),
    children: e
  });
}
function Fh(_ref21) {
  let {
    children: e,
    ...t
  } = _ref21;
  return /* @__PURE__ */u.jsx(pe, {
    as: "ul",
    ...t,
    className: ye([Oh, t.className]),
    children: e
  });
}
function Uh(_ref22) {
  let {
    children: e,
    ...t
  } = _ref22;
  return /* @__PURE__ */u.jsx(pe, {
    as: "li",
    className: ye([Ah, t.className]),
    ...t,
    children: e
  });
}
function Yh(_ref23) {
  let {
    children: e,
    ...t
  } = _ref23;
  return /* @__PURE__ */u.jsx(pe, {
    ...t,
    className: ye([zh, t.className]),
    children: e
  });
}
function Ra(_ref24) {
  let {
    children: e,
    ...t
  } = _ref24;
  return /* @__PURE__ */u.jsx(pe, {
    as: "ul",
    display: "flex",
    flexDirection: "column",
    gap: "lg",
    ...t,
    children: e
  });
}
function Pa(_ref25) {
  let {
    children: e,
    underlined: t,
    ...n
  } = _ref25;
  return /* @__PURE__ */u.jsx("li", {
    children: /* @__PURE__ */u.jsx("a", {
      ...n,
      className: Lh({
        underlined: t
      }),
      children: e
    })
  });
}
function Wh(_ref26) {
  let {
    children: e,
    ...t
  } = _ref26;
  return /* @__PURE__ */u.jsx("span", {
    ...t,
    className: ye([$h, t.className]),
    children: e
  });
}
function au(_ref27) {
  let {
    children: e,
    ...t
  } = _ref27;
  return /* @__PURE__ */u.jsx(pe, {
    display: "flex",
    flexDirection: {
      _: "row-reverse",
      md: "row"
    },
    gap: {
      md: "xl"
    },
    justifyContent: {
      _: "space-between",
      md: "flex-start"
    },
    ...t,
    children: e
  });
}
function ON(_ref28) {
  let {
    children: e,
    ...t
  } = _ref28;
  return /* @__PURE__ */u.jsx(pe, {
    className: ye([Rh, t.className]),
    ...t,
    children: e
  });
}
var Bs = "_86277sa",
  iu = "_86277sb _86277sa",
  Rr = Ue({
    defaultClassName: "_86277sc",
    variantClassNames: {
      variant: {
        light: "_86277sd",
        dark: "_86277se"
      },
      disabled: {
        true: "_86277sf"
      },
      invalid: {
        true: "_86277sg"
      },
      labelOnTop: {
        true: "_86277sh"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  xn = Ue({
    defaultClassName: "_86277si",
    variantClassNames: {
      required: {
        true: "_86277sj"
      },
      labelOnTop: {
        true: "_86277sk"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  lu = "_86277sl",
  Bh = "_86277sm _86277sl",
  Hh = "_86277sn _86277sl",
  Qh = "_86277so _86277sn _86277sl",
  Pr = "_86277sp",
  cu = "_86277sq _86277sp";
const AN = ce((_ref29, g) => {
    let {
      name: e,
      id: t,
      type: n = "text",
      label: r,
      placeholder: o,
      disabled: s,
      error: a,
      className: i,
      required: l,
      labelOnTop: c = !1,
      variant: d = "light",
      ...f
    } = _ref29;
    return /* @__PURE__ */u.jsxs("div", {
      className: ye([c ? iu : Bs, i]),
      children: [c ? /* @__PURE__ */u.jsx("label", {
        className: xn({
          required: l,
          labelOnTop: c
        }),
        htmlFor: t || e,
        children: r
      }) : null, /* @__PURE__ */u.jsxs("div", {
        className: Rr({
          disabled: s,
          invalid: !!a,
          variant: d,
          labelOnTop: c
        }),
        children: [c ? null : /* @__PURE__ */u.jsx("label", {
          className: xn({
            required: l,
            labelOnTop: c
          }),
          htmlFor: t || e,
          children: r
        }), a ? /* @__PURE__ */u.jsx("span", {
          className: c ? cu : Pr,
          id: `error-${t}`,
          children: a
        }) : null, /* @__PURE__ */u.jsx("input", {
          ref: g,
          "aria-describedby": a ? `error-${t}` : void 0,
          className: c ? Bh : lu,
          "data-testid": `input-${e}`,
          disabled: s ? !0 : void 0,
          id: t || e,
          name: e,
          placeholder: o,
          required: l,
          type: n,
          ...f
        })]
      })]
    });
  }),
  $N = ce((_ref30, g) => {
    let {
      name: e,
      id: t,
      label: n,
      placeholder: r,
      disabled: o,
      error: s,
      required: a,
      rows: i = 2,
      className: l,
      variant: c = "light",
      labelOnTop: d = !1,
      ...f
    } = _ref30;
    return /* @__PURE__ */u.jsxs("div", {
      className: ye([d ? iu : Bs, l]),
      children: [d ? /* @__PURE__ */u.jsx("label", {
        className: xn({
          required: a,
          labelOnTop: d
        }),
        htmlFor: t || e,
        children: n
      }) : null, /* @__PURE__ */u.jsxs("div", {
        className: Rr({
          disabled: o,
          invalid: !!s,
          variant: c,
          labelOnTop: d
        }),
        children: [d ? null : /* @__PURE__ */u.jsx("label", {
          className: xn({
            required: a
          }),
          htmlFor: t || e,
          children: n
        }), s ? /* @__PURE__ */u.jsx("span", {
          className: d ? cu : Pr,
          children: s
        }) : null, /* @__PURE__ */u.jsx("textarea", {
          ref: g,
          className: d ? Qh : Hh,
          disabled: o ? !0 : void 0,
          id: t || e,
          name: e,
          placeholder: r,
          required: a,
          rows: i,
          ...f
        })]
      })]
    });
  });
function hl(e, _ref31) {
  let [t, n] = _ref31;
  return Math.min(n, Math.max(t, e));
}
function Pe(e, t) {
  let {
    checkForDefaultPrevented: n = !0
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function uu(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let n = [];
  function r(s, a) {
    const i = M.createContext(a),
      l = n.length;
    n = [...n, a];
    const c = f => {
      var j;
      const {
          scope: g,
          children: p,
          ...x
        } = f,
        m = ((j = g == null ? void 0 : g[e]) == null ? void 0 : j[l]) || i,
        h = M.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */u.jsx(m.Provider, {
        value: h,
        children: p
      });
    };
    c.displayName = s + "Provider";
    function d(f, g) {
      var m;
      const p = ((m = g == null ? void 0 : g[e]) == null ? void 0 : m[l]) || i,
        x = M.useContext(p);
      if (x) return x;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [c, d];
  }
  const o = () => {
    const s = n.map(a => M.createContext(a));
    return function (i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return M.useMemo(() => ({
        [`__scope${e}`]: {
          ...i,
          [e]: l
        }
      }), [i, l]);
    };
  };
  return o.scopeName = e, [r, qh(o, ...t)];
}
function qh() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(o => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function (s) {
      const a = r.reduce((i, _ref32) => {
        let {
          useScope: l,
          scopeName: c
        } = _ref32;
        const f = l(s)[`__scope${c}`];
        return {
          ...i,
          ...f
        };
      }, {});
      return M.useMemo(() => ({
        [`__scope${t.scopeName}`]: a
      }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function vl(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function du() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  return t => {
    let n = !1;
    const r = e.map(o => {
      const s = vl(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n) return () => {
      for (let o = 0; o < r.length; o++) {
        const s = r[o];
        typeof s == "function" ? s() : vl(e[o], null);
      }
    };
  };
}
function Ke() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }
  return M.useCallback(du(...e), e);
}
// @__NO_SIDE_EFFECTS__
function js(e) {
  const t = /* @__PURE__ */Kh(e),
    n = M.forwardRef((r, o) => {
      const {
          children: s,
          ...a
        } = r,
        i = M.Children.toArray(s),
        l = i.find(Gh);
      if (l) {
        const c = l.props.children,
          d = i.map(f => f === l ? M.Children.count(c) > 1 ? M.Children.only(null) : M.isValidElement(c) ? c.props.children : null : f);
        return /* @__PURE__ */u.jsx(t, {
          ...a,
          ref: o,
          children: M.isValidElement(c) ? M.cloneElement(c, void 0, d) : null
        });
      }
      return /* @__PURE__ */u.jsx(t, {
        ...a,
        ref: o,
        children: s
      });
    });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Kh(e) {
  const t = M.forwardRef((n, r) => {
    const {
      children: o,
      ...s
    } = n;
    if (M.isValidElement(o)) {
      const a = Xh(o),
        i = Jh(s, o.props);
      return o.type !== M.Fragment && (i.ref = r ? du(r, a) : a), M.cloneElement(o, i);
    }
    return M.Children.count(o) > 1 ? M.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Zh = Symbol("radix.slottable");
function Gh(e) {
  return M.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Zh;
}
function Jh(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r],
      s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = function () {
      s(...arguments), o(...arguments);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...s
    } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Xh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get,
    n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ev(e) {
  const t = e + "CollectionProvider",
    [n, r] = uu(t),
    [o, s] = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    a = m => {
      const {
          scope: h,
          children: j
        } = m,
        v = te.useRef(null),
        _ = te.useRef(/* @__PURE__ */new Map()).current;
      return /* @__PURE__ */u.jsx(o, {
        scope: h,
        itemMap: _,
        collectionRef: v,
        children: j
      });
    };
  a.displayName = t;
  const i = e + "CollectionSlot",
    l = /* @__PURE__ */js(i),
    c = te.forwardRef((m, h) => {
      const {
          scope: j,
          children: v
        } = m,
        _ = s(i, j),
        k = Ke(h, _.collectionRef);
      return /* @__PURE__ */u.jsx(l, {
        ref: k,
        children: v
      });
    });
  c.displayName = i;
  const d = e + "CollectionItemSlot",
    f = "data-radix-collection-item",
    g = /* @__PURE__ */js(d),
    p = te.forwardRef((m, h) => {
      const {
          scope: j,
          children: v,
          ..._
        } = m,
        k = te.useRef(null),
        y = Ke(h, k),
        b = s(d, j);
      return te.useEffect(() => (b.itemMap.set(k, {
        ref: k,
        ..._
      }), () => void b.itemMap.delete(k))), /* @__PURE__ */u.jsx(g, {
        [f]: "",
        ref: y,
        children: v
      });
    });
  p.displayName = d;
  function x(m) {
    const h = s(e + "CollectionConsumer", m);
    return te.useCallback(() => {
      const v = h.collectionRef.current;
      if (!v) return [];
      const _ = Array.from(v.querySelectorAll(`[${f}]`));
      return Array.from(h.itemMap.values()).sort((b, C) => _.indexOf(b.ref.current) - _.indexOf(C.ref.current));
    }, [h.collectionRef, h.itemMap]);
  }
  return [{
    Provider: a,
    Slot: c,
    ItemSlot: p
  }, x, r];
}
var tv = M.createContext(void 0);
function nv(e) {
  const t = M.useContext(tv);
  return e || t || "ltr";
}
var rv = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"],
  Qe = rv.reduce((e, t) => {
    const n = /* @__PURE__ */js(`Primitive.${t}`),
      r = M.forwardRef((o, s) => {
        const {
            asChild: a,
            ...i
          } = o,
          l = a ? n : t;
        return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */u.jsx(l, {
          ...i,
          ref: s
        });
      });
    return r.displayName = `Primitive.${t}`, {
      ...e,
      [t]: r
    };
  }, {});
function sv(e, t) {
  e && Fs.flushSync(() => e.dispatchEvent(t));
}
function Gt(e) {
  const t = M.useRef(e);
  return M.useEffect(() => {
    t.current = e;
  }), M.useMemo(() => function () {
    var r;
    for (var _len4 = arguments.length, n = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      n[_key4] = arguments[_key4];
    }
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ov(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = Gt(e);
  M.useEffect(() => {
    const r = o => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, {
      capture: !0
    }), () => t.removeEventListener("keydown", r, {
      capture: !0
    });
  }, [n, t]);
}
var av = "DismissableLayer",
  Go = "dismissableLayer.update",
  iv = "dismissableLayer.pointerDownOutside",
  lv = "dismissableLayer.focusOutside",
  _l,
  fu = M.createContext({
    layers: /* @__PURE__ */new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
    branches: /* @__PURE__ */new Set()
  }),
  pu = M.forwardRef((e, t) => {
    const {
        disableOutsidePointerEvents: n = !1,
        onEscapeKeyDown: r,
        onPointerDownOutside: o,
        onFocusOutside: s,
        onInteractOutside: a,
        onDismiss: i,
        ...l
      } = e,
      c = M.useContext(fu),
      [d, f] = M.useState(null),
      g = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document),
      [, p] = M.useState({}),
      x = Ke(t, C => f(C)),
      m = Array.from(c.layers),
      [h] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1),
      j = m.indexOf(h),
      v = d ? m.indexOf(d) : -1,
      _ = c.layersWithOutsidePointerEventsDisabled.size > 0,
      k = v >= j,
      y = dv(C => {
        const N = C.target,
          T = [...c.branches].some(z => z.contains(N));
        !k || T || (o == null || o(C), a == null || a(C), C.defaultPrevented || i == null || i());
      }, g),
      b = fv(C => {
        const N = C.target;
        [...c.branches].some(z => z.contains(N)) || (s == null || s(C), a == null || a(C), C.defaultPrevented || i == null || i());
      }, g);
    return ov(C => {
      v === c.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && i && (C.preventDefault(), i()));
    }, g), M.useEffect(() => {
      if (d) return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (_l = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), jl(), () => {
        n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = _l);
      };
    }, [d, g, n, c]), M.useEffect(() => () => {
      d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), jl());
    }, [d, c]), M.useEffect(() => {
      const C = () => p({});
      return document.addEventListener(Go, C), () => document.removeEventListener(Go, C);
    }, []), /* @__PURE__ */u.jsx(Qe.div, {
      ...l,
      ref: x,
      style: {
        pointerEvents: _ ? k ? "auto" : "none" : void 0,
        ...e.style
      },
      onFocusCapture: Pe(e.onFocusCapture, b.onFocusCapture),
      onBlurCapture: Pe(e.onBlurCapture, b.onBlurCapture),
      onPointerDownCapture: Pe(e.onPointerDownCapture, y.onPointerDownCapture)
    });
  });
pu.displayName = av;
var cv = "DismissableLayerBranch",
  uv = M.forwardRef((e, t) => {
    const n = M.useContext(fu),
      r = M.useRef(null),
      o = Ke(t, r);
    return M.useEffect(() => {
      const s = r.current;
      if (s) return n.branches.add(s), () => {
        n.branches.delete(s);
      };
    }, [n.branches]), /* @__PURE__ */u.jsx(Qe.div, {
      ...e,
      ref: o
    });
  });
uv.displayName = cv;
function dv(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = Gt(e),
    r = M.useRef(!1),
    o = M.useRef(() => {});
  return M.useEffect(() => {
    const s = i => {
        if (i.target && !r.current) {
          let l = function () {
            mu(iv, n, c, {
              discrete: !0
            });
          };
          const c = {
            originalEvent: i
          };
          i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
            once: !0
          })) : l();
        } else t.removeEventListener("click", o.current);
        r.current = !1;
      },
      a = window.setTimeout(() => {
        t.addEventListener("pointerdown", s);
      }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function fv(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = Gt(e),
    r = M.useRef(!1);
  return M.useEffect(() => {
    const o = s => {
      s.target && !r.current && mu(lv, n, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function jl() {
  const e = new CustomEvent(Go);
  document.dispatchEvent(e);
}
function mu(e, t, n, _ref33) {
  let {
    discrete: r
  } = _ref33;
  const o = n.originalEvent.target,
    s = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? sv(o, s) : o.dispatchEvent(s);
}
var xo = 0;
function pv() {
  M.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? yl()), document.body.insertAdjacentElement("beforeend", e[1] ?? yl()), xo++, () => {
      xo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(t => t.remove()), xo--;
    };
  }, []);
}
function yl() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ko = "focusScope.autoFocusOnMount",
  Mo = "focusScope.autoFocusOnUnmount",
  xl = {
    bubbles: !1,
    cancelable: !0
  },
  mv = "FocusScope",
  gu = M.forwardRef((e, t) => {
    const {
        loop: n = !1,
        trapped: r = !1,
        onMountAutoFocus: o,
        onUnmountAutoFocus: s,
        ...a
      } = e,
      [i, l] = M.useState(null),
      c = Gt(o),
      d = Gt(s),
      f = M.useRef(null),
      g = Ke(t, m => l(m)),
      p = M.useRef({
        paused: !1,
        pause() {
          this.paused = !0;
        },
        resume() {
          this.paused = !1;
        }
      }).current;
    M.useEffect(() => {
      if (r) {
        let m = function (_) {
            if (p.paused || !i) return;
            const k = _.target;
            i.contains(k) ? f.current = k : Ut(f.current, {
              select: !0
            });
          },
          h = function (_) {
            if (p.paused || !i) return;
            const k = _.relatedTarget;
            k !== null && (i.contains(k) || Ut(f.current, {
              select: !0
            }));
          },
          j = function (_) {
            if (document.activeElement === document.body) for (const y of _) y.removedNodes.length > 0 && Ut(i);
          };
        document.addEventListener("focusin", m), document.addEventListener("focusout", h);
        const v = new MutationObserver(j);
        return i && v.observe(i, {
          childList: !0,
          subtree: !0
        }), () => {
          document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), v.disconnect();
        };
      }
    }, [r, i, p.paused]), M.useEffect(() => {
      if (i) {
        Ml.add(p);
        const m = document.activeElement;
        if (!i.contains(m)) {
          const j = new CustomEvent(ko, xl);
          i.addEventListener(ko, c), i.dispatchEvent(j), j.defaultPrevented || (gv(yv(hu(i)), {
            select: !0
          }), document.activeElement === m && Ut(i));
        }
        return () => {
          i.removeEventListener(ko, c), setTimeout(() => {
            const j = new CustomEvent(Mo, xl);
            i.addEventListener(Mo, d), i.dispatchEvent(j), j.defaultPrevented || Ut(m ?? document.body, {
              select: !0
            }), i.removeEventListener(Mo, d), Ml.remove(p);
          }, 0);
        };
      }
    }, [i, c, d, p]);
    const x = M.useCallback(m => {
      if (!n && !r || p.paused) return;
      const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey,
        j = document.activeElement;
      if (h && j) {
        const v = m.currentTarget,
          [_, k] = hv(v);
        _ && k ? !m.shiftKey && j === k ? (m.preventDefault(), n && Ut(_, {
          select: !0
        })) : m.shiftKey && j === _ && (m.preventDefault(), n && Ut(k, {
          select: !0
        })) : j === v && m.preventDefault();
      }
    }, [n, r, p.paused]);
    return /* @__PURE__ */u.jsx(Qe.div, {
      tabIndex: -1,
      ...a,
      ref: g,
      onKeyDown: x
    });
  });
gu.displayName = mv;
function gv(e) {
  let {
    select: t = !1
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const n = document.activeElement;
  for (const r of e) if (Ut(r, {
    select: t
  }), document.activeElement !== n) return;
}
function hv(e) {
  const t = hu(e),
    n = kl(t, e),
    r = kl(t.reverse(), e);
  return [n, r];
}
function hu(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: r => {
        const o = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function kl(e, t) {
  for (const n of e) if (!vv(n, {
    upTo: t
  })) return n;
}
function vv(e, _ref34) {
  let {
    upTo: t
  } = _ref34;
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e;) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function _v(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ut(e) {
  let {
    select: t = !1
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && _v(e) && t && e.select();
  }
}
var Ml = jv();
function jv() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = bl(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = bl(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function bl(e, t) {
  const n = [...e],
    r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function yv(e) {
  return e.filter(t => t.tagName !== "A");
}
var At = globalThis != null && globalThis.document ? M.useLayoutEffect : () => {},
  xv = M[" useId ".trim().toString()] || (() => {}),
  kv = 0;
function Va(e) {
  const [t, n] = M.useState(xv());
  return At(() => {
    e || n(r => r ?? String(kv++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const Mv = ["top", "right", "bottom", "left"],
  yt = Math.min,
  nt = Math.max,
  ys = Math.round,
  Zr = Math.floor,
  Jt = e => ({
    x: e,
    y: e
  }),
  bv = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  wv = {
    start: "end",
    end: "start"
  };
function Jo(e, t, n) {
  return nt(e, yt(t, n));
}
function $t(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Lt(e) {
  return e.split("-")[0];
}
function tr(e) {
  return e.split("-")[1];
}
function Fa(e) {
  return e === "x" ? "y" : "x";
}
function Ua(e) {
  return e === "y" ? "height" : "width";
}
function nr(e) {
  return ["top", "bottom"].includes(Lt(e)) ? "y" : "x";
}
function Ya(e) {
  return Fa(nr(e));
}
function Cv(e, t, n) {
  n === void 0 && (n = !1);
  const r = tr(e),
    o = Ya(e),
    s = Ua(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = xs(a)), [a, xs(a)];
}
function Nv(e) {
  const t = xs(e);
  return [Xo(e), t, Xo(t)];
}
function Xo(e) {
  return e.replace(/start|end/g, t => wv[t]);
}
function Iv(e, t, n) {
  const r = ["left", "right"],
    o = ["right", "left"],
    s = ["top", "bottom"],
    a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? s : a;
    default:
      return [];
  }
}
function Ev(e, t, n, r) {
  const o = tr(e);
  let s = Iv(Lt(e), n === "start", r);
  return o && (s = s.map(a => a + "-" + o), t && (s = s.concat(s.map(Xo)))), s;
}
function xs(e) {
  return e.replace(/left|right|bottom|top/g, t => bv[t]);
}
function Sv(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function vu(e) {
  return typeof e != "number" ? Sv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ks(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function wl(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = nr(t),
    a = Ya(t),
    i = Ua(a),
    l = Lt(t),
    c = s === "y",
    d = r.x + r.width / 2 - o.width / 2,
    f = r.y + r.height / 2 - o.height / 2,
    g = r[i] / 2 - o[i] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (tr(t)) {
    case "start":
      p[a] -= g * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += g * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const Tv = async (e, t, n) => {
  const {
      placement: r = "bottom",
      strategy: o = "absolute",
      middleware: s = [],
      platform: a
    } = n,
    i = s.filter(Boolean),
    l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }),
    {
      x: d,
      y: f
    } = wl(c, r, l),
    g = r,
    p = {},
    x = 0;
  for (let m = 0; m < i.length; m++) {
    const {
        name: h,
        fn: j
      } = i[m],
      {
        x: v,
        y: _,
        data: k,
        reset: y
      } = await j({
        x: d,
        y: f,
        initialPlacement: r,
        placement: g,
        strategy: o,
        middlewareData: p,
        rects: c,
        platform: a,
        elements: {
          reference: e,
          floating: t
        }
      });
    d = v ?? d, f = _ ?? f, p = {
      ...p,
      [h]: {
        ...p[h],
        ...k
      }
    }, y && x <= 50 && (x++, typeof y == "object" && (y.placement && (g = y.placement), y.rects && (c = y.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : y.rects), {
      x: d,
      y: f
    } = wl(c, g, l)), m = -1);
  }
  return {
    x: d,
    y: f,
    placement: g,
    strategy: o,
    middlewareData: p
  };
};
async function hr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
      x: r,
      y: o,
      platform: s,
      rects: a,
      elements: i,
      strategy: l
    } = e,
    {
      boundary: c = "clippingAncestors",
      rootBoundary: d = "viewport",
      elementContext: f = "floating",
      altBoundary: g = !1,
      padding: p = 0
    } = $t(t, e),
    x = vu(p),
    h = i[g ? f === "floating" ? "reference" : "floating" : f],
    j = ks(await s.getClippingRect({
      element: (n = await (s.isElement == null ? void 0 : s.isElement(h))) == null || n ? h : h.contextElement || (await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating))),
      boundary: c,
      rootBoundary: d,
      strategy: l
    })),
    v = f === "floating" ? {
      x: r,
      y: o,
      width: a.floating.width,
      height: a.floating.height
    } : a.reference,
    _ = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)),
    k = (await (s.isElement == null ? void 0 : s.isElement(_))) ? (await (s.getScale == null ? void 0 : s.getScale(_))) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    },
    y = ks(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: i,
      rect: v,
      offsetParent: _,
      strategy: l
    }) : v);
  return {
    top: (j.top - y.top + x.top) / k.y,
    bottom: (y.bottom - j.bottom + x.bottom) / k.y,
    left: (j.left - y.left + x.left) / k.x,
    right: (y.right - j.right + x.right) / k.x
  };
}
const Dv = e => ({
    name: "arrow",
    options: e,
    async fn(t) {
      const {
          x: n,
          y: r,
          placement: o,
          rects: s,
          platform: a,
          elements: i,
          middlewareData: l
        } = t,
        {
          element: c,
          padding: d = 0
        } = $t(e, t) || {};
      if (c == null) return {};
      const f = vu(d),
        g = {
          x: n,
          y: r
        },
        p = Ya(o),
        x = Ua(p),
        m = await a.getDimensions(c),
        h = p === "y",
        j = h ? "top" : "left",
        v = h ? "bottom" : "right",
        _ = h ? "clientHeight" : "clientWidth",
        k = s.reference[x] + s.reference[p] - g[p] - s.floating[x],
        y = g[p] - s.reference[p],
        b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
      let C = b ? b[_] : 0;
      (!C || !(await (a.isElement == null ? void 0 : a.isElement(b)))) && (C = i.floating[_] || s.floating[x]);
      const N = k / 2 - y / 2,
        T = C / 2 - m[x] / 2 - 1,
        z = yt(f[j], T),
        K = yt(f[v], T),
        L = z,
        H = C - m[x] - K,
        Y = C / 2 - m[x] / 2 + N,
        X = Jo(L, Y, H),
        ne = !l.arrow && tr(o) != null && Y !== X && s.reference[x] / 2 - (Y < L ? z : K) - m[x] / 2 < 0,
        U = ne ? Y < L ? Y - L : Y - H : 0;
      return {
        [p]: g[p] + U,
        data: {
          [p]: X,
          centerOffset: Y - X - U,
          ...(ne && {
            alignmentOffset: U
          })
        },
        reset: ne
      };
    }
  }),
  Ov = function (e) {
    return e === void 0 && (e = {}), {
      name: "flip",
      options: e,
      async fn(t) {
        var n, r;
        const {
            placement: o,
            middlewareData: s,
            rects: a,
            initialPlacement: i,
            platform: l,
            elements: c
          } = t,
          {
            mainAxis: d = !0,
            crossAxis: f = !0,
            fallbackPlacements: g,
            fallbackStrategy: p = "bestFit",
            fallbackAxisSideDirection: x = "none",
            flipAlignment: m = !0,
            ...h
          } = $t(e, t);
        if ((n = s.arrow) != null && n.alignmentOffset) return {};
        const j = Lt(o),
          v = Lt(i) === i,
          _ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)),
          k = g || (v || !m ? [xs(i)] : Nv(i));
        !g && x !== "none" && k.push(...Ev(i, m, x, _));
        const y = [i, ...k],
          b = await hr(t, h),
          C = [];
        let N = ((r = s.flip) == null ? void 0 : r.overflows) || [];
        if (d && C.push(b[j]), f) {
          const L = Cv(o, a, _);
          C.push(b[L[0]], b[L[1]]);
        }
        if (N = [...N, {
          placement: o,
          overflows: C
        }], !C.every(L => L <= 0)) {
          var T, z;
          const L = (((T = s.flip) == null ? void 0 : T.index) || 0) + 1,
            H = y[L];
          if (H) return {
            data: {
              index: L,
              overflows: N
            },
            reset: {
              placement: H
            }
          };
          let Y = (z = N.filter(X => X.overflows[0] <= 0).sort((X, ne) => X.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : z.placement;
          if (!Y) switch (p) {
            case "bestFit":
              {
                var K;
                const X = (K = N.map(ne => [ne.placement, ne.overflows.filter(U => U > 0).reduce((U, de) => U + de, 0)]).sort((ne, U) => ne[1] - U[1])[0]) == null ? void 0 : K[0];
                X && (Y = X);
                break;
              }
            case "initialPlacement":
              Y = i;
              break;
          }
          if (o !== Y) return {
            reset: {
              placement: Y
            }
          };
        }
        return {};
      }
    };
  };
function Cl(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Nl(e) {
  return Mv.some(t => e[t] >= 0);
}
const Av = function (e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
          rects: n
        } = t,
        {
          strategy: r = "referenceHidden",
          ...o
        } = $t(e, t);
      switch (r) {
        case "referenceHidden":
          {
            const s = await hr(t, {
                ...o,
                elementContext: "reference"
              }),
              a = Cl(s, n.reference);
            return {
              data: {
                referenceHiddenOffsets: a,
                referenceHidden: Nl(a)
              }
            };
          }
        case "escaped":
          {
            const s = await hr(t, {
                ...o,
                altBoundary: !0
              }),
              a = Cl(s, n.floating);
            return {
              data: {
                escapedOffsets: a,
                escaped: Nl(a)
              }
            };
          }
        default:
          return {};
      }
    }
  };
};
async function $v(e, t) {
  const {
      placement: n,
      platform: r,
      elements: o
    } = e,
    s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)),
    a = Lt(n),
    i = tr(n),
    l = nr(n) === "y",
    c = ["left", "top"].includes(a) ? -1 : 1,
    d = s && l ? -1 : 1,
    f = $t(t, e);
  let {
    mainAxis: g,
    crossAxis: p,
    alignmentAxis: x
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return i && typeof x == "number" && (p = i === "end" ? x * -1 : x), l ? {
    x: p * d,
    y: g * c
  } : {
    x: g * c,
    y: p * d
  };
}
const Lv = function (e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      async fn(t) {
        var n, r;
        const {
            x: o,
            y: s,
            placement: a,
            middlewareData: i
          } = t,
          l = await $v(t, e);
        return a === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
          x: o + l.x,
          y: s + l.y,
          data: {
            ...l,
            placement: a
          }
        };
      }
    };
  },
  zv = function (e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      async fn(t) {
        const {
            x: n,
            y: r,
            placement: o
          } = t,
          {
            mainAxis: s = !0,
            crossAxis: a = !1,
            limiter: i = {
              fn: h => {
                let {
                  x: j,
                  y: v
                } = h;
                return {
                  x: j,
                  y: v
                };
              }
            },
            ...l
          } = $t(e, t),
          c = {
            x: n,
            y: r
          },
          d = await hr(t, l),
          f = nr(Lt(o)),
          g = Fa(f);
        let p = c[g],
          x = c[f];
        if (s) {
          const h = g === "y" ? "top" : "left",
            j = g === "y" ? "bottom" : "right",
            v = p + d[h],
            _ = p - d[j];
          p = Jo(v, p, _);
        }
        if (a) {
          const h = f === "y" ? "top" : "left",
            j = f === "y" ? "bottom" : "right",
            v = x + d[h],
            _ = x - d[j];
          x = Jo(v, x, _);
        }
        const m = i.fn({
          ...t,
          [g]: p,
          [f]: x
        });
        return {
          ...m,
          data: {
            x: m.x - n,
            y: m.y - r
          }
        };
      }
    };
  },
  Rv = function (e) {
    return e === void 0 && (e = {}), {
      options: e,
      fn(t) {
        const {
            x: n,
            y: r,
            placement: o,
            rects: s,
            middlewareData: a
          } = t,
          {
            offset: i = 0,
            mainAxis: l = !0,
            crossAxis: c = !0
          } = $t(e, t),
          d = {
            x: n,
            y: r
          },
          f = nr(o),
          g = Fa(f);
        let p = d[g],
          x = d[f];
        const m = $t(i, t),
          h = typeof m == "number" ? {
            mainAxis: m,
            crossAxis: 0
          } : {
            mainAxis: 0,
            crossAxis: 0,
            ...m
          };
        if (l) {
          const _ = g === "y" ? "height" : "width",
            k = s.reference[g] - s.floating[_] + h.mainAxis,
            y = s.reference[g] + s.reference[_] - h.mainAxis;
          p < k ? p = k : p > y && (p = y);
        }
        if (c) {
          var j, v;
          const _ = g === "y" ? "width" : "height",
            k = ["top", "left"].includes(Lt(o)),
            y = s.reference[f] - s.floating[_] + (k && ((j = a.offset) == null ? void 0 : j[f]) || 0) + (k ? 0 : h.crossAxis),
            b = s.reference[f] + s.reference[_] + (k ? 0 : ((v = a.offset) == null ? void 0 : v[f]) || 0) - (k ? h.crossAxis : 0);
          x < y ? x = y : x > b && (x = b);
        }
        return {
          [g]: p,
          [f]: x
        };
      }
    };
  },
  Pv = function (e) {
    return e === void 0 && (e = {}), {
      name: "size",
      options: e,
      async fn(t) {
        const {
            placement: n,
            rects: r,
            platform: o,
            elements: s
          } = t,
          {
            apply: a = () => {},
            ...i
          } = $t(e, t),
          l = await hr(t, i),
          c = Lt(n),
          d = tr(n),
          f = nr(n) === "y",
          {
            width: g,
            height: p
          } = r.floating;
        let x, m;
        c === "top" || c === "bottom" ? (x = c, m = d === ((await (o.isRTL == null ? void 0 : o.isRTL(s.floating))) ? "start" : "end") ? "left" : "right") : (m = c, x = d === "end" ? "top" : "bottom");
        const h = p - l.top - l.bottom,
          j = g - l.left - l.right,
          v = yt(p - l[x], h),
          _ = yt(g - l[m], j),
          k = !t.middlewareData.shift;
        let y = v,
          b = _;
        if (f ? b = d || k ? yt(_, j) : j : y = d || k ? yt(v, h) : h, k && !d) {
          const N = nt(l.left, 0),
            T = nt(l.right, 0),
            z = nt(l.top, 0),
            K = nt(l.bottom, 0);
          f ? b = g - 2 * (N !== 0 || T !== 0 ? N + T : nt(l.left, l.right)) : y = p - 2 * (z !== 0 || K !== 0 ? z + K : nt(l.top, l.bottom));
        }
        await a({
          ...t,
          availableWidth: b,
          availableHeight: y
        });
        const C = await o.getDimensions(s.floating);
        return g !== C.width || p !== C.height ? {
          reset: {
            rects: !0
          }
        } : {};
      }
    };
  };
function rr(e) {
  return _u(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ot(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pt(e) {
  var t;
  return (t = (_u(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _u(e) {
  return e instanceof Node || e instanceof ot(e).Node;
}
function bt(e) {
  return e instanceof Element || e instanceof ot(e).Element;
}
function wt(e) {
  return e instanceof HTMLElement || e instanceof ot(e).HTMLElement;
}
function Il(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ot(e).ShadowRoot;
}
function Vr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = _t(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Vv(e) {
  return ["table", "td", "th"].includes(rr(e));
}
function Wa(e) {
  const t = Ba(),
    n = _t(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some(r => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some(r => (n.contain || "").includes(r));
}
function Fv(e) {
  let t = Xt(e);
  for (; wt(t) && !Kn(t);) {
    if (Wa(t)) return t;
    t = Xt(t);
  }
  return null;
}
function Ba() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Kn(e) {
  return ["html", "body", "#document"].includes(rr(e));
}
function _t(e) {
  return ot(e).getComputedStyle(e);
}
function Hs(e) {
  return bt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Xt(e) {
  if (rr(e) === "html") return e;
  const t =
  // Step into the shadow DOM of the parent of a slotted node.
  e.assignedSlot ||
  // DOM Element detected.
  e.parentNode ||
  // ShadowRoot detected.
  Il(e) && e.host ||
  // Fallback.
  Pt(e);
  return Il(t) ? t.host : t;
}
function ju(e) {
  const t = Xt(e);
  return Kn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : wt(t) && Vr(t) ? t : ju(t);
}
function vr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = ju(e),
    s = o === ((r = e.ownerDocument) == null ? void 0 : r.body),
    a = ot(o);
  return s ? t.concat(a, a.visualViewport || [], Vr(o) ? o : [], a.frameElement && n ? vr(a.frameElement) : []) : t.concat(o, vr(o, [], n));
}
function yu(e) {
  const t = _t(e);
  let n = parseFloat(t.width) || 0,
    r = parseFloat(t.height) || 0;
  const o = wt(e),
    s = o ? e.offsetWidth : n,
    a = o ? e.offsetHeight : r,
    i = ys(n) !== s || ys(r) !== a;
  return i && (n = s, r = a), {
    width: n,
    height: r,
    $: i
  };
}
function Ha(e) {
  return bt(e) ? e : e.contextElement;
}
function Wn(e) {
  const t = Ha(e);
  if (!wt(t)) return Jt(1);
  const n = t.getBoundingClientRect(),
    {
      width: r,
      height: o,
      $: s
    } = yu(t);
  let a = (s ? ys(n.width) : n.width) / r,
    i = (s ? ys(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const Uv = /* @__PURE__ */Jt(0);
function xu(e) {
  const t = ot(e);
  return !Ba() || !t.visualViewport ? Uv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Yv(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ot(e) ? !1 : t;
}
function kn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(),
    s = Ha(e);
  let a = Jt(1);
  t && (r ? bt(r) && (a = Wn(r)) : a = Wn(e));
  const i = Yv(s, n, r) ? xu(s) : Jt(0);
  let l = (o.left + i.x) / a.x,
    c = (o.top + i.y) / a.y,
    d = o.width / a.x,
    f = o.height / a.y;
  if (s) {
    const g = ot(s),
      p = r && bt(r) ? ot(r) : r;
    let x = g,
      m = x.frameElement;
    for (; m && r && p !== x;) {
      const h = Wn(m),
        j = m.getBoundingClientRect(),
        v = _t(m),
        _ = j.left + (m.clientLeft + parseFloat(v.paddingLeft)) * h.x,
        k = j.top + (m.clientTop + parseFloat(v.paddingTop)) * h.y;
      l *= h.x, c *= h.y, d *= h.x, f *= h.y, l += _, c += k, x = ot(m), m = x.frameElement;
    }
  }
  return ks({
    width: d,
    height: f,
    x: l,
    y: c
  });
}
const Wv = [":popover-open", ":modal"];
function Qa(e) {
  return Wv.some(t => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Bv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed",
    a = Pt(r),
    i = t ? Qa(t.floating) : !1;
  if (r === a || i && s) return n;
  let l = {
      scrollLeft: 0,
      scrollTop: 0
    },
    c = Jt(1);
  const d = Jt(0),
    f = wt(r);
  if ((f || !f && !s) && ((rr(r) !== "body" || Vr(a)) && (l = Hs(r)), wt(r))) {
    const g = kn(r);
    c = Wn(r), d.x = g.x + r.clientLeft, d.y = g.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y
  };
}
function Hv(e) {
  return Array.from(e.getClientRects());
}
function ku(e) {
  return kn(Pt(e)).left + Hs(e).scrollLeft;
}
function Qv(e) {
  const t = Pt(e),
    n = Hs(e),
    r = e.ownerDocument.body,
    o = nt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth),
    s = nt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + ku(e);
  const i = -n.scrollTop;
  return _t(r).direction === "rtl" && (a += nt(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: a,
    y: i
  };
}
function qv(e, t) {
  const n = ot(e),
    r = Pt(e),
    o = n.visualViewport;
  let s = r.clientWidth,
    a = r.clientHeight,
    i = 0,
    l = 0;
  if (o) {
    s = o.width, a = o.height;
    const c = Ba();
    (!c || c && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: i,
    y: l
  };
}
function Kv(e, t) {
  const n = kn(e, !0, t === "fixed"),
    r = n.top + e.clientTop,
    o = n.left + e.clientLeft,
    s = wt(e) ? Wn(e) : Jt(1),
    a = e.clientWidth * s.x,
    i = e.clientHeight * s.y,
    l = o * s.x,
    c = r * s.y;
  return {
    width: a,
    height: i,
    x: l,
    y: c
  };
}
function El(e, t, n) {
  let r;
  if (t === "viewport") r = qv(e, n);else if (t === "document") r = Qv(Pt(e));else if (bt(t)) r = Kv(t, n);else {
    const o = xu(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return ks(r);
}
function Mu(e, t) {
  const n = Xt(e);
  return n === t || !bt(n) || Kn(n) ? !1 : _t(n).position === "fixed" || Mu(n, t);
}
function Zv(e, t) {
  const n = t.get(e);
  if (n) return n;
  let r = vr(e, [], !1).filter(i => bt(i) && rr(i) !== "body"),
    o = null;
  const s = _t(e).position === "fixed";
  let a = s ? Xt(e) : e;
  for (; bt(a) && !Kn(a);) {
    const i = _t(a),
      l = Wa(a);
    !l && i.position === "fixed" && (o = null), (s ? !l && !o : !l && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Vr(a) && !l && Mu(e, a)) ? r = r.filter(d => d !== a) : o = i, a = Xt(a);
  }
  return t.set(e, r), r;
}
function Gv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...(n === "clippingAncestors" ? Qa(t) ? [] : Zv(t, this._c) : [].concat(n)), r],
    i = a[0],
    l = a.reduce((c, d) => {
      const f = El(t, d, o);
      return c.top = nt(f.top, c.top), c.right = yt(f.right, c.right), c.bottom = yt(f.bottom, c.bottom), c.left = nt(f.left, c.left), c;
    }, El(t, i, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Jv(e) {
  const {
    width: t,
    height: n
  } = yu(e);
  return {
    width: t,
    height: n
  };
}
function Xv(e, t, n) {
  const r = wt(t),
    o = Pt(t),
    s = n === "fixed",
    a = kn(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if (r || !r && !s) if ((rr(t) !== "body" || Vr(o)) && (i = Hs(t)), r) {
    const f = kn(t, !0, s, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  } else o && (l.x = ku(o));
  const c = a.left + i.scrollLeft - l.x,
    d = a.top + i.scrollTop - l.y;
  return {
    x: c,
    y: d,
    width: a.width,
    height: a.height
  };
}
function bo(e) {
  return _t(e).position === "static";
}
function Sl(e, t) {
  return !wt(e) || _t(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function bu(e, t) {
  const n = ot(e);
  if (Qa(e)) return n;
  if (!wt(e)) {
    let o = Xt(e);
    for (; o && !Kn(o);) {
      if (bt(o) && !bo(o)) return o;
      o = Xt(o);
    }
    return n;
  }
  let r = Sl(e, t);
  for (; r && Vv(r) && bo(r);) r = Sl(r, t);
  return r && Kn(r) && bo(r) && !Wa(r) ? n : r || Fv(e) || n;
}
const e1 = async function (e) {
  const t = this.getOffsetParent || bu,
    n = this.getDimensions,
    r = await n(e.floating);
  return {
    reference: Xv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function t1(e) {
  return _t(e).direction === "rtl";
}
const n1 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Bv,
  getDocumentElement: Pt,
  getClippingRect: Gv,
  getOffsetParent: bu,
  getElementRects: e1,
  getClientRects: Hv,
  getDimensions: Jv,
  getScale: Wn,
  isElement: bt,
  isRTL: t1
};
function r1(e, t) {
  let n = null,
    r;
  const o = Pt(e);
  function s() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function a(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), s();
    const {
      left: c,
      top: d,
      width: f,
      height: g
    } = e.getBoundingClientRect();
    if (i || t(), !f || !g) return;
    const p = Zr(d),
      x = Zr(o.clientWidth - (c + f)),
      m = Zr(o.clientHeight - (d + g)),
      h = Zr(c),
      v = {
        rootMargin: -p + "px " + -x + "px " + -m + "px " + -h + "px",
        threshold: nt(0, yt(1, l)) || 1
      };
    let _ = !0;
    function k(y) {
      const b = y[0].intersectionRatio;
      if (b !== l) {
        if (!_) return a();
        b ? a(!1, b) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      _ = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, v);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function wu(e, t, n, r) {
  r === void 0 && (r = {});
  const {
      ancestorScroll: o = !0,
      ancestorResize: s = !0,
      elementResize: a = typeof ResizeObserver == "function",
      layoutShift: i = typeof IntersectionObserver == "function",
      animationFrame: l = !1
    } = r,
    c = Ha(e),
    d = o || s ? [...(c ? vr(c) : []), ...vr(t)] : [];
  d.forEach(j => {
    o && j.addEventListener("scroll", n, {
      passive: !0
    }), s && j.addEventListener("resize", n);
  });
  const f = c && i ? r1(c, n) : null;
  let g = -1,
    p = null;
  a && (p = new ResizeObserver(j => {
    let [v] = j;
    v && v.target === c && p && (p.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var _;
      (_ = p) == null || _.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let x,
    m = l ? kn(e) : null;
  l && h();
  function h() {
    const j = kn(e);
    m && (j.x !== m.x || j.y !== m.y || j.width !== m.width || j.height !== m.height) && n(), m = j, x = requestAnimationFrame(h);
  }
  return n(), () => {
    var j;
    d.forEach(v => {
      o && v.removeEventListener("scroll", n), s && v.removeEventListener("resize", n);
    }), f == null || f(), (j = p) == null || j.disconnect(), p = null, l && cancelAnimationFrame(x);
  };
}
const s1 = Lv,
  o1 = zv,
  a1 = Ov,
  i1 = Pv,
  l1 = Av,
  Tl = Dv,
  c1 = Rv,
  u1 = (e, t, n) => {
    const r = /* @__PURE__ */new Map(),
      o = {
        platform: n1,
        ...n
      },
      s = {
        ...o.platform,
        _c: r
      };
    return Tv(e, t, {
      ...o,
      platform: s
    });
  };
var is = typeof document < "u" ? Da : fe;
function Ms(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0;) if (!Ms(e[r], t[r])) return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length) return !1;
    for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, o[r])) return !1;
    for (r = n; r-- !== 0;) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !Ms(e[s], t[s])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Cu(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Dl(e, t) {
  const n = Cu(e);
  return Math.round(t * n) / n;
}
function Ol(e) {
  const t = M.useRef(e);
  return is(() => {
    t.current = e;
  }), t;
}
function Nu(e) {
  e === void 0 && (e = {});
  const {
      placement: t = "bottom",
      strategy: n = "absolute",
      middleware: r = [],
      platform: o,
      elements: {
        reference: s,
        floating: a
      } = {},
      transform: i = !0,
      whileElementsMounted: l,
      open: c
    } = e,
    [d, f] = M.useState({
      x: 0,
      y: 0,
      strategy: n,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }),
    [g, p] = M.useState(r);
  Ms(g, r) || p(r);
  const [x, m] = M.useState(null),
    [h, j] = M.useState(null),
    v = M.useCallback(U => {
      U !== b.current && (b.current = U, m(U));
    }, []),
    _ = M.useCallback(U => {
      U !== C.current && (C.current = U, j(U));
    }, []),
    k = s || x,
    y = a || h,
    b = M.useRef(null),
    C = M.useRef(null),
    N = M.useRef(d),
    T = l != null,
    z = Ol(l),
    K = Ol(o),
    L = M.useCallback(() => {
      if (!b.current || !C.current) return;
      const U = {
        placement: t,
        strategy: n,
        middleware: g
      };
      K.current && (U.platform = K.current), u1(b.current, C.current, U).then(de => {
        const Z = {
          ...de,
          isPositioned: !0
        };
        H.current && !Ms(N.current, Z) && (N.current = Z, Fs.flushSync(() => {
          f(Z);
        }));
      });
    }, [g, t, n, K]);
  is(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, f(U => ({
      ...U,
      isPositioned: !1
    })));
  }, [c]);
  const H = M.useRef(!1);
  is(() => (H.current = !0, () => {
    H.current = !1;
  }), []), is(() => {
    if (k && (b.current = k), y && (C.current = y), k && y) {
      if (z.current) return z.current(k, y, L);
      L();
    }
  }, [k, y, L, z, T]);
  const Y = M.useMemo(() => ({
      reference: b,
      floating: C,
      setReference: v,
      setFloating: _
    }), [v, _]),
    X = M.useMemo(() => ({
      reference: k,
      floating: y
    }), [k, y]),
    ne = M.useMemo(() => {
      const U = {
        position: n,
        left: 0,
        top: 0
      };
      if (!X.floating) return U;
      const de = Dl(X.floating, d.x),
        Z = Dl(X.floating, d.y);
      return i ? {
        ...U,
        transform: "translate(" + de + "px, " + Z + "px)",
        ...(Cu(X.floating) >= 1.5 && {
          willChange: "transform"
        })
      } : {
        position: n,
        left: de,
        top: Z
      };
    }, [n, i, X.floating, d.x, d.y]);
  return M.useMemo(() => ({
    ...d,
    update: L,
    refs: Y,
    elements: X,
    floatingStyles: ne
  }), [d, L, Y, X, ne]);
}
const d1 = e => {
    function t(n) {
      return {}.hasOwnProperty.call(n, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn(n) {
        const {
          element: r,
          padding: o
        } = typeof e == "function" ? e(n) : e;
        return r && t(r) ? r.current != null ? Tl({
          element: r.current,
          padding: o
        }).fn(n) : {} : r ? Tl({
          element: r,
          padding: o
        }).fn(n) : {};
      }
    };
  },
  Iu = (e, t) => ({
    ...s1(e),
    options: [e, t]
  }),
  Eu = (e, t) => ({
    ...o1(e),
    options: [e, t]
  }),
  Su = (e, t) => ({
    ...c1(e),
    options: [e, t]
  }),
  Tu = (e, t) => ({
    ...a1(e),
    options: [e, t]
  }),
  Du = (e, t) => ({
    ...i1(e),
    options: [e, t]
  }),
  Ou = (e, t) => ({
    ...l1(e),
    options: [e, t]
  }),
  Au = (e, t) => ({
    ...d1(e),
    options: [e, t]
  });
function Al(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function $u() {
  for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    e[_key5] = arguments[_key5];
  }
  return t => {
    let n = !1;
    const r = e.map(o => {
      const s = Al(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n) return () => {
      for (let o = 0; o < r.length; o++) {
        const s = r[o];
        typeof s == "function" ? s() : Al(e[o], null);
      }
    };
  };
}
function Lu() {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }
  return M.useCallback($u(...e), e);
}
// @__NO_SIDE_EFFECTS__
function f1(e) {
  const t = /* @__PURE__ */p1(e),
    n = M.forwardRef((r, o) => {
      const {
          children: s,
          ...a
        } = r,
        i = M.Children.toArray(s),
        l = i.find(g1);
      if (l) {
        const c = l.props.children,
          d = i.map(f => f === l ? M.Children.count(c) > 1 ? M.Children.only(null) : M.isValidElement(c) ? c.props.children : null : f);
        return /* @__PURE__ */u.jsx(t, {
          ...a,
          ref: o,
          children: M.isValidElement(c) ? M.cloneElement(c, void 0, d) : null
        });
      }
      return /* @__PURE__ */u.jsx(t, {
        ...a,
        ref: o,
        children: s
      });
    });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function p1(e) {
  const t = M.forwardRef((n, r) => {
    const {
      children: o,
      ...s
    } = n;
    if (M.isValidElement(o)) {
      const a = v1(o),
        i = h1(s, o.props);
      return o.type !== M.Fragment && (i.ref = r ? $u(r, a) : a), M.cloneElement(o, i);
    }
    return M.Children.count(o) > 1 ? M.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var m1 = Symbol("radix.slottable");
function g1(e) {
  return M.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === m1;
}
function h1(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r],
      s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = function () {
      s(...arguments), o(...arguments);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...s
    } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function v1(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get,
    n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _1 = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"],
  qa = _1.reduce((e, t) => {
    const n = /* @__PURE__ */f1(`Primitive.${t}`),
      r = M.forwardRef((o, s) => {
        const {
            asChild: a,
            ...i
          } = o,
          l = a ? n : t;
        return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */u.jsx(l, {
          ...i,
          ref: s
        });
      });
    return r.displayName = `Primitive.${t}`, {
      ...e,
      [t]: r
    };
  }, {}),
  j1 = "Arrow",
  zu = M.forwardRef((e, t) => {
    const {
      children: n,
      width: r = 10,
      height: o = 5,
      ...s
    } = e;
    return /* @__PURE__ */u.jsx(qa.svg, {
      ...s,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */u.jsx("polygon", {
        points: "0,0 30,0 15,10"
      })
    });
  });
zu.displayName = j1;
var y1 = zu;
function x1(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let n = [];
  function r(s, a) {
    const i = M.createContext(a),
      l = n.length;
    n = [...n, a];
    const c = f => {
      var j;
      const {
          scope: g,
          children: p,
          ...x
        } = f,
        m = ((j = g == null ? void 0 : g[e]) == null ? void 0 : j[l]) || i,
        h = M.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */u.jsx(m.Provider, {
        value: h,
        children: p
      });
    };
    c.displayName = s + "Provider";
    function d(f, g) {
      var m;
      const p = ((m = g == null ? void 0 : g[e]) == null ? void 0 : m[l]) || i,
        x = M.useContext(p);
      if (x) return x;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [c, d];
  }
  const o = () => {
    const s = n.map(a => M.createContext(a));
    return function (i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return M.useMemo(() => ({
        [`__scope${e}`]: {
          ...i,
          [e]: l
        }
      }), [i, l]);
    };
  };
  return o.scopeName = e, [r, k1(o, ...t)];
}
function k1() {
  for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    e[_key7] = arguments[_key7];
  }
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(o => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function (s) {
      const a = r.reduce((i, _ref35) => {
        let {
          useScope: l,
          scopeName: c
        } = _ref35;
        const f = l(s)[`__scope${c}`];
        return {
          ...i,
          ...f
        };
      }, {});
      return M.useMemo(() => ({
        [`__scope${t.scopeName}`]: a
      }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function M1(e) {
  const t = M.useRef(e);
  return M.useEffect(() => {
    t.current = e;
  }), M.useMemo(() => function () {
    var r;
    for (var _len8 = arguments.length, n = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      n[_key8] = arguments[_key8];
    }
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var ea = globalThis != null && globalThis.document ? M.useLayoutEffect : () => {};
function b1(e) {
  const [t, n] = M.useState(void 0);
  return ea(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver(o => {
        if (!Array.isArray(o) || !o.length) return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize,
            c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, i = c.blockSize;
        } else a = e.offsetWidth, i = e.offsetHeight;
        n({
          width: a,
          height: i
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else n(void 0);
  }, [e]), t;
}
var Ka = "Popper",
  [Ru, Pu] = x1(Ka),
  [w1, Vu] = Ru(Ka),
  Fu = e => {
    const {
        __scopePopper: t,
        children: n
      } = e,
      [r, o] = M.useState(null);
    return /* @__PURE__ */u.jsx(w1, {
      scope: t,
      anchor: r,
      onAnchorChange: o,
      children: n
    });
  };
Fu.displayName = Ka;
var Uu = "PopperAnchor",
  Yu = M.forwardRef((e, t) => {
    const {
        __scopePopper: n,
        virtualRef: r,
        ...o
      } = e,
      s = Vu(Uu, n),
      a = M.useRef(null),
      i = Lu(t, a);
    return M.useEffect(() => {
      s.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */u.jsx(qa.div, {
      ...o,
      ref: i
    });
  });
Yu.displayName = Uu;
var Za = "PopperContent",
  [C1, N1] = Ru(Za),
  Wu = M.forwardRef((e, t) => {
    var E, G, B, Q, ie, $;
    const {
        __scopePopper: n,
        side: r = "bottom",
        sideOffset: o = 0,
        align: s = "center",
        alignOffset: a = 0,
        arrowPadding: i = 0,
        avoidCollisions: l = !0,
        collisionBoundary: c = [],
        collisionPadding: d = 0,
        sticky: f = "partial",
        hideWhenDetached: g = !1,
        updatePositionStrategy: p = "optimized",
        onPlaced: x,
        ...m
      } = e,
      h = Vu(Za, n),
      [j, v] = M.useState(null),
      _ = Lu(t, je => v(je)),
      [k, y] = M.useState(null),
      b = b1(k),
      C = (b == null ? void 0 : b.width) ?? 0,
      N = (b == null ? void 0 : b.height) ?? 0,
      T = r + (s !== "center" ? "-" + s : ""),
      z = typeof d == "number" ? d : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...d
      },
      K = Array.isArray(c) ? c : [c],
      L = K.length > 0,
      H = {
        padding: z,
        boundary: K.filter(E1),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: L
      },
      {
        refs: Y,
        floatingStyles: X,
        placement: ne,
        isPositioned: U,
        middlewareData: de
      } = Nu({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: T,
        whileElementsMounted: function () {
          for (var _len9 = arguments.length, je = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            je[_key9] = arguments[_key9];
          }
          return wu(...je, {
            animationFrame: p === "always"
          });
        },
        elements: {
          reference: h.anchor
        },
        middleware: [Iu({
          mainAxis: o + N,
          alignmentAxis: a
        }), l && Eu({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Su() : void 0,
          ...H
        }), l && Tu({
          ...H
        }), Du({
          ...H,
          apply: _ref36 => {
            let {
              elements: je,
              rects: J,
              availableWidth: Ce,
              availableHeight: Ne
            } = _ref36;
            const {
                width: Ye,
                height: lt
              } = J.reference,
              Be = je.floating.style;
            Be.setProperty("--radix-popper-available-width", `${Ce}px`), Be.setProperty("--radix-popper-available-height", `${Ne}px`), Be.setProperty("--radix-popper-anchor-width", `${Ye}px`), Be.setProperty("--radix-popper-anchor-height", `${lt}px`);
          }
        }), k && Au({
          element: k,
          padding: i
        }), S1({
          arrowWidth: C,
          arrowHeight: N
        }), g && Ou({
          strategy: "referenceHidden",
          ...H
        })]
      }),
      [Z, S] = Qu(ne),
      R = M1(x);
    ea(() => {
      U && (R == null || R());
    }, [U, R]);
    const ae = (E = de.arrow) == null ? void 0 : E.x,
      P = (G = de.arrow) == null ? void 0 : G.y,
      D = ((B = de.arrow) == null ? void 0 : B.centerOffset) !== 0,
      [O, A] = M.useState();
    return ea(() => {
      j && A(window.getComputedStyle(j).zIndex);
    }, [j]), /* @__PURE__ */u.jsx("div", {
      ref: Y.setFloating,
      "data-radix-popper-content-wrapper": "",
      style: {
        ...X,
        transform: U ? X.transform : "translate(0, -200%)",
        // keep off the page when measuring
        minWidth: "max-content",
        zIndex: O,
        "--radix-popper-transform-origin": [(Q = de.transformOrigin) == null ? void 0 : Q.x, (ie = de.transformOrigin) == null ? void 0 : ie.y].join(" "),
        // hide the content if using the hide middleware and should be hidden
        // set visibility to hidden and disable pointer events so the UI behaves
        // as if the PopperContent isn't there at all
        ...((($ = de.hide) == null ? void 0 : $.referenceHidden) && {
          visibility: "hidden",
          pointerEvents: "none"
        })
      },
      dir: e.dir,
      children: /* @__PURE__ */u.jsx(C1, {
        scope: n,
        placedSide: Z,
        onArrowChange: y,
        arrowX: ae,
        arrowY: P,
        shouldHideArrow: D,
        children: /* @__PURE__ */u.jsx(qa.div, {
          "data-side": Z,
          "data-align": S,
          ...m,
          ref: _,
          style: {
            ...m.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: U ? void 0 : "none"
          }
        })
      })
    });
  });
Wu.displayName = Za;
var Bu = "PopperArrow",
  I1 = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  },
  Hu = M.forwardRef(function (t, n) {
    const {
        __scopePopper: r,
        ...o
      } = t,
      s = N1(Bu, r),
      a = I1[s.placedSide];
    return (
      // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
      // doesn't report size as we'd expect on SVG elements.
      // it reports their bounding box which is effectively the largest path inside the SVG.
      /* @__PURE__ */
      u.jsx("span", {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */u.jsx(y1, {
          ...o,
          ref: n,
          style: {
            ...o.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
          }
        })
      })
    );
  });
Hu.displayName = Bu;
function E1(e) {
  return e !== null;
}
var S1 = e => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var h, j, v;
    const {
        placement: n,
        rects: r,
        middlewareData: o
      } = t,
      a = ((h = o.arrow) == null ? void 0 : h.centerOffset) !== 0,
      i = a ? 0 : e.arrowWidth,
      l = a ? 0 : e.arrowHeight,
      [c, d] = Qu(n),
      f = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[d],
      g = (((j = o.arrow) == null ? void 0 : j.x) ?? 0) + i / 2,
      p = (((v = o.arrow) == null ? void 0 : v.y) ?? 0) + l / 2;
    let x = "",
      m = "";
    return c === "bottom" ? (x = a ? f : `${g}px`, m = `${-l}px`) : c === "top" ? (x = a ? f : `${g}px`, m = `${r.floating.height + l}px`) : c === "right" ? (x = `${-l}px`, m = a ? f : `${p}px`) : c === "left" && (x = `${r.floating.width + l}px`, m = a ? f : `${p}px`), {
      data: {
        x,
        y: m
      }
    };
  }
});
function Qu(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var T1 = Fu,
  D1 = Yu,
  O1 = Wu,
  A1 = Hu;
function $l(_ref37) {
  let {
    prop: e,
    defaultProp: t,
    onChange: n = () => {}
  } = _ref37;
  const [r, o] = $1({
      defaultProp: t,
      onChange: n
    }),
    s = e !== void 0,
    a = s ? e : r,
    i = Gt(n),
    l = M.useCallback(c => {
      if (s) {
        const f = typeof c == "function" ? c(e) : c;
        f !== e && i(f);
      } else o(c);
    }, [s, e, o, i]);
  return [a, l];
}
function $1(_ref38) {
  let {
    defaultProp: e,
    onChange: t
  } = _ref38;
  const n = M.useState(e),
    [r] = n,
    o = M.useRef(r),
    s = Gt(t);
  return M.useEffect(() => {
    o.current !== r && (s(r), o.current = r);
  }, [r, o, s]), n;
}
function L1(e) {
  const t = M.useRef({
    value: e,
    previous: e
  });
  return M.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var z1 = "VisuallyHidden",
  qu = M.forwardRef((e, t) => /* @__PURE__ */u.jsx(Qe.span, {
    ...e,
    ref: t,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...e.style
    }
  }));
qu.displayName = z1;
var R1 = function (e) {
    if (typeof document > "u") return null;
    var t = Array.isArray(e) ? e[0] : e;
    return t.ownerDocument.body;
  },
  On = /* @__PURE__ */new WeakMap(),
  Gr = /* @__PURE__ */new WeakMap(),
  Jr = {},
  wo = 0,
  Ku = function (e) {
    return e && (e.host || Ku(e.parentNode));
  },
  P1 = function (e, t) {
    return t.map(function (n) {
      if (e.contains(n)) return n;
      var r = Ku(n);
      return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
    }).filter(function (n) {
      return !!n;
    });
  },
  V1 = function (e, t, n, r) {
    var o = P1(t, Array.isArray(e) ? e : [e]);
    Jr[n] || (Jr[n] = /* @__PURE__ */new WeakMap());
    var s = Jr[n],
      a = [],
      i = /* @__PURE__ */new Set(),
      l = new Set(o),
      c = function (f) {
        !f || i.has(f) || (i.add(f), c(f.parentNode));
      };
    o.forEach(c);
    var d = function (f) {
      !f || l.has(f) || Array.prototype.forEach.call(f.children, function (g) {
        if (i.has(g)) d(g);else try {
          var p = g.getAttribute(r),
            x = p !== null && p !== "false",
            m = (On.get(g) || 0) + 1,
            h = (s.get(g) || 0) + 1;
          On.set(g, m), s.set(g, h), a.push(g), m === 1 && x && Gr.set(g, !0), h === 1 && g.setAttribute(n, "true"), x || g.setAttribute(r, "true");
        } catch (j) {
          console.error("aria-hidden: cannot operate on ", g, j);
        }
      });
    };
    return d(t), i.clear(), wo++, function () {
      a.forEach(function (f) {
        var g = On.get(f) - 1,
          p = s.get(f) - 1;
        On.set(f, g), s.set(f, p), g || (Gr.has(f) || f.removeAttribute(r), Gr.delete(f)), p || f.removeAttribute(n);
      }), wo--, wo || (On = /* @__PURE__ */new WeakMap(), On = /* @__PURE__ */new WeakMap(), Gr = /* @__PURE__ */new WeakMap(), Jr = {});
    };
  },
  Zu = function (e, t, n) {
    n === void 0 && (n = "data-aria-hidden");
    var r = Array.from(Array.isArray(e) ? e : [e]),
      o = t || R1(e);
    return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), V1(r, o, n, "aria-hidden")) : function () {
      return null;
    };
  },
  Le = function () {
    return Le = Object.assign || function (t) {
      for (var n, r = 1, o = arguments.length; r < o; r++) {
        n = arguments[r];
        for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
      }
      return t;
    }, Le.apply(this, arguments);
  };
function Qs(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Gu(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++) (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var ls = "right-scroll-bar-position",
  cs = "width-before-scroll-bar",
  F1 = "with-scroll-bars-hidden",
  U1 = "--removed-body-scroll-bar-size";
function Co(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Y1(e, t) {
  var n = le(function () {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var W1 = typeof window < "u" ? M.useLayoutEffect : M.useEffect,
  Ll = /* @__PURE__ */new WeakMap();
function B1(e, t) {
  var n = Y1(t || null, function (r) {
    return e.forEach(function (o) {
      return Co(o, r);
    });
  });
  return W1(function () {
    var r = Ll.get(n);
    if (r) {
      var o = new Set(r),
        s = new Set(e),
        a = n.current;
      o.forEach(function (i) {
        s.has(i) || Co(i, null);
      }), s.forEach(function (i) {
        o.has(i) || Co(i, a);
      });
    }
    Ll.set(n, e);
  }, [e]), n;
}
function H1(e) {
  return e;
}
function Q1(e, t) {
  t === void 0 && (t = H1);
  var n = [],
    r = !1,
    o = {
      read: function () {
        if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return n.length ? n[n.length - 1] : e;
      },
      useMedium: function (s) {
        var a = t(s, r);
        return n.push(a), function () {
          n = n.filter(function (i) {
            return i !== a;
          });
        };
      },
      assignSyncMedium: function (s) {
        for (r = !0; n.length;) {
          var a = n;
          n = [], a.forEach(s);
        }
        n = {
          push: function (i) {
            return s(i);
          },
          filter: function () {
            return n;
          }
        };
      },
      assignMedium: function (s) {
        r = !0;
        var a = [];
        if (n.length) {
          var i = n;
          n = [], i.forEach(s), a = n;
        }
        var l = function () {
            var d = a;
            a = [], d.forEach(s);
          },
          c = function () {
            return Promise.resolve().then(l);
          };
        c(), n = {
          push: function (d) {
            a.push(d), c();
          },
          filter: function (d) {
            return a = a.filter(d), n;
          }
        };
      }
    };
  return o;
}
function q1(e) {
  e === void 0 && (e = {});
  var t = Q1(null);
  return t.options = Le({
    async: !0,
    ssr: !1
  }, e), t;
}
var Ju = function (e) {
  var t = e.sideCar,
    n = Qs(e, ["sideCar"]);
  if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r) throw new Error("Sidecar medium not found");
  return M.createElement(r, Le({}, n));
};
Ju.isSideCarExport = !0;
function K1(e, t) {
  return e.useMedium(t), Ju;
}
var Xu = q1(),
  No = function () {},
  qs = M.forwardRef(function (e, t) {
    var n = M.useRef(null),
      r = M.useState({
        onScrollCapture: No,
        onWheelCapture: No,
        onTouchMoveCapture: No
      }),
      o = r[0],
      s = r[1],
      a = e.forwardProps,
      i = e.children,
      l = e.className,
      c = e.removeScrollBar,
      d = e.enabled,
      f = e.shards,
      g = e.sideCar,
      p = e.noIsolation,
      x = e.inert,
      m = e.allowPinchZoom,
      h = e.as,
      j = h === void 0 ? "div" : h,
      v = e.gapMode,
      _ = Qs(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]),
      k = g,
      y = B1([n, t]),
      b = Le(Le({}, _), o);
    return M.createElement(M.Fragment, null, d && M.createElement(k, {
      sideCar: Xu,
      removeScrollBar: c,
      shards: f,
      noIsolation: p,
      inert: x,
      setCallbacks: s,
      allowPinchZoom: !!m,
      lockRef: n,
      gapMode: v
    }), a ? M.cloneElement(M.Children.only(i), Le(Le({}, b), {
      ref: y
    })) : M.createElement(j, Le({}, b, {
      className: l,
      ref: y
    }), i));
  });
qs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
qs.classNames = {
  fullWidth: cs,
  zeroRight: ls
};
var zl,
  Ga = function () {
    if (zl) return zl;
    if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
  };
function Z1() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ga();
  return t && e.setAttribute("nonce", t), e;
}
function G1(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function J1(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var X1 = function () {
    var e = 0,
      t = null;
    return {
      add: function (n) {
        e == 0 && (t = Z1()) && (G1(t, n), J1(t)), e++;
      },
      remove: function () {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  e_ = function () {
    var e = X1();
    return function (t, n) {
      M.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    };
  },
  t_ = function () {
    var e = e_(),
      t = function (n) {
        var r = n.styles,
          o = n.dynamic;
        return e(r, o), null;
      };
    return t;
  },
  n_ = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  Io = function (e) {
    return parseInt(e || "", 10) || 0;
  },
  r_ = function (e) {
    var t = window.getComputedStyle(document.body),
      n = t[e === "padding" ? "paddingLeft" : "marginLeft"],
      r = t[e === "padding" ? "paddingTop" : "marginTop"],
      o = t[e === "padding" ? "paddingRight" : "marginRight"];
    return [Io(n), Io(r), Io(o)];
  },
  s_ = function (e) {
    if (e === void 0 && (e = "margin"), typeof window > "u") return n_;
    var t = r_(e),
      n = document.documentElement.clientWidth,
      r = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, r - n + t[2] - t[0])
    };
  },
  o_ = t_(),
  Bn = "data-scroll-locked",
  a_ = function (e, t, n, r) {
    var o = e.left,
      s = e.top,
      a = e.right,
      i = e.gap;
    return n === void 0 && (n = "margin"), `
  .`.concat(F1, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(Bn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([t && "position: relative ".concat(r, ";"), n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `), n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(ls, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(cs, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(ls, " .").concat(ls, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(cs, " .").concat(cs, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Bn, `] {
    `).concat(U1, ": ").concat(i, `px;
  }
`);
  },
  Rl = function () {
    var e = parseInt(document.body.getAttribute(Bn) || "0", 10);
    return isFinite(e) ? e : 0;
  },
  i_ = function () {
    M.useEffect(function () {
      return document.body.setAttribute(Bn, (Rl() + 1).toString()), function () {
        var e = Rl() - 1;
        e <= 0 ? document.body.removeAttribute(Bn) : document.body.setAttribute(Bn, e.toString());
      };
    }, []);
  },
  l_ = function (e) {
    var t = e.noRelative,
      n = e.noImportant,
      r = e.gapMode,
      o = r === void 0 ? "margin" : r;
    i_();
    var s = M.useMemo(function () {
      return s_(o);
    }, [o]);
    return M.createElement(o_, {
      styles: a_(s, !t, o, n ? "" : "!important")
    });
  };
function c_() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ga();
  return t && e.setAttribute("nonce", t), e;
}
function u_(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function d_(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var f_ = function () {
    var e = 0,
      t = null;
    return {
      add: function (n) {
        e == 0 && (t = c_()) && (u_(t, n), d_(t)), e++;
      },
      remove: function () {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  p_ = function () {
    var e = f_();
    return function (t, n) {
      M.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    };
  },
  m_ = function () {
    var e = p_(),
      t = function (n) {
        var r = n.styles,
          o = n.dynamic;
        return e(r, o), null;
      };
    return t;
  },
  ta = !1;
if (typeof window < "u") try {
  var Xr = Object.defineProperty({}, "passive", {
    get: function () {
      return ta = !0, !0;
    }
  });
  window.addEventListener("test", Xr, Xr), window.removeEventListener("test", Xr, Xr);
} catch {
  ta = !1;
}
var An = ta ? {
    passive: !1
  } : !1,
  g_ = function (e) {
    return e.tagName === "TEXTAREA";
  },
  ed = function (e, t) {
    if (!(e instanceof Element)) return !1;
    var n = window.getComputedStyle(e);
    return (
      // not-not-scrollable
      n[t] !== "hidden" &&
      // contains scroll inside self
      !(n.overflowY === n.overflowX && !g_(e) && n[t] === "visible")
    );
  },
  h_ = function (e) {
    return ed(e, "overflowY");
  },
  v_ = function (e) {
    return ed(e, "overflowX");
  },
  Pl = function (e, t) {
    var n = t.ownerDocument,
      r = t;
    do {
      typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
      var o = td(e, r);
      if (o) {
        var s = nd(e, r),
          a = s[1],
          i = s[2];
        if (a > i) return !0;
      }
      r = r.parentNode;
    } while (r && r !== n.body);
    return !1;
  },
  __ = function (e) {
    var t = e.scrollTop,
      n = e.scrollHeight,
      r = e.clientHeight;
    return [t, n, r];
  },
  j_ = function (e) {
    var t = e.scrollLeft,
      n = e.scrollWidth,
      r = e.clientWidth;
    return [t, n, r];
  },
  td = function (e, t) {
    return e === "v" ? h_(t) : v_(t);
  },
  nd = function (e, t) {
    return e === "v" ? __(t) : j_(t);
  },
  y_ = function (e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
  },
  x_ = function (e, t, n, r, o) {
    var s = y_(e, window.getComputedStyle(t).direction),
      a = s * r,
      i = n.target,
      l = t.contains(i),
      c = !1,
      d = a > 0,
      f = 0,
      g = 0;
    do {
      var p = nd(e, i),
        x = p[0],
        m = p[1],
        h = p[2],
        j = m - h - s * x;
      (x || j) && td(e, i) && (f += j, g += x), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
    } while (
    // portaled content
    !l && i !== document.body ||
    // self content
    l && (t.contains(i) || t === i));
    return (d && (o && Math.abs(f) < 1 || !o && a > f) || !d && (o && Math.abs(g) < 1 || !o && -a > g)) && (c = !0), c;
  },
  es = function (e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
  Vl = function (e) {
    return [e.deltaX, e.deltaY];
  },
  Fl = function (e) {
    return e && "current" in e ? e.current : e;
  },
  k_ = function (e, t) {
    return e[0] === t[0] && e[1] === t[1];
  },
  M_ = function (e) {
    return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
  },
  b_ = 0,
  $n = [];
function w_(e) {
  var t = M.useRef([]),
    n = M.useRef([0, 0]),
    r = M.useRef(),
    o = M.useState(b_++)[0],
    s = M.useState(m_)[0],
    a = M.useRef(e);
  M.useEffect(function () {
    a.current = e;
  }, [e]), M.useEffect(function () {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = Gu([e.lockRef.current], (e.shards || []).map(Fl), !0).filter(Boolean);
      return m.forEach(function (h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function (h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = M.useCallback(function (m, h) {
      if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey) return !a.current.allowPinchZoom;
      var j = es(m),
        v = n.current,
        _ = "deltaX" in m ? m.deltaX : v[0] - j[0],
        k = "deltaY" in m ? m.deltaY : v[1] - j[1],
        y,
        b = m.target,
        C = Math.abs(_) > Math.abs(k) ? "h" : "v";
      if ("touches" in m && C === "h" && b.type === "range") return !1;
      var N = Pl(C, b);
      if (!N) return !0;
      if (N ? y = C : (y = C === "v" ? "h" : "v", N = Pl(C, b)), !N) return !1;
      if (!r.current && "changedTouches" in m && (_ || k) && (r.current = y), !y) return !0;
      var T = r.current || y;
      return x_(T, h, m, T === "h" ? _ : k, !0);
    }, []),
    l = M.useCallback(function (m) {
      var h = m;
      if (!(!$n.length || $n[$n.length - 1] !== s)) {
        var j = "deltaY" in h ? Vl(h) : es(h),
          v = t.current.filter(function (y) {
            return y.name === h.type && (y.target === h.target || h.target === y.shadowParent) && k_(y.delta, j);
          })[0];
        if (v && v.should) {
          h.cancelable && h.preventDefault();
          return;
        }
        if (!v) {
          var _ = (a.current.shards || []).map(Fl).filter(Boolean).filter(function (y) {
              return y.contains(h.target);
            }),
            k = _.length > 0 ? i(h, _[0]) : !a.current.noIsolation;
          k && h.cancelable && h.preventDefault();
        }
      }
    }, []),
    c = M.useCallback(function (m, h, j, v) {
      var _ = {
        name: m,
        delta: h,
        target: j,
        should: v,
        shadowParent: C_(j)
      };
      t.current.push(_), setTimeout(function () {
        t.current = t.current.filter(function (k) {
          return k !== _;
        });
      }, 1);
    }, []),
    d = M.useCallback(function (m) {
      n.current = es(m), r.current = void 0;
    }, []),
    f = M.useCallback(function (m) {
      c(m.type, Vl(m), m.target, i(m, e.lockRef.current));
    }, []),
    g = M.useCallback(function (m) {
      c(m.type, es(m), m.target, i(m, e.lockRef.current));
    }, []);
  M.useEffect(function () {
    return $n.push(s), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", l, An), document.addEventListener("touchmove", l, An), document.addEventListener("touchstart", d, An), function () {
      $n = $n.filter(function (m) {
        return m !== s;
      }), document.removeEventListener("wheel", l, An), document.removeEventListener("touchmove", l, An), document.removeEventListener("touchstart", d, An);
    };
  }, []);
  var p = e.removeScrollBar,
    x = e.inert;
  return M.createElement(M.Fragment, null, x ? M.createElement(s, {
    styles: M_(o)
  }) : null, p ? M.createElement(l_, {
    gapMode: e.gapMode
  }) : null);
}
function C_(e) {
  for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const N_ = K1(Xu, w_);
var rd = M.forwardRef(function (e, t) {
  return M.createElement(qs, Le({}, e, {
    ref: t,
    sideCar: N_
  }));
});
rd.classNames = qs.classNames;
const I_ = rd;
var E_ = [" ", "Enter", "ArrowUp", "ArrowDown"],
  S_ = [" ", "Enter"],
  Fr = "Select",
  [Ks, Zs, T_] = ev(Fr),
  [sr, LN] = uu(Fr, [T_, Pu]),
  Gs = Pu(),
  [D_, an] = sr(Fr),
  [O_, A_] = sr(Fr),
  sd = e => {
    const {
        __scopeSelect: t,
        children: n,
        open: r,
        defaultOpen: o,
        onOpenChange: s,
        value: a,
        defaultValue: i,
        onValueChange: l,
        dir: c,
        name: d,
        autoComplete: f,
        disabled: g,
        required: p,
        form: x
      } = e,
      m = Gs(t),
      [h, j] = M.useState(null),
      [v, _] = M.useState(null),
      [k, y] = M.useState(!1),
      b = nv(c),
      [C = !1, N] = $l({
        prop: r,
        defaultProp: o,
        onChange: s
      }),
      [T, z] = $l({
        prop: a,
        defaultProp: i,
        onChange: l
      }),
      K = M.useRef(null),
      L = h ? x || !!h.closest("form") : !0,
      [H, Y] = M.useState(/* @__PURE__ */new Set()),
      X = Array.from(H).map(ne => ne.props.value).join(";");
    return /* @__PURE__ */u.jsx(T1, {
      ...m,
      children: /* @__PURE__ */u.jsxs(D_, {
        required: p,
        scope: t,
        trigger: h,
        onTriggerChange: j,
        valueNode: v,
        onValueNodeChange: _,
        valueNodeHasChildren: k,
        onValueNodeHasChildrenChange: y,
        contentId: Va(),
        value: T,
        onValueChange: z,
        open: C,
        onOpenChange: N,
        dir: b,
        triggerPointerDownPosRef: K,
        disabled: g,
        children: [/* @__PURE__ */u.jsx(Ks.Provider, {
          scope: t,
          children: /* @__PURE__ */u.jsx(O_, {
            scope: e.__scopeSelect,
            onNativeOptionAdd: M.useCallback(ne => {
              Y(U => new Set(U).add(ne));
            }, []),
            onNativeOptionRemove: M.useCallback(ne => {
              Y(U => {
                const de = new Set(U);
                return de.delete(ne), de;
              });
            }, []),
            children: n
          })
        }), L ? /* @__PURE__ */u.jsxs(Cd, {
          "aria-hidden": !0,
          required: p,
          tabIndex: -1,
          name: d,
          autoComplete: f,
          value: T,
          onChange: ne => z(ne.target.value),
          disabled: g,
          form: x,
          children: [T === void 0 ? /* @__PURE__ */u.jsx("option", {
            value: ""
          }) : null, Array.from(H)]
        }, X) : null]
      })
    });
  };
sd.displayName = Fr;
var od = "SelectTrigger",
  ad = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        disabled: r = !1,
        ...o
      } = e,
      s = Gs(n),
      a = an(od, n),
      i = a.disabled || r,
      l = Ke(t, a.onTriggerChange),
      c = Zs(n),
      d = M.useRef("touch"),
      [f, g, p] = Nd(m => {
        const h = c().filter(_ => !_.disabled),
          j = h.find(_ => _.value === a.value),
          v = Id(h, m, j);
        v !== void 0 && a.onValueChange(v.value);
      }),
      x = m => {
        i || (a.onOpenChange(!0), p()), m && (a.triggerPointerDownPosRef.current = {
          x: Math.round(m.pageX),
          y: Math.round(m.pageY)
        });
      };
    return /* @__PURE__ */u.jsx(D1, {
      asChild: !0,
      ...s,
      children: /* @__PURE__ */u.jsx(Qe.button, {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": wd(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: Pe(o.onClick, m => {
          m.currentTarget.focus(), d.current !== "mouse" && x(m);
        }),
        onPointerDown: Pe(o.onPointerDown, m => {
          d.current = m.pointerType;
          const h = m.target;
          h.hasPointerCapture(m.pointerId) && h.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (x(m), m.preventDefault());
        }),
        onKeyDown: Pe(o.onKeyDown, m => {
          const h = f.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && g(m.key), !(h && m.key === " ") && E_.includes(m.key) && (x(), m.preventDefault());
        })
      })
    });
  });
ad.displayName = od;
var id = "SelectValue",
  ld = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        className: r,
        style: o,
        children: s,
        placeholder: a = "",
        ...i
      } = e,
      l = an(id, n),
      {
        onValueNodeHasChildrenChange: c
      } = l,
      d = s !== void 0,
      f = Ke(t, l.onValueNodeChange);
    return At(() => {
      c(d);
    }, [c, d]), /* @__PURE__ */u.jsx(Qe.span, {
      ...i,
      ref: f,
      style: {
        pointerEvents: "none"
      },
      children: wd(l.value) ? /* @__PURE__ */u.jsx(u.Fragment, {
        children: a
      }) : s
    });
  });
ld.displayName = id;
var $_ = "SelectIcon",
  cd = M.forwardRef((e, t) => {
    const {
      __scopeSelect: n,
      children: r,
      ...o
    } = e;
    return /* @__PURE__ */u.jsx(Qe.span, {
      "aria-hidden": !0,
      ...o,
      ref: t,
      children: r || "▼"
    });
  });
cd.displayName = $_;
var Mn = "SelectContent",
  ud = M.forwardRef((e, t) => {
    const n = an(Mn, e.__scopeSelect),
      [r, o] = M.useState();
    if (At(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const s = r;
      return s ? Fs.createPortal(/* @__PURE__ */u.jsx(dd, {
        scope: e.__scopeSelect,
        children: /* @__PURE__ */u.jsx(Ks.Slot, {
          scope: e.__scopeSelect,
          children: /* @__PURE__ */u.jsx("div", {
            children: e.children
          })
        })
      }), s) : null;
    }
    return /* @__PURE__ */u.jsx(fd, {
      ...e,
      ref: t
    });
  });
ud.displayName = Mn;
var mt = 10,
  [dd, ln] = sr(Mn),
  L_ = "SelectContentImpl",
  z_ = /* @__PURE__ */js("SelectContent.RemoveScroll"),
  fd = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        position: r = "item-aligned",
        onCloseAutoFocus: o,
        onEscapeKeyDown: s,
        onPointerDownOutside: a,
        //
        // PopperContent props
        side: i,
        sideOffset: l,
        align: c,
        alignOffset: d,
        arrowPadding: f,
        collisionBoundary: g,
        collisionPadding: p,
        sticky: x,
        hideWhenDetached: m,
        avoidCollisions: h,
        //
        ...j
      } = e,
      v = an(Mn, n),
      [_, k] = M.useState(null),
      [y, b] = M.useState(null),
      C = Ke(t, E => k(E)),
      [N, T] = M.useState(null),
      [z, K] = M.useState(null),
      L = Zs(n),
      [H, Y] = M.useState(!1),
      X = M.useRef(!1);
    M.useEffect(() => {
      if (_) return Zu(_);
    }, [_]), pv();
    const ne = M.useCallback(E => {
        const [G, ...B] = L().map($ => $.ref.current),
          [Q] = B.slice(-1),
          ie = document.activeElement;
        for (const $ of E) if ($ === ie || ($ == null || $.scrollIntoView({
          block: "nearest"
        }), $ === G && y && (y.scrollTop = 0), $ === Q && y && (y.scrollTop = y.scrollHeight), $ == null || $.focus(), document.activeElement !== ie)) return;
      }, [L, y]),
      U = M.useCallback(() => ne([N, _]), [ne, N, _]);
    M.useEffect(() => {
      H && U();
    }, [H, U]);
    const {
      onOpenChange: de,
      triggerPointerDownPosRef: Z
    } = v;
    M.useEffect(() => {
      if (_) {
        let E = {
          x: 0,
          y: 0
        };
        const G = Q => {
            var ie, $;
            E = {
              x: Math.abs(Math.round(Q.pageX) - (((ie = Z.current) == null ? void 0 : ie.x) ?? 0)),
              y: Math.abs(Math.round(Q.pageY) - ((($ = Z.current) == null ? void 0 : $.y) ?? 0))
            };
          },
          B = Q => {
            E.x <= 10 && E.y <= 10 ? Q.preventDefault() : _.contains(Q.target) || de(!1), document.removeEventListener("pointermove", G), Z.current = null;
          };
        return Z.current !== null && (document.addEventListener("pointermove", G), document.addEventListener("pointerup", B, {
          capture: !0,
          once: !0
        })), () => {
          document.removeEventListener("pointermove", G), document.removeEventListener("pointerup", B, {
            capture: !0
          });
        };
      }
    }, [_, de, Z]), M.useEffect(() => {
      const E = () => de(!1);
      return window.addEventListener("blur", E), window.addEventListener("resize", E), () => {
        window.removeEventListener("blur", E), window.removeEventListener("resize", E);
      };
    }, [de]);
    const [S, R] = Nd(E => {
        const G = L().filter(ie => !ie.disabled),
          B = G.find(ie => ie.ref.current === document.activeElement),
          Q = Id(G, E, B);
        Q && setTimeout(() => Q.ref.current.focus());
      }),
      ae = M.useCallback((E, G, B) => {
        const Q = !X.current && !B;
        (v.value !== void 0 && v.value === G || Q) && (T(E), Q && (X.current = !0));
      }, [v.value]),
      P = M.useCallback(() => _ == null ? void 0 : _.focus(), [_]),
      D = M.useCallback((E, G, B) => {
        const Q = !X.current && !B;
        (v.value !== void 0 && v.value === G || Q) && K(E);
      }, [v.value]),
      O = r === "popper" ? na : pd,
      A = O === na ? {
        side: i,
        sideOffset: l,
        align: c,
        alignOffset: d,
        arrowPadding: f,
        collisionBoundary: g,
        collisionPadding: p,
        sticky: x,
        hideWhenDetached: m,
        avoidCollisions: h
      } : {};
    return /* @__PURE__ */u.jsx(dd, {
      scope: n,
      content: _,
      viewport: y,
      onViewportChange: b,
      itemRefCallback: ae,
      selectedItem: N,
      onItemLeave: P,
      itemTextRefCallback: D,
      focusSelectedItem: U,
      selectedItemText: z,
      position: r,
      isPositioned: H,
      searchRef: S,
      children: /* @__PURE__ */u.jsx(I_, {
        as: z_,
        allowPinchZoom: !0,
        children: /* @__PURE__ */u.jsx(gu, {
          asChild: !0,
          trapped: v.open,
          onMountAutoFocus: E => {
            E.preventDefault();
          },
          onUnmountAutoFocus: Pe(o, E => {
            var G;
            (G = v.trigger) == null || G.focus({
              preventScroll: !0
            }), E.preventDefault();
          }),
          children: /* @__PURE__ */u.jsx(pu, {
            asChild: !0,
            disableOutsidePointerEvents: !0,
            onEscapeKeyDown: s,
            onPointerDownOutside: a,
            onFocusOutside: E => E.preventDefault(),
            onDismiss: () => v.onOpenChange(!1),
            children: /* @__PURE__ */u.jsx(O, {
              role: "listbox",
              id: v.contentId,
              "data-state": v.open ? "open" : "closed",
              dir: v.dir,
              onContextMenu: E => E.preventDefault(),
              ...j,
              ...A,
              onPlaced: () => Y(!0),
              ref: C,
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...j.style
              },
              onKeyDown: Pe(j.onKeyDown, E => {
                const G = E.ctrlKey || E.altKey || E.metaKey;
                if (E.key === "Tab" && E.preventDefault(), !G && E.key.length === 1 && R(E.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(E.key)) {
                  let Q = L().filter(ie => !ie.disabled).map(ie => ie.ref.current);
                  if (["ArrowUp", "End"].includes(E.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(E.key)) {
                    const ie = E.target,
                      $ = Q.indexOf(ie);
                    Q = Q.slice($ + 1);
                  }
                  setTimeout(() => ne(Q)), E.preventDefault();
                }
              })
            })
          })
        })
      })
    });
  });
fd.displayName = L_;
var R_ = "SelectItemAlignedPosition",
  pd = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        onPlaced: r,
        ...o
      } = e,
      s = an(Mn, n),
      a = ln(Mn, n),
      [i, l] = M.useState(null),
      [c, d] = M.useState(null),
      f = Ke(t, C => d(C)),
      g = Zs(n),
      p = M.useRef(!1),
      x = M.useRef(!0),
      {
        viewport: m,
        selectedItem: h,
        selectedItemText: j,
        focusSelectedItem: v
      } = a,
      _ = M.useCallback(() => {
        if (s.trigger && s.valueNode && i && c && m && h && j) {
          const C = s.trigger.getBoundingClientRect(),
            N = c.getBoundingClientRect(),
            T = s.valueNode.getBoundingClientRect(),
            z = j.getBoundingClientRect();
          if (s.dir !== "rtl") {
            const ie = z.left - N.left,
              $ = T.left - ie,
              je = C.left - $,
              J = C.width + je,
              Ce = Math.max(J, N.width),
              Ne = window.innerWidth - mt,
              Ye = hl($, [mt,
              // Prevents the content from going off the starting edge of the
              // viewport. It may still go off the ending edge, but this can be
              // controlled by the user since they may want to manage overflow in a
              // specific way.
              // https://github.com/radix-ui/primitives/issues/2049
              Math.max(mt, Ne - Ce)]);
            i.style.minWidth = J + "px", i.style.left = Ye + "px";
          } else {
            const ie = N.right - z.right,
              $ = window.innerWidth - T.right - ie,
              je = window.innerWidth - C.right - $,
              J = C.width + je,
              Ce = Math.max(J, N.width),
              Ne = window.innerWidth - mt,
              Ye = hl($, [mt, Math.max(mt, Ne - Ce)]);
            i.style.minWidth = J + "px", i.style.right = Ye + "px";
          }
          const K = g(),
            L = window.innerHeight - mt * 2,
            H = m.scrollHeight,
            Y = window.getComputedStyle(c),
            X = parseInt(Y.borderTopWidth, 10),
            ne = parseInt(Y.paddingTop, 10),
            U = parseInt(Y.borderBottomWidth, 10),
            de = parseInt(Y.paddingBottom, 10),
            Z = X + ne + H + de + U,
            S = Math.min(h.offsetHeight * 5, Z),
            R = window.getComputedStyle(m),
            ae = parseInt(R.paddingTop, 10),
            P = parseInt(R.paddingBottom, 10),
            D = C.top + C.height / 2 - mt,
            O = L - D,
            A = h.offsetHeight / 2,
            E = h.offsetTop + A,
            G = X + ne + E,
            B = Z - G;
          if (G <= D) {
            const ie = K.length > 0 && h === K[K.length - 1].ref.current;
            i.style.bottom = "0px";
            const $ = c.clientHeight - m.offsetTop - m.offsetHeight,
              je = Math.max(O, A + (
              // viewport might have padding bottom, include it to avoid a scrollable viewport
              ie ? P : 0) + $ + U),
              J = G + je;
            i.style.height = J + "px";
          } else {
            const ie = K.length > 0 && h === K[0].ref.current;
            i.style.top = "0px";
            const je = Math.max(D, X + m.offsetTop + (
            // viewport might have padding top, include it to avoid a scrollable viewport
            ie ? ae : 0) + A) + B;
            i.style.height = je + "px", m.scrollTop = G - D + m.offsetTop;
          }
          i.style.margin = `${mt}px 0`, i.style.minHeight = S + "px", i.style.maxHeight = L + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
        }
      }, [g, s.trigger, s.valueNode, i, c, m, h, j, s.dir, r]);
    At(() => _(), [_]);
    const [k, y] = M.useState();
    At(() => {
      c && y(window.getComputedStyle(c).zIndex);
    }, [c]);
    const b = M.useCallback(C => {
      C && x.current === !0 && (_(), v == null || v(), x.current = !1);
    }, [_, v]);
    return /* @__PURE__ */u.jsx(V_, {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: b,
      children: /* @__PURE__ */u.jsx("div", {
        ref: l,
        style: {
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          zIndex: k
        },
        children: /* @__PURE__ */u.jsx(Qe.div, {
          ...o,
          ref: f,
          style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: "border-box",
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: "100%",
            ...o.style
          }
        })
      })
    });
  });
pd.displayName = R_;
var P_ = "SelectPopperPosition",
  na = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        align: r = "start",
        collisionPadding: o = mt,
        ...s
      } = e,
      a = Gs(n);
    return /* @__PURE__ */u.jsx(O1, {
      ...a,
      ...s,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    });
  });
na.displayName = P_;
var [V_, Ja] = sr(Mn, {}),
  ra = "SelectViewport",
  md = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        nonce: r,
        ...o
      } = e,
      s = ln(ra, n),
      a = Ja(ra, n),
      i = Ke(t, s.onViewportChange),
      l = M.useRef(0);
    return /* @__PURE__ */u.jsxs(u.Fragment, {
      children: [/* @__PURE__ */u.jsx("style", {
        dangerouslySetInnerHTML: {
          __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
        },
        nonce: r
      }), /* @__PURE__ */u.jsx(Ks.Slot, {
        scope: n,
        children: /* @__PURE__ */u.jsx(Qe.div, {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: Pe(o.onScroll, c => {
            const d = c.currentTarget,
              {
                contentWrapper: f,
                shouldExpandOnScrollRef: g
              } = a;
            if (g != null && g.current && f) {
              const p = Math.abs(l.current - d.scrollTop);
              if (p > 0) {
                const x = window.innerHeight - mt * 2,
                  m = parseFloat(f.style.minHeight),
                  h = parseFloat(f.style.height),
                  j = Math.max(m, h);
                if (j < x) {
                  const v = j + p,
                    _ = Math.min(x, v),
                    k = v - _;
                  f.style.height = _ + "px", f.style.bottom === "0px" && (d.scrollTop = k > 0 ? k : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        })
      })]
    });
  });
md.displayName = ra;
var gd = "SelectGroup",
  [F_, U_] = sr(gd),
  Y_ = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        ...r
      } = e,
      o = Va();
    return /* @__PURE__ */u.jsx(F_, {
      scope: n,
      id: o,
      children: /* @__PURE__ */u.jsx(Qe.div, {
        role: "group",
        "aria-labelledby": o,
        ...r,
        ref: t
      })
    });
  });
Y_.displayName = gd;
var hd = "SelectLabel",
  W_ = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        ...r
      } = e,
      o = U_(hd, n);
    return /* @__PURE__ */u.jsx(Qe.div, {
      id: o.id,
      ...r,
      ref: t
    });
  });
W_.displayName = hd;
var bs = "SelectItem",
  [B_, vd] = sr(bs),
  _d = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        value: r,
        disabled: o = !1,
        textValue: s,
        ...a
      } = e,
      i = an(bs, n),
      l = ln(bs, n),
      c = i.value === r,
      [d, f] = M.useState(s ?? ""),
      [g, p] = M.useState(!1),
      x = Ke(t, v => {
        var _;
        return (_ = l.itemRefCallback) == null ? void 0 : _.call(l, v, r, o);
      }),
      m = Va(),
      h = M.useRef("touch"),
      j = () => {
        o || (i.onValueChange(r), i.onOpenChange(!1));
      };
    if (r === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */u.jsx(B_, {
      scope: n,
      value: r,
      disabled: o,
      textId: m,
      isSelected: c,
      onItemTextChange: M.useCallback(v => {
        f(_ => _ || ((v == null ? void 0 : v.textContent) ?? "").trim());
      }, []),
      children: /* @__PURE__ */u.jsx(Ks.ItemSlot, {
        scope: n,
        value: r,
        disabled: o,
        textValue: d,
        children: /* @__PURE__ */u.jsx(Qe.div, {
          role: "option",
          "aria-labelledby": m,
          "data-highlighted": g ? "" : void 0,
          "aria-selected": c && g,
          "data-state": c ? "checked" : "unchecked",
          "aria-disabled": o || void 0,
          "data-disabled": o ? "" : void 0,
          tabIndex: o ? void 0 : -1,
          ...a,
          ref: x,
          onFocus: Pe(a.onFocus, () => p(!0)),
          onBlur: Pe(a.onBlur, () => p(!1)),
          onClick: Pe(a.onClick, () => {
            h.current !== "mouse" && j();
          }),
          onPointerUp: Pe(a.onPointerUp, () => {
            h.current === "mouse" && j();
          }),
          onPointerDown: Pe(a.onPointerDown, v => {
            h.current = v.pointerType;
          }),
          onPointerMove: Pe(a.onPointerMove, v => {
            var _;
            h.current = v.pointerType, o ? (_ = l.onItemLeave) == null || _.call(l) : h.current === "mouse" && v.currentTarget.focus({
              preventScroll: !0
            });
          }),
          onPointerLeave: Pe(a.onPointerLeave, v => {
            var _;
            v.currentTarget === document.activeElement && ((_ = l.onItemLeave) == null || _.call(l));
          }),
          onKeyDown: Pe(a.onKeyDown, v => {
            var k;
            ((k = l.searchRef) == null ? void 0 : k.current) !== "" && v.key === " " || (S_.includes(v.key) && j(), v.key === " " && v.preventDefault());
          })
        })
      })
    });
  });
_d.displayName = bs;
var dr = "SelectItemText",
  jd = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        className: r,
        style: o,
        ...s
      } = e,
      a = an(dr, n),
      i = ln(dr, n),
      l = vd(dr, n),
      c = A_(dr, n),
      [d, f] = M.useState(null),
      g = Ke(t, j => f(j), l.onItemTextChange, j => {
        var v;
        return (v = i.itemTextRefCallback) == null ? void 0 : v.call(i, j, l.value, l.disabled);
      }),
      p = d == null ? void 0 : d.textContent,
      x = M.useMemo(() => /* @__PURE__ */u.jsx("option", {
        value: l.value,
        disabled: l.disabled,
        children: p
      }, l.value), [l.disabled, l.value, p]),
      {
        onNativeOptionAdd: m,
        onNativeOptionRemove: h
      } = c;
    return At(() => (m(x), () => h(x)), [m, h, x]), /* @__PURE__ */u.jsxs(u.Fragment, {
      children: [/* @__PURE__ */u.jsx(Qe.span, {
        id: l.textId,
        ...s,
        ref: g
      }), l.isSelected && a.valueNode && !a.valueNodeHasChildren ? Fs.createPortal(s.children, a.valueNode) : null]
    });
  });
jd.displayName = dr;
var yd = "SelectItemIndicator",
  xd = M.forwardRef((e, t) => {
    const {
      __scopeSelect: n,
      ...r
    } = e;
    return vd(yd, n).isSelected ? /* @__PURE__ */u.jsx(Qe.span, {
      "aria-hidden": !0,
      ...r,
      ref: t
    }) : null;
  });
xd.displayName = yd;
var sa = "SelectScrollUpButton",
  kd = M.forwardRef((e, t) => {
    const n = ln(sa, e.__scopeSelect),
      r = Ja(sa, e.__scopeSelect),
      [o, s] = M.useState(!1),
      a = Ke(t, r.onScrollButtonChange);
    return At(() => {
      if (n.viewport && n.isPositioned) {
        let i = function () {
          const c = l.scrollTop > 0;
          s(c);
        };
        const l = n.viewport;
        return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
      }
    }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */u.jsx(bd, {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const {
          viewport: i,
          selectedItem: l
        } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }) : null;
  });
kd.displayName = sa;
var oa = "SelectScrollDownButton",
  Md = M.forwardRef((e, t) => {
    const n = ln(oa, e.__scopeSelect),
      r = Ja(oa, e.__scopeSelect),
      [o, s] = M.useState(!1),
      a = Ke(t, r.onScrollButtonChange);
    return At(() => {
      if (n.viewport && n.isPositioned) {
        let i = function () {
          const c = l.scrollHeight - l.clientHeight,
            d = Math.ceil(l.scrollTop) < c;
          s(d);
        };
        const l = n.viewport;
        return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
      }
    }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */u.jsx(bd, {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const {
          viewport: i,
          selectedItem: l
        } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }) : null;
  });
Md.displayName = oa;
var bd = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        onAutoScroll: r,
        ...o
      } = e,
      s = ln("SelectScrollButton", n),
      a = M.useRef(null),
      i = Zs(n),
      l = M.useCallback(() => {
        a.current !== null && (window.clearInterval(a.current), a.current = null);
      }, []);
    return M.useEffect(() => () => l(), [l]), At(() => {
      var d;
      const c = i().find(f => f.ref.current === document.activeElement);
      (d = c == null ? void 0 : c.ref.current) == null || d.scrollIntoView({
        block: "nearest"
      });
    }, [i]), /* @__PURE__ */u.jsx(Qe.div, {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: {
        flexShrink: 0,
        ...o.style
      },
      onPointerDown: Pe(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: Pe(o.onPointerMove, () => {
        var c;
        (c = s.onItemLeave) == null || c.call(s), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Pe(o.onPointerLeave, () => {
        l();
      })
    });
  }),
  H_ = "SelectSeparator",
  Q_ = M.forwardRef((e, t) => {
    const {
      __scopeSelect: n,
      ...r
    } = e;
    return /* @__PURE__ */u.jsx(Qe.div, {
      "aria-hidden": !0,
      ...r,
      ref: t
    });
  });
Q_.displayName = H_;
var aa = "SelectArrow",
  q_ = M.forwardRef((e, t) => {
    const {
        __scopeSelect: n,
        ...r
      } = e,
      o = Gs(n),
      s = an(aa, n),
      a = ln(aa, n);
    return s.open && a.position === "popper" ? /* @__PURE__ */u.jsx(A1, {
      ...o,
      ...r,
      ref: t
    }) : null;
  });
q_.displayName = aa;
function wd(e) {
  return e === "" || e === void 0;
}
var Cd = M.forwardRef((e, t) => {
  const {
      value: n,
      ...r
    } = e,
    o = M.useRef(null),
    s = Ke(t, o),
    a = L1(n);
  return M.useEffect(() => {
    const i = o.current,
      l = window.HTMLSelectElement.prototype,
      d = Object.getOwnPropertyDescriptor(l, "value").set;
    if (a !== n && d) {
      const f = new Event("change", {
        bubbles: !0
      });
      d.call(i, n), i.dispatchEvent(f);
    }
  }, [a, n]), /* @__PURE__ */u.jsx(qu, {
    asChild: !0,
    children: /* @__PURE__ */u.jsx("select", {
      ...r,
      ref: s,
      defaultValue: n
    })
  });
});
Cd.displayName = "BubbleSelect";
function Nd(e) {
  const t = Gt(e),
    n = M.useRef(""),
    r = M.useRef(0),
    o = M.useCallback(a => {
      const i = n.current + a;
      t(i), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(i);
    }, [t]),
    s = M.useCallback(() => {
      n.current = "", window.clearTimeout(r.current);
    }, []);
  return M.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, s];
}
function Id(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(c => c === t[0]) ? t[0] : t,
    s = n ? e.indexOf(n) : -1;
  let a = K_(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter(c => c !== n));
  const l = a.find(c => c.textValue.toLowerCase().startsWith(o.toLowerCase()));
  return l !== n ? l : void 0;
}
function K_(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Z_ = sd,
  G_ = ad,
  J_ = ld,
  X_ = cd,
  ej = ud,
  tj = md,
  nj = _d,
  rj = jd,
  sj = xd,
  oj = kd,
  aj = Md;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ct = function () {
  return Ct = Object.assign || function (t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Ct.apply(this, arguments);
};
function cn(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Ed(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 16 17",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("path", {
    d: "M5.198 12.346L8 9.555l2.802 2.79 1.055-1.06L9.06 8.5l2.802-2.791-1.06-1.055L8 7.445l-2.802-2.79-1.06 1.054L6.94 8.5l-2.797 2.786 1.055 1.06z"
  }));
}
function ij(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 24 24",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.878 7.203a.669.669 0 010 .979l-8 7.615a.753.753 0 01-1.029 0l-3.636-3.461a.67.67 0 010-.98.754.754 0 011.029 0l3.122 2.973 7.485-7.126a.753.753 0 011.029 0z"
  }));
}
function Sd(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 24 24",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("path", {
    d: "M10.133 17.6l9.4-9.4-1.866-1.867-7.534 7.534-3.8-3.8-1.866 1.866 5.666 5.667z"
  }));
}
function lj(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("g", {
    clipPath: "url(#a)"
  }, M.createElement("path", {
    d: "M8.55 12l1.95-1.95L12.45 12l1.05-1.05L11.55 9l1.95-1.95L12.45 6 10.5 7.95 8.55 6 7.5 7.05 9.45 9 7.5 10.95 8.55 12zm-6.3-3l3.263-4.612c.137-.2.315-.357.534-.47.219-.112.453-.168.703-.168h7.5c.412 0 .766.147 1.06.441.293.293.44.647.44 1.059v7.5c0 .412-.147.766-.44 1.06a1.45 1.45 0 01-1.06.44h-7.5c-.25 0-.484-.056-.704-.169a1.433 1.433 0 01-.534-.468L2.25 9z"
  })), M.createElement("defs", null, M.createElement("clipPath", {
    id: "a"
  }, M.createElement("path", {
    d: "M0 0h18v18H0z"
  }))));
}
function cj(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 20 20",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("path", {
    d: "M10 19a9 9 0 100-18m0 18a9 9 0 110-18m0 18c2.294 0 4.154-4.03 4.154-9S12.294 1 10 1m0 18c-2.294 0-4.154-4.03-4.154-9S7.706 1 10 1m-8.308 9h16.616",
    stroke: "#182931",
    strokeWidth: 2,
    strokeLinecap: "square"
  }));
}
function uj(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("g", {
    clipPath: "url(#a)"
  }, M.createElement("path", {
    d: "M8.25 14.25v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5h-4.5v4.5h-1.5z"
  })), M.createElement("defs", null, M.createElement("clipPath", {
    id: "a"
  }, M.createElement("path", {
    d: "M0 0h18v18H0z"
  }))));
}
function dj(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 18 18",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("g", {
    clipPath: "url(#clip0_4586_37550)"
  }, M.createElement("path", {
    d: "M14.85 16.275l-3.15-3.113c-.438.138-.878.241-1.321.31A9.031 9.031 0 019 13.575c-1.888 0-3.569-.522-5.044-1.565A8.929 8.929 0 01.75 7.95a8.899 8.899 0 01.994-1.847c.4-.569.856-1.078 1.368-1.528l-2.062-2.1 1.05-1.05 13.8 13.8-1.05 1.05zM9 11.325c.137 0 .265-.006.384-.019.119-.012.247-.037.385-.075l-4.05-4.05a2.438 2.438 0 00-.075.385 3.671 3.671 0 00-.019.384c0 .937.328 1.734.984 2.39.657.657 1.454.985 2.391.985zm5.475.337L12.094 9.3c.087-.213.156-.428.206-.647.05-.219.075-.453.075-.703 0-.938-.328-1.735-.984-2.391-.656-.656-1.454-.984-2.391-.984-.25 0-.485.025-.704.075-.218.05-.433.125-.646.225L5.737 2.962A8.33 8.33 0 019 2.325c1.887 0 3.569.522 5.044 1.565a8.929 8.929 0 013.206 4.06 8.787 8.787 0 01-1.134 2.053 8.269 8.269 0 01-1.641 1.66zm-3.469-3.45l-2.25-2.25c.35-.062.672-.034.966.084.294.12.547.291.76.516.212.225.365.485.459.779.093.293.115.584.065.871z"
  })), M.createElement("defs", null, M.createElement("clipPath", {
    id: "clip0_4586_37550"
  }, M.createElement("path", {
    d: "M0 0h18v18H0z"
  }))));
}
function fj(e) {
  var t = e.title,
    n = e.titleId,
    r = cn(e, ["title", "titleId"]);
  return M.createElement("svg", Ct({}, r, {
    width: r.width,
    height: r.height,
    viewBox: "0 0 18 18",
    fill: r.color,
    "aria-hidden": r.hide ? "true" : "false",
    role: r.role,
    "aria-labelledby": n
  }), t ? M.createElement("title", {
    id: n
  }, t) : null, M.createElement("g", {
    clipPath: "url(#clip0_4586_37533)"
  }, M.createElement("path", {
    d: "M9 11.175c.938 0 1.735-.328 2.391-.984.656-.657.984-1.454.984-2.391 0-.938-.328-1.735-.984-2.391-.656-.656-1.454-.984-2.391-.984-.938 0-1.734.328-2.391.984-.656.656-.984 1.453-.984 2.39 0 .938.328 1.735.984 2.392.657.656 1.454.984 2.391.984zm0-1.35c-.563 0-1.04-.197-1.434-.591A1.951 1.951 0 016.975 7.8c0-.563.197-1.04.591-1.435.394-.393.872-.59 1.434-.59.563 0 1.04.197 1.435.59.393.394.59.872.59 1.435 0 .562-.197 1.04-.59 1.434A1.954 1.954 0 019 9.824zm0 3.6a8.682 8.682 0 01-4.987-1.529C2.513 10.878 1.425 9.512.75 7.8c.675-1.713 1.763-3.078 3.263-4.097A8.685 8.685 0 019 2.175c1.825 0 3.488.51 4.988 1.528 1.5 1.019 2.587 2.384 3.262 4.097-.675 1.712-1.762 3.078-3.262 4.096A8.682 8.682 0 019 13.425z"
  })), M.createElement("defs", null, M.createElement("clipPath", {
    id: "clip0_4586_37533"
  }, M.createElement("path", {
    d: "M0 0h18v18H0z"
  }))));
}
var pj = "_6akzrw1",
  mj = {
    down: "_6akzrw2 _6akzrw0",
    up: "_6akzrw3 _6akzrw0"
  },
  Ul = "_6akzrw4",
  gj = "_6akzrw5 _86277sl",
  hj = "_6akzrw6",
  vj = "_6akzrw7",
  _j = "_6akzrw8",
  jj = "_6akzrw9";
function Eo(_ref39) {
  let {
    direction: e = "down"
  } = _ref39;
  return /* @__PURE__ */u.jsx("span", {
    className: mj[e]
  });
}
const zN = ce((_ref40, p) => {
    let {
      children: e,
      label: t,
      error: n,
      disabled: r,
      className: o,
      required: s,
      variant: a = "light",
      name: i,
      placeholder: l,
      showPreselectedValue: c,
      onValueChange: d,
      labelOnTop: f = !1,
      ...g
    } = _ref40;
    const [x, m] = te.useState(""),
      h = j => {
        m(j), d(j);
      };
    return /* @__PURE__ */u.jsxs("div", {
      className: ye([Bs, o]),
      children: [t && f ? /* @__PURE__ */u.jsx("label", {
        className: xn({
          required: s
        }),
        htmlFor: i,
        children: t
      }) : null, /* @__PURE__ */u.jsxs("div", {
        className: Rr({
          disabled: r,
          invalid: !!n,
          variant: a
        }),
        children: [/* @__PURE__ */u.jsxs(Z_, {
          value: x,
          onValueChange: j => h(j),
          ...g,
          children: [/* @__PURE__ */u.jsxs(G_, {
            ref: p,
            "aria-label": x,
            className: gj,
            children: [c || x ? null : /* @__PURE__ */u.jsx("span", {
              children: l
            }), /* @__PURE__ */u.jsx(J_, {}), /* @__PURE__ */u.jsx(X_, {
              className: pj,
              children: /* @__PURE__ */u.jsx(Eo, {})
            })]
          }), /* @__PURE__ */u.jsxs(ej, {
            className: hj,
            children: [/* @__PURE__ */u.jsx(oj, {
              className: Ul,
              children: /* @__PURE__ */u.jsx(Eo, {
                direction: "up"
              })
            }), /* @__PURE__ */u.jsx(tj, {
              className: vj,
              children: e
            }), /* @__PURE__ */u.jsx(aj, {
              className: Ul,
              children: /* @__PURE__ */u.jsx(Eo, {})
            })]
          })]
        }), n ? /* @__PURE__ */u.jsx("span", {
          className: Pr,
          children: n
        }) : null]
      })]
    });
  }),
  RN = ce((_ref41, n) => {
    let {
      children: e,
      ...t
    } = _ref41;
    return /* @__PURE__ */u.jsxs(nj, {
      ref: n,
      className: _j,
      ...t,
      children: [/* @__PURE__ */u.jsx(rj, {
        children: e
      }), /* @__PURE__ */u.jsx(sj, {
        className: jj,
        children: /* @__PURE__ */u.jsx(ij, {
          color: "currentColor",
          height: "1.5em",
          width: "1.5em"
        })
      })]
    });
  });
var ia = {
    exports: {}
  },
  Te = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yl;
function yj() {
  if (Yl) return Te;
  Yl = 1;
  var e = Symbol.for("react.element"),
    t = Symbol.for("react.portal"),
    n = Symbol.for("react.fragment"),
    r = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"),
    s = Symbol.for("react.provider"),
    a = Symbol.for("react.context"),
    i = Symbol.for("react.server_context"),
    l = Symbol.for("react.forward_ref"),
    c = Symbol.for("react.suspense"),
    d = Symbol.for("react.suspense_list"),
    f = Symbol.for("react.memo"),
    g = Symbol.for("react.lazy"),
    p = Symbol.for("react.offscreen"),
    x;
  x = Symbol.for("react.module.reference");
  function m(h) {
    if (typeof h == "object" && h !== null) {
      var j = h.$$typeof;
      switch (j) {
        case e:
          switch (h = h.type, h) {
            case n:
            case o:
            case r:
            case c:
            case d:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case i:
                case a:
                case l:
                case g:
                case f:
                case s:
                  return h;
                default:
                  return j;
              }
          }
        case t:
          return j;
      }
    }
  }
  return Te.ContextConsumer = a, Te.ContextProvider = s, Te.Element = e, Te.ForwardRef = l, Te.Fragment = n, Te.Lazy = g, Te.Memo = f, Te.Portal = t, Te.Profiler = o, Te.StrictMode = r, Te.Suspense = c, Te.SuspenseList = d, Te.isAsyncMode = function () {
    return !1;
  }, Te.isConcurrentMode = function () {
    return !1;
  }, Te.isContextConsumer = function (h) {
    return m(h) === a;
  }, Te.isContextProvider = function (h) {
    return m(h) === s;
  }, Te.isElement = function (h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, Te.isForwardRef = function (h) {
    return m(h) === l;
  }, Te.isFragment = function (h) {
    return m(h) === n;
  }, Te.isLazy = function (h) {
    return m(h) === g;
  }, Te.isMemo = function (h) {
    return m(h) === f;
  }, Te.isPortal = function (h) {
    return m(h) === t;
  }, Te.isProfiler = function (h) {
    return m(h) === o;
  }, Te.isStrictMode = function (h) {
    return m(h) === r;
  }, Te.isSuspense = function (h) {
    return m(h) === c;
  }, Te.isSuspenseList = function (h) {
    return m(h) === d;
  }, Te.isValidElementType = function (h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === o || h === r || h === c || h === d || h === p || typeof h == "object" && h !== null && (h.$$typeof === g || h.$$typeof === f || h.$$typeof === s || h.$$typeof === a || h.$$typeof === l || h.$$typeof === x || h.getModuleId !== void 0);
  }, Te.typeOf = m, Te;
}
var De = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wl;
function xj() {
  return Wl || (Wl = 1, process.env.NODE_ENV !== "production" && function () {
    var e = Symbol.for("react.element"),
      t = Symbol.for("react.portal"),
      n = Symbol.for("react.fragment"),
      r = Symbol.for("react.strict_mode"),
      o = Symbol.for("react.profiler"),
      s = Symbol.for("react.provider"),
      a = Symbol.for("react.context"),
      i = Symbol.for("react.server_context"),
      l = Symbol.for("react.forward_ref"),
      c = Symbol.for("react.suspense"),
      d = Symbol.for("react.suspense_list"),
      f = Symbol.for("react.memo"),
      g = Symbol.for("react.lazy"),
      p = Symbol.for("react.offscreen"),
      x = !1,
      m = !1,
      h = !1,
      j = !1,
      v = !1,
      _;
    _ = Symbol.for("react.module.reference");
    function k(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === n || J === o || v || J === r || J === c || J === d || j || J === p || x || m || h || typeof J == "object" && J !== null && (J.$$typeof === g || J.$$typeof === f || J.$$typeof === s || J.$$typeof === a || J.$$typeof === l ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === _ || J.getModuleId !== void 0));
    }
    function y(J) {
      if (typeof J == "object" && J !== null) {
        var Ce = J.$$typeof;
        switch (Ce) {
          case e:
            var Ne = J.type;
            switch (Ne) {
              case n:
              case o:
              case r:
              case c:
              case d:
                return Ne;
              default:
                var Ye = Ne && Ne.$$typeof;
                switch (Ye) {
                  case i:
                  case a:
                  case l:
                  case g:
                  case f:
                  case s:
                    return Ye;
                  default:
                    return Ce;
                }
            }
          case t:
            return Ce;
        }
      }
    }
    var b = a,
      C = s,
      N = e,
      T = l,
      z = n,
      K = g,
      L = f,
      H = t,
      Y = o,
      X = r,
      ne = c,
      U = d,
      de = !1,
      Z = !1;
    function S(J) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function R(J) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ae(J) {
      return y(J) === a;
    }
    function P(J) {
      return y(J) === s;
    }
    function D(J) {
      return typeof J == "object" && J !== null && J.$$typeof === e;
    }
    function O(J) {
      return y(J) === l;
    }
    function A(J) {
      return y(J) === n;
    }
    function E(J) {
      return y(J) === g;
    }
    function G(J) {
      return y(J) === f;
    }
    function B(J) {
      return y(J) === t;
    }
    function Q(J) {
      return y(J) === o;
    }
    function ie(J) {
      return y(J) === r;
    }
    function $(J) {
      return y(J) === c;
    }
    function je(J) {
      return y(J) === d;
    }
    De.ContextConsumer = b, De.ContextProvider = C, De.Element = N, De.ForwardRef = T, De.Fragment = z, De.Lazy = K, De.Memo = L, De.Portal = H, De.Profiler = Y, De.StrictMode = X, De.Suspense = ne, De.SuspenseList = U, De.isAsyncMode = S, De.isConcurrentMode = R, De.isContextConsumer = ae, De.isContextProvider = P, De.isElement = D, De.isForwardRef = O, De.isFragment = A, De.isLazy = E, De.isMemo = G, De.isPortal = B, De.isProfiler = Q, De.isStrictMode = ie, De.isSuspense = $, De.isSuspenseList = je, De.isValidElementType = k, De.typeOf = y;
  }()), De;
}
process.env.NODE_ENV === "production" ? ia.exports = yj() : ia.exports = xj();
var Bl = ia.exports;
const Hl = e => typeof e == "object" && e != null && e.nodeType === 1,
  Ql = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip",
  So = (e, t) => {
    if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
      const n = getComputedStyle(e, null);
      return Ql(n.overflowY, t) || Ql(n.overflowX, t) || (r => {
        const o = (s => {
          if (!s.ownerDocument || !s.ownerDocument.defaultView) return null;
          try {
            return s.ownerDocument.defaultView.frameElement;
          } catch {
            return null;
          }
        })(r);
        return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
      })(e);
    }
    return !1;
  },
  ts = (e, t, n, r, o, s, a, i) => s < e && a > t || s > e && a < t ? 0 : s <= e && i <= n || a >= t && i >= n ? s - e - r : a > t && i < n || s < e && i > n ? a - t + o : 0,
  kj = e => {
    const t = e.parentElement;
    return t ?? (e.getRootNode().host || null);
  },
  Mj = (e, t) => {
    var n, r, o, s;
    if (typeof document > "u") return [];
    const {
        scrollMode: a,
        block: i,
        inline: l,
        boundary: c,
        skipOverflowHiddenElements: d
      } = t,
      f = typeof c == "function" ? c : ne => ne !== c;
    if (!Hl(e)) throw new TypeError("Invalid target");
    const g = document.scrollingElement || document.documentElement,
      p = [];
    let x = e;
    for (; Hl(x) && f(x);) {
      if (x = kj(x), x === g) {
        p.push(x);
        break;
      }
      x != null && x === document.body && So(x) && !So(document.documentElement) || x != null && So(x, d) && p.push(x);
    }
    const m = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth,
      h = (s = (o = window.visualViewport) == null ? void 0 : o.height) != null ? s : innerHeight,
      {
        scrollX: j,
        scrollY: v
      } = window,
      {
        height: _,
        width: k,
        top: y,
        right: b,
        bottom: C,
        left: N
      } = e.getBoundingClientRect(),
      {
        top: T,
        right: z,
        bottom: K,
        left: L
      } = (ne => {
        const U = window.getComputedStyle(ne);
        return {
          top: parseFloat(U.scrollMarginTop) || 0,
          right: parseFloat(U.scrollMarginRight) || 0,
          bottom: parseFloat(U.scrollMarginBottom) || 0,
          left: parseFloat(U.scrollMarginLeft) || 0
        };
      })(e);
    let H = i === "start" || i === "nearest" ? y - T : i === "end" ? C + K : y + _ / 2 - T + K,
      Y = l === "center" ? N + k / 2 - L + z : l === "end" ? b + z : N - L;
    const X = [];
    for (let ne = 0; ne < p.length; ne++) {
      const U = p[ne],
        {
          height: de,
          width: Z,
          top: S,
          right: R,
          bottom: ae,
          left: P
        } = U.getBoundingClientRect();
      if (a === "if-needed" && y >= 0 && N >= 0 && C <= h && b <= m && y >= S && C <= ae && N >= P && b <= R) return X;
      const D = getComputedStyle(U),
        O = parseInt(D.borderLeftWidth, 10),
        A = parseInt(D.borderTopWidth, 10),
        E = parseInt(D.borderRightWidth, 10),
        G = parseInt(D.borderBottomWidth, 10);
      let B = 0,
        Q = 0;
      const ie = "offsetWidth" in U ? U.offsetWidth - U.clientWidth - O - E : 0,
        $ = "offsetHeight" in U ? U.offsetHeight - U.clientHeight - A - G : 0,
        je = "offsetWidth" in U ? U.offsetWidth === 0 ? 0 : Z / U.offsetWidth : 0,
        J = "offsetHeight" in U ? U.offsetHeight === 0 ? 0 : de / U.offsetHeight : 0;
      if (g === U) B = i === "start" ? H : i === "end" ? H - h : i === "nearest" ? ts(v, v + h, h, A, G, v + H, v + H + _, _) : H - h / 2, Q = l === "start" ? Y : l === "center" ? Y - m / 2 : l === "end" ? Y - m : ts(j, j + m, m, O, E, j + Y, j + Y + k, k), B = Math.max(0, B + v), Q = Math.max(0, Q + j);else {
        B = i === "start" ? H - S - A : i === "end" ? H - ae + G + $ : i === "nearest" ? ts(S, ae, de, A, G + $, H, H + _, _) : H - (S + de / 2) + $ / 2, Q = l === "start" ? Y - P - O : l === "center" ? Y - (P + Z / 2) + ie / 2 : l === "end" ? Y - R + E + ie : ts(P, R, Z, O, E + ie, Y, Y + k, k);
        const {
          scrollLeft: Ce,
          scrollTop: Ne
        } = U;
        B = J === 0 ? 0 : Math.max(0, Math.min(Ne + B / J, U.scrollHeight - de / J + $)), Q = je === 0 ? 0 : Math.max(0, Math.min(Ce + Q / je, U.scrollWidth - Z / je + ie)), H += Ne - B, Y += Ce - Q;
      }
      X.push({
        el: U,
        top: B,
        left: Q
      });
    }
    return X;
  };
var bj = 0;
function ql(e) {
  return typeof e == "function" ? e : tt;
}
function tt() {}
function Td(e, t) {
  if (e) {
    var n = Mj(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function (r) {
      var o = r.el,
        s = r.top,
        a = r.left;
      o.scrollTop = s, o.scrollLeft = a;
    });
  }
}
function Kl(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Xa(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var s = arguments.length, a = new Array(s), i = 0; i < s; i++) a[i] = arguments[i];
    r(), n = setTimeout(function () {
      n = null, e.apply(void 0, a);
    }, t);
  }
  return o.cancel = r, o;
}
function Ve() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return function (r) {
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++) s[a - 1] = arguments[a];
    return t.some(function (i) {
      return i && i.apply(void 0, [r].concat(s)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Fn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return function (r) {
    t.forEach(function (o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function Dd() {
  return String(bj++);
}
function Od(e) {
  var t = e.isOpen,
    n = e.resultCount,
    r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Zl(e, t) {
  return e = Array.isArray(e) ? (/* istanbul ignore next (preact) */
  e[0]) : e, !e && t ? t : e;
}
function Ad(e) {
  return typeof e.type == "string";
}
function $d(e) {
  return e.props;
}
function wj(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var Cj = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function ns(e) {
  e === void 0 && (e = {});
  var t = {};
  return Cj.forEach(function (n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function ws(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function (n, r) {
    return n[r] = Cs(t, r) ? t[r] : e[r], n;
  }, {});
}
function Cs(e, t) {
  return e[t] !== void 0;
}
function la(e) {
  var t = e.key,
    n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function Nj(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function jn(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (s === 0) return -1;
  var a = s - 1;
  (typeof e != "number" || e < 0 || e > a) && (e = t > 0 ? -1 : a + 1);
  var i = e + t;
  i < 0 ? i = o ? a : 0 : i > a && (i = o ? 0 : a);
  var l = Zn(i, t < 0, n, r, o);
  return l === -1 ? e >= s ? -1 : e : l;
}
function Zn(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (t) {
    for (var a = e; a >= 0; a--) if (!r(n[a], a)) return a;
  } else for (var i = e; i < s; i++) if (!r(n[i], i)) return i;
  return o ? Zn(t ? s - 1 : 0, t, n, r) : -1;
}
function Ns(e, t, n, r) {
  return r === void 0 && (r = !0), n && t.some(function (o) {
    return o && (Kl(o, e, n) || r && Kl(o, n.document.activeElement, n));
  });
}
var ei = tt;
process.env.NODE_ENV !== "production" && (ei = function (t, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function (s) {
    n[s] !== void 0 && r[s] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + s + '" to be uncontrolled. ' + o) : n[s] === void 0 && r[s] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + s + '" to be controlled. ' + o);
  });
});
var Ij = Xa(function (e) {
  Ld(e).textContent = "";
}, 500);
function Ld(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function zd(e, t) {
  if (!(!e || !t)) {
    var n = Ld(t);
    n.textContent = e, Ij(t);
  }
}
var Rd = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0,
  Pd = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1,
  Vd = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2,
  us = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3,
  ds = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4,
  Fd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5,
  Ud = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6,
  Yd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7,
  Wd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8,
  Bd = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9,
  Hd = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10,
  Qd = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11,
  qd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12,
  ca = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13,
  Kd = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14,
  Zd = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15,
  Gd = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16,
  Ej = /* @__PURE__ */Object.freeze({
    __proto__: null,
    unknown: Rd,
    mouseUp: Pd,
    itemMouseEnter: Vd,
    keyDownArrowUp: us,
    keyDownArrowDown: ds,
    keyDownEscape: Fd,
    keyDownEnter: Ud,
    keyDownHome: Yd,
    keyDownEnd: Wd,
    clickItem: Bd,
    blurInput: Hd,
    changeInput: Qd,
    keyDownSpaceButton: qd,
    clickButton: ca,
    blurButton: Kd,
    controlledPropUpdatedSelectedItem: Zd,
    touchEnd: Gd
  }),
  Sj = ["refKey", "ref"],
  Tj = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  Dj = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  Oj = ["refKey", "ref"],
  Aj = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
  $j = /* @__PURE__ */function () {
    var e = /* @__PURE__ */function (t) {
      Ws(n, t);
      function n(o) {
        var s;
        s = t.call(this, o) || this, s.id = s.props.id || "downshift-" + Dd(), s.menuId = s.props.menuId || s.id + "-menu", s.labelId = s.props.labelId || s.id + "-label", s.inputId = s.props.inputId || s.id + "-input", s.getItemId = s.props.getItemId || function (v) {
          return s.id + "-item-" + v;
        }, s.items = [], s.itemCount = null, s.previousResultCount = 0, s.timeoutIds = [], s.internalSetTimeout = function (v, _) {
          var k = setTimeout(function () {
            s.timeoutIds = s.timeoutIds.filter(function (y) {
              return y !== k;
            }), v();
          }, _);
          s.timeoutIds.push(k);
        }, s.setItemCount = function (v) {
          s.itemCount = v;
        }, s.unsetItemCount = function () {
          s.itemCount = null;
        }, s.isItemDisabled = function (v, _) {
          var k = s.getItemNodeFromIndex(_);
          return k && k.hasAttribute("disabled");
        }, s.setHighlightedIndex = function (v, _) {
          v === void 0 && (v = s.props.defaultHighlightedIndex), _ === void 0 && (_ = {}), _ = ns(_), s.internalSetState(V({
            highlightedIndex: v
          }, _));
        }, s.clearSelection = function (v) {
          s.internalSetState({
            selectedItem: null,
            inputValue: "",
            highlightedIndex: s.props.defaultHighlightedIndex,
            isOpen: s.props.defaultIsOpen
          }, v);
        }, s.selectItem = function (v, _, k) {
          _ = ns(_), s.internalSetState(V({
            isOpen: s.props.defaultIsOpen,
            highlightedIndex: s.props.defaultHighlightedIndex,
            selectedItem: v,
            inputValue: s.props.itemToString(v)
          }, _), k);
        }, s.selectItemAtIndex = function (v, _, k) {
          var y = s.items[v];
          y != null && s.selectItem(y, _, k);
        }, s.selectHighlightedItem = function (v, _) {
          return s.selectItemAtIndex(s.getState().highlightedIndex, v, _);
        }, s.internalSetState = function (v, _) {
          var k,
            y,
            b = {},
            C = typeof v == "function";
          return !C && v.hasOwnProperty("inputValue") && s.props.onInputValueChange(v.inputValue, V({}, s.getStateAndHelpers(), v)), s.setState(function (N) {
            var T;
            N = s.getState(N);
            var z = C ? v(N) : v;
            z = s.props.stateReducer(N, z), k = z.hasOwnProperty("selectedItem");
            var K = {};
            return k && z.selectedItem !== N.selectedItem && (y = z.selectedItem), (T = z).type || (T.type = Rd), Object.keys(z).forEach(function (L) {
              N[L] !== z[L] && (b[L] = z[L]), L !== "type" && (z[L], Cs(s.props, L) || (K[L] = z[L]));
            }), C && z.hasOwnProperty("inputValue") && s.props.onInputValueChange(z.inputValue, V({}, s.getStateAndHelpers(), z)), K;
          }, function () {
            ql(_)();
            var N = Object.keys(b).length > 1;
            N && s.props.onStateChange(b, s.getStateAndHelpers()), k && s.props.onSelect(v.selectedItem, s.getStateAndHelpers()), y !== void 0 && s.props.onChange(y, s.getStateAndHelpers()), s.props.onUserAction(b, s.getStateAndHelpers());
          });
        }, s.rootRef = function (v) {
          return s._rootNode = v;
        }, s.getRootProps = function (v, _) {
          var k,
            y = v === void 0 ? {} : v,
            b = y.refKey,
            C = b === void 0 ? "ref" : b,
            N = y.ref,
            T = st(y, Sj),
            z = _ === void 0 ? {} : _,
            K = z.suppressRefError,
            L = K === void 0 ? !1 : K;
          s.getRootProps.called = !0, s.getRootProps.refKey = C, s.getRootProps.suppressRefError = L;
          var H = s.getState(),
            Y = H.isOpen;
          return V((k = {}, k[C] = Fn(N, s.rootRef), k.role = "combobox", k["aria-expanded"] = Y, k["aria-haspopup"] = "listbox", k["aria-owns"] = Y ? s.menuId : void 0, k["aria-labelledby"] = s.labelId, k), T);
        }, s.keyDownHandlers = {
          ArrowDown: function (_) {
            var k = this;
            if (_.preventDefault(), this.getState().isOpen) {
              var y = _.shiftKey ? 5 : 1;
              this.moveHighlightedIndex(y, {
                type: ds
              });
            } else this.internalSetState({
              isOpen: !0,
              type: ds
            }, function () {
              var b = k.getItemCount();
              if (b > 0) {
                var C = k.getState(),
                  N = C.highlightedIndex,
                  T = jn(N, 1, {
                    length: b
                  }, k.isItemDisabled, !0);
                k.setHighlightedIndex(T, {
                  type: ds
                });
              }
            });
          },
          ArrowUp: function (_) {
            var k = this;
            if (_.preventDefault(), this.getState().isOpen) {
              var y = _.shiftKey ? -5 : -1;
              this.moveHighlightedIndex(y, {
                type: us
              });
            } else this.internalSetState({
              isOpen: !0,
              type: us
            }, function () {
              var b = k.getItemCount();
              if (b > 0) {
                var C = k.getState(),
                  N = C.highlightedIndex,
                  T = jn(N, -1, {
                    length: b
                  }, k.isItemDisabled, !0);
                k.setHighlightedIndex(T, {
                  type: us
                });
              }
            });
          },
          Enter: function (_) {
            if (_.which !== 229) {
              var k = this.getState(),
                y = k.isOpen,
                b = k.highlightedIndex;
              if (y && b != null) {
                _.preventDefault();
                var C = this.items[b],
                  N = this.getItemNodeFromIndex(b);
                if (C == null || N && N.hasAttribute("disabled")) return;
                this.selectHighlightedItem({
                  type: Ud
                });
              }
            }
          },
          Escape: function (_) {
            _.preventDefault(), this.reset(V({
              type: Fd
            }, !this.state.isOpen && {
              selectedItem: null,
              inputValue: ""
            }));
          }
        }, s.buttonKeyDownHandlers = V({}, s.keyDownHandlers, {
          " ": function (_) {
            _.preventDefault(), this.toggleMenu({
              type: qd
            });
          }
        }), s.inputKeyDownHandlers = V({}, s.keyDownHandlers, {
          Home: function (_) {
            var k = this.getState(),
              y = k.isOpen;
            if (y) {
              _.preventDefault();
              var b = this.getItemCount();
              if (!(b <= 0 || !y)) {
                var C = Zn(0, !1, {
                  length: b
                }, this.isItemDisabled);
                this.setHighlightedIndex(C, {
                  type: Yd
                });
              }
            }
          },
          End: function (_) {
            var k = this.getState(),
              y = k.isOpen;
            if (y) {
              _.preventDefault();
              var b = this.getItemCount();
              if (!(b <= 0 || !y)) {
                var C = Zn(b - 1, !0, {
                  length: b
                }, this.isItemDisabled);
                this.setHighlightedIndex(C, {
                  type: Wd
                });
              }
            }
          }
        }), s.getToggleButtonProps = function (v) {
          var _ = v === void 0 ? {} : v,
            k = _.onClick;
          _.onPress;
          var y = _.onKeyDown,
            b = _.onKeyUp,
            C = _.onBlur,
            N = st(_, Tj),
            T = s.getState(),
            z = T.isOpen,
            K = {
              onClick: Ve(k, s.buttonHandleClick),
              onKeyDown: Ve(y, s.buttonHandleKeyDown),
              onKeyUp: Ve(b, s.buttonHandleKeyUp),
              onBlur: Ve(C, s.buttonHandleBlur)
            },
            L = N.disabled ? {} : K;
          return V({
            type: "button",
            role: "button",
            "aria-label": z ? "close menu" : "open menu",
            "aria-haspopup": !0,
            "data-toggle": !0
          }, L, N);
        }, s.buttonHandleKeyUp = function (v) {
          v.preventDefault();
        }, s.buttonHandleKeyDown = function (v) {
          var _ = la(v);
          s.buttonKeyDownHandlers[_] && s.buttonKeyDownHandlers[_].call(Zo(s), v);
        }, s.buttonHandleClick = function (v) {
          if (v.preventDefault(), s.props.environment) {
            var _ = s.props.environment.document,
              k = _.body,
              y = _.activeElement;
            k && k === y && v.target.focus();
          }
          process.env.NODE_ENV === "test" ? s.toggleMenu({
            type: ca
          }) : s.internalSetTimeout(function () {
            return s.toggleMenu({
              type: ca
            });
          });
        }, s.buttonHandleBlur = function (v) {
          var _ = v.target;
          s.internalSetTimeout(function () {
            if (!(s.isMouseDown || !s.props.environment)) {
              var k = s.props.environment.document.activeElement;
              (k == null || k.id !== s.inputId) && k !== _ && s.reset({
                type: Kd
              });
            }
          });
        }, s.getLabelProps = function (v) {
          return V({
            htmlFor: s.inputId,
            id: s.labelId
          }, v);
        }, s.getInputProps = function (v) {
          var _ = v === void 0 ? {} : v,
            k = _.onKeyDown,
            y = _.onBlur,
            b = _.onChange,
            C = _.onInput;
          _.onChangeText;
          var N = st(_, Dj),
            T,
            z = {};
          T = "onChange";
          var K = s.getState(),
            L = K.inputValue,
            H = K.isOpen,
            Y = K.highlightedIndex;
          if (!N.disabled) {
            var X;
            z = (X = {}, X[T] = Ve(b, C, s.inputHandleChange), X.onKeyDown = Ve(k, s.inputHandleKeyDown), X.onBlur = Ve(y, s.inputHandleBlur), X);
          }
          return V({
            "aria-autocomplete": "list",
            "aria-activedescendant": H && typeof Y == "number" && Y >= 0 ? s.getItemId(Y) : void 0,
            "aria-controls": H ? s.menuId : void 0,
            "aria-labelledby": N && N["aria-label"] ? void 0 : s.labelId,
            // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
            autoComplete: "off",
            value: L,
            id: s.inputId
          }, z, N);
        }, s.inputHandleKeyDown = function (v) {
          var _ = la(v);
          _ && s.inputKeyDownHandlers[_] && s.inputKeyDownHandlers[_].call(Zo(s), v);
        }, s.inputHandleChange = function (v) {
          s.internalSetState({
            type: Qd,
            isOpen: !0,
            inputValue: v.target.value,
            highlightedIndex: s.props.defaultHighlightedIndex
          });
        }, s.inputHandleBlur = function () {
          s.internalSetTimeout(function () {
            var v;
            if (!(s.isMouseDown || !s.props.environment)) {
              var _ = s.props.environment.document.activeElement,
                k = (_ == null || (v = _.dataset) == null ? void 0 : v.toggle) && s._rootNode && s._rootNode.contains(_);
              k || s.reset({
                type: Hd
              });
            }
          });
        }, s.menuRef = function (v) {
          s._menuNode = v;
        }, s.getMenuProps = function (v, _) {
          var k,
            y = v === void 0 ? {} : v,
            b = y.refKey,
            C = b === void 0 ? "ref" : b,
            N = y.ref,
            T = st(y, Oj),
            z = _ === void 0 ? {} : _,
            K = z.suppressRefError,
            L = K === void 0 ? !1 : K;
          return s.getMenuProps.called = !0, s.getMenuProps.refKey = C, s.getMenuProps.suppressRefError = L, V((k = {}, k[C] = Fn(N, s.menuRef), k.role = "listbox", k["aria-labelledby"] = T && T["aria-label"] ? void 0 : s.labelId, k.id = s.menuId, k), T);
        }, s.getItemProps = function (v) {
          var _,
            k = v === void 0 ? {} : v,
            y = k.onMouseMove,
            b = k.onMouseDown,
            C = k.onClick;
          k.onPress;
          var N = k.index,
            T = k.item,
            z = T === void 0 ? process.env.NODE_ENV === "production" ? (/* istanbul ignore next */
            void 0) : wj("getItemProps", "item") : T,
            K = st(k, Aj);
          N === void 0 ? (s.items.push(z), N = s.items.indexOf(z)) : s.items[N] = z;
          var L = "onClick",
            H = C,
            Y = (_ = {
              // onMouseMove is used over onMouseEnter here. onMouseMove
              // is only triggered on actual mouse movement while onMouseEnter
              // can fire on DOM changes, interrupting keyboard navigation
              onMouseMove: Ve(y, function () {
                N !== s.getState().highlightedIndex && (s.setHighlightedIndex(N, {
                  type: Vd
                }), s.avoidScrolling = !0, s.internalSetTimeout(function () {
                  return s.avoidScrolling = !1;
                }, 250));
              }),
              onMouseDown: Ve(b, function (ne) {
                ne.preventDefault();
              })
            }, _[L] = Ve(H, function () {
              s.selectItemAtIndex(N, {
                type: Bd
              });
            }), _),
            X = K.disabled ? {
              onMouseDown: Y.onMouseDown
            } : Y;
          return V({
            id: s.getItemId(N),
            role: "option",
            "aria-selected": s.getState().highlightedIndex === N
          }, X, K);
        }, s.clearItems = function () {
          s.items = [];
        }, s.reset = function (v, _) {
          v === void 0 && (v = {}), v = ns(v), s.internalSetState(function (k) {
            var y = k.selectedItem;
            return V({
              isOpen: s.props.defaultIsOpen,
              highlightedIndex: s.props.defaultHighlightedIndex,
              inputValue: s.props.itemToString(y)
            }, v);
          }, _);
        }, s.toggleMenu = function (v, _) {
          v === void 0 && (v = {}), v = ns(v), s.internalSetState(function (k) {
            var y = k.isOpen;
            return V({
              isOpen: !y
            }, y && {
              highlightedIndex: s.props.defaultHighlightedIndex
            }, v);
          }, function () {
            var k = s.getState(),
              y = k.isOpen,
              b = k.highlightedIndex;
            y && s.getItemCount() > 0 && typeof b == "number" && s.setHighlightedIndex(b, v), ql(_)();
          });
        }, s.openMenu = function (v) {
          s.internalSetState({
            isOpen: !0
          }, v);
        }, s.closeMenu = function (v) {
          s.internalSetState({
            isOpen: !1
          }, v);
        }, s.updateStatus = Xa(function () {
          var v;
          if ((v = s.props) != null && (v = v.environment) != null && v.document) {
            var _ = s.getState(),
              k = s.items[_.highlightedIndex],
              y = s.getItemCount(),
              b = s.props.getA11yStatusMessage(V({
                itemToString: s.props.itemToString,
                previousResultCount: s.previousResultCount,
                resultCount: y,
                highlightedItem: k
              }, _));
            s.previousResultCount = y, zd(b, s.props.environment.document);
          }
        }, 200);
        var a = s.props,
          i = a.defaultHighlightedIndex,
          l = a.initialHighlightedIndex,
          c = l === void 0 ? i : l,
          d = a.defaultIsOpen,
          f = a.initialIsOpen,
          g = f === void 0 ? d : f,
          p = a.initialInputValue,
          x = p === void 0 ? "" : p,
          m = a.initialSelectedItem,
          h = m === void 0 ? null : m,
          j = s.getState({
            highlightedIndex: c,
            isOpen: g,
            inputValue: x,
            selectedItem: h
          });
        return j.selectedItem != null && s.props.initialInputValue === void 0 && (j.inputValue = s.props.itemToString(j.selectedItem)), s.state = j, s;
      }
      var r = n.prototype;
      return r.internalClearTimeouts = function () {
        this.timeoutIds.forEach(function (s) {
          clearTimeout(s);
        }), this.timeoutIds = [];
      }, r.getState = function (s) {
        return s === void 0 && (s = this.state), ws(s, this.props);
      }, r.getItemCount = function () {
        var s = this.items.length;
        return this.itemCount != null ? s = this.itemCount : this.props.itemCount !== void 0 && (s = this.props.itemCount), s;
      }, r.getItemNodeFromIndex = function (s) {
        return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(s)) : null;
      }, r.scrollHighlightedItemIntoView = function () {
        {
          var s = this.getItemNodeFromIndex(this.getState().highlightedIndex);
          this.props.scrollIntoView(s, this._menuNode);
        }
      }, r.moveHighlightedIndex = function (s, a) {
        var i = this.getItemCount(),
          l = this.getState(),
          c = l.highlightedIndex;
        if (i > 0) {
          var d = jn(c, s, {
            length: i
          }, this.isItemDisabled, !0);
          this.setHighlightedIndex(d, a);
        }
      }, r.getStateAndHelpers = function () {
        var s = this.getState(),
          a = s.highlightedIndex,
          i = s.inputValue,
          l = s.selectedItem,
          c = s.isOpen,
          d = this.props.itemToString,
          f = this.id,
          g = this.getRootProps,
          p = this.getToggleButtonProps,
          x = this.getLabelProps,
          m = this.getMenuProps,
          h = this.getInputProps,
          j = this.getItemProps,
          v = this.openMenu,
          _ = this.closeMenu,
          k = this.toggleMenu,
          y = this.selectItem,
          b = this.selectItemAtIndex,
          C = this.selectHighlightedItem,
          N = this.setHighlightedIndex,
          T = this.clearSelection,
          z = this.clearItems,
          K = this.reset,
          L = this.setItemCount,
          H = this.unsetItemCount,
          Y = this.internalSetState;
        return {
          // prop getters
          getRootProps: g,
          getToggleButtonProps: p,
          getLabelProps: x,
          getMenuProps: m,
          getInputProps: h,
          getItemProps: j,
          // actions
          reset: K,
          openMenu: v,
          closeMenu: _,
          toggleMenu: k,
          selectItem: y,
          selectItemAtIndex: b,
          selectHighlightedItem: C,
          setHighlightedIndex: N,
          clearSelection: T,
          clearItems: z,
          setItemCount: L,
          unsetItemCount: H,
          setState: Y,
          // props
          itemToString: d,
          // derived
          id: f,
          // state
          highlightedIndex: a,
          inputValue: i,
          isOpen: c,
          selectedItem: l
        };
      }, r.componentDidMount = function () {
        var s = this;
        if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Gl(this._menuNode, this.getMenuProps), !this.props.environment) this.cleanup = function () {
          s.internalClearTimeouts();
        };else {
          var a = function () {
              s.isMouseDown = !0;
            },
            i = function (p) {
              s.isMouseDown = !1;
              var x = Ns(p.target, [s._rootNode, s._menuNode], s.props.environment);
              !x && s.getState().isOpen && s.reset({
                type: Pd
              }, function () {
                return s.props.onOuterClick(s.getStateAndHelpers());
              });
            },
            l = function () {
              s.isTouchMove = !1;
            },
            c = function () {
              s.isTouchMove = !0;
            },
            d = function (p) {
              var x = Ns(p.target, [s._rootNode, s._menuNode], s.props.environment, !1);
              !s.isTouchMove && !x && s.getState().isOpen && s.reset({
                type: Gd
              }, function () {
                return s.props.onOuterClick(s.getStateAndHelpers());
              });
            },
            f = this.props.environment;
          f.addEventListener("mousedown", a), f.addEventListener("mouseup", i), f.addEventListener("touchstart", l), f.addEventListener("touchmove", c), f.addEventListener("touchend", d), this.cleanup = function () {
            s.internalClearTimeouts(), s.updateStatus.cancel(), f.removeEventListener("mousedown", a), f.removeEventListener("mouseup", i), f.removeEventListener("touchstart", l), f.removeEventListener("touchmove", c), f.removeEventListener("touchend", d);
          };
        }
      }, r.shouldScroll = function (s, a) {
        var i = this.props.highlightedIndex === void 0 ? this.getState() : this.props,
          l = i.highlightedIndex,
          c = a.highlightedIndex === void 0 ? s : a,
          d = c.highlightedIndex,
          f = l && this.getState().isOpen && !s.isOpen,
          g = l !== d;
        return f || g;
      }, r.componentDidUpdate = function (s, a) {
        process.env.NODE_ENV !== "production" && (ei(this.state, s, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Gl(this._menuNode, this.getMenuProps)), Cs(this.props, "selectedItem") && this.props.selectedItemChanged(s.selectedItem, this.props.selectedItem) && this.internalSetState({
          type: Zd,
          inputValue: this.props.itemToString(this.props.selectedItem)
        }), !this.avoidScrolling && this.shouldScroll(a, s) && this.scrollHighlightedItemIntoView(), this.updateStatus();
      }, r.componentWillUnmount = function () {
        this.cleanup();
      }, r.render = function () {
        var s = Zl(this.props.children, tt);
        this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
        var a = Zl(s(this.getStateAndHelpers()));
        if (!a) return null;
        if (this.getRootProps.called || this.props.suppressRefError) return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && Lj(a, this.getRootProps), a;
        if (Ad(a)) return /* @__PURE__ */Ot(a, this.getRootProps($d(a)));
        if (process.env.NODE_ENV !== "production") throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
      }, n;
    }(Ym);
    return e.defaultProps = {
      defaultHighlightedIndex: null,
      defaultIsOpen: !1,
      getA11yStatusMessage: Od,
      itemToString: function (n) {
        return n == null ? "" : (process.env.NODE_ENV !== "production" && Nj(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
      },
      onStateChange: tt,
      onInputValueChange: tt,
      onUserAction: tt,
      onChange: tt,
      onSelect: tt,
      onOuterClick: tt,
      selectedItemChanged: function (n, r) {
        return n !== r;
      },
      environment: (/* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window),
      stateReducer: function (n, r) {
        return r;
      },
      suppressRefError: !1,
      scrollIntoView: Td
    }, e.stateChangeTypes = Ej, e;
  }();
process.env.NODE_ENV !== "production" && ($j.propTypes = {
  children: I.func,
  defaultHighlightedIndex: I.number,
  defaultIsOpen: I.bool,
  initialHighlightedIndex: I.number,
  initialSelectedItem: I.any,
  initialInputValue: I.string,
  initialIsOpen: I.bool,
  getA11yStatusMessage: I.func,
  itemToString: I.func,
  onChange: I.func,
  onSelect: I.func,
  onStateChange: I.func,
  onInputValueChange: I.func,
  onUserAction: I.func,
  onOuterClick: I.func,
  selectedItemChanged: I.func,
  stateReducer: I.func,
  itemCount: I.number,
  id: I.string,
  environment: I.shape({
    addEventListener: I.func.isRequired,
    removeEventListener: I.func.isRequired,
    document: I.shape({
      createElement: I.func.isRequired,
      getElementById: I.func.isRequired,
      activeElement: I.any.isRequired,
      body: I.any.isRequired
    }).isRequired,
    Node: I.func.isRequired
  }),
  suppressRefError: I.bool,
  scrollIntoView: I.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: I.any,
  isOpen: I.bool,
  inputValue: I.string,
  highlightedIndex: I.number,
  labelId: I.string,
  inputId: I.string,
  menuId: I.string,
  getItemId: I.func
  /* eslint-enable react/no-unused-prop-types */
});
function Gl(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function Lj(e, t) {
  var n = t.refKey,
    r = n !== "ref",
    o = !Ad(e);
  o && !r && !Bl.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Bl.isForwardRef(e) && !$d(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var zj = ["highlightedIndex", "items", "environment"],
  Jd = {
    highlightedIndex: -1,
    isOpen: !1,
    selectedItem: null,
    inputValue: ""
  };
function Rj(e, t, n) {
  var r = e.props,
    o = e.type,
    s = {};
  Object.keys(t).forEach(function (a) {
    Pj(a, e, t, n), n[a] !== t[a] && (s[a] = n[a]);
  }), r.onStateChange && Object.keys(s).length && r.onStateChange(V({
    type: o
  }, s));
}
function Pj(e, t, n, r) {
  var o = t.props,
    s = t.type,
    a = "on" + ti(e) + "Change";
  o[a] && r[e] !== void 0 && r[e] !== n[e] && o[a](V({
    type: s
  }, r));
}
function Vj(e, t) {
  return t.changes;
}
function Fj(e) {
  var t = e.selectedItem,
    n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var Uj = Xa(function (e, t) {
    zd(e(), t);
  }, 200),
  Yj = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Da : fe,
  Wj = "useId" in te ? function (t) {
    var n = t.id,
      r = t.labelId,
      o = t.menuId,
      s = t.getItemId,
      a = t.toggleButtonId,
      i = t.inputId,
      l = "downshift-" + te.useId();
    n || (n = l);
    var c = ee({
      labelId: r || n + "-label",
      menuId: o || n + "-menu",
      getItemId: s || function (d) {
        return n + "-item-" + d;
      },
      toggleButtonId: a || n + "-toggle-button",
      inputId: i || n + "-input"
    });
    return c.current;
  } : function (t) {
    var n = t.id,
      r = n === void 0 ? "downshift-" + Dd() : n,
      o = t.labelId,
      s = t.menuId,
      a = t.getItemId,
      i = t.toggleButtonId,
      l = t.inputId,
      c = ee({
        labelId: o || r + "-label",
        menuId: s || r + "-menu",
        getItemId: a || function (d) {
          return r + "-item-" + d;
        },
        toggleButtonId: i || r + "-toggle-button",
        inputId: l || r + "-input"
      });
    return c.current;
  };
function Bj(e, t, n, r) {
  var o, s;
  if (e === void 0) {
    if (t === void 0) throw new Error(r);
    o = n[t], s = t;
  } else s = t === void 0 ? n.indexOf(e) : t, o = e;
  return [o, s];
}
function ti(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Xd(e) {
  var t = ee(e);
  return t.current = e, t;
}
function Hj(e, t, n, r) {
  var o = ee(),
    s = ee(),
    a = ge(function (p, x) {
      s.current = x, p = ws(p, x.props);
      var m = e(p, x),
        h = x.props.stateReducer(p, V({}, x, {
          changes: m
        }));
      return h;
    }, [e]),
    i = $r(a, t, n),
    l = i[0],
    c = i[1],
    d = Xd(t),
    f = ge(function (p) {
      return c(V({
        props: d.current
      }, p));
    }, [d]),
    g = s.current;
  return fe(function () {
    var p = ws(o.current, g == null ? void 0 : g.props),
      x = g && o.current && !r(p, l);
    x && Rj(g, p, l), o.current = l;
  }, [l, g, r]), [l, f];
}
var Un = {
  itemToString: function (t) {
    return t ? String(t) : "";
  },
  itemToKey: function (t) {
    return t;
  },
  stateReducer: Vj,
  getA11ySelectionMessage: Fj,
  scrollIntoView: Td,
  environment: (/* istanbul ignore next (ssr) */
  typeof window > "u" ? void 0 : window)
};
function xt(e, t, n) {
  n === void 0 && (n = Jd);
  var r = e["default" + ti(t)];
  return r !== void 0 ? r : n[t];
}
function fr(e, t, n) {
  n === void 0 && (n = Jd);
  var r = e[t];
  if (r !== void 0) return r;
  var o = e["initial" + ti(t)];
  return o !== void 0 ? o : xt(e, t, n);
}
function Qj(e) {
  var t = fr(e, "selectedItem"),
    n = fr(e, "isOpen"),
    r = fr(e, "highlightedIndex"),
    o = fr(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.findIndex(function (s) {
      return e.itemToKey(s) === e.itemToKey(t);
    }) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: o
  };
}
function gr(e, t, n) {
  var r = e.items,
    o = e.initialHighlightedIndex,
    s = e.defaultHighlightedIndex,
    a = e.itemToKey,
    i = t.selectedItem,
    l = t.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && l === o ? o : s !== void 0 ? s : i ? r.findIndex(function (c) {
    return a(i) === a(c);
  }) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function qj(e, t, n) {
  var r = ee({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return fe(function () {
    if (!e) return tt;
    var o = t.map(function (d) {
      return d.current;
    });
    function s() {
      r.current.isTouchEnd = !1, r.current.isMouseDown = !0;
    }
    function a(d) {
      r.current.isMouseDown = !1, Ns(d.target, o, e) || n();
    }
    function i() {
      r.current.isTouchEnd = !1, r.current.isTouchMove = !1;
    }
    function l() {
      r.current.isTouchMove = !0;
    }
    function c(d) {
      r.current.isTouchEnd = !0, !r.current.isTouchMove && !Ns(d.target, o, e, !1) && n();
    }
    return e.addEventListener("mousedown", s), e.addEventListener("mouseup", a), e.addEventListener("touchstart", i), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function () {
      e.removeEventListener("mousedown", s), e.removeEventListener("mouseup", a), e.removeEventListener("touchstart", i), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [e, n]), r.current;
}
var ef = function () {
  return tt;
};
process.env.NODE_ENV !== "production" && (ef = function () {
  for (var t = ee(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
  var s = ee(r.reduce(function (i, l) {
    return i[l] = {}, i;
  }, {}));
  fe(function () {
    Object.keys(s.current).forEach(function (i) {
      var l = s.current[i];
      if (t.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + i + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError,
        d = l.refKey,
        f = l.elementRef;
      (!f || !f.current) && !c && console.error('downshift: The ref prop "' + d + '" from ' + i + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var a = ge(function (i, l, c, d) {
    s.current[i] = {
      suppressRefError: l,
      refKey: c,
      elementRef: d
    };
  }, []);
  return a;
});
function Jl(e, t, n) {
  var r = n.highlightedIndex,
    o = n.items,
    s = n.environment,
    a = st(n, zj),
    i = Js();
  fe(function () {
    i || !(s != null && s.document) || Uj(function () {
      return e(V({
        highlightedIndex: r,
        highlightedItem: o[r],
        resultCount: o.length
      }, a));
    }, s.document);
  }, t);
}
function Kj(e) {
  var t = e.highlightedIndex,
    n = e.isOpen,
    r = e.itemRefs,
    o = e.getItemNodeFromIndex,
    s = e.menuElement,
    a = e.scrollIntoView,
    i = ee(!0);
  return Yj(function () {
    t < 0 || !n || !Object.keys(r.current).length || (i.current === !1 ? i.current = !0 : a(o(t), s));
  }, [t]), i;
}
var tf = tt;
process.env.NODE_ENV !== "production" && (tf = function (t) {
  var n = t.props,
    r = t.state,
    o = ee(n),
    s = Js();
  fe(function () {
    s || (ei(r, o.current, n), o.current = n);
  }, [r, n, s]);
});
function Xl(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return V({
    isOpen: !1,
    highlightedIndex: -1
  }, o && V({
    selectedItem: e.items[t],
    isOpen: xt(e, "isOpen"),
    highlightedIndex: xt(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function Zj(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function Js() {
  var e = te.useRef(!0);
  return te.useEffect(function () {
    return e.current = !1, function () {
      e.current = !0;
    };
  }, []), e.current;
}
var nf = {
    environment: I.shape({
      addEventListener: I.func.isRequired,
      removeEventListener: I.func.isRequired,
      document: I.shape({
        createElement: I.func.isRequired,
        getElementById: I.func.isRequired,
        activeElement: I.any.isRequired,
        body: I.any.isRequired
      }).isRequired,
      Node: I.func.isRequired
    }),
    itemToString: I.func,
    itemToKey: I.func,
    stateReducer: I.func
  },
  rf = V({}, nf, {
    getA11yStatusMessage: I.func,
    highlightedIndex: I.number,
    defaultHighlightedIndex: I.number,
    initialHighlightedIndex: I.number,
    isOpen: I.bool,
    defaultIsOpen: I.bool,
    initialIsOpen: I.bool,
    selectedItem: I.any,
    initialSelectedItem: I.any,
    defaultSelectedItem: I.any,
    id: I.string,
    labelId: I.string,
    menuId: I.string,
    getItemId: I.func,
    toggleButtonId: I.string,
    onSelectedItemChange: I.func,
    onHighlightedIndexChange: I.func,
    onStateChange: I.func,
    onIsOpenChange: I.func,
    scrollIntoView: I.func
  });
function Gj(e, t, n) {
  var r = t.type,
    o = t.props,
    s;
  switch (r) {
    case n.ItemMouseMove:
      s = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      s = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : gr(o, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      s = {
        isOpen: !0,
        highlightedIndex: gr(o, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      s = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      s = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      s = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      s = {
        highlightedIndex: xt(o, "highlightedIndex"),
        isOpen: xt(o, "isOpen"),
        selectedItem: xt(o, "selectedItem"),
        inputValue: xt(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return V({}, e, s);
}
Le(Le({}, rf), {
  items: I.array.isRequired,
  isItemDisabled: I.func,
  getA11ySelectionMessage: I.func
});
function Jj(e) {
  var t = e.isOpen,
    n = e.resultCount,
    r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
Le(Le({}, Un), {
  getA11yStatusMessage: Jj,
  isItemDisabled: function () {
    return !1;
  }
});
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var ni = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0,
  ri = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1,
  si = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2,
  oi = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3,
  ai = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4,
  ii = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5,
  li = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6,
  ci = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7,
  ui = process.env.NODE_ENV !== "production" ? "__input_change__" : 8,
  Is = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9,
  di = process.env.NODE_ENV !== "production" ? "__input_click__" : 10,
  sf = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11,
  of = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12,
  fi = process.env.NODE_ENV !== "production" ? "__item_click__" : 13,
  af = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14,
  lf = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15,
  cf = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16,
  uf = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17,
  df = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18,
  pi = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19,
  ff = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20,
  pf = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21,
  mi = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22,
  mf = /* @__PURE__ */Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: ni,
    InputKeyDownArrowUp: ri,
    InputKeyDownEscape: si,
    InputKeyDownHome: oi,
    InputKeyDownEnd: ai,
    InputKeyDownPageUp: ii,
    InputKeyDownPageDown: li,
    InputKeyDownEnter: ci,
    InputChange: ui,
    InputBlur: Is,
    InputClick: di,
    MenuMouseLeave: sf,
    ItemMouseMove: of,
    ItemClick: fi,
    ToggleButtonClick: af,
    FunctionToggleMenu: lf,
    FunctionOpenMenu: cf,
    FunctionCloseMenu: uf,
    FunctionSetHighlightedIndex: df,
    FunctionSelectItem: pi,
    FunctionSetInputValue: ff,
    FunctionReset: pf,
    ControlledPropUpdatedSelectedItem: mi
  });
function Xj(e) {
  var t = Qj(e),
    n = t.selectedItem,
    r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), V({}, t, {
    inputValue: r
  });
}
var ey = V({}, rf, {
  items: I.array.isRequired,
  isItemDisabled: I.func,
  selectedItemChanged: I.func,
  getA11ySelectionMessage: I.func,
  inputValue: I.string,
  defaultInputValue: I.string,
  initialInputValue: I.string,
  inputId: I.string,
  onInputValueChange: I.func
});
function ty(e, t, n, r) {
  var o = ee(),
    s = Hj(e, t, n, r),
    a = s[0],
    i = s[1],
    l = Js();
  return fe(function () {
    if (Cs(t, "selectedItem")) {
      if (!l) {
        var c;
        t.selectedItemChanged === void 0 ? c = t.itemToKey(t.selectedItem) !== t.itemToKey(o.current) : (console.warn('The "selectedItemChanged" is deprecated. Please use "itemToKey instead". https://github.com/downshift-js/downshift/blob/master/src/hooks/useCombobox/README.md#selecteditemchanged'), c = t.selectedItemChanged(o.current, t.selectedItem)), c && i({
          type: mi,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      o.current = a.selectedItem === o.current ? t.selectedItem : a.selectedItem;
    }
  }, [a.selectedItem, t.selectedItem]), [ws(a, t), i];
}
var gf = tt;
process.env.NODE_ENV !== "production" && (gf = function (t, n) {
  I.checkPropTypes(ey, t, "prop", n.name);
});
var ny = V({}, Un, {
  getA11yStatusMessage: Od,
  isItemDisabled: function () {
    return !1;
  }
});
function ry(e, t) {
  var n,
    r = t.type,
    o = t.props,
    s = t.altKey,
    a;
  switch (r) {
    case fi:
      a = {
        isOpen: xt(o, "isOpen"),
        highlightedIndex: xt(o, "highlightedIndex"),
        selectedItem: o.items[t.index],
        inputValue: o.itemToString(o.items[t.index])
      };
      break;
    case ni:
      e.isOpen ? a = {
        highlightedIndex: jn(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : a = {
        highlightedIndex: s && e.selectedItem == null ? -1 : gr(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case ri:
      e.isOpen ? s ? a = Xl(o, e.highlightedIndex) : a = {
        highlightedIndex: jn(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : a = {
        highlightedIndex: gr(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case ci:
      a = Xl(o, e.highlightedIndex);
      break;
    case si:
      a = V({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case ii:
      a = {
        highlightedIndex: jn(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case li:
      a = {
        highlightedIndex: jn(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case oi:
      a = {
        highlightedIndex: Zn(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case ai:
      a = {
        highlightedIndex: Zn(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case Is:
      a = V({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case ui:
      a = {
        isOpen: !0,
        highlightedIndex: xt(o, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case di:
      a = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : gr(o, e, 0)
      };
      break;
    case pi:
      a = {
        selectedItem: t.selectedItem,
        inputValue: o.itemToString(t.selectedItem)
      };
      break;
    case mi:
      a = {
        inputValue: t.inputValue
      };
      break;
    default:
      return Gj(e, t, mf);
  }
  return V({}, e, a);
}
var sy = ["onMouseLeave", "refKey", "ref"],
  oy = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  ay = ["onClick", "onPress", "refKey", "ref"],
  iy = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
gi.stateChangeTypes = mf;
function gi(e) {
  e === void 0 && (e = {}), gf(e, gi);
  var t = V({}, ny, e),
    n = t.items,
    r = t.scrollIntoView,
    o = t.environment,
    s = t.getA11yStatusMessage,
    a = t.getA11ySelectionMessage,
    i = t.itemToString,
    l = ty(ry, t, Xj, Zj),
    c = l[0],
    d = l[1],
    f = c.isOpen,
    g = c.highlightedIndex,
    p = c.selectedItem,
    x = c.inputValue,
    m = ee(null),
    h = ee({}),
    j = ee(null),
    v = ee(null),
    _ = Js(),
    k = Wj(t),
    y = ee(),
    b = Xd({
      state: c,
      props: t
    }),
    C = ge(function (D) {
      return h.current[k.getItemId(D)];
    }, [k]);
  Jl(s, [f, g, x, n], V({
    previousResultCount: y.current,
    items: n,
    environment: o,
    itemToString: i
  }, c)), Jl(a, [p], V({
    previousResultCount: y.current,
    items: n,
    environment: o,
    itemToString: i
  }, c));
  var N = Kj({
    menuElement: m.current,
    highlightedIndex: g,
    isOpen: f,
    itemRefs: h,
    scrollIntoView: r,
    getItemNodeFromIndex: C
  });
  tf({
    props: t,
    state: c
  }), fe(function () {
    var D = fr(t, "isOpen");
    D && j.current && j.current.focus();
  }, []), fe(function () {
    _ || (y.current = n.length);
  });
  var T = qj(o, [v, m, j], ge(function () {
      b.current.state.isOpen && d({
        type: Is,
        selectItem: !1
      });
    }, [d, b])),
    z = ef("getInputProps", "getMenuProps");
  fe(function () {
    f || (h.current = {});
  }, [f]), fe(function () {
    var D;
    !f || !(o != null && o.document) || !(j != null && (D = j.current) != null && D.focus) || o.document.activeElement !== j.current && j.current.focus();
  }, [f, o]);
  var K = it(function () {
      return {
        ArrowDown: function (O) {
          O.preventDefault(), d({
            type: ni,
            altKey: O.altKey
          });
        },
        ArrowUp: function (O) {
          O.preventDefault(), d({
            type: ri,
            altKey: O.altKey
          });
        },
        Home: function (O) {
          b.current.state.isOpen && (O.preventDefault(), d({
            type: oi
          }));
        },
        End: function (O) {
          b.current.state.isOpen && (O.preventDefault(), d({
            type: ai
          }));
        },
        Escape: function (O) {
          var A = b.current.state;
          (A.isOpen || A.inputValue || A.selectedItem || A.highlightedIndex > -1) && (O.preventDefault(), d({
            type: si
          }));
        },
        Enter: function (O) {
          var A = b.current.state;
          !A.isOpen || O.which === 229 || (O.preventDefault(), d({
            type: ci
          }));
        },
        PageUp: function (O) {
          b.current.state.isOpen && (O.preventDefault(), d({
            type: ii
          }));
        },
        PageDown: function (O) {
          b.current.state.isOpen && (O.preventDefault(), d({
            type: li
          }));
        }
      };
    }, [d, b]),
    L = ge(function (D) {
      return V({
        id: k.labelId,
        htmlFor: k.inputId
      }, D);
    }, [k]),
    H = ge(function (D, O) {
      var A,
        E = D === void 0 ? {} : D,
        G = E.onMouseLeave,
        B = E.refKey,
        Q = B === void 0 ? "ref" : B,
        ie = E.ref,
        $ = st(E, sy),
        je = O === void 0 ? {} : O,
        J = je.suppressRefError,
        Ce = J === void 0 ? !1 : J;
      return z("getMenuProps", Ce, Q, m), V((A = {}, A[Q] = Fn(ie, function (Ne) {
        m.current = Ne;
      }), A.id = k.menuId, A.role = "listbox", A["aria-labelledby"] = $ && $["aria-label"] ? void 0 : "" + k.labelId, A.onMouseLeave = Ve(G, function () {
        d({
          type: sf
        });
      }), A), $);
    }, [d, z, k]),
    Y = ge(function (D) {
      var O,
        A,
        E = D === void 0 ? {} : D,
        G = E.item,
        B = E.index,
        Q = E.refKey,
        ie = Q === void 0 ? "ref" : Q,
        $ = E.ref,
        je = E.onMouseMove,
        J = E.onMouseDown,
        Ce = E.onClick;
      E.onPress;
      var Ne = E.disabled,
        Ye = st(E, oy);
      Ne !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
      var lt = b.current,
        Be = lt.props,
        et = lt.state,
        dt = Bj(G, B, Be.items, "Pass either item or index to getItemProps!"),
        fn = dt[0],
        ft = dt[1],
        pn = Be.isItemDisabled(fn, ft),
        En = "onClick",
        mn = Ce,
        Ge = function () {
          T.isTouchEnd || ft === et.highlightedIndex || (N.current = !1, d({
            type: of,
            index: ft,
            disabled: pn
          }));
        },
        St = function () {
          d({
            type: fi,
            index: ft
          });
        },
        pt = function (ar) {
          return ar.preventDefault();
        };
      return V((O = {}, O[ie] = Fn($, function (Je) {
        Je && (h.current[k.getItemId(ft)] = Je);
      }), O["aria-disabled"] = pn, O["aria-selected"] = "" + (ft === et.highlightedIndex), O.id = k.getItemId(ft), O.role = "option", O), !pn && (A = {}, A[En] = Ve(mn, St), A), {
        onMouseMove: Ve(je, Ge),
        onMouseDown: Ve(J, pt)
      }, Ye);
    }, [d, k, b, T, N]),
    X = ge(function (D) {
      var O,
        A = D === void 0 ? {} : D,
        E = A.onClick;
      A.onPress;
      var G = A.refKey,
        B = G === void 0 ? "ref" : G,
        Q = A.ref,
        ie = st(A, ay),
        $ = b.current.state,
        je = function () {
          d({
            type: af
          });
        };
      return V((O = {}, O[B] = Fn(Q, function (J) {
        v.current = J;
      }), O["aria-controls"] = k.menuId, O["aria-expanded"] = $.isOpen, O.id = k.toggleButtonId, O.tabIndex = -1, O), !ie.disabled && V({}, {
        onClick: Ve(E, je)
      }), ie);
    }, [d, b, k]),
    ne = ge(function (D, O) {
      var A,
        E = D === void 0 ? {} : D,
        G = E.onKeyDown,
        B = E.onChange,
        Q = E.onInput,
        ie = E.onBlur;
      E.onChangeText;
      var $ = E.onClick,
        je = E.refKey,
        J = je === void 0 ? "ref" : je,
        Ce = E.ref,
        Ne = st(E, iy),
        Ye = O === void 0 ? {} : O,
        lt = Ye.suppressRefError,
        Be = lt === void 0 ? !1 : lt;
      z("getInputProps", Be, J, j);
      var et = b.current.state,
        dt = function (pt) {
          var Je = la(pt);
          Je && K[Je] && K[Je](pt);
        },
        fn = function (pt) {
          d({
            type: ui,
            inputValue: pt.target.value
          });
        },
        ft = function (pt) {
          if (o != null && o.document && et.isOpen && !T.isMouseDown) {
            var Je = pt.relatedTarget === null && o.document.activeElement !== o.document.body;
            d({
              type: Is,
              selectItem: !Je
            });
          }
        },
        pn = function () {
          d({
            type: di
          });
        },
        En = "onChange",
        mn = {};
      if (!Ne.disabled) {
        var Ge;
        mn = (Ge = {}, Ge[En] = Ve(B, Q, fn), Ge.onKeyDown = Ve(G, dt), Ge.onBlur = Ve(ie, ft), Ge.onClick = Ve($, pn), Ge);
      }
      return V((A = {}, A[J] = Fn(Ce, function (St) {
        j.current = St;
      }), A["aria-activedescendant"] = et.isOpen && et.highlightedIndex > -1 ? k.getItemId(et.highlightedIndex) : "", A["aria-autocomplete"] = "list", A["aria-controls"] = k.menuId, A["aria-expanded"] = et.isOpen, A["aria-labelledby"] = Ne && Ne["aria-label"] ? void 0 : k.labelId, A.autoComplete = "off", A.id = k.inputId, A.role = "combobox", A.value = et.inputValue, A), mn, Ne);
    }, [d, k, o, K, b, T, z]),
    U = ge(function () {
      d({
        type: lf
      });
    }, [d]),
    de = ge(function () {
      d({
        type: uf
      });
    }, [d]),
    Z = ge(function () {
      d({
        type: cf
      });
    }, [d]),
    S = ge(function (D) {
      d({
        type: df,
        highlightedIndex: D
      });
    }, [d]),
    R = ge(function (D) {
      d({
        type: pi,
        selectedItem: D
      });
    }, [d]),
    ae = ge(function (D) {
      d({
        type: ff,
        inputValue: D
      });
    }, [d]),
    P = ge(function () {
      d({
        type: pf
      });
    }, [d]);
  return {
    // prop getters.
    getItemProps: Y,
    getLabelProps: L,
    getMenuProps: H,
    getInputProps: ne,
    getToggleButtonProps: X,
    // actions.
    toggleMenu: U,
    openMenu: Z,
    closeMenu: de,
    setHighlightedIndex: S,
    setInputValue: ae,
    selectItem: R,
    reset: P,
    // state.
    highlightedIndex: g,
    isOpen: f,
    selectedItem: p,
    inputValue: x
  };
}
function ly(e) {
  var t = e.removedSelectedItem,
    n = e.itemToString;
  return n(t) + " has been removed.";
}
V({}, nf, {
  selectedItems: I.array,
  initialSelectedItems: I.array,
  defaultSelectedItems: I.array,
  getA11yRemovalMessage: I.func,
  activeIndex: I.number,
  initialActiveIndex: I.number,
  defaultActiveIndex: I.number,
  onActiveIndexChange: I.func,
  onSelectedItemsChange: I.func,
  keyNavigationNext: I.string,
  keyNavigationPrevious: I.string
});
Un.itemToString, Un.itemToKey, Un.stateReducer, Un.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var hf = {
  exports: {}
};
(function (e, t) {
  (function (n, r, o) {
    e.exports = o(), e.exports.default = o();
  })("slugify", Dt, function () {
    var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`),
      r = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
    function o(s, a) {
      if (typeof s != "string") throw new Error("slugify: string argument expected");
      a = typeof a == "string" ? {
        replacement: a
      } : a || {};
      var i = r[a.locale] || {},
        l = a.replacement === void 0 ? "-" : a.replacement,
        c = a.trim === void 0 ? !0 : a.trim,
        d = s.normalize().split("").reduce(function (f, g) {
          var p = i[g];
          return p === void 0 && (p = n[g]), p === void 0 && (p = g), p === l && (p = " "), f + p.replace(a.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
      return a.strict && (d = d.replace(/[^A-Za-z0-9\s]/g, "")), c && (d = d.trim()), d = d.replace(/\s+/g, l), a.lower && (d = d.toLowerCase()), d;
    }
    return o.extend = function (s) {
      Object.assign(n, s);
    }, o;
  });
})(hf);
var cy = hf.exports;
const uy = /* @__PURE__ */Ys(cy);
var dy = "_1ui4ujz0 _86277sl",
  fy = "_1ui4ujz1",
  py = "_1ui4ujz2",
  my = "_1ui4ujz3",
  gy = "_1ui4ujz4",
  hy = "_1ui4ujz5",
  vy = "_1ui4ujz6 _1ui4ujz4";
const _y = e => {
    const t = e.toLowerCase();
    return n => !e || n.display.toLowerCase().includes(t) || n.value.toLowerCase().includes(t);
  },
  ec = (e, t) => {
    const n = e.toLowerCase();
    return t.map(_ref42 => {
      let {
        display: o
      } = _ref42;
      return o.toLowerCase();
    }).includes(n);
  },
  jy = (e, t) => {
    const n = e.toLowerCase();
    return t.find(_ref43 => {
      let {
        display: o
      } = _ref43;
      return o.toLowerCase() === n;
    });
  },
  yy = e => `Use "${e.display}"`,
  xy = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const n = e.toLowerCase(),
      r = t.toLowerCase();
    if (n && r.includes(n)) {
      const o = r.indexOf(n),
        s = t.split(""),
        a = s.slice(0, o).join(""),
        i = s.slice(o, o + n.length).join(""),
        l = s.slice(o + n.length).join("");
      return /* @__PURE__ */u.jsxs("span", {
        children: [a, /* @__PURE__ */u.jsx("span", {
          className: py,
          children: i
        }), l]
      });
    }
    return t;
  },
  PN = ce((_ref44, g) => {
    let {
      name: e,
      id: t,
      label: n,
      disabled: r,
      options: o,
      required: s,
      error: a,
      className: i,
      variant: l = "light",
      onSelectionChange: c,
      formatCreateOption: d = yy,
      ...f
    } = _ref44;
    const [p, x] = le(o),
      [m, h] = le(null),
      j = ee(null),
      {
        isOpen: v,
        getLabelProps: _,
        getMenuProps: k,
        getInputProps: y,
        highlightedIndex: b,
        getItemProps: C,
        setInputValue: N,
        inputValue: T
      } = gi({
        selectedItem: m,
        items: p,
        onInputValueChange: _ref45 => {
          let {
            inputValue: L
          } = _ref45;
          if (typeof L < "u") {
            const H = o.filter(_y(L)),
              Y = L && L !== "" && !ec(L, o),
              X = Y ? {
                value: uy(L),
                display: L,
                isCreated: !0
              } : {
                value: "error",
                display: "",
                isCreated: !0
              };
            x(Y ? [...H, X] : H);
          }
        },
        onIsOpenChange: L => {
          const {
            isOpen: H,
            inputValue: Y
          } = L;
          if (H) return;
          const X = jy(Y ?? "", o),
            ne = Y && Y !== "" && !ec(Y, o);
          if (typeof X < "u") h(X), c(X && X.value);else if (ne) {
            const U = p[p.length - 1] ?? null;
            h(U), c(U && U.value);
          } else h(null), c(null);
        },
        itemToString: L => L ? L.display : ""
      }),
      z = ge(() => {
        h(null), x(o), N(""), c(null);
        const L = j.current ? j.current.querySelector("input") : null;
        L && L.focus();
      }, [h, x]),
      K = L => b === L ? "focus" : null;
    return /* @__PURE__ */u.jsxs("div", {
      ref: j,
      className: ye([Bs, i]),
      children: [/* @__PURE__ */u.jsxs("div", {
        className: Rr({
          disabled: r,
          invalid: !!a,
          variant: l
        }),
        children: [/* @__PURE__ */u.jsx("label", {
          className: xn({
            required: s
          }),
          ..._(),
          children: n
        }), a ? /* @__PURE__ */u.jsx("span", {
          className: Pr,
          children: a
        }) : null, /* @__PURE__ */u.jsxs(pe, {
          display: "flex",
          position: "relative",
          children: [/* @__PURE__ */u.jsx("input", {
            ref: g,
            className: dy,
            disabled: r ? !0 : void 0,
            id: t || e,
            name: e,
            required: s,
            ...f,
            ...y()
          }), m ? /* @__PURE__ */u.jsx("button", {
            className: fy,
            type: "button",
            onClick: z,
            children: /* @__PURE__ */u.jsx(lj, {
              color: "currentColor",
              height: "1rem",
              width: "1rem"
            })
          }) : null]
        })]
      }), /* @__PURE__ */u.jsx("ul", {
        ...k(),
        className: my,
        "data-state": v ? "open" : "closed",
        children: p.map((L, H) => L.isCreated ? /* @__PURE__ */u.jsx("li", {
          className: p.length === 1 ? void 0 : hy,
          children: /* @__PURE__ */u.jsxs("div", {
            className: vy,
            ...C({
              item: L,
              index: H
            }),
            "data-state": K(H),
            children: [/* @__PURE__ */u.jsx(uj, {
              color: "currentColor",
              height: "1rem",
              width: "1rem"
            }), d(L)]
          })
        }, L.value) : /* @__PURE__ */u.jsxs("li", {
          ...C({
            item: L,
            index: H
          }),
          className: gy,
          "data-state": K(H),
          children: [/* @__PURE__ */u.jsx("span", {
            className: Us,
            children: L.display
          }), /* @__PURE__ */u.jsx("span", {
            "aria-hidden": !0,
            children: xy(T, L.display)
          })]
        }, L.value))
      })]
    });
  });
var vf = "_14ttsqz4",
  _f = "_14ttsqz5",
  ky = "_14ttsqz6",
  jf = Ue({
    defaultClassName: "_14ttsqz7",
    variantClassNames: {
      radio: {
        true: "_14ttsqz8"
      },
      invalid: {
        true: "_14ttsqz9"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  });
const VN = ce((_ref46, a) => {
    let {
      id: e,
      label: t,
      error: n,
      disabled: r,
      className: o,
      ...s
    } = _ref46;
    return /* @__PURE__ */u.jsxs("label", {
      "aria-disabled": r ? !0 : void 0,
      className: ye([_f, o]),
      htmlFor: e,
      children: [/* @__PURE__ */u.jsx("input", {
        ref: a,
        className: Us,
        disabled: r ? !0 : void 0,
        id: e,
        type: "checkbox",
        ...s
      }), /* @__PURE__ */u.jsxs("div", {
        className: vf,
        children: [/* @__PURE__ */u.jsx("span", {
          className: jf({
            invalid: !!n
          }),
          children: /* @__PURE__ */u.jsx("span", {
            className: ky,
            children: /* @__PURE__ */u.jsx(Sd, {
              color: "currentColor"
            })
          })
        }), t]
      })]
    });
  }),
  My = ce((_ref47, d) => {
    let {
      id: e,
      label: t,
      name: n,
      value: r,
      error: o,
      disabled: s,
      checked: a,
      onChange: i,
      className: l,
      ...c
    } = _ref47;
    return /* @__PURE__ */u.jsxs("label", {
      "aria-disabled": s ? !0 : void 0,
      className: ye([_f, l]),
      htmlFor: e,
      children: [/* @__PURE__ */u.jsx("input", {
        ref: d,
        checked: a,
        className: Us,
        disabled: s ? !0 : void 0,
        id: e,
        name: n,
        type: "radio",
        value: r,
        onChange: () => i && r ? i(r) : null,
        ...c
      }), /* @__PURE__ */u.jsxs("div", {
        className: vf,
        children: [/* @__PURE__ */u.jsx("span", {
          className: jf({
            invalid: !!o,
            radio: !0
          })
        }), t]
      })]
    });
  });
var by = "g83y2s0",
  wy = "g83y2s1";
const FN = ce((_ref48, i) => {
  let {
    id: e,
    label: t,
    options: n,
    error: r,
    disabled: o,
    value: s,
    onChange: a
  } = _ref48;
  return /* @__PURE__ */u.jsx("div", {
    className: wy,
    children: /* @__PURE__ */u.jsxs("fieldset", {
      ref: i,
      children: [/* @__PURE__ */u.jsx(ut, {
        as: "legend",
        weight: 600,
        size: "sm",
        children: t
      }), r ? /* @__PURE__ */u.jsx("span", {
        className: by,
        children: r
      }) : null, /* @__PURE__ */u.jsx("div", {
        className: hs({
          display: "flex",
          flexDirection: "column",
          gap: "xs",
          marginBlockStart: "xs",
          position: "relative"
        }),
        children: n.map(l => /* @__PURE__ */u.jsx(My, {
          name: e,
          id: `${e}-${l.value}`,
          value: l.value,
          label: l.label,
          error: r,
          disabled: o,
          onChange: a,
          checked: s === l.value
        }, `${e}-${l.value}`))
      })]
    })
  });
});
var Cy = "_86277sa",
  Ny = "nhyzoz0",
  Iy = "nhyzoz1 _1j2kes84g",
  Ey = "nhyzoz2",
  Sy = "nhyzoz3",
  rs = {
    initial: "nhyzoz5 nhyzoz4",
    busy: "nhyzoz6 nhyzoz4",
    valid: "nhyzoz7 nhyzoz4",
    invalid: "nhyzoz8 nhyzoz4"
  },
  Ty = "nhyzoz9",
  Dy = "Expected a function",
  tc = 0 / 0,
  Oy = "[object Symbol]",
  Ay = /^\s+|\s+$/g,
  $y = /^[-+]0x[0-9a-f]+$/i,
  Ly = /^0b[01]+$/i,
  zy = /^0o[0-7]+$/i,
  Ry = parseInt,
  Py = typeof Dt == "object" && Dt && Dt.Object === Object && Dt,
  Vy = typeof self == "object" && self && self.Object === Object && self,
  Fy = Py || Vy || Function("return this")(),
  Uy = Object.prototype,
  Yy = Uy.toString,
  Wy = Math.max,
  By = Math.min,
  To = function () {
    return Fy.Date.now();
  };
function Hy(e, t, n) {
  var r,
    o,
    s,
    a,
    i,
    l,
    c = 0,
    d = !1,
    f = !1,
    g = !0;
  if (typeof e != "function") throw new TypeError(Dy);
  t = nc(t) || 0, ua(n) && (d = !!n.leading, f = "maxWait" in n, s = f ? Wy(nc(n.maxWait) || 0, t) : s, g = "trailing" in n ? !!n.trailing : g);
  function p(b) {
    var C = r,
      N = o;
    return r = o = void 0, c = b, a = e.apply(N, C), a;
  }
  function x(b) {
    return c = b, i = setTimeout(j, t), d ? p(b) : a;
  }
  function m(b) {
    var C = b - l,
      N = b - c,
      T = t - C;
    return f ? By(T, s - N) : T;
  }
  function h(b) {
    var C = b - l,
      N = b - c;
    return l === void 0 || C >= t || C < 0 || f && N >= s;
  }
  function j() {
    var b = To();
    if (h(b)) return v(b);
    i = setTimeout(j, m(b));
  }
  function v(b) {
    return i = void 0, g && r ? p(b) : (r = o = void 0, a);
  }
  function _() {
    i !== void 0 && clearTimeout(i), c = 0, r = l = o = i = void 0;
  }
  function k() {
    return i === void 0 ? a : v(To());
  }
  function y() {
    var b = To(),
      C = h(b);
    if (r = arguments, o = this, l = b, C) {
      if (i === void 0) return x(l);
      if (f) return i = setTimeout(j, t), p(l);
    }
    return i === void 0 && (i = setTimeout(j, t)), a;
  }
  return y.cancel = _, y.flush = k, y;
}
function ua(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Qy(e) {
  return !!e && typeof e == "object";
}
function qy(e) {
  return typeof e == "symbol" || Qy(e) && Yy.call(e) == Oy;
}
function nc(e) {
  if (typeof e == "number") return e;
  if (qy(e)) return tc;
  if (ua(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ua(t) ? t + "" : t;
  }
  if (typeof e != "string") return e === 0 ? e : +e;
  e = e.replace(Ay, "");
  var n = Ly.test(e);
  return n || zy.test(e) ? Ry(e.slice(2), n ? 2 : 8) : $y.test(e) ? tc : +e;
}
var Ky = Hy;
const yf = /* @__PURE__ */Ys(Ky);
var we;
(function (e) {
  e.assertEqual = o => o;
  function t(o) {}
  e.assertIs = t;
  function n(o) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = o => {
    const s = {};
    for (const a of o) s[a] = a;
    return s;
  }, e.getValidEnumValues = o => {
    const s = e.objectKeys(o).filter(i => typeof o[o[i]] != "number"),
      a = {};
    for (const i of s) a[i] = o[i];
    return e.objectValues(a);
  }, e.objectValues = o => e.objectKeys(o).map(function (s) {
    return o[s];
  }), e.objectKeys = typeof Object.keys == "function" ? o => Object.keys(o) : o => {
    const s = [];
    for (const a in o) Object.prototype.hasOwnProperty.call(o, a) && s.push(a);
    return s;
  }, e.find = (o, s) => {
    for (const a of o) if (s(a)) return a;
  }, e.isInteger = typeof Number.isInteger == "function" ? o => Number.isInteger(o) : o => typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  function r(o) {
    let s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
    return o.map(a => typeof a == "string" ? `'${a}'` : a).join(s);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (o, s) => typeof s == "bigint" ? s.toString() : s;
})(we || (we = {}));
var da;
(function (e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(da || (da = {}));
const oe = we.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]),
  Ht = e => {
    switch (typeof e) {
      case "undefined":
        return oe.undefined;
      case "string":
        return oe.string;
      case "number":
        return isNaN(e) ? oe.nan : oe.number;
      case "boolean":
        return oe.boolean;
      case "function":
        return oe.function;
      case "bigint":
        return oe.bigint;
      case "symbol":
        return oe.symbol;
      case "object":
        return Array.isArray(e) ? oe.array : e === null ? oe.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? oe.promise : typeof Map < "u" && e instanceof Map ? oe.map : typeof Set < "u" && e instanceof Set ? oe.set : typeof Date < "u" && e instanceof Date ? oe.date : oe.object;
      default:
        return oe.unknown;
    }
  },
  q = we.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]),
  Zy = e => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class at extends Error {
  constructor(t) {
    var _this;
    super(), _this = this, this.issues = [], this.addIssue = r => {
      this.issues = [...this.issues, r];
    }, this.addIssues = function () {
      let r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this.issues = [..._this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function (s) {
        return s.message;
      },
      r = {
        _errors: []
      },
      o = s => {
        for (const a of s.issues) if (a.code === "invalid_union") a.unionErrors.map(o);else if (a.code === "invalid_return_type") o(a.returnTypeError);else if (a.code === "invalid_arguments") o(a.argumentsError);else if (a.path.length === 0) r._errors.push(n(a));else {
          let i = r,
            l = 0;
          for (; l < a.path.length;) {
            const c = a.path[l];
            l === a.path.length - 1 ? (i[c] = i[c] || {
              _errors: []
            }, i[c]._errors.push(n(a))) : i[c] = i[c] || {
              _errors: []
            }, i = i[c], l++;
          }
        }
      };
    return o(this), r;
  }
  static assert(t) {
    if (!(t instanceof at)) throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, we.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n => n.message;
    const n = {},
      r = [];
    for (const o of this.issues) o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
    return {
      formErrors: r,
      fieldErrors: n
    };
  }
  get formErrors() {
    return this.flatten();
  }
}
at.create = e => new at(e);
const Gn = (e, t) => {
  let n;
  switch (e.code) {
    case q.invalid_type:
      e.received === oe.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case q.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, we.jsonStringifyReplacer)}`;
      break;
    case q.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${we.joinValues(e.keys, ", ")}`;
      break;
    case q.invalid_union:
      n = "Invalid input";
      break;
    case q.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${we.joinValues(e.options)}`;
      break;
    case q.invalid_enum_value:
      n = `Invalid enum value. Expected ${we.joinValues(e.options)}, received '${e.received}'`;
      break;
    case q.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case q.invalid_return_type:
      n = "Invalid function return type";
      break;
    case q.invalid_date:
      n = "Invalid date";
      break;
    case q.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : we.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case q.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case q.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case q.custom:
      n = "Invalid input";
      break;
    case q.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case q.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case q.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, we.assertNever(e);
  }
  return {
    message: n
  };
};
let xf = Gn;
function Gy(e) {
  xf = e;
}
function Es() {
  return xf;
}
const Ss = e => {
    const {
        data: t,
        path: n,
        errorMaps: r,
        issueData: o
      } = e,
      s = [...n, ...(o.path || [])],
      a = {
        ...o,
        path: s
      };
    if (o.message !== void 0) return {
      ...o,
      path: s,
      message: o.message
    };
    let i = "";
    const l = r.filter(c => !!c).slice().reverse();
    for (const c of l) i = c(a, {
      data: t,
      defaultError: i
    }).message;
    return {
      ...o,
      path: s,
      message: i
    };
  },
  Jy = [];
function se(e, t) {
  const n = Es(),
    r = Ss({
      issueData: t,
      data: e.data,
      path: e.path,
      errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, n, n === Gn ? void 0 : Gn
      // then global default map
      ].filter(o => !!o)
    });
  e.common.issues.push(r);
}
class He {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const o of n) {
      if (o.status === "aborted") return he;
      o.status === "dirty" && t.dirty(), r.push(o.value);
    }
    return {
      status: t.value,
      value: r
    };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const o of n) {
      const s = await o.key,
        a = await o.value;
      r.push({
        key: s,
        value: a
      });
    }
    return He.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const o of n) {
      const {
        key: s,
        value: a
      } = o;
      if (s.status === "aborted" || a.status === "aborted") return he;
      s.status === "dirty" && t.dirty(), a.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof a.value < "u" || o.alwaysSet) && (r[s.value] = a.value);
    }
    return {
      status: t.value,
      value: r
    };
  }
}
const he = Object.freeze({
    status: "aborted"
  }),
  Yn = e => ({
    status: "dirty",
    value: e
  }),
  Ze = e => ({
    status: "valid",
    value: e
  }),
  fa = e => e.status === "aborted",
  pa = e => e.status === "dirty",
  _r = e => e.status === "valid",
  jr = e => typeof Promise < "u" && e instanceof Promise;
function Ts(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function kf(e, t, n, r, o) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !o) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
}
var ue;
(function (e) {
  e.errToObj = t => typeof t == "string" ? {
    message: t
  } : t || {}, e.toString = t => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(ue || (ue = {}));
var pr, mr;
class Nt {
  constructor(t, n, r, o) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const rc = (e, t) => {
  if (_r(t)) return {
    success: !0,
    data: t.value
  };
  if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error) return this._error;
      const n = new at(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function xe(e) {
  if (!e) return {};
  const {
    errorMap: t,
    invalid_type_error: n,
    required_error: r,
    description: o
  } = e;
  if (t && (n || r)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? {
    errorMap: t,
    description: o
  } : {
    errorMap: (a, i) => {
      var l, c;
      const {
        message: d
      } = e;
      return a.code === "invalid_enum_value" ? {
        message: d ?? i.defaultError
      } : typeof i.data > "u" ? {
        message: (l = d ?? r) !== null && l !== void 0 ? l : i.defaultError
      } : a.code !== "invalid_type" ? {
        message: i.defaultError
      } : {
        message: (c = d ?? n) !== null && c !== void 0 ? c : i.defaultError
      };
    },
    description: o
  };
}
class ke {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Ht(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: Ht(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new He(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Ht(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (jr(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success) return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const o = {
        common: {
          issues: [],
          async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
          contextualErrorMap: n == null ? void 0 : n.errorMap
        },
        path: (n == null ? void 0 : n.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: t,
        parsedType: Ht(t)
      },
      s = this._parseSync({
        data: t,
        path: o.path,
        parent: o
      });
    return rc(o, s);
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success) return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
        common: {
          issues: [],
          contextualErrorMap: n == null ? void 0 : n.errorMap,
          async: !0
        },
        path: (n == null ? void 0 : n.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: t,
        parsedType: Ht(t)
      },
      o = this._parse({
        data: t,
        path: r.path,
        parent: r
      }),
      s = await (jr(o) ? o : Promise.resolve(o));
    return rc(r, s);
  }
  refine(t, n) {
    const r = o => typeof n == "string" || typeof n > "u" ? {
      message: n
    } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, s) => {
      const a = t(o),
        i = () => s.addIssue({
          code: q.custom,
          ...r(o)
        });
      return typeof Promise < "u" && a instanceof Promise ? a.then(l => l ? !0 : (i(), !1)) : a ? !0 : (i(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, o) => t(r) ? !0 : (o.addIssue(typeof n == "function" ? n(r, o) : n), !1));
  }
  _refinement(t) {
    return new jt({
      schema: this,
      typeName: me.ZodEffects,
      effect: {
        type: "refinement",
        refinement: t
      }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return Mt.create(this, this._def);
  }
  nullable() {
    return rn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return vt.create(this, this._def);
  }
  promise() {
    return Xn.create(this, this._def);
  }
  or(t) {
    return Mr.create([this, t], this._def);
  }
  and(t) {
    return br.create(this, t, this._def);
  }
  transform(t) {
    return new jt({
      ...xe(this._def),
      schema: this,
      typeName: me.ZodEffects,
      effect: {
        type: "transform",
        transform: t
      }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Er({
      ...xe(this._def),
      innerType: this,
      defaultValue: n,
      typeName: me.ZodDefault
    });
  }
  brand() {
    return new hi({
      typeName: me.ZodBranded,
      type: this,
      ...xe(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Sr({
      ...xe(this._def),
      innerType: this,
      catchValue: n,
      typeName: me.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Ur.create(this, t);
  }
  readonly() {
    return Tr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Xy = /^c[^\s-]{8,}$/i,
  ex = /^[0-9a-z]+$/,
  tx = /^[0-9A-HJKMNP-TV-Z]{26}$/,
  nx = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,
  rx = /^[a-z0-9_-]{21}$/i,
  sx = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/,
  ox = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,
  ax = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Do;
const ix = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
  lx = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
  cx = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
  Mf = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))",
  ux = new RegExp(`^${Mf}$`);
function bf(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function dx(e) {
  return new RegExp(`^${bf(e)}$`);
}
function wf(e) {
  let t = `${Mf}T${bf(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function fx(e, t) {
  return !!((t === "v4" || !t) && ix.test(e) || (t === "v6" || !t) && lx.test(e));
}
class gt extends ke {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== oe.string) {
      const s = this._getOrReturnCtx(t);
      return se(s, {
        code: q.invalid_type,
        expected: oe.string,
        received: s.parsedType
      }), he;
    }
    const r = new He();
    let o;
    for (const s of this._def.checks) if (s.kind === "min") t.data.length < s.value && (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.too_small,
      minimum: s.value,
      type: "string",
      inclusive: !0,
      exact: !1,
      message: s.message
    }), r.dirty());else if (s.kind === "max") t.data.length > s.value && (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.too_big,
      maximum: s.value,
      type: "string",
      inclusive: !0,
      exact: !1,
      message: s.message
    }), r.dirty());else if (s.kind === "length") {
      const a = t.data.length > s.value,
        i = t.data.length < s.value;
      (a || i) && (o = this._getOrReturnCtx(t, o), a ? se(o, {
        code: q.too_big,
        maximum: s.value,
        type: "string",
        inclusive: !0,
        exact: !0,
        message: s.message
      }) : i && se(o, {
        code: q.too_small,
        minimum: s.value,
        type: "string",
        inclusive: !0,
        exact: !0,
        message: s.message
      }), r.dirty());
    } else if (s.kind === "email") ox.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "email",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "emoji") Do || (Do = new RegExp(ax, "u")), Do.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "emoji",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "uuid") nx.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "uuid",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "nanoid") rx.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "nanoid",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "cuid") Xy.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "cuid",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "cuid2") ex.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "cuid2",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "ulid") tx.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "ulid",
      code: q.invalid_string,
      message: s.message
    }), r.dirty());else if (s.kind === "url") try {
      new URL(t.data);
    } catch {
      o = this._getOrReturnCtx(t, o), se(o, {
        validation: "url",
        code: q.invalid_string,
        message: s.message
      }), r.dirty();
    } else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "regex",
      code: q.invalid_string,
      message: s.message
    }), r.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: {
        includes: s.value,
        position: s.position
      },
      message: s.message
    }), r.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: {
        startsWith: s.value
      },
      message: s.message
    }), r.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: {
        endsWith: s.value
      },
      message: s.message
    }), r.dirty()) : s.kind === "datetime" ? wf(s).test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: "datetime",
      message: s.message
    }), r.dirty()) : s.kind === "date" ? ux.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: "date",
      message: s.message
    }), r.dirty()) : s.kind === "time" ? dx(s).test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.invalid_string,
      validation: "time",
      message: s.message
    }), r.dirty()) : s.kind === "duration" ? sx.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "duration",
      code: q.invalid_string,
      message: s.message
    }), r.dirty()) : s.kind === "ip" ? fx(t.data, s.version) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "ip",
      code: q.invalid_string,
      message: s.message
    }), r.dirty()) : s.kind === "base64" ? cx.test(t.data) || (o = this._getOrReturnCtx(t, o), se(o, {
      validation: "base64",
      code: q.invalid_string,
      message: s.message
    }), r.dirty()) : we.assertNever(s);
    return {
      status: r.value,
      value: t.data
    };
  }
  _regex(t, n, r) {
    return this.refinement(o => t.test(o), {
      validation: n,
      code: q.invalid_string,
      ...ue.errToObj(r)
    });
  }
  _addCheck(t) {
    return new gt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({
      kind: "email",
      ...ue.errToObj(t)
    });
  }
  url(t) {
    return this._addCheck({
      kind: "url",
      ...ue.errToObj(t)
    });
  }
  emoji(t) {
    return this._addCheck({
      kind: "emoji",
      ...ue.errToObj(t)
    });
  }
  uuid(t) {
    return this._addCheck({
      kind: "uuid",
      ...ue.errToObj(t)
    });
  }
  nanoid(t) {
    return this._addCheck({
      kind: "nanoid",
      ...ue.errToObj(t)
    });
  }
  cuid(t) {
    return this._addCheck({
      kind: "cuid",
      ...ue.errToObj(t)
    });
  }
  cuid2(t) {
    return this._addCheck({
      kind: "cuid2",
      ...ue.errToObj(t)
    });
  }
  ulid(t) {
    return this._addCheck({
      kind: "ulid",
      ...ue.errToObj(t)
    });
  }
  base64(t) {
    return this._addCheck({
      kind: "base64",
      ...ue.errToObj(t)
    });
  }
  ip(t) {
    return this._addCheck({
      kind: "ip",
      ...ue.errToObj(t)
    });
  }
  datetime(t) {
    var n, r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (r = t == null ? void 0 : t.local) !== null && r !== void 0 ? r : !1,
      ...ue.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({
      kind: "date",
      message: t
    });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...ue.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({
      kind: "duration",
      ...ue.errToObj(t)
    });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...ue.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...ue.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...ue.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...ue.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...ue.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...ue.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...ue.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, ue.errToObj(t));
  }
  trim() {
    return new gt({
      ...this._def,
      checks: [...this._def.checks, {
        kind: "trim"
      }]
    });
  }
  toLowerCase() {
    return new gt({
      ...this._def,
      checks: [...this._def.checks, {
        kind: "toLowerCase"
      }]
    });
  }
  toUpperCase() {
    return new gt({
      ...this._def,
      checks: [...this._def.checks, {
        kind: "toUpperCase"
      }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find(t => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find(t => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find(t => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find(t => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find(t => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find(t => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find(t => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find(t => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find(t => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find(t => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find(t => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find(t => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find(t => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find(t => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
gt.create = e => {
  var t;
  return new gt({
    checks: [],
    typeName: me.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...xe(e)
  });
};
function px(e, t) {
  const n = (e.toString().split(".")[1] || "").length,
    r = (t.toString().split(".")[1] || "").length,
    o = n > r ? n : r,
    s = parseInt(e.toFixed(o).replace(".", "")),
    a = parseInt(t.toFixed(o).replace(".", ""));
  return s % a / Math.pow(10, o);
}
class en extends ke {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== oe.number) {
      const s = this._getOrReturnCtx(t);
      return se(s, {
        code: q.invalid_type,
        expected: oe.number,
        received: s.parsedType
      }), he;
    }
    let r;
    const o = new He();
    for (const s of this._def.checks) s.kind === "int" ? we.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.invalid_type,
      expected: "integer",
      received: "float",
      message: s.message
    }), o.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.too_small,
      minimum: s.value,
      type: "number",
      inclusive: s.inclusive,
      exact: !1,
      message: s.message
    }), o.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.too_big,
      maximum: s.value,
      type: "number",
      inclusive: s.inclusive,
      exact: !1,
      message: s.message
    }), o.dirty()) : s.kind === "multipleOf" ? px(t.data, s.value) !== 0 && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.not_multiple_of,
      multipleOf: s.value,
      message: s.message
    }), o.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.not_finite,
      message: s.message
    }), o.dirty()) : we.assertNever(s);
    return {
      status: o.value,
      value: t.data
    };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, ue.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, ue.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, ue.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, ue.toString(n));
  }
  setLimit(t, n, r, o) {
    return new en({
      ...this._def,
      checks: [...this._def.checks, {
        kind: t,
        value: n,
        inclusive: r,
        message: ue.toString(o)
      }]
    });
  }
  _addCheck(t) {
    return new en({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: ue.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: ue.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: ue.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: ue.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: ue.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: ue.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: ue.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: ue.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: ue.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find(t => t.kind === "int" || t.kind === "multipleOf" && we.isInteger(t.value));
  }
  get isFinite() {
    let t = null,
      n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf") return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
en.create = e => new en({
  checks: [],
  typeName: me.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...xe(e)
});
class tn extends ke {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== oe.bigint) {
      const s = this._getOrReturnCtx(t);
      return se(s, {
        code: q.invalid_type,
        expected: oe.bigint,
        received: s.parsedType
      }), he;
    }
    let r;
    const o = new He();
    for (const s of this._def.checks) s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.too_small,
      type: "bigint",
      minimum: s.value,
      inclusive: s.inclusive,
      message: s.message
    }), o.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.too_big,
      type: "bigint",
      maximum: s.value,
      inclusive: s.inclusive,
      message: s.message
    }), o.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), se(r, {
      code: q.not_multiple_of,
      multipleOf: s.value,
      message: s.message
    }), o.dirty()) : we.assertNever(s);
    return {
      status: o.value,
      value: t.data
    };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, ue.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, ue.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, ue.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, ue.toString(n));
  }
  setLimit(t, n, r, o) {
    return new tn({
      ...this._def,
      checks: [...this._def.checks, {
        kind: t,
        value: n,
        inclusive: r,
        message: ue.toString(o)
      }]
    });
  }
  _addCheck(t) {
    return new tn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: ue.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: ue.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: ue.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: ue.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: ue.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
tn.create = e => {
  var t;
  return new tn({
    checks: [],
    typeName: me.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...xe(e)
  });
};
class yr extends ke {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== oe.boolean) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.boolean,
        received: r.parsedType
      }), he;
    }
    return Ze(t.data);
  }
}
yr.create = e => new yr({
  typeName: me.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...xe(e)
});
class bn extends ke {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== oe.date) {
      const s = this._getOrReturnCtx(t);
      return se(s, {
        code: q.invalid_type,
        expected: oe.date,
        received: s.parsedType
      }), he;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return se(s, {
        code: q.invalid_date
      }), he;
    }
    const r = new He();
    let o;
    for (const s of this._def.checks) s.kind === "min" ? t.data.getTime() < s.value && (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.too_small,
      message: s.message,
      inclusive: !0,
      exact: !1,
      minimum: s.value,
      type: "date"
    }), r.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (o = this._getOrReturnCtx(t, o), se(o, {
      code: q.too_big,
      message: s.message,
      inclusive: !0,
      exact: !1,
      maximum: s.value,
      type: "date"
    }), r.dirty()) : we.assertNever(s);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new bn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: ue.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: ue.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
bn.create = e => new bn({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: me.ZodDate,
  ...xe(e)
});
class Ds extends ke {
  _parse(t) {
    if (this._getType(t) !== oe.symbol) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.symbol,
        received: r.parsedType
      }), he;
    }
    return Ze(t.data);
  }
}
Ds.create = e => new Ds({
  typeName: me.ZodSymbol,
  ...xe(e)
});
class xr extends ke {
  _parse(t) {
    if (this._getType(t) !== oe.undefined) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.undefined,
        received: r.parsedType
      }), he;
    }
    return Ze(t.data);
  }
}
xr.create = e => new xr({
  typeName: me.ZodUndefined,
  ...xe(e)
});
class kr extends ke {
  _parse(t) {
    if (this._getType(t) !== oe.null) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.null,
        received: r.parsedType
      }), he;
    }
    return Ze(t.data);
  }
}
kr.create = e => new kr({
  typeName: me.ZodNull,
  ...xe(e)
});
class Jn extends ke {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Ze(t.data);
  }
}
Jn.create = e => new Jn({
  typeName: me.ZodAny,
  ...xe(e)
});
class yn extends ke {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Ze(t.data);
  }
}
yn.create = e => new yn({
  typeName: me.ZodUnknown,
  ...xe(e)
});
class zt extends ke {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return se(n, {
      code: q.invalid_type,
      expected: oe.never,
      received: n.parsedType
    }), he;
  }
}
zt.create = e => new zt({
  typeName: me.ZodNever,
  ...xe(e)
});
class Os extends ke {
  _parse(t) {
    if (this._getType(t) !== oe.undefined) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.void,
        received: r.parsedType
      }), he;
    }
    return Ze(t.data);
  }
}
Os.create = e => new Os({
  typeName: me.ZodVoid,
  ...xe(e)
});
class vt extends ke {
  _parse(t) {
    const {
        ctx: n,
        status: r
      } = this._processInputParams(t),
      o = this._def;
    if (n.parsedType !== oe.array) return se(n, {
      code: q.invalid_type,
      expected: oe.array,
      received: n.parsedType
    }), he;
    if (o.exactLength !== null) {
      const a = n.data.length > o.exactLength.value,
        i = n.data.length < o.exactLength.value;
      (a || i) && (se(n, {
        code: a ? q.too_big : q.too_small,
        minimum: i ? o.exactLength.value : void 0,
        maximum: a ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (se(n, {
      code: q.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (se(n, {
      code: q.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), n.common.async) return Promise.all([...n.data].map((a, i) => o.type._parseAsync(new Nt(n, a, n.path, i)))).then(a => He.mergeArray(r, a));
    const s = [...n.data].map((a, i) => o.type._parseSync(new Nt(n, a, n.path, i)));
    return He.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new vt({
      ...this._def,
      minLength: {
        value: t,
        message: ue.toString(n)
      }
    });
  }
  max(t, n) {
    return new vt({
      ...this._def,
      maxLength: {
        value: t,
        message: ue.toString(n)
      }
    });
  }
  length(t, n) {
    return new vt({
      ...this._def,
      exactLength: {
        value: t,
        message: ue.toString(n)
      }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
vt.create = (e, t) => new vt({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: me.ZodArray,
  ...xe(t)
});
function Pn(e) {
  if (e instanceof $e) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = Mt.create(Pn(r));
    }
    return new $e({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof vt ? new vt({
    ...e._def,
    type: Pn(e.element)
  }) : e instanceof Mt ? Mt.create(Pn(e.unwrap())) : e instanceof rn ? rn.create(Pn(e.unwrap())) : e instanceof It ? It.create(e.items.map(t => Pn(t))) : e;
}
class $e extends ke {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const t = this._def.shape(),
      n = we.objectKeys(t);
    return this._cached = {
      shape: t,
      keys: n
    };
  }
  _parse(t) {
    if (this._getType(t) !== oe.object) {
      const c = this._getOrReturnCtx(t);
      return se(c, {
        code: q.invalid_type,
        expected: oe.object,
        received: c.parsedType
      }), he;
    }
    const {
        status: r,
        ctx: o
      } = this._processInputParams(t),
      {
        shape: s,
        keys: a
      } = this._getCached(),
      i = [];
    if (!(this._def.catchall instanceof zt && this._def.unknownKeys === "strip")) for (const c in o.data) a.includes(c) || i.push(c);
    const l = [];
    for (const c of a) {
      const d = s[c],
        f = o.data[c];
      l.push({
        key: {
          status: "valid",
          value: c
        },
        value: d._parse(new Nt(o, f, o.path, c)),
        alwaysSet: c in o.data
      });
    }
    if (this._def.catchall instanceof zt) {
      const c = this._def.unknownKeys;
      if (c === "passthrough") for (const d of i) l.push({
        key: {
          status: "valid",
          value: d
        },
        value: {
          status: "valid",
          value: o.data[d]
        }
      });else if (c === "strict") i.length > 0 && (se(o, {
        code: q.unrecognized_keys,
        keys: i
      }), r.dirty());else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const d of i) {
        const f = o.data[d];
        l.push({
          key: {
            status: "valid",
            value: d
          },
          value: c._parse(new Nt(o, f, o.path, d)
          //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const d of l) {
        const f = await d.key,
          g = await d.value;
        c.push({
          key: f,
          value: g,
          alwaysSet: d.alwaysSet
        });
      }
      return c;
    }).then(c => He.mergeObjectSync(r, c)) : He.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return ue.errToObj, new $e({
      ...this._def,
      unknownKeys: "strict",
      ...(t !== void 0 ? {
        errorMap: (n, r) => {
          var o, s, a, i;
          const l = (a = (s = (o = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(o, n, r).message) !== null && a !== void 0 ? a : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (i = ue.errToObj(t).message) !== null && i !== void 0 ? i : l
          } : {
            message: l
          };
        }
      } : {})
    });
  }
  strip() {
    return new $e({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new $e({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new $e({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new $e({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: me.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({
      [t]: n
    });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new $e({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return we.objectKeys(t).forEach(r => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new $e({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return we.objectKeys(this.shape).forEach(r => {
      t[r] || (n[r] = this.shape[r]);
    }), new $e({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Pn(this);
  }
  partial(t) {
    const n = {};
    return we.objectKeys(this.shape).forEach(r => {
      const o = this.shape[r];
      t && !t[r] ? n[r] = o : n[r] = o.optional();
    }), new $e({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return we.objectKeys(this.shape).forEach(r => {
      if (t && !t[r]) n[r] = this.shape[r];else {
        let s = this.shape[r];
        for (; s instanceof Mt;) s = s._def.innerType;
        n[r] = s;
      }
    }), new $e({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Cf(we.objectKeys(this.shape));
  }
}
$e.create = (e, t) => new $e({
  shape: () => e,
  unknownKeys: "strip",
  catchall: zt.create(),
  typeName: me.ZodObject,
  ...xe(t)
});
$e.strictCreate = (e, t) => new $e({
  shape: () => e,
  unknownKeys: "strict",
  catchall: zt.create(),
  typeName: me.ZodObject,
  ...xe(t)
});
$e.lazycreate = (e, t) => new $e({
  shape: e,
  unknownKeys: "strip",
  catchall: zt.create(),
  typeName: me.ZodObject,
  ...xe(t)
});
class Mr extends ke {
  _parse(t) {
    const {
        ctx: n
      } = this._processInputParams(t),
      r = this._def.options;
    function o(s) {
      for (const i of s) if (i.result.status === "valid") return i.result;
      for (const i of s) if (i.result.status === "dirty") return n.common.issues.push(...i.ctx.common.issues), i.result;
      const a = s.map(i => new at(i.ctx.common.issues));
      return se(n, {
        code: q.invalid_union,
        unionErrors: a
      }), he;
    }
    if (n.common.async) return Promise.all(r.map(async s => {
      const a = {
        ...n,
        common: {
          ...n.common,
          issues: []
        },
        parent: null
      };
      return {
        result: await s._parseAsync({
          data: n.data,
          path: n.path,
          parent: a
        }),
        ctx: a
      };
    })).then(o);
    {
      let s;
      const a = [];
      for (const l of r) {
        const c = {
            ...n,
            common: {
              ...n.common,
              issues: []
            },
            parent: null
          },
          d = l._parseSync({
            data: n.data,
            path: n.path,
            parent: c
          });
        if (d.status === "valid") return d;
        d.status === "dirty" && !s && (s = {
          result: d,
          ctx: c
        }), c.common.issues.length && a.push(c.common.issues);
      }
      if (s) return n.common.issues.push(...s.ctx.common.issues), s.result;
      const i = a.map(l => new at(l));
      return se(n, {
        code: q.invalid_union,
        unionErrors: i
      }), he;
    }
  }
  get options() {
    return this._def.options;
  }
}
Mr.create = (e, t) => new Mr({
  options: e,
  typeName: me.ZodUnion,
  ...xe(t)
});
const Tt = e => e instanceof Cr ? Tt(e.schema) : e instanceof jt ? Tt(e.innerType()) : e instanceof Nr ? [e.value] : e instanceof nn ? e.options : e instanceof Ir ? we.objectValues(e.enum) : e instanceof Er ? Tt(e._def.innerType) : e instanceof xr ? [void 0] : e instanceof kr ? [null] : e instanceof Mt ? [void 0, ...Tt(e.unwrap())] : e instanceof rn ? [null, ...Tt(e.unwrap())] : e instanceof hi || e instanceof Tr ? Tt(e.unwrap()) : e instanceof Sr ? Tt(e._def.innerType) : [];
class Xs extends ke {
  _parse(t) {
    const {
      ctx: n
    } = this._processInputParams(t);
    if (n.parsedType !== oe.object) return se(n, {
      code: q.invalid_type,
      expected: oe.object,
      received: n.parsedType
    }), he;
    const r = this.discriminator,
      o = n.data[r],
      s = this.optionsMap.get(o);
    return s ? n.common.async ? s._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : s._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (se(n, {
      code: q.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), he);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const o = /* @__PURE__ */new Map();
    for (const s of n) {
      const a = Tt(s.shape[t]);
      if (!a.length) throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const i of a) {
        if (o.has(i)) throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(i)}`);
        o.set(i, s);
      }
    }
    return new Xs({
      typeName: me.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: o,
      ...xe(r)
    });
  }
}
function ma(e, t) {
  const n = Ht(e),
    r = Ht(t);
  if (e === t) return {
    valid: !0,
    data: e
  };
  if (n === oe.object && r === oe.object) {
    const o = we.objectKeys(t),
      s = we.objectKeys(e).filter(i => o.indexOf(i) !== -1),
      a = {
        ...e,
        ...t
      };
    for (const i of s) {
      const l = ma(e[i], t[i]);
      if (!l.valid) return {
        valid: !1
      };
      a[i] = l.data;
    }
    return {
      valid: !0,
      data: a
    };
  } else if (n === oe.array && r === oe.array) {
    if (e.length !== t.length) return {
      valid: !1
    };
    const o = [];
    for (let s = 0; s < e.length; s++) {
      const a = e[s],
        i = t[s],
        l = ma(a, i);
      if (!l.valid) return {
        valid: !1
      };
      o.push(l.data);
    }
    return {
      valid: !0,
      data: o
    };
  } else return n === oe.date && r === oe.date && +e == +t ? {
    valid: !0,
    data: e
  } : {
    valid: !1
  };
}
class br extends ke {
  _parse(t) {
    const {
        status: n,
        ctx: r
      } = this._processInputParams(t),
      o = (s, a) => {
        if (fa(s) || fa(a)) return he;
        const i = ma(s.value, a.value);
        return i.valid ? ((pa(s) || pa(a)) && n.dirty(), {
          status: n.value,
          value: i.data
        }) : (se(r, {
          code: q.invalid_intersection_types
        }), he);
      };
    return r.common.async ? Promise.all([this._def.left._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    })]).then(_ref49 => {
      let [s, a] = _ref49;
      return o(s, a);
    }) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
br.create = (e, t, n) => new br({
  left: e,
  right: t,
  typeName: me.ZodIntersection,
  ...xe(n)
});
class It extends ke {
  _parse(t) {
    const {
      status: n,
      ctx: r
    } = this._processInputParams(t);
    if (r.parsedType !== oe.array) return se(r, {
      code: q.invalid_type,
      expected: oe.array,
      received: r.parsedType
    }), he;
    if (r.data.length < this._def.items.length) return se(r, {
      code: q.too_small,
      minimum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), he;
    !this._def.rest && r.data.length > this._def.items.length && (se(r, {
      code: q.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...r.data].map((a, i) => {
      const l = this._def.items[i] || this._def.rest;
      return l ? l._parse(new Nt(r, a, r.path, i)) : null;
    }).filter(a => !!a);
    return r.common.async ? Promise.all(s).then(a => He.mergeArray(n, a)) : He.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new It({
      ...this._def,
      rest: t
    });
  }
}
It.create = (e, t) => {
  if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new It({
    items: e,
    typeName: me.ZodTuple,
    rest: null,
    ...xe(t)
  });
};
class wr extends ke {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const {
      status: n,
      ctx: r
    } = this._processInputParams(t);
    if (r.parsedType !== oe.object) return se(r, {
      code: q.invalid_type,
      expected: oe.object,
      received: r.parsedType
    }), he;
    const o = [],
      s = this._def.keyType,
      a = this._def.valueType;
    for (const i in r.data) o.push({
      key: s._parse(new Nt(r, i, r.path, i)),
      value: a._parse(new Nt(r, r.data[i], r.path, i)),
      alwaysSet: i in r.data
    });
    return r.common.async ? He.mergeObjectAsync(n, o) : He.mergeObjectSync(n, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof ke ? new wr({
      keyType: t,
      valueType: n,
      typeName: me.ZodRecord,
      ...xe(r)
    }) : new wr({
      keyType: gt.create(),
      valueType: t,
      typeName: me.ZodRecord,
      ...xe(n)
    });
  }
}
class As extends ke {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const {
      status: n,
      ctx: r
    } = this._processInputParams(t);
    if (r.parsedType !== oe.map) return se(r, {
      code: q.invalid_type,
      expected: oe.map,
      received: r.parsedType
    }), he;
    const o = this._def.keyType,
      s = this._def.valueType,
      a = [...r.data.entries()].map((_ref50, c) => {
        let [i, l] = _ref50;
        return {
          key: o._parse(new Nt(r, i, r.path, [c, "key"])),
          value: s._parse(new Nt(r, l, r.path, [c, "value"]))
        };
      });
    if (r.common.async) {
      const i = /* @__PURE__ */new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const c = await l.key,
            d = await l.value;
          if (c.status === "aborted" || d.status === "aborted") return he;
          (c.status === "dirty" || d.status === "dirty") && n.dirty(), i.set(c.value, d.value);
        }
        return {
          status: n.value,
          value: i
        };
      });
    } else {
      const i = /* @__PURE__ */new Map();
      for (const l of a) {
        const c = l.key,
          d = l.value;
        if (c.status === "aborted" || d.status === "aborted") return he;
        (c.status === "dirty" || d.status === "dirty") && n.dirty(), i.set(c.value, d.value);
      }
      return {
        status: n.value,
        value: i
      };
    }
  }
}
As.create = (e, t, n) => new As({
  valueType: t,
  keyType: e,
  typeName: me.ZodMap,
  ...xe(n)
});
class wn extends ke {
  _parse(t) {
    const {
      status: n,
      ctx: r
    } = this._processInputParams(t);
    if (r.parsedType !== oe.set) return se(r, {
      code: q.invalid_type,
      expected: oe.set,
      received: r.parsedType
    }), he;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (se(r, {
      code: q.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (se(r, {
      code: q.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function a(l) {
      const c = /* @__PURE__ */new Set();
      for (const d of l) {
        if (d.status === "aborted") return he;
        d.status === "dirty" && n.dirty(), c.add(d.value);
      }
      return {
        status: n.value,
        value: c
      };
    }
    const i = [...r.data.values()].map((l, c) => s._parse(new Nt(r, l, r.path, c)));
    return r.common.async ? Promise.all(i).then(l => a(l)) : a(i);
  }
  min(t, n) {
    return new wn({
      ...this._def,
      minSize: {
        value: t,
        message: ue.toString(n)
      }
    });
  }
  max(t, n) {
    return new wn({
      ...this._def,
      maxSize: {
        value: t,
        message: ue.toString(n)
      }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
wn.create = (e, t) => new wn({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: me.ZodSet,
  ...xe(t)
});
class Hn extends ke {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const {
      ctx: n
    } = this._processInputParams(t);
    if (n.parsedType !== oe.function) return se(n, {
      code: q.invalid_type,
      expected: oe.function,
      received: n.parsedType
    }), he;
    function r(i, l) {
      return Ss({
        data: i,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, Es(), Gn].filter(c => !!c),
        issueData: {
          code: q.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function o(i, l) {
      return Ss({
        data: i,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, Es(), Gn].filter(c => !!c),
        issueData: {
          code: q.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const s = {
        errorMap: n.common.contextualErrorMap
      },
      a = n.data;
    if (this._def.returns instanceof Xn) {
      const i = this;
      return Ze(async function () {
        for (var _len10 = arguments.length, l = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          l[_key10] = arguments[_key10];
        }
        const c = new at([]),
          d = await i._def.args.parseAsync(l, s).catch(p => {
            throw c.addIssue(r(l, p)), c;
          }),
          f = await Reflect.apply(a, this, d);
        return await i._def.returns._def.type.parseAsync(f, s).catch(p => {
          throw c.addIssue(o(f, p)), c;
        });
      });
    } else {
      const i = this;
      return Ze(function () {
        for (var _len11 = arguments.length, l = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          l[_key11] = arguments[_key11];
        }
        const c = i._def.args.safeParse(l, s);
        if (!c.success) throw new at([r(l, c.error)]);
        const d = Reflect.apply(a, this, c.data),
          f = i._def.returns.safeParse(d, s);
        if (!f.success) throw new at([o(d, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args() {
    for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      t[_key12] = arguments[_key12];
    }
    return new Hn({
      ...this._def,
      args: It.create(t).rest(yn.create())
    });
  }
  returns(t) {
    return new Hn({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Hn({
      args: t || It.create([]).rest(yn.create()),
      returns: n || yn.create(),
      typeName: me.ZodFunction,
      ...xe(r)
    });
  }
}
class Cr extends ke {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const {
      ctx: n
    } = this._processInputParams(t);
    return this._def.getter()._parse({
      data: n.data,
      path: n.path,
      parent: n
    });
  }
}
Cr.create = (e, t) => new Cr({
  getter: e,
  typeName: me.ZodLazy,
  ...xe(t)
});
class Nr extends ke {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return se(n, {
        received: n.data,
        code: q.invalid_literal,
        expected: this._def.value
      }), he;
    }
    return {
      status: "valid",
      value: t.data
    };
  }
  get value() {
    return this._def.value;
  }
}
Nr.create = (e, t) => new Nr({
  value: e,
  typeName: me.ZodLiteral,
  ...xe(t)
});
function Cf(e, t) {
  return new nn({
    values: e,
    typeName: me.ZodEnum,
    ...xe(t)
  });
}
class nn extends ke {
  constructor() {
    super(...arguments), pr.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t),
        r = this._def.values;
      return se(n, {
        expected: we.joinValues(r),
        received: n.parsedType,
        code: q.invalid_type
      }), he;
    }
    if (Ts(this, pr, "f") || kf(this, pr, new Set(this._def.values), "f"), !Ts(this, pr, "f").has(t.data)) {
      const n = this._getOrReturnCtx(t),
        r = this._def.values;
      return se(n, {
        received: n.data,
        code: q.invalid_enum_value,
        options: r
      }), he;
    }
    return Ze(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  extract(t) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._def;
    return nn.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._def;
    return nn.create(this.options.filter(r => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
pr = /* @__PURE__ */new WeakMap();
nn.create = Cf;
class Ir extends ke {
  constructor() {
    super(...arguments), mr.set(this, void 0);
  }
  _parse(t) {
    const n = we.getValidEnumValues(this._def.values),
      r = this._getOrReturnCtx(t);
    if (r.parsedType !== oe.string && r.parsedType !== oe.number) {
      const o = we.objectValues(n);
      return se(r, {
        expected: we.joinValues(o),
        received: r.parsedType,
        code: q.invalid_type
      }), he;
    }
    if (Ts(this, mr, "f") || kf(this, mr, new Set(we.getValidEnumValues(this._def.values)), "f"), !Ts(this, mr, "f").has(t.data)) {
      const o = we.objectValues(n);
      return se(r, {
        received: r.data,
        code: q.invalid_enum_value,
        options: o
      }), he;
    }
    return Ze(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
mr = /* @__PURE__ */new WeakMap();
Ir.create = (e, t) => new Ir({
  values: e,
  typeName: me.ZodNativeEnum,
  ...xe(t)
});
class Xn extends ke {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const {
      ctx: n
    } = this._processInputParams(t);
    if (n.parsedType !== oe.promise && n.common.async === !1) return se(n, {
      code: q.invalid_type,
      expected: oe.promise,
      received: n.parsedType
    }), he;
    const r = n.parsedType === oe.promise ? n.data : Promise.resolve(n.data);
    return Ze(r.then(o => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Xn.create = (e, t) => new Xn({
  type: e,
  typeName: me.ZodPromise,
  ...xe(t)
});
class jt extends ke {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === me.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const {
        status: n,
        ctx: r
      } = this._processInputParams(t),
      o = this._def.effect || null,
      s = {
        addIssue: a => {
          se(r, a), a.fatal ? n.abort() : n.dirty();
        },
        get path() {
          return r.path;
        }
      };
    if (s.addIssue = s.addIssue.bind(s), o.type === "preprocess") {
      const a = o.transform(r.data, s);
      if (r.common.async) return Promise.resolve(a).then(async i => {
        if (n.value === "aborted") return he;
        const l = await this._def.schema._parseAsync({
          data: i,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? he : l.status === "dirty" || n.value === "dirty" ? Yn(l.value) : l;
      });
      {
        if (n.value === "aborted") return he;
        const i = this._def.schema._parseSync({
          data: a,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? he : i.status === "dirty" || n.value === "dirty" ? Yn(i.value) : i;
      }
    }
    if (o.type === "refinement") {
      const a = i => {
        const l = o.refinement(i, s);
        if (r.common.async) return Promise.resolve(l);
        if (l instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return i;
      };
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? he : (i.status === "dirty" && n.dirty(), a(i.value), {
          status: n.value,
          value: i.value
        });
      } else return this._def.schema._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }).then(i => i.status === "aborted" ? he : (i.status === "dirty" && n.dirty(), a(i.value).then(() => ({
        status: n.value,
        value: i.value
      }))));
    }
    if (o.type === "transform") if (r.common.async === !1) {
      const a = this._def.schema._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      if (!_r(a)) return a;
      const i = o.transform(a.value, s);
      if (i instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
      return {
        status: n.value,
        value: i
      };
    } else return this._def.schema._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }).then(a => _r(a) ? Promise.resolve(o.transform(a.value, s)).then(i => ({
      status: n.value,
      value: i
    })) : a);
    we.assertNever(o);
  }
}
jt.create = (e, t, n) => new jt({
  schema: e,
  typeName: me.ZodEffects,
  effect: t,
  ...xe(n)
});
jt.createWithPreprocess = (e, t, n) => new jt({
  schema: t,
  effect: {
    type: "preprocess",
    transform: e
  },
  typeName: me.ZodEffects,
  ...xe(n)
});
class Mt extends ke {
  _parse(t) {
    return this._getType(t) === oe.undefined ? Ze(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Mt.create = (e, t) => new Mt({
  innerType: e,
  typeName: me.ZodOptional,
  ...xe(t)
});
class rn extends ke {
  _parse(t) {
    return this._getType(t) === oe.null ? Ze(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
rn.create = (e, t) => new rn({
  innerType: e,
  typeName: me.ZodNullable,
  ...xe(t)
});
class Er extends ke {
  _parse(t) {
    const {
      ctx: n
    } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === oe.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Er.create = (e, t) => new Er({
  innerType: e,
  typeName: me.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...xe(t)
});
class Sr extends ke {
  _parse(t) {
    const {
        ctx: n
      } = this._processInputParams(t),
      r = {
        ...n,
        common: {
          ...n.common,
          issues: []
        }
      },
      o = this._def.innerType._parse({
        data: r.data,
        path: r.path,
        parent: {
          ...r
        }
      });
    return jr(o) ? o.then(s => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new at(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new at(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Sr.create = (e, t) => new Sr({
  innerType: e,
  typeName: me.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...xe(t)
});
class $s extends ke {
  _parse(t) {
    if (this._getType(t) !== oe.nan) {
      const r = this._getOrReturnCtx(t);
      return se(r, {
        code: q.invalid_type,
        expected: oe.nan,
        received: r.parsedType
      }), he;
    }
    return {
      status: "valid",
      value: t.data
    };
  }
}
$s.create = e => new $s({
  typeName: me.ZodNaN,
  ...xe(e)
});
const mx = Symbol("zod_brand");
class hi extends ke {
  _parse(t) {
    const {
        ctx: n
      } = this._processInputParams(t),
      r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ur extends ke {
  _parse(t) {
    const {
      status: n,
      ctx: r
    } = this._processInputParams(t);
    if (r.common.async) return (async () => {
      const s = await this._def.in._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? he : s.status === "dirty" ? (n.dirty(), Yn(s.value)) : this._def.out._parseAsync({
        data: s.value,
        path: r.path,
        parent: r
      });
    })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? he : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new Ur({
      in: t,
      out: n,
      typeName: me.ZodPipeline
    });
  }
}
class Tr extends ke {
  _parse(t) {
    const n = this._def.innerType._parse(t),
      r = o => (_r(o) && (o.value = Object.freeze(o.value)), o);
    return jr(n) ? n.then(o => r(o)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Tr.create = (e, t) => new Tr({
  innerType: e,
  typeName: me.ZodReadonly,
  ...xe(t)
});
function Nf(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let n = arguments.length > 2 ? arguments[2] : undefined;
  return e ? Jn.create().superRefine((r, o) => {
    var s, a;
    if (!e(r)) {
      const i = typeof t == "function" ? t(r) : typeof t == "string" ? {
          message: t
        } : t,
        l = (a = (s = i.fatal) !== null && s !== void 0 ? s : n) !== null && a !== void 0 ? a : !0,
        c = typeof i == "string" ? {
          message: i
        } : i;
      o.addIssue({
        code: "custom",
        ...c,
        fatal: l
      });
    }
  }) : Jn.create();
}
const gx = {
  object: $e.lazycreate
};
var me;
(function (e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(me || (me = {}));
const hx = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      message: `Input not instance of ${e.name}`
    };
    return Nf(n => n instanceof e, t);
  },
  If = gt.create,
  Ef = en.create,
  vx = $s.create,
  _x = tn.create,
  Sf = yr.create,
  jx = bn.create,
  yx = Ds.create,
  xx = xr.create,
  kx = kr.create,
  Mx = Jn.create,
  bx = yn.create,
  wx = zt.create,
  Cx = Os.create,
  Nx = vt.create,
  Ix = $e.create,
  Ex = $e.strictCreate,
  Sx = Mr.create,
  Tx = Xs.create,
  Dx = br.create,
  Ox = It.create,
  Ax = wr.create,
  $x = As.create,
  Lx = wn.create,
  zx = Hn.create,
  Rx = Cr.create,
  Px = Nr.create,
  Vx = nn.create,
  Fx = Ir.create,
  Ux = Xn.create,
  sc = jt.create,
  Yx = Mt.create,
  Wx = rn.create,
  Bx = jt.createWithPreprocess,
  Hx = Ur.create,
  Qx = () => If().optional(),
  qx = () => Ef().optional(),
  Kx = () => Sf().optional(),
  Zx = {
    string: e => gt.create({
      ...e,
      coerce: !0
    }),
    number: e => en.create({
      ...e,
      coerce: !0
    }),
    boolean: e => yr.create({
      ...e,
      coerce: !0
    }),
    bigint: e => tn.create({
      ...e,
      coerce: !0
    }),
    date: e => bn.create({
      ...e,
      coerce: !0
    })
  },
  Gx = he;
var Vn = /* @__PURE__ */Object.freeze({
  __proto__: null,
  defaultErrorMap: Gn,
  setErrorMap: Gy,
  getErrorMap: Es,
  makeIssue: Ss,
  EMPTY_PATH: Jy,
  addIssueToContext: se,
  ParseStatus: He,
  INVALID: he,
  DIRTY: Yn,
  OK: Ze,
  isAborted: fa,
  isDirty: pa,
  isValid: _r,
  isAsync: jr,
  get util() {
    return we;
  },
  get objectUtil() {
    return da;
  },
  ZodParsedType: oe,
  getParsedType: Ht,
  ZodType: ke,
  datetimeRegex: wf,
  ZodString: gt,
  ZodNumber: en,
  ZodBigInt: tn,
  ZodBoolean: yr,
  ZodDate: bn,
  ZodSymbol: Ds,
  ZodUndefined: xr,
  ZodNull: kr,
  ZodAny: Jn,
  ZodUnknown: yn,
  ZodNever: zt,
  ZodVoid: Os,
  ZodArray: vt,
  ZodObject: $e,
  ZodUnion: Mr,
  ZodDiscriminatedUnion: Xs,
  ZodIntersection: br,
  ZodTuple: It,
  ZodRecord: wr,
  ZodMap: As,
  ZodSet: wn,
  ZodFunction: Hn,
  ZodLazy: Cr,
  ZodLiteral: Nr,
  ZodEnum: nn,
  ZodNativeEnum: Ir,
  ZodPromise: Xn,
  ZodEffects: jt,
  ZodTransformer: jt,
  ZodOptional: Mt,
  ZodNullable: rn,
  ZodDefault: Er,
  ZodCatch: Sr,
  ZodNaN: $s,
  BRAND: mx,
  ZodBranded: hi,
  ZodPipeline: Ur,
  ZodReadonly: Tr,
  custom: Nf,
  Schema: ke,
  ZodSchema: ke,
  late: gx,
  get ZodFirstPartyTypeKind() {
    return me;
  },
  coerce: Zx,
  any: Mx,
  array: Nx,
  bigint: _x,
  boolean: Sf,
  date: jx,
  discriminatedUnion: Tx,
  effect: sc,
  enum: Vx,
  function: zx,
  instanceof: hx,
  intersection: Dx,
  lazy: Rx,
  literal: Px,
  map: $x,
  nan: vx,
  nativeEnum: Fx,
  never: wx,
  null: kx,
  nullable: Wx,
  number: Ef,
  object: Ix,
  oboolean: Kx,
  onumber: qx,
  optional: Yx,
  ostring: Qx,
  pipeline: Hx,
  preprocess: Bx,
  promise: Ux,
  record: Ax,
  set: Lx,
  strictObject: Ex,
  string: If,
  symbol: yx,
  transformer: sc,
  tuple: Ox,
  undefined: xx,
  union: Sx,
  unknown: bx,
  void: Cx,
  NEVER: Gx,
  ZodIssueCode: q,
  quotelessJson: Zy,
  ZodError: at
});
const Jx = "https://api.secretcdn-stg.net/signup/validate";
var Yt = /* @__PURE__ */(e => (e.Length = "length", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Number = "number", e.Symbol = "symbol", e.Pattern = "pattern", e))(Yt || {});
const Xx = Vn.string().min(12, "length"
/* Length */).refine(e => /[A-Z]/.test(e), {
  message: "uppercase"
  /* Uppercase */
}).refine(e => /[a-z]/.test(e), {
  message: "lowercase"
  /* Lowercase */
}).refine(e => /\d/.test(e), {
  message: "number"
  /* Number */
}).refine(e => /[!-\/:-@[-`{-~]/.test(e), {
  message: "symbol"
  /* Symbol */
});
var Tf = /* @__PURE__ */(e => (e.Sequence = "contains_sequence", e.Word = "contains_dictionary_word", e))(Tf || {});
const ek = Vn.object({
    valid: Vn.boolean(),
    errors: Vn.object({
      password: Vn.array(Vn.nativeEnum(Tf))
    }).optional()
  }),
  tk = e => {
    const t = Xx.safeParse(e);
    return t.success ? [] : t.error.issues.map(_ref51 => {
      let {
        message: n
      } = _ref51;
      return n;
    });
  },
  nk = _ref52 => {
    let {
      url: e,
      onError: t
    } = _ref52;
    return async (n, r) => {
      var o;
      if (typeof window < "u") try {
        const s = await fetch(e, {
          method: "POST",
          body: JSON.stringify({
            password: n
          }),
          headers: {
            "Fastly-Ui-Client": "www-fastly-com",
            "Content-Type": "application/json;charset=UTF-8"
          }
        }).then(a => a.json()).then(ek.safeParse);
        return s.success && !s.data.valid && (o = s.data.errors) != null && o.password ? r(s.data.errors.password) : r([]);
      } catch (s) {
        t(s);
      }
    };
  },
  ga = {
    value: "",
    clientErrors: [],
    serverErrors: [],
    errors: [],
    asyncStatus: 0,
    touched: !1,
    hasFocus: !1,
    showValidation: !1
  },
  rk = (e, t) => {
    if (t.type === 0) {
      const n = t.payload !== ga.value,
        r = tk(t.payload),
        o = e.serverErrors.length > 0 ? ["pattern"
        /* Pattern */] : [];
      return {
        ...e,
        clientErrors: r,
        errors: [...r, ...o],
        value: t.payload,
        touched: n
      };
    }
    if (t.type === 1) {
      const n = t.payload,
        r = n.length > 0 ? ["pattern"
        /* Pattern */] : [],
        o = [...e.clientErrors, ...r];
      return {
        ...e,
        serverErrors: n,
        errors: o,
        asyncStatus: 2
        /* Fulfilled */
      };
    }
    if (t.type === 2) {
      const n = t.payload;
      return {
        ...e,
        asyncStatus: n
      };
    }
    if (t.type === 3) {
      const n = t.payload;
      let r = n;
      return !n && e.touched && e.errors.length > 0 && (r = !0), !n && e.touched && e.asyncStatus === 1 && (r = !0), {
        ...e,
        hasFocus: n,
        showValidation: r
      };
    }
    return t.type === 4 ? {
      ...e,
      showValidation: !1
    } : e;
  };
function UN() {
  let {
    url: e = Jx,
    wait: t = 1e3,
    onError: n = console.error,
    onChange: r
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [o, s] = $r(rk, ga),
    {
      value: a,
      errors: i,
      asyncStatus: l,
      touched: c,
      showValidation: d,
      hasFocus: f
    } = o,
    g = ge(nk({
      url: e,
      onError: n
    }), [e, n]),
    p = ge(yf(g, t), [g]),
    x = j => {
      s({
        type: 0,
        payload: j.target.value
      }), r && r(j), j.target.value !== ga.value && (s({
        type: 2,
        payload: 1
        /* Pending */
      }), p(j.target.value, v => s({
        type: 1,
        payload: v
      })));
    },
    m = () => {
      s({
        type: 3,
        payload: !0
      });
    },
    h = () => {
      s({
        type: 3,
        payload: !1
      });
    };
  return fe(() => {
    let j;
    return l === 2 && !f && i.length === 0 && (j = window.setTimeout(() => {
      s({
        type: 4
        /* HideValidation */
      });
    }, 1e3)), () => {
      j && window.clearTimeout(j);
    };
  }, [l, f, i.length]), {
    handleChange: x,
    handleFocus: m,
    handleBlur: h,
    value: a,
    errors: i,
    loading: l === 1,
    touched: c,
    showValidation: d
  };
}
function sk() {
  return /* @__PURE__ */u.jsxs(u.Fragment, {
    children: [/* @__PURE__ */u.jsx("span", {
      className: rs.initial,
      children: /* @__PURE__ */u.jsx("span", {
        className: Ty,
        children: "•"
      })
    }), /* @__PURE__ */u.jsx(pe, {
      className: rs.busy,
      children: /* @__PURE__ */u.jsx(Oa, {
        size: "sm"
      })
    }), /* @__PURE__ */u.jsx(pe, {
      className: rs.valid,
      children: /* @__PURE__ */u.jsx(Sd, {
        color: "currentColor",
        height: "1em",
        width: "1em"
      })
    }), /* @__PURE__ */u.jsx(pe, {
      className: rs.invalid,
      children: /* @__PURE__ */u.jsx(Ed, {
        color: "currentColor",
        height: "1em",
        width: "1em"
      })
    })]
  });
}
function ok(_ref53) {
  let {
    state: e,
    children: t
  } = _ref53;
  return /* @__PURE__ */u.jsxs("li", {
    className: Sy,
    "data-state": e,
    children: [/* @__PURE__ */u.jsx(sk, {}), /* @__PURE__ */u.jsx(ut, {
      type: "sm",
      children: t
    })]
  });
}
function ak(_ref54) {
  let {
    errors: e,
    touched: t,
    loading: n,
    helpers: r
  } = _ref54;
  const {
      getA11yMessage: o,
      getRuleMessage: s
    } = r,
    a = {
      [Yt.Length]: s("length"),
      [Yt.Uppercase]: s("uppercase"),
      [Yt.Lowercase]: s("lowercase"),
      [Yt.Number]: s("number"),
      [Yt.Symbol]: s("symbol"),
      [Yt.Pattern]: s("pattern")
    },
    i = c => c === Yt.Pattern && n ? "busy" : e.includes(c) ? "invalid" : "valid",
    l = () => t ? e.length > 0 ? `${o("invalid")} ${e.map(c => a[c]).join(", ")}` : o("success") : `${o("initial")} ${Object.values(a).join(", ")}`;
  return /* @__PURE__ */u.jsxs("div", {
    children: [/* @__PURE__ */u.jsx("p", {
      "aria-live": "polite",
      className: Us,
      id: "password-validation",
      children: l()
    }), /* @__PURE__ */u.jsx("ul", {
      "aria-hidden": "true",
      className: Ny,
      children: Object.entries(a).map(_ref55 => {
        let [c, d] = _ref55;
        return /* @__PURE__ */u.jsx(ok, {
          state: t ? i(c) : "initial",
          children: d
        }, c);
      })
    })]
  });
}
const ik = {
    "rule-length": "Is at least 12 characters long",
    "rule-uppercase": "Contains an uppercase letter",
    "rule-lowercase": "Contains a lowercase letter",
    "rule-number": "Contains a number",
    "rule-symbol": "Contains a symbol",
    "rule-pattern": "Is not a common word, pattern or name",
    "a11y-initial": "Password must satisfy the following rules:",
    "a11y-invalid": "Password does not satisfy the following rules:",
    "a11y-success": "Password satisfies all rules",
    "a11y-hide": "Hide password",
    "a11y-show": "Show password"
  },
  YN = ce((_ref56, v) => {
    let {
      name: e,
      label: t,
      placeholder: n,
      disabled: r,
      touched: o = !1,
      errors: s = [],
      error: a,
      handleChange: i,
      handleFocus: l,
      handleBlur: c,
      showValidation: d = !1,
      value: f,
      loading: g = !1,
      required: p,
      microcopy: x = ik,
      className: m,
      variant: h = "light",
      ...j
    } = _ref56;
    const [_, k] = le(!1),
      y = () => k(N => !N),
      b = ge(N => x[`rule-${N}`] || N, [x]),
      C = ge(N => x[`a11y-${N}`] || N, [x]);
    return /* @__PURE__ */u.jsxs("div", {
      className: ye([Cy, m]),
      "data-validation": d,
      onBlur: c,
      onFocus: l,
      children: [/* @__PURE__ */u.jsxs("div", {
        className: Rr({
          invalid: !!a,
          variant: h
        }),
        children: [/* @__PURE__ */u.jsx("label", {
          className: xn({
            required: p
          }),
          htmlFor: e,
          children: t
        }), a ? /* @__PURE__ */u.jsx("span", {
          className: Pr,
          children: a
        }) : null, /* @__PURE__ */u.jsxs(pe, {
          display: "flex",
          children: [/* @__PURE__ */u.jsx("input", {
            ref: v,
            "aria-describedby": "password-validation",
            className: `${Iy} ${lu}`,
            id: e,
            name: e,
            placeholder: n,
            required: p,
            type: _ ? "text" : "password",
            value: f,
            onChange: i,
            ...j
          }), /* @__PURE__ */u.jsx("button", {
            "aria-label": C(_ ? "hide" : "show"),
            className: Ey,
            type: "button",
            onClick: y,
            children: _ ? /* @__PURE__ */u.jsx(dj, {
              color: "currentColor",
              height: "1rem",
              width: "1rem"
            }) : /* @__PURE__ */u.jsx(fj, {
              color: "currentColor",
              height: "1rem",
              width: "1rem"
            })
          })]
        })]
      }), /* @__PURE__ */u.jsx(ak, {
        errors: s,
        helpers: {
          getA11yMessage: C,
          getRuleMessage: b
        },
        loading: g,
        touched: o
      })]
    });
  });
function lk(e) {
  const [t, n] = le(e),
    r = ee(null),
    o = s => {
      r.current && !r.current.contains(s.target) && n(!0);
    };
  return fe(() => (document.addEventListener("click", o, !0), () => {
    document.removeEventListener("click", o, !0);
  }), []), {
    targetRef: r,
    hasClickedOutsideTarget: t,
    setHasClickedOutsideTarget: n
  };
}
var ck = Ue({
    defaultClassName: "_8tvhac7 _86277sc",
    variantClassNames: {
      showList: {
        true: "_8tvhac8"
      },
      disabled: {
        true: "_8tvhac9 _86277sc _86277sf"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  uk = Ue({
    defaultClassName: "_8tvhacb _8tvhaca _1j2kes8fu _1j2kes8vt _1j2kes8j1 _1j2kes8sm _1j2kes8k _1j2kes83h _1j2kes80 _1j2kes812g",
    variantClassNames: {
      showList: {
        false: "_8tvhacc",
        true: "_8tvhacd"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  dk = Ue({
    defaultClassName: "_8tvhacf _8tvhace _1j2kes87x _1j2kes8e6 _1j2kes8a0 _1j2kes8c3",
    variantClassNames: {
      active: {
        true: "_8tvhacg"
      },
      selected: {
        true: "_8tvhach"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  });
const fk = _ref57 => {
    let {
      item: e,
      index: t,
      id: n,
      activeItem: r,
      listActiveItem: o,
      handleOnClickItem: s
    } = _ref57;
    const a = (r == null ? void 0 : r.name) === e.name,
      i = (o == null ? void 0 : o.name) === e.name;
    return /* @__PURE__ */u.jsx("li", {
      "aria-selected": a,
      className: dk({
        active: i,
        selected: a
      }),
      "data-testid": `option-${t}`,
      id: `${n}-${e != null && e.languageCode ? e.languageCode.replace("/", "") : "default"}`,
      role: "option",
      tabIndex: -1,
      onClick: l => s(l, t),
      children: e.name
    }, `option-key-${t}`);
  },
  pk = _ref58 => {
    let {
      children: e,
      id: t,
      showList: n,
      UIActiveItem: r
    } = _ref58;
    return /* @__PURE__ */u.jsx("ul", {
      "aria-activedescendant": `${t}-${r != null && r.languageCode ? r.languageCode.replace("/", "") : "default"}`,
      "aria-expanded": n,
      "aria-label": "Set a site language",
      "aria-orientation": "vertical",
      className: uk({
        showList: n
      }),
      "data-testid": "options",
      dir: "ltr",
      id: t,
      role: "listbox",
      tabIndex: -1,
      children: e
    });
  },
  mk = _ref59 => {
    let {
      id: e,
      showList: t,
      setShowList: n,
      activeItem: r
    } = _ref59;
    return /* @__PURE__ */u.jsxs("button", {
      "aria-controls": e,
      "aria-expanded": t,
      "aria-haspopup": "menu",
      className: ck({
        showList: t
      }),
      id: `${e}-button-select-languages`,
      type: "button",
      onClick: () => n(!t),
      children: [/* @__PURE__ */u.jsx(cj, {
        "aria-hidden": "true",
        color: "transparent",
        role: "img",
        width: "14px"
      }), /* @__PURE__ */u.jsx("span", {
        "data-label": "true",
        children: r == null ? void 0 : r.name
      })]
    });
  },
  WN = _ref60 => {
    let {
      id: e,
      defaultSelected: t,
      onSelect: n,
      locales: r
    } = _ref60;
    const {
        hasClickedOutsideTarget: o,
        setHasClickedOutsideTarget: s,
        targetRef: a
      } = lk(!1),
      i = r.findIndex(j => t === j.languageCode),
      l = i >= 0 ? {
        ...r[i],
        index: i
      } : r[0],
      [c, d] = le(l),
      [f, g] = le(l),
      [p, x] = le(!1);
    fe(() => {
      o && (x(!p), s(!p));
    }, [p, o]);
    const m = (j, v) => {
        j.preventDefault();
        const _ = {
          index: v,
          ...r[v]
        };
        x(!p), d(_), g(_), n(_);
      },
      h = j => {
        const v = f.index,
          _ = (k, y) => {
            k.preventDefault(), k.stopPropagation();
            const b = {
              index: y,
              ...r[y]
            };
            return p || x(!p), g(b), null;
          };
        switch (j.code) {
          case "Enter":
          case "Space":
            p && m(j, v);
            break;
          case "ArrowDown":
            v !== r.length - 1 ? _(j, v + 1) : _(j, 0);
            break;
          case "ArrowUp":
            v < 0 ? _(j, 0) : v !== 0 ? _(j, v - 1) : _(j, r.length - 1);
            break;
          case "Home":
            _(j, 0);
            break;
          case "End":
            _(j, r.length - 1);
            break;
          case "Escape":
            x(!1);
            break;
        }
      };
    return /* @__PURE__ */u.jsxs(pe, {
      innerRef: a,
      position: "relative",
      width: "fitContent",
      onKeyDown: h,
      children: [/* @__PURE__ */u.jsx(mk, {
        activeItem: c,
        id: e,
        setShowList: x,
        showList: p
      }), /* @__PURE__ */u.jsx(pk, {
        UIActiveItem: f,
        id: e,
        showList: p,
        children: r.map((j, v) => /* @__PURE__ */u.jsx(fk, {
          activeItem: c,
          handleOnClickItem: m,
          id: e,
          index: v,
          item: j,
          listActiveItem: f,
          children: j.name
        }, j.id))
      })]
    });
  },
  BN = {
    "en-US": "/",
    de: "/de",
    es: "/es",
    ja: "/jp",
    fr: "/fr"
  };
function ha(e) {
  var t = e.match(/^var\((.*)\)$/);
  return t ? t[1] : e;
}
function Df(e, t) {
  var n = e;
  for (var r of t) {
    if (!(r in n)) throw new Error("Path ".concat(t.join(" -> "), " does not exist in object"));
    n = n[r];
  }
  return n;
}
function vi(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [],
    r = {};
  for (var o in e) {
    var s = e[o],
      a = [...n, o];
    typeof s == "string" || typeof s == "number" || s == null ? r[o] = t(s, a) : typeof s == "object" && !Array.isArray(s) ? r[o] = vi(s, t, a) : console.warn('Skipping invalid key "'.concat(a.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(s) ? "Array" : typeof s, '"'));
  }
  return r;
}
function _i(e, t) {
  var n = {};
  if (typeof t == "object") {
    var r = e;
    vi(t, (i, l) => {
      if (i != null) {
        var c = Df(r, l);
        n[ha(c)] = String(i);
      }
    });
  } else {
    var o = e;
    for (var s in o) {
      var a = o[s];
      a != null && (n[ha(s)] = a);
    }
  }
  return Object.defineProperty(n, "toString", {
    value: function () {
      return Object.keys(this).map(l => "".concat(l, ":").concat(this[l])).join(";");
    },
    writable: !1
  }), n;
}
function oc(e, t, n) {
  e.style.setProperty(ha(t), n);
}
function Oo(e, t, n) {
  if (typeof n == "object") {
    var r = t;
    vi(n, (i, l) => {
      i != null && oc(e, Df(r, l), String(i));
    });
  } else {
    var o = t;
    for (var s in o) {
      var a = o[s];
      a != null && oc(e, s, o[s]);
    }
  }
}
var gk = "var(--v4rwel0)",
  hk = "var(--v4rwel1)",
  ac = "var(--v4rwel2)",
  vk = "v4rwel4",
  _k = "v4rwel5",
  jk = "v4rwel6",
  yk = "v4rwel7";
const HN = _ref61 => {
    let {
      children: e,
      speed: t = 40,
      gap: n = 10,
      inView: r = !1,
      id: o
    } = _ref61;
    fe(() => {
      const a = document.querySelector("[data-marquee='wrapper']"),
        i = document.querySelector(`[data-marquee="content-${o}"]`),
        l = document.querySelector(`[data-marquee="contentHidden-${o}"]`);
      if (i) {
        const c = t < 40 ? t * 2 : t,
          d = {
            [gk]: `${t}s`,
            [hk]: `${c}s`,
            [ac]: `${n}px`
          };
        Oo(i, d), Oo(l, d), Oo(a, {
          [ac]: `${n}px`
        });
      }
    });
    const s = ye([_k, !r && jk]);
    return /* @__PURE__ */u.jsxs("div", {
      className: vk,
      "data-marquee": "wrapper",
      children: [/* @__PURE__ */u.jsx("ul", {
        className: s,
        "data-marquee": `content-${o}`,
        children: e
      }), /* @__PURE__ */u.jsx("ul", {
        "aria-hidden": "true",
        className: s,
        "data-marquee": `contentHidden-${o}`,
        children: e
      })]
    });
  },
  xk = _ref62 => {
    let {
      children: e,
      id: t,
      ...n
    } = _ref62;
    return /* @__PURE__ */u.jsx("li", {
      className: yk,
      ...n,
      children: e
    });
  },
  QN = xk;
function _e(e, t) {
  let {
    checkForDefaultPrevented: n = !0
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function kk(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function eo() {
  for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    e[_key13] = arguments[_key13];
  }
  return t => e.forEach(n => kk(n, t));
}
function Fe() {
  for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    e[_key14] = arguments[_key14];
  }
  return ge(eo(...e), e);
}
function Vt(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let n = [];
  function r(s, a) {
    const i = /* @__PURE__ */qn(a),
      l = n.length;
    n = [...n, a];
    function c(f) {
      const {
          scope: g,
          children: p,
          ...x
        } = f,
        m = (g == null ? void 0 : g[e][l]) || i,
        h = it(() => x, Object.values(x));
      return /* @__PURE__ */F(m.Provider, {
        value: h
      }, p);
    }
    function d(f, g) {
      const p = (g == null ? void 0 : g[e][l]) || i,
        x = Lr(p);
      if (x) return x;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return c.displayName = s + "Provider", [c, d];
  }
  const o = () => {
    const s = n.map(a => /* @__PURE__ */qn(a));
    return function (i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return it(() => ({
        [`__scope${e}`]: {
          ...i,
          [e]: l
        }
      }), [i, l]);
    };
  };
  return o.scopeName = e, [r, Mk(o, ...t)];
}
function Mk() {
  for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    e[_key15] = arguments[_key15];
  }
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(o => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function (s) {
      const a = r.reduce((i, _ref63) => {
        let {
          useScope: l,
          scopeName: c
        } = _ref63;
        const f = l(s)[`__scope${c}`];
        return {
          ...i,
          ...f
        };
      }, {});
      return it(() => ({
        [`__scope${t.scopeName}`]: a
      }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function We(e) {
  const t = ee(e);
  return fe(() => {
    t.current = e;
  }), it(() => function () {
    var r;
    for (var _len16 = arguments.length, n = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      n[_key16] = arguments[_key16];
    }
    return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
  }, []);
}
function Nn(_ref64) {
  let {
    prop: e,
    defaultProp: t,
    onChange: n = () => {}
  } = _ref64;
  const [r, o] = bk({
      defaultProp: t,
      onChange: n
    }),
    s = e !== void 0,
    a = s ? e : r,
    i = We(n),
    l = ge(c => {
      if (s) {
        const f = typeof c == "function" ? c(e) : c;
        f !== e && i(f);
      } else o(c);
    }, [s, e, o, i]);
  return [a, l];
}
function bk(_ref65) {
  let {
    defaultProp: e,
    onChange: t
  } = _ref65;
  const n = le(e),
    [r] = n,
    o = ee(r),
    s = We(t);
  return fe(() => {
    o.current !== r && (s(r), o.current = r);
  }, [r, o, s]), n;
}
const Dr = /* @__PURE__ */ce((e, t) => {
  const {
      children: n,
      ...r
    } = e,
    o = ht.toArray(n),
    s = o.find(Ck);
  if (s) {
    const a = s.props.children,
      i = o.map(l => l === s ? ht.count(a) > 1 ? ht.only(null) : /* @__PURE__ */kt(a) ? a.props.children : null : l);
    return /* @__PURE__ */F(va, V({}, r, {
      ref: t
    }), /* @__PURE__ */kt(a) ? /* @__PURE__ */Ot(a, void 0, i) : null);
  }
  return /* @__PURE__ */F(va, V({}, r, {
    ref: t
  }), n);
});
Dr.displayName = "Slot";
const va = /* @__PURE__ */ce((e, t) => {
  const {
    children: n,
    ...r
  } = e;
  return /* @__PURE__ */kt(n) ? /* @__PURE__ */Ot(n, {
    ...Nk(r, n.props),
    ref: t ? eo(t, n.ref) : n.ref
  }) : ht.count(n) > 1 ? ht.only(null) : null;
});
va.displayName = "SlotClone";
const wk = _ref66 => {
  let {
    children: e
  } = _ref66;
  return /* @__PURE__ */F(gs, null, e);
};
function Ck(e) {
  return /* @__PURE__ */kt(e) && e.type === wk;
}
function Nk(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r],
      s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = function () {
      s(...arguments), o(...arguments);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...s
    } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Ik = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"],
  Oe = Ik.reduce((e, t) => {
    const n = /* @__PURE__ */ce((r, o) => {
      const {
          asChild: s,
          ...a
        } = r,
        i = s ? Dr : t;
      return fe(() => {
        window[Symbol.for("radix-ui")] = !0;
      }, []), /* @__PURE__ */F(i, V({}, a, {
        ref: o
      }));
    });
    return n.displayName = `Primitive.${t}`, {
      ...e,
      [t]: n
    };
  }, {});
function Ls(e, t) {
  e && Hc(() => e.dispatchEvent(t));
}
function Yr(e) {
  const t = e + "CollectionProvider",
    [n, r] = Vt(t),
    [o, s] = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    a = p => {
      const {
          scope: x,
          children: m
        } = p,
        h = te.useRef(null),
        j = te.useRef(/* @__PURE__ */new Map()).current;
      return /* @__PURE__ */te.createElement(o, {
        scope: x,
        itemMap: j,
        collectionRef: h
      }, m);
    },
    i = e + "CollectionSlot",
    l = /* @__PURE__ */te.forwardRef((p, x) => {
      const {
          scope: m,
          children: h
        } = p,
        j = s(i, m),
        v = Fe(x, j.collectionRef);
      return /* @__PURE__ */te.createElement(Dr, {
        ref: v
      }, h);
    }),
    c = e + "CollectionItemSlot",
    d = "data-radix-collection-item",
    f = /* @__PURE__ */te.forwardRef((p, x) => {
      const {
          scope: m,
          children: h,
          ...j
        } = p,
        v = te.useRef(null),
        _ = Fe(x, v),
        k = s(c, m);
      return te.useEffect(() => (k.itemMap.set(v, {
        ref: v,
        ...j
      }), () => void k.itemMap.delete(v))), /* @__PURE__ */te.createElement(Dr, {
        [d]: "",
        ref: _
      }, h);
    });
  function g(p) {
    const x = s(e + "CollectionConsumer", p);
    return te.useCallback(() => {
      const h = x.collectionRef.current;
      if (!h) return [];
      const j = Array.from(h.querySelectorAll(`[${d}]`));
      return Array.from(x.itemMap.values()).sort((k, y) => j.indexOf(k.ref.current) - j.indexOf(y.ref.current));
    }, [x.collectionRef, x.itemMap]);
  }
  return [{
    Provider: a,
    Slot: l,
    ItemSlot: f
  }, g, r];
}
const Ek = /* @__PURE__ */qn(void 0);
function Wr(e) {
  const t = Lr(Ek);
  return e || t || "ltr";
}
function Sk(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = We(e);
  fe(() => {
    const r = o => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [n, t]);
}
const _a = "dismissableLayer.update",
  Tk = "dismissableLayer.pointerDownOutside",
  Dk = "dismissableLayer.focusOutside";
let ic;
const Ok = /* @__PURE__ */qn({
    layers: /* @__PURE__ */new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
    branches: /* @__PURE__ */new Set()
  }),
  Of = /* @__PURE__ */ce((e, t) => {
    var n;
    const {
        disableOutsidePointerEvents: r = !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: s,
        onFocusOutside: a,
        onInteractOutside: i,
        onDismiss: l,
        ...c
      } = e,
      d = Lr(Ok),
      [f, g] = le(null),
      p = (n = f == null ? void 0 : f.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document,
      [, x] = le({}),
      m = Fe(t, N => g(N)),
      h = Array.from(d.layers),
      [j] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1),
      v = h.indexOf(j),
      _ = f ? h.indexOf(f) : -1,
      k = d.layersWithOutsidePointerEventsDisabled.size > 0,
      y = _ >= v,
      b = Ak(N => {
        const T = N.target,
          z = [...d.branches].some(K => K.contains(T));
        !y || z || (s == null || s(N), i == null || i(N), N.defaultPrevented || l == null || l());
      }, p),
      C = $k(N => {
        const T = N.target;
        [...d.branches].some(K => K.contains(T)) || (a == null || a(N), i == null || i(N), N.defaultPrevented || l == null || l());
      }, p);
    return Sk(N => {
      _ === d.layers.size - 1 && (o == null || o(N), !N.defaultPrevented && l && (N.preventDefault(), l()));
    }, p), fe(() => {
      if (f) return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (ic = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), lc(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = ic);
      };
    }, [f, p, r, d]), fe(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), lc());
    }, [f, d]), fe(() => {
      const N = () => x({});
      return document.addEventListener(_a, N), () => document.removeEventListener(_a, N);
    }, []), /* @__PURE__ */F(Oe.div, V({}, c, {
      ref: m,
      style: {
        pointerEvents: k ? y ? "auto" : "none" : void 0,
        ...e.style
      },
      onFocusCapture: _e(e.onFocusCapture, C.onFocusCapture),
      onBlurCapture: _e(e.onBlurCapture, C.onBlurCapture),
      onPointerDownCapture: _e(e.onPointerDownCapture, b.onPointerDownCapture)
    }));
  });
function Ak(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = We(e),
    r = ee(!1),
    o = ee(() => {});
  return fe(() => {
    const s = i => {
        if (i.target && !r.current) {
          let c = function () {
            Af(Tk, n, l, {
              discrete: !0
            });
          };
          const l = {
            originalEvent: i
          };
          i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
            once: !0
          })) : c();
        } else t.removeEventListener("click", o.current);
        r.current = !1;
      },
      a = window.setTimeout(() => {
        t.addEventListener("pointerdown", s);
      }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function $k(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis == null ? void 0 : globalThis.document;
  const n = We(e),
    r = ee(!1);
  return fe(() => {
    const o = s => {
      s.target && !r.current && Af(Dk, n, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function lc() {
  const e = new CustomEvent(_a);
  document.dispatchEvent(e);
}
function Af(e, t, n, _ref67) {
  let {
    discrete: r
  } = _ref67;
  const o = n.originalEvent.target,
    s = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? Ls(o, s) : o.dispatchEvent(s);
}
let Ao = 0;
function Lk() {
  fe(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : cc()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : cc()), Ao++, () => {
      Ao === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(r => r.remove()), Ao--;
    };
  }, []);
}
function cc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const $o = "focusScope.autoFocusOnMount",
  Lo = "focusScope.autoFocusOnUnmount",
  uc = {
    bubbles: !1,
    cancelable: !0
  },
  zk = /* @__PURE__ */ce((e, t) => {
    const {
        loop: n = !1,
        trapped: r = !1,
        onMountAutoFocus: o,
        onUnmountAutoFocus: s,
        ...a
      } = e,
      [i, l] = le(null),
      c = We(o),
      d = We(s),
      f = ee(null),
      g = Fe(t, m => l(m)),
      p = ee({
        paused: !1,
        pause() {
          this.paused = !0;
        },
        resume() {
          this.paused = !1;
        }
      }).current;
    fe(() => {
      if (r) {
        let m = function (_) {
            if (p.paused || !i) return;
            const k = _.target;
            i.contains(k) ? f.current = k : Wt(f.current, {
              select: !0
            });
          },
          h = function (_) {
            if (p.paused || !i) return;
            const k = _.relatedTarget;
            k !== null && (i.contains(k) || Wt(f.current, {
              select: !0
            }));
          },
          j = function (_) {
            if (document.activeElement === document.body) for (const y of _) y.removedNodes.length > 0 && Wt(i);
          };
        document.addEventListener("focusin", m), document.addEventListener("focusout", h);
        const v = new MutationObserver(j);
        return i && v.observe(i, {
          childList: !0,
          subtree: !0
        }), () => {
          document.removeEventListener("focusin", m), document.removeEventListener("focusout", h), v.disconnect();
        };
      }
    }, [r, i, p.paused]), fe(() => {
      if (i) {
        fc.add(p);
        const m = document.activeElement;
        if (!i.contains(m)) {
          const j = new CustomEvent($o, uc);
          i.addEventListener($o, c), i.dispatchEvent(j), j.defaultPrevented || (Rk(Yk($f(i)), {
            select: !0
          }), document.activeElement === m && Wt(i));
        }
        return () => {
          i.removeEventListener($o, c), setTimeout(() => {
            const j = new CustomEvent(Lo, uc);
            i.addEventListener(Lo, d), i.dispatchEvent(j), j.defaultPrevented || Wt(m ?? document.body, {
              select: !0
            }), i.removeEventListener(Lo, d), fc.remove(p);
          }, 0);
        };
      }
    }, [i, c, d, p]);
    const x = ge(m => {
      if (!n && !r || p.paused) return;
      const h = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey,
        j = document.activeElement;
      if (h && j) {
        const v = m.currentTarget,
          [_, k] = Pk(v);
        _ && k ? !m.shiftKey && j === k ? (m.preventDefault(), n && Wt(_, {
          select: !0
        })) : m.shiftKey && j === _ && (m.preventDefault(), n && Wt(k, {
          select: !0
        })) : j === v && m.preventDefault();
      }
    }, [n, r, p.paused]);
    return /* @__PURE__ */F(Oe.div, V({
      tabIndex: -1
    }, a, {
      ref: g,
      onKeyDown: x
    }));
  });
function Rk(e) {
  let {
    select: t = !1
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const n = document.activeElement;
  for (const r of e) if (Wt(r, {
    select: t
  }), document.activeElement !== n) return;
}
function Pk(e) {
  const t = $f(e),
    n = dc(t, e),
    r = dc(t.reverse(), e);
  return [n, r];
}
function $f(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: r => {
        const o = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function dc(e, t) {
  for (const n of e) if (!Vk(n, {
    upTo: t
  })) return n;
}
function Vk(e, _ref68) {
  let {
    upTo: t
  } = _ref68;
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e;) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Fk(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wt(e) {
  let {
    select: t = !1
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Fk(e) && t && e.select();
  }
}
const fc = Uk();
function Uk() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = pc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = pc(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function pc(e, t) {
  const n = [...e],
    r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Yk(e) {
  return e.filter(t => t.tagName !== "A");
}
const Et = globalThis != null && globalThis.document ? Da : () => {},
  Wk = M["useId".toString()] || (() => {});
let Bk = 0;
function sn(e) {
  const [t, n] = M.useState(Wk());
  return Et(() => {
    e || n(r => r ?? String(Bk++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Hk(e) {
  const [t, n] = le(void 0);
  return Et(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver(o => {
        if (!Array.isArray(o) || !o.length) return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize,
            c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, i = c.blockSize;
        } else a = e.offsetWidth, i = e.offsetHeight;
        n({
          width: a,
          height: i
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else n(void 0);
  }, [e]), t;
}
const Lf = "Popper",
  [zf, Rf] = Vt(Lf),
  [Qk, Pf] = zf(Lf),
  qk = e => {
    const {
        __scopePopper: t,
        children: n
      } = e,
      [r, o] = le(null);
    return /* @__PURE__ */F(Qk, {
      scope: t,
      anchor: r,
      onAnchorChange: o
    }, n);
  },
  Kk = "PopperAnchor",
  Zk = /* @__PURE__ */ce((e, t) => {
    const {
        __scopePopper: n,
        virtualRef: r,
        ...o
      } = e,
      s = Pf(Kk, n),
      a = ee(null),
      i = Fe(t, a);
    return fe(() => {
      s.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */F(Oe.div, V({}, o, {
      ref: i
    }));
  }),
  Vf = "PopperContent",
  [Gk, qN] = zf(Vf),
  Jk = /* @__PURE__ */ce((e, t) => {
    var n, r, o, s, a, i, l, c;
    const {
        __scopePopper: d,
        side: f = "bottom",
        sideOffset: g = 0,
        align: p = "center",
        alignOffset: x = 0,
        arrowPadding: m = 0,
        avoidCollisions: h = !0,
        collisionBoundary: j = [],
        collisionPadding: v = 0,
        sticky: _ = "partial",
        hideWhenDetached: k = !1,
        updatePositionStrategy: y = "optimized",
        onPlaced: b,
        ...C
      } = e,
      N = Pf(Vf, d),
      [T, z] = le(null),
      K = Fe(t, Ce => z(Ce)),
      [L, H] = le(null),
      Y = Hk(L),
      X = (n = Y == null ? void 0 : Y.width) !== null && n !== void 0 ? n : 0,
      ne = (r = Y == null ? void 0 : Y.height) !== null && r !== void 0 ? r : 0,
      U = f + (p !== "center" ? "-" + p : ""),
      de = typeof v == "number" ? v : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...v
      },
      Z = Array.isArray(j) ? j : [j],
      S = Z.length > 0,
      R = {
        padding: de,
        boundary: Z.filter(Xk),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: S
      },
      {
        refs: ae,
        floatingStyles: P,
        placement: D,
        isPositioned: O,
        middlewareData: A
      } = Nu({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: U,
        whileElementsMounted: function () {
          for (var _len17 = arguments.length, Ce = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            Ce[_key17] = arguments[_key17];
          }
          return wu(...Ce, {
            animationFrame: y === "always"
          });
        },
        elements: {
          reference: N.anchor
        },
        middleware: [Iu({
          mainAxis: g + ne,
          alignmentAxis: x
        }), h && Eu({
          mainAxis: !0,
          crossAxis: !1,
          limiter: _ === "partial" ? Su() : void 0,
          ...R
        }), h && Tu({
          ...R
        }), Du({
          ...R,
          apply: _ref69 => {
            let {
              elements: Ce,
              rects: Ne,
              availableWidth: Ye,
              availableHeight: lt
            } = _ref69;
            const {
                width: Be,
                height: et
              } = Ne.reference,
              dt = Ce.floating.style;
            dt.setProperty("--radix-popper-available-width", `${Ye}px`), dt.setProperty("--radix-popper-available-height", `${lt}px`), dt.setProperty("--radix-popper-anchor-width", `${Be}px`), dt.setProperty("--radix-popper-anchor-height", `${et}px`);
          }
        }), L && Au({
          element: L,
          padding: m
        }), e2({
          arrowWidth: X,
          arrowHeight: ne
        }), k && Ou({
          strategy: "referenceHidden",
          ...R
        })]
      }),
      [E, G] = Ff(D),
      B = We(b);
    Et(() => {
      O && (B == null || B());
    }, [O, B]);
    const Q = (o = A.arrow) === null || o === void 0 ? void 0 : o.x,
      ie = (s = A.arrow) === null || s === void 0 ? void 0 : s.y,
      $ = ((a = A.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0,
      [je, J] = le();
    return Et(() => {
      T && J(window.getComputedStyle(T).zIndex);
    }, [T]), /* @__PURE__ */F("div", {
      ref: ae.setFloating,
      "data-radix-popper-content-wrapper": "",
      style: {
        ...P,
        transform: O ? P.transform : "translate(0, -200%)",
        // keep off the page when measuring
        minWidth: "max-content",
        zIndex: je,
        "--radix-popper-transform-origin": [(i = A.transformOrigin) === null || i === void 0 ? void 0 : i.x, (l = A.transformOrigin) === null || l === void 0 ? void 0 : l.y].join(" ")
      },
      dir: e.dir
    }, /* @__PURE__ */F(Gk, {
      scope: d,
      placedSide: E,
      onArrowChange: H,
      arrowX: Q,
      arrowY: ie,
      shouldHideArrow: $
    }, /* @__PURE__ */F(Oe.div, V({
      "data-side": E,
      "data-align": G
    }, C, {
      ref: K,
      style: {
        ...C.style,
        // if the PopperContent hasn't been placed yet (not all measurements done)
        // we prevent animations so that users's animation don't kick in too early referring wrong sides
        animation: O ? void 0 : "none",
        // hide the content if using the hide middleware and should be hidden
        opacity: (c = A.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
      }
    }))));
  });
function Xk(e) {
  return e !== null;
}
const e2 = e => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, s, a;
    const {
        placement: i,
        rects: l,
        middlewareData: c
      } = t,
      f = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0,
      g = f ? 0 : e.arrowWidth,
      p = f ? 0 : e.arrowHeight,
      [x, m] = Ff(i),
      h = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[m],
      j = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + g / 2,
      v = ((s = (a = c.arrow) === null || a === void 0 ? void 0 : a.y) !== null && s !== void 0 ? s : 0) + p / 2;
    let _ = "",
      k = "";
    return x === "bottom" ? (_ = f ? h : `${j}px`, k = `${-p}px`) : x === "top" ? (_ = f ? h : `${j}px`, k = `${l.floating.height + p}px`) : x === "right" ? (_ = `${-p}px`, k = f ? h : `${v}px`) : x === "left" && (_ = `${l.floating.width + p}px`, k = f ? h : `${v}px`), {
      data: {
        x: _,
        y: k
      }
    };
  }
});
function Ff(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
const t2 = qk,
  n2 = Zk,
  r2 = Jk,
  s2 = /* @__PURE__ */ce((e, t) => {
    var n;
    const {
      container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body,
      ...o
    } = e;
    return r ? /* @__PURE__ */cr.createPortal(/* @__PURE__ */F(Oe.div, V({}, o, {
      ref: t
    })), r) : null;
  });
function o2(e, t) {
  return $r((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const un = e => {
  const {
      present: t,
      children: n
    } = e,
    r = a2(t),
    o = typeof n == "function" ? n({
      present: r.isPresent
    }) : ht.only(n),
    s = Fe(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */Ot(o, {
    ref: s
  }) : null;
};
un.displayName = "Presence";
function a2(e) {
  const [t, n] = le(),
    r = ee({}),
    o = ee(e),
    s = ee("none"),
    a = e ? "mounted" : "unmounted",
    [i, l] = o2(a, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    });
  return fe(() => {
    const c = ss(r.current);
    s.current = i === "mounted" ? c : "none";
  }, [i]), Et(() => {
    const c = r.current,
      d = o.current;
    if (d !== e) {
      const g = s.current,
        p = ss(c);
      e ? l("MOUNT") : p === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && g !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), Et(() => {
    if (t) {
      const c = f => {
          const p = ss(r.current).includes(f.animationName);
          f.target === t && p && Hc(() => l("ANIMATION_END"));
        },
        d = f => {
          f.target === t && (s.current = ss(r.current));
        };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: ge(c => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function ss(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const zo = "rovingFocusGroup.onEntryFocus",
  i2 = {
    bubbles: !1,
    cancelable: !0
  },
  ji = "RovingFocusGroup",
  [ja, Uf, l2] = Yr(ji),
  [c2, to] = Vt(ji, [l2]),
  [u2, d2] = c2(ji),
  f2 = /* @__PURE__ */ce((e, t) => /* @__PURE__ */F(ja.Provider, {
    scope: e.__scopeRovingFocusGroup
  }, /* @__PURE__ */F(ja.Slot, {
    scope: e.__scopeRovingFocusGroup
  }, /* @__PURE__ */F(p2, V({}, e, {
    ref: t
  }))))),
  p2 = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeRovingFocusGroup: n,
        orientation: r,
        loop: o = !1,
        dir: s,
        currentTabStopId: a,
        defaultCurrentTabStopId: i,
        onCurrentTabStopIdChange: l,
        onEntryFocus: c,
        ...d
      } = e,
      f = ee(null),
      g = Fe(t, f),
      p = Wr(s),
      [x = null, m] = Nn({
        prop: a,
        defaultProp: i,
        onChange: l
      }),
      [h, j] = le(!1),
      v = We(c),
      _ = Uf(n),
      k = ee(!1),
      [y, b] = le(0);
    return fe(() => {
      const C = f.current;
      if (C) return C.addEventListener(zo, v), () => C.removeEventListener(zo, v);
    }, [v]), /* @__PURE__ */F(u2, {
      scope: n,
      orientation: r,
      dir: p,
      loop: o,
      currentTabStopId: x,
      onItemFocus: ge(C => m(C), [m]),
      onItemShiftTab: ge(() => j(!0), []),
      onFocusableItemAdd: ge(() => b(C => C + 1), []),
      onFocusableItemRemove: ge(() => b(C => C - 1), [])
    }, /* @__PURE__ */F(Oe.div, V({
      tabIndex: h || y === 0 ? -1 : 0,
      "data-orientation": r
    }, d, {
      ref: g,
      style: {
        outline: "none",
        ...e.style
      },
      onMouseDown: _e(e.onMouseDown, () => {
        k.current = !0;
      }),
      onFocus: _e(e.onFocus, C => {
        const N = !k.current;
        if (C.target === C.currentTarget && N && !h) {
          const T = new CustomEvent(zo, i2);
          if (C.currentTarget.dispatchEvent(T), !T.defaultPrevented) {
            const z = _().filter(X => X.focusable),
              K = z.find(X => X.active),
              L = z.find(X => X.id === x),
              Y = [K, L, ...z].filter(Boolean).map(X => X.ref.current);
            Yf(Y);
          }
        }
        k.current = !1;
      }),
      onBlur: _e(e.onBlur, () => j(!1))
    })));
  }),
  m2 = "RovingFocusGroupItem",
  g2 = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeRovingFocusGroup: n,
        focusable: r = !0,
        active: o = !1,
        tabStopId: s,
        ...a
      } = e,
      i = sn(),
      l = s || i,
      c = d2(m2, n),
      d = c.currentTabStopId === l,
      f = Uf(n),
      {
        onFocusableItemAdd: g,
        onFocusableItemRemove: p
      } = c;
    return fe(() => {
      if (r) return g(), () => p();
    }, [r, g, p]), /* @__PURE__ */F(ja.ItemSlot, {
      scope: n,
      id: l,
      focusable: r,
      active: o
    }, /* @__PURE__ */F(Oe.span, V({
      tabIndex: d ? 0 : -1,
      "data-orientation": c.orientation
    }, a, {
      ref: t,
      onMouseDown: _e(e.onMouseDown, x => {
        r ? c.onItemFocus(l) : x.preventDefault();
      }),
      onFocus: _e(e.onFocus, () => c.onItemFocus(l)),
      onKeyDown: _e(e.onKeyDown, x => {
        if (x.key === "Tab" && x.shiftKey) {
          c.onItemShiftTab();
          return;
        }
        if (x.target !== x.currentTarget) return;
        const m = _2(x, c.orientation, c.dir);
        if (m !== void 0) {
          x.preventDefault();
          let j = f().filter(v => v.focusable).map(v => v.ref.current);
          if (m === "last") j.reverse();else if (m === "prev" || m === "next") {
            m === "prev" && j.reverse();
            const v = j.indexOf(x.currentTarget);
            j = c.loop ? j2(j, v + 1) : j.slice(v + 1);
          }
          setTimeout(() => Yf(j));
        }
      })
    })));
  }),
  h2 = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
function v2(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function _2(e, t, n) {
  const r = v2(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return h2[r];
}
function Yf(e) {
  const t = document.activeElement;
  for (const n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function j2(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
const Wf = f2,
  Bf = g2;
var fs = "right-scroll-bar-position",
  ps = "width-before-scroll-bar",
  y2 = "with-scroll-bars-hidden",
  x2 = "--removed-body-scroll-bar-size";
function Ro(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function k2(e, t) {
  var n = le(function () {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var M2 = typeof window < "u" ? M.useLayoutEffect : M.useEffect,
  mc = /* @__PURE__ */new WeakMap();
function b2(e, t) {
  var n = k2(t || null, function (r) {
    return e.forEach(function (o) {
      return Ro(o, r);
    });
  });
  return M2(function () {
    var r = mc.get(n);
    if (r) {
      var o = new Set(r),
        s = new Set(e),
        a = n.current;
      o.forEach(function (i) {
        s.has(i) || Ro(i, null);
      }), s.forEach(function (i) {
        o.has(i) || Ro(i, a);
      });
    }
    mc.set(n, e);
  }, [e]), n;
}
function w2(e) {
  return e;
}
function C2(e, t) {
  t === void 0 && (t = w2);
  var n = [],
    r = !1,
    o = {
      read: function () {
        if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return n.length ? n[n.length - 1] : e;
      },
      useMedium: function (s) {
        var a = t(s, r);
        return n.push(a), function () {
          n = n.filter(function (i) {
            return i !== a;
          });
        };
      },
      assignSyncMedium: function (s) {
        for (r = !0; n.length;) {
          var a = n;
          n = [], a.forEach(s);
        }
        n = {
          push: function (i) {
            return s(i);
          },
          filter: function () {
            return n;
          }
        };
      },
      assignMedium: function (s) {
        r = !0;
        var a = [];
        if (n.length) {
          var i = n;
          n = [], i.forEach(s), a = n;
        }
        var l = function () {
            var d = a;
            a = [], d.forEach(s);
          },
          c = function () {
            return Promise.resolve().then(l);
          };
        c(), n = {
          push: function (d) {
            a.push(d), c();
          },
          filter: function (d) {
            return a = a.filter(d), n;
          }
        };
      }
    };
  return o;
}
function N2(e) {
  e === void 0 && (e = {});
  var t = C2(null);
  return t.options = Le({
    async: !0,
    ssr: !1
  }, e), t;
}
var Hf = function (e) {
  var t = e.sideCar,
    n = Qs(e, ["sideCar"]);
  if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r) throw new Error("Sidecar medium not found");
  return M.createElement(r, Le({}, n));
};
Hf.isSideCarExport = !0;
function I2(e, t) {
  return e.useMedium(t), Hf;
}
var Qf = N2(),
  Po = function () {},
  no = M.forwardRef(function (e, t) {
    var n = M.useRef(null),
      r = M.useState({
        onScrollCapture: Po,
        onWheelCapture: Po,
        onTouchMoveCapture: Po
      }),
      o = r[0],
      s = r[1],
      a = e.forwardProps,
      i = e.children,
      l = e.className,
      c = e.removeScrollBar,
      d = e.enabled,
      f = e.shards,
      g = e.sideCar,
      p = e.noIsolation,
      x = e.inert,
      m = e.allowPinchZoom,
      h = e.as,
      j = h === void 0 ? "div" : h,
      v = Qs(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
      _ = g,
      k = b2([n, t]),
      y = Le(Le({}, v), o);
    return M.createElement(M.Fragment, null, d && M.createElement(_, {
      sideCar: Qf,
      removeScrollBar: c,
      shards: f,
      noIsolation: p,
      inert: x,
      setCallbacks: s,
      allowPinchZoom: !!m,
      lockRef: n
    }), a ? M.cloneElement(M.Children.only(i), Le(Le({}, y), {
      ref: k
    })) : M.createElement(j, Le({}, y, {
      className: l,
      ref: k
    }), i));
  });
no.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
no.classNames = {
  fullWidth: ps,
  zeroRight: fs
};
function E2() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ga();
  return t && e.setAttribute("nonce", t), e;
}
function S2(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function T2(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var D2 = function () {
    var e = 0,
      t = null;
    return {
      add: function (n) {
        e == 0 && (t = E2()) && (S2(t, n), T2(t)), e++;
      },
      remove: function () {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  O2 = function () {
    var e = D2();
    return function (t, n) {
      M.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    };
  },
  qf = function () {
    var e = O2(),
      t = function (n) {
        var r = n.styles,
          o = n.dynamic;
        return e(r, o), null;
      };
    return t;
  },
  A2 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  Vo = function (e) {
    return parseInt(e || "", 10) || 0;
  },
  $2 = function (e) {
    var t = window.getComputedStyle(document.body),
      n = t[e === "padding" ? "paddingLeft" : "marginLeft"],
      r = t[e === "padding" ? "paddingTop" : "marginTop"],
      o = t[e === "padding" ? "paddingRight" : "marginRight"];
    return [Vo(n), Vo(r), Vo(o)];
  },
  L2 = function (e) {
    if (e === void 0 && (e = "margin"), typeof window > "u") return A2;
    var t = $2(e),
      n = document.documentElement.clientWidth,
      r = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, r - n + t[2] - t[0])
    };
  },
  z2 = qf(),
  Qn = "data-scroll-locked",
  R2 = function (e, t, n, r) {
    var o = e.left,
      s = e.top,
      a = e.right,
      i = e.gap;
    return n === void 0 && (n = "margin"), `
  .`.concat(y2, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(Qn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([t && "position: relative ".concat(r, ";"), n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `), n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(fs, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(ps, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(fs, " .").concat(fs, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ps, " .").concat(ps, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Qn, `] {
    `).concat(x2, ": ").concat(i, `px;
  }
`);
  },
  gc = function () {
    var e = parseInt(document.body.getAttribute(Qn) || "0", 10);
    return isFinite(e) ? e : 0;
  },
  P2 = function () {
    M.useEffect(function () {
      return document.body.setAttribute(Qn, (gc() + 1).toString()), function () {
        var e = gc() - 1;
        e <= 0 ? document.body.removeAttribute(Qn) : document.body.setAttribute(Qn, e.toString());
      };
    }, []);
  },
  V2 = function (e) {
    var t = e.noRelative,
      n = e.noImportant,
      r = e.gapMode,
      o = r === void 0 ? "margin" : r;
    P2();
    var s = M.useMemo(function () {
      return L2(o);
    }, [o]);
    return M.createElement(z2, {
      styles: R2(s, !t, o, n ? "" : "!important")
    });
  },
  ya = !1;
if (typeof window < "u") try {
  var os = Object.defineProperty({}, "passive", {
    get: function () {
      return ya = !0, !0;
    }
  });
  window.addEventListener("test", os, os), window.removeEventListener("test", os, os);
} catch {
  ya = !1;
}
var Ln = ya ? {
    passive: !1
  } : !1,
  F2 = function (e) {
    return e.tagName === "TEXTAREA";
  },
  Kf = function (e, t) {
    var n = window.getComputedStyle(e);
    return (
      // not-not-scrollable
      n[t] !== "hidden" &&
      // contains scroll inside self
      !(n.overflowY === n.overflowX && !F2(e) && n[t] === "visible")
    );
  },
  U2 = function (e) {
    return Kf(e, "overflowY");
  },
  Y2 = function (e) {
    return Kf(e, "overflowX");
  },
  hc = function (e, t) {
    var n = t;
    do {
      typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
      var r = Zf(e, n);
      if (r) {
        var o = Gf(e, n),
          s = o[1],
          a = o[2];
        if (s > a) return !0;
      }
      n = n.parentNode;
    } while (n && n !== document.body);
    return !1;
  },
  W2 = function (e) {
    var t = e.scrollTop,
      n = e.scrollHeight,
      r = e.clientHeight;
    return [t, n, r];
  },
  B2 = function (e) {
    var t = e.scrollLeft,
      n = e.scrollWidth,
      r = e.clientWidth;
    return [t, n, r];
  },
  Zf = function (e, t) {
    return e === "v" ? U2(t) : Y2(t);
  },
  Gf = function (e, t) {
    return e === "v" ? W2(t) : B2(t);
  },
  H2 = function (e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
  },
  Q2 = function (e, t, n, r, o) {
    var s = H2(e, window.getComputedStyle(t).direction),
      a = s * r,
      i = n.target,
      l = t.contains(i),
      c = !1,
      d = a > 0,
      f = 0,
      g = 0;
    do {
      var p = Gf(e, i),
        x = p[0],
        m = p[1],
        h = p[2],
        j = m - h - s * x;
      (x || j) && Zf(e, i) && (f += j, g += x), i = i.parentNode;
    } while (
    // portaled content
    !l && i !== document.body ||
    // self content
    l && (t.contains(i) || t === i));
    return (d && (o && f === 0 || !o && a > f) || !d && (o && g === 0 || !o && -a > g)) && (c = !0), c;
  },
  as = function (e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
  vc = function (e) {
    return [e.deltaX, e.deltaY];
  },
  _c = function (e) {
    return e && "current" in e ? e.current : e;
  },
  q2 = function (e, t) {
    return e[0] === t[0] && e[1] === t[1];
  },
  K2 = function (e) {
    return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
  },
  Z2 = 0,
  zn = [];
function G2(e) {
  var t = M.useRef([]),
    n = M.useRef([0, 0]),
    r = M.useRef(),
    o = M.useState(Z2++)[0],
    s = M.useState(function () {
      return qf();
    })[0],
    a = M.useRef(e);
  M.useEffect(function () {
    a.current = e;
  }, [e]), M.useEffect(function () {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = Gu([e.lockRef.current], (e.shards || []).map(_c), !0).filter(Boolean);
      return m.forEach(function (h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function (h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = M.useCallback(function (m, h) {
      if ("touches" in m && m.touches.length === 2) return !a.current.allowPinchZoom;
      var j = as(m),
        v = n.current,
        _ = "deltaX" in m ? m.deltaX : v[0] - j[0],
        k = "deltaY" in m ? m.deltaY : v[1] - j[1],
        y,
        b = m.target,
        C = Math.abs(_) > Math.abs(k) ? "h" : "v";
      if ("touches" in m && C === "h" && b.type === "range") return !1;
      var N = hc(C, b);
      if (!N) return !0;
      if (N ? y = C : (y = C === "v" ? "h" : "v", N = hc(C, b)), !N) return !1;
      if (!r.current && "changedTouches" in m && (_ || k) && (r.current = y), !y) return !0;
      var T = r.current || y;
      return Q2(T, h, m, T === "h" ? _ : k, !0);
    }, []),
    l = M.useCallback(function (m) {
      var h = m;
      if (!(!zn.length || zn[zn.length - 1] !== s)) {
        var j = "deltaY" in h ? vc(h) : as(h),
          v = t.current.filter(function (y) {
            return y.name === h.type && y.target === h.target && q2(y.delta, j);
          })[0];
        if (v && v.should) {
          h.cancelable && h.preventDefault();
          return;
        }
        if (!v) {
          var _ = (a.current.shards || []).map(_c).filter(Boolean).filter(function (y) {
              return y.contains(h.target);
            }),
            k = _.length > 0 ? i(h, _[0]) : !a.current.noIsolation;
          k && h.cancelable && h.preventDefault();
        }
      }
    }, []),
    c = M.useCallback(function (m, h, j, v) {
      var _ = {
        name: m,
        delta: h,
        target: j,
        should: v
      };
      t.current.push(_), setTimeout(function () {
        t.current = t.current.filter(function (k) {
          return k !== _;
        });
      }, 1);
    }, []),
    d = M.useCallback(function (m) {
      n.current = as(m), r.current = void 0;
    }, []),
    f = M.useCallback(function (m) {
      c(m.type, vc(m), m.target, i(m, e.lockRef.current));
    }, []),
    g = M.useCallback(function (m) {
      c(m.type, as(m), m.target, i(m, e.lockRef.current));
    }, []);
  M.useEffect(function () {
    return zn.push(s), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", l, Ln), document.addEventListener("touchmove", l, Ln), document.addEventListener("touchstart", d, Ln), function () {
      zn = zn.filter(function (m) {
        return m !== s;
      }), document.removeEventListener("wheel", l, Ln), document.removeEventListener("touchmove", l, Ln), document.removeEventListener("touchstart", d, Ln);
    };
  }, []);
  var p = e.removeScrollBar,
    x = e.inert;
  return M.createElement(M.Fragment, null, x ? M.createElement(s, {
    styles: K2(o)
  }) : null, p ? M.createElement(V2, {
    gapMode: "margin"
  }) : null);
}
const J2 = I2(Qf, G2);
var Jf = M.forwardRef(function (e, t) {
  return M.createElement(no, Le({}, e, {
    ref: t,
    sideCar: J2
  }));
});
Jf.classNames = no.classNames;
const X2 = Jf,
  eM = ["Enter", " "],
  tM = ["ArrowDown", "PageUp", "Home"],
  Xf = ["ArrowUp", "PageDown", "End"],
  nM = [...tM, ...Xf],
  ro = "Menu",
  [xa, rM, sM] = Yr(ro),
  [In, ep] = Vt(ro, [sM, Rf, to]),
  yi = Rf(),
  tp = to(),
  [oM, Br] = In(ro),
  [aM, xi] = In(ro),
  iM = e => {
    const {
        __scopeMenu: t,
        open: n = !1,
        children: r,
        dir: o,
        onOpenChange: s,
        modal: a = !0
      } = e,
      i = yi(t),
      [l, c] = le(null),
      d = ee(!1),
      f = We(s),
      g = Wr(o);
    return fe(() => {
      const p = () => {
          d.current = !0, document.addEventListener("pointerdown", x, {
            capture: !0,
            once: !0
          }), document.addEventListener("pointermove", x, {
            capture: !0,
            once: !0
          });
        },
        x = () => d.current = !1;
      return document.addEventListener("keydown", p, {
        capture: !0
      }), () => {
        document.removeEventListener("keydown", p, {
          capture: !0
        }), document.removeEventListener("pointerdown", x, {
          capture: !0
        }), document.removeEventListener("pointermove", x, {
          capture: !0
        });
      };
    }, []), /* @__PURE__ */F(t2, i, /* @__PURE__ */F(oM, {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: c
    }, /* @__PURE__ */F(aM, {
      scope: t,
      onClose: ge(() => f(!1), [f]),
      isUsingKeyboardRef: d,
      dir: g,
      modal: a
    }, r)));
  },
  lM = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeMenu: n,
        ...r
      } = e,
      o = yi(n);
    return /* @__PURE__ */F(n2, V({}, o, r, {
      ref: t
    }));
  }),
  np = "MenuPortal",
  [cM, uM] = In(np, {
    forceMount: void 0
  }),
  dM = e => {
    const {
        __scopeMenu: t,
        forceMount: n,
        children: r,
        container: o
      } = e,
      s = Br(np, t);
    return /* @__PURE__ */F(cM, {
      scope: t,
      forceMount: n
    }, /* @__PURE__ */F(un, {
      present: n || s.open
    }, /* @__PURE__ */F(s2, {
      asChild: !0,
      container: o
    }, r)));
  },
  qt = "MenuContent",
  [fM, rp] = In(qt),
  pM = /* @__PURE__ */ce((e, t) => {
    const n = uM(qt, e.__scopeMenu),
      {
        forceMount: r = n.forceMount,
        ...o
      } = e,
      s = Br(qt, e.__scopeMenu),
      a = xi(qt, e.__scopeMenu);
    return /* @__PURE__ */F(xa.Provider, {
      scope: e.__scopeMenu
    }, /* @__PURE__ */F(un, {
      present: r || s.open
    }, /* @__PURE__ */F(xa.Slot, {
      scope: e.__scopeMenu
    }, a.modal ? /* @__PURE__ */F(mM, V({}, o, {
      ref: t
    })) : /* @__PURE__ */F(gM, V({}, o, {
      ref: t
    })))));
  }),
  mM = /* @__PURE__ */ce((e, t) => {
    const n = Br(qt, e.__scopeMenu),
      r = ee(null),
      o = Fe(t, r);
    return fe(() => {
      const s = r.current;
      if (s) return Zu(s);
    }, []), /* @__PURE__ */F(sp, V({}, e, {
      ref: o,
      trapFocus: n.open,
      disableOutsidePointerEvents: n.open,
      disableOutsideScroll: !0,
      onFocusOutside: _e(e.onFocusOutside, s => s.preventDefault(), {
        checkForDefaultPrevented: !1
      }),
      onDismiss: () => n.onOpenChange(!1)
    }));
  }),
  gM = /* @__PURE__ */ce((e, t) => {
    const n = Br(qt, e.__scopeMenu);
    return /* @__PURE__ */F(sp, V({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }));
  }),
  sp = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeMenu: n,
        loop: r = !1,
        trapFocus: o,
        onOpenAutoFocus: s,
        onCloseAutoFocus: a,
        disableOutsidePointerEvents: i,
        onEntryFocus: l,
        onEscapeKeyDown: c,
        onPointerDownOutside: d,
        onFocusOutside: f,
        onInteractOutside: g,
        onDismiss: p,
        disableOutsideScroll: x,
        ...m
      } = e,
      h = Br(qt, n),
      j = xi(qt, n),
      v = yi(n),
      _ = tp(n),
      k = rM(n),
      [y, b] = le(null),
      C = ee(null),
      N = Fe(t, C, h.onContentChange),
      T = ee(0),
      z = ee(""),
      K = ee(0),
      L = ee(null),
      H = ee("right"),
      Y = ee(0),
      X = x ? X2 : gs,
      ne = x ? {
        as: Dr,
        allowPinchZoom: !0
      } : void 0,
      U = Z => {
        var S, R;
        const ae = z.current + Z,
          P = k().filter(B => !B.disabled),
          D = document.activeElement,
          O = (S = P.find(B => B.ref.current === D)) === null || S === void 0 ? void 0 : S.textValue,
          A = P.map(B => B.textValue),
          E = wM(A, ae, O),
          G = (R = P.find(B => B.textValue === E)) === null || R === void 0 ? void 0 : R.ref.current;
        (function B(Q) {
          z.current = Q, window.clearTimeout(T.current), Q !== "" && (T.current = window.setTimeout(() => B(""), 1e3));
        })(ae), G && setTimeout(() => G.focus());
      };
    fe(() => () => window.clearTimeout(T.current), []), Lk();
    const de = ge(Z => {
      var S, R;
      return H.current === ((S = L.current) === null || S === void 0 ? void 0 : S.side) && NM(Z, (R = L.current) === null || R === void 0 ? void 0 : R.area);
    }, []);
    return /* @__PURE__ */F(fM, {
      scope: n,
      searchRef: z,
      onItemEnter: ge(Z => {
        de(Z) && Z.preventDefault();
      }, [de]),
      onItemLeave: ge(Z => {
        var S;
        de(Z) || ((S = C.current) === null || S === void 0 || S.focus(), b(null));
      }, [de]),
      onTriggerLeave: ge(Z => {
        de(Z) && Z.preventDefault();
      }, [de]),
      pointerGraceTimerRef: K,
      onPointerGraceIntentChange: ge(Z => {
        L.current = Z;
      }, [])
    }, /* @__PURE__ */F(X, ne, /* @__PURE__ */F(zk, {
      asChild: !0,
      trapped: o,
      onMountAutoFocus: _e(s, Z => {
        var S;
        Z.preventDefault(), (S = C.current) === null || S === void 0 || S.focus();
      }),
      onUnmountAutoFocus: a
    }, /* @__PURE__ */F(Of, {
      asChild: !0,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: c,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: g,
      onDismiss: p
    }, /* @__PURE__ */F(Wf, V({
      asChild: !0
    }, _, {
      dir: j.dir,
      orientation: "vertical",
      loop: r,
      currentTabStopId: y,
      onCurrentTabStopIdChange: b,
      onEntryFocus: _e(l, Z => {
        j.isUsingKeyboardRef.current || Z.preventDefault();
      })
    }), /* @__PURE__ */F(r2, V({
      role: "menu",
      "aria-orientation": "vertical",
      "data-state": kM(h.open),
      "data-radix-menu-content": "",
      dir: j.dir
    }, v, m, {
      ref: N,
      style: {
        outline: "none",
        ...m.style
      },
      onKeyDown: _e(m.onKeyDown, Z => {
        const R = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget,
          ae = Z.ctrlKey || Z.altKey || Z.metaKey,
          P = Z.key.length === 1;
        R && (Z.key === "Tab" && Z.preventDefault(), !ae && P && U(Z.key));
        const D = C.current;
        if (Z.target !== D || !nM.includes(Z.key)) return;
        Z.preventDefault();
        const A = k().filter(E => !E.disabled).map(E => E.ref.current);
        Xf.includes(Z.key) && A.reverse(), MM(A);
      }),
      onBlur: _e(e.onBlur, Z => {
        Z.currentTarget.contains(Z.target) || (window.clearTimeout(T.current), z.current = "");
      }),
      onPointerMove: _e(e.onPointerMove, Ma(Z => {
        const S = Z.target,
          R = Y.current !== Z.clientX;
        if (Z.currentTarget.contains(S) && R) {
          const ae = Z.clientX > Y.current ? "right" : "left";
          H.current = ae, Y.current = Z.clientX;
        }
      }))
    })))))));
  }),
  hM = /* @__PURE__ */ce((e, t) => {
    const {
      __scopeMenu: n,
      ...r
    } = e;
    return /* @__PURE__ */F(Oe.div, V({
      role: "group"
    }, r, {
      ref: t
    }));
  }),
  ka = "MenuItem",
  jc = "menu.itemSelect",
  vM = /* @__PURE__ */ce((e, t) => {
    const {
        disabled: n = !1,
        onSelect: r,
        ...o
      } = e,
      s = ee(null),
      a = xi(ka, e.__scopeMenu),
      i = rp(ka, e.__scopeMenu),
      l = Fe(t, s),
      c = ee(!1),
      d = () => {
        const f = s.current;
        if (!n && f) {
          const g = new CustomEvent(jc, {
            bubbles: !0,
            cancelable: !0
          });
          f.addEventListener(jc, p => r == null ? void 0 : r(p), {
            once: !0
          }), Ls(f, g), g.defaultPrevented ? c.current = !1 : a.onClose();
        }
      };
    return /* @__PURE__ */F(_M, V({}, o, {
      ref: l,
      disabled: n,
      onClick: _e(e.onClick, d),
      onPointerDown: f => {
        var g;
        (g = e.onPointerDown) === null || g === void 0 || g.call(e, f), c.current = !0;
      },
      onPointerUp: _e(e.onPointerUp, f => {
        var g;
        c.current || (g = f.currentTarget) === null || g === void 0 || g.click();
      }),
      onKeyDown: _e(e.onKeyDown, f => {
        const g = i.searchRef.current !== "";
        n || g && f.key === " " || eM.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
      })
    }));
  }),
  _M = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeMenu: n,
        disabled: r = !1,
        textValue: o,
        ...s
      } = e,
      a = rp(ka, n),
      i = tp(n),
      l = ee(null),
      c = Fe(t, l),
      [d, f] = le(!1),
      [g, p] = le("");
    return fe(() => {
      const x = l.current;
      if (x) {
        var m;
        p(((m = x.textContent) !== null && m !== void 0 ? m : "").trim());
      }
    }, [s.children]), /* @__PURE__ */F(xa.ItemSlot, {
      scope: n,
      disabled: r,
      textValue: o ?? g
    }, /* @__PURE__ */F(Bf, V({
      asChild: !0
    }, i, {
      focusable: !r
    }), /* @__PURE__ */F(Oe.div, V({
      role: "menuitem",
      "data-highlighted": d ? "" : void 0,
      "aria-disabled": r || void 0,
      "data-disabled": r ? "" : void 0
    }, s, {
      ref: c,
      onPointerMove: _e(e.onPointerMove, Ma(x => {
        r ? a.onItemLeave(x) : (a.onItemEnter(x), x.defaultPrevented || x.currentTarget.focus());
      })),
      onPointerLeave: _e(e.onPointerLeave, Ma(x => a.onItemLeave(x))),
      onFocus: _e(e.onFocus, () => f(!0)),
      onBlur: _e(e.onBlur, () => f(!1))
    }))));
  }),
  jM = "MenuRadioGroup";
In(jM, {
  value: void 0,
  onValueChange: () => {}
});
const yM = "MenuItemIndicator";
In(yM, {
  checked: !1
});
const xM = "MenuSub";
In(xM);
function kM(e) {
  return e ? "open" : "closed";
}
function MM(e) {
  const t = document.activeElement;
  for (const n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function bM(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function wM(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(c => c === t[0]) ? t[0] : t,
    s = n ? e.indexOf(n) : -1;
  let a = bM(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter(c => c !== n));
  const l = a.find(c => c.toLowerCase().startsWith(o.toLowerCase()));
  return l !== n ? l : void 0;
}
function CM(e, t) {
  const {
    x: n,
    y: r
  } = e;
  let o = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const i = t[s].x,
      l = t[s].y,
      c = t[a].x,
      d = t[a].y;
    l > r != d > r && n < (c - i) * (r - l) / (d - l) + i && (o = !o);
  }
  return o;
}
function NM(e, t) {
  if (!t) return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return CM(n, t);
}
function Ma(e) {
  return t => t.pointerType === "mouse" ? e(t) : void 0;
}
const IM = iM,
  EM = lM,
  SM = dM,
  TM = pM,
  DM = hM,
  OM = vM,
  op = "DropdownMenu",
  [AM, KN] = Vt(op, [ep]),
  or = ep(),
  [$M, ap] = AM(op),
  LM = e => {
    const {
        __scopeDropdownMenu: t,
        children: n,
        dir: r,
        open: o,
        defaultOpen: s,
        onOpenChange: a,
        modal: i = !0
      } = e,
      l = or(t),
      c = ee(null),
      [d = !1, f] = Nn({
        prop: o,
        defaultProp: s,
        onChange: a
      });
    return /* @__PURE__ */F($M, {
      scope: t,
      triggerId: sn(),
      triggerRef: c,
      contentId: sn(),
      open: d,
      onOpenChange: f,
      onOpenToggle: ge(() => f(g => !g), [f]),
      modal: i
    }, /* @__PURE__ */F(IM, V({}, l, {
      open: d,
      onOpenChange: f,
      dir: r,
      modal: i
    }), n));
  },
  zM = "DropdownMenuTrigger",
  RM = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeDropdownMenu: n,
        disabled: r = !1,
        ...o
      } = e,
      s = ap(zM, n),
      a = or(n);
    return /* @__PURE__ */F(EM, V({
      asChild: !0
    }, a), /* @__PURE__ */F(Oe.button, V({
      type: "button",
      id: s.triggerId,
      "aria-haspopup": "menu",
      "aria-expanded": s.open,
      "aria-controls": s.open ? s.contentId : void 0,
      "data-state": s.open ? "open" : "closed",
      "data-disabled": r ? "" : void 0,
      disabled: r
    }, o, {
      ref: eo(t, s.triggerRef),
      onPointerDown: _e(e.onPointerDown, i => {
        !r && i.button === 0 && i.ctrlKey === !1 && (s.onOpenToggle(), s.open || i.preventDefault());
      }),
      onKeyDown: _e(e.onKeyDown, i => {
        r || (["Enter", " "].includes(i.key) && s.onOpenToggle(), i.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
      })
    })));
  }),
  PM = e => {
    const {
        __scopeDropdownMenu: t,
        ...n
      } = e,
      r = or(t);
    return /* @__PURE__ */F(SM, V({}, r, n));
  },
  VM = "DropdownMenuContent",
  FM = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeDropdownMenu: n,
        ...r
      } = e,
      o = ap(VM, n),
      s = or(n),
      a = ee(!1);
    return /* @__PURE__ */F(TM, V({
      id: o.contentId,
      "aria-labelledby": o.triggerId
    }, s, r, {
      ref: t,
      onCloseAutoFocus: _e(e.onCloseAutoFocus, i => {
        var l;
        a.current || (l = o.triggerRef.current) === null || l === void 0 || l.focus(), a.current = !1, i.preventDefault();
      }),
      onInteractOutside: _e(e.onInteractOutside, i => {
        const l = i.detail.originalEvent,
          c = l.button === 0 && l.ctrlKey === !0,
          d = l.button === 2 || c;
        (!o.modal || d) && (a.current = !0);
      }),
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }));
  }),
  UM = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeDropdownMenu: n,
        ...r
      } = e,
      o = or(n);
    return /* @__PURE__ */F(DM, V({}, o, r, {
      ref: t
    }));
  }),
  YM = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeDropdownMenu: n,
        ...r
      } = e,
      o = or(n);
    return /* @__PURE__ */F(OM, V({}, o, r, {
      ref: t
    }));
  }),
  WM = LM,
  BM = RM,
  HM = PM,
  QM = FM,
  ip = UM,
  yc = YM,
  qM = "data:image/svg+xml;base64,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",
  KM = "data:image/svg+xml;base64,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",
  zs = _ref70 => {
    let {
      src: e,
      alt: t = "",
      ...n
    } = _ref70;
    return /* @__PURE__ */u.jsx("img", {
      alt: t,
      src: e || KM,
      ...n
    });
  };
var ZM = "iyrzia0",
  GM = "iyrzia2",
  JM = "iyrzia3",
  XM = "iyrzia4",
  eb = "iyrzia5",
  tb = "iyrzia6",
  nb = "iyrzia7",
  rb = "iyrzia8",
  xc = "iyrzia9",
  sb = "iyrziaa",
  ob = "iyrziab",
  ab = "iyrziac",
  Fo = "iyrziad",
  kc = "iyrziae",
  Mc = "iyrziaf",
  bc = "iyrziag",
  ib = "iyrziah";
function lb(_ref71) {
  let {
    children: e,
    onClick: t
  } = _ref71;
  return /* @__PURE__ */u.jsx(BM, {
    className: tb,
    asChild: !0,
    children: /* @__PURE__ */u.jsx("button", {
      onClick: t,
      children: e
    })
  });
}
function cb(_ref72) {
  let {
    src: e,
    href: t = "/",
    title: n,
    children: r,
    ...o
  } = _ref72;
  return /* @__PURE__ */u.jsx("div", {
    className: JM,
    ...o,
    children: r || /* @__PURE__ */u.jsx("a", {
      href: t,
      title: n,
      children: /* @__PURE__ */u.jsx(zs, {
        alt: "",
        src: e
      })
    })
  });
}
function ub(_ref73) {
  let {
    children: e,
    container: t,
    ...n
  } = _ref73;
  return /* @__PURE__ */u.jsx(HM, {
    className: eb,
    container: t,
    ...n,
    children: e
  });
}
function db(_ref74) {
  let {
    children: e,
    nestedLevel: t = 0,
    sideOffset: n = 26,
    ...r
  } = _ref74;
  return /* @__PURE__ */u.jsx(QM, {
    className: rb,
    sideOffset: n,
    ...r,
    children: e
  });
}
function fb(_ref75) {
  let {
    children: e,
    ...t
  } = _ref75;
  return /* @__PURE__ */u.jsx(ip, {
    className: ab,
    ...t,
    children: e
  });
}
function pb(_ref76) {
  let {
    children: e,
    className: t,
    ...n
  } = _ref76;
  return /* @__PURE__ */u.jsx(ip, {
    className: ye([ob, t]),
    ...n,
    children: e
  });
}
function lp(_ref77) {
  let {
    children: e,
    href: t,
    description: n,
    onClick: r,
    icon: o,
    featured: s,
    dataName: a,
    ...i
  } = _ref77;
  return r ? /* @__PURE__ */u.jsx(yc, {
    onSelect: r,
    children: /* @__PURE__ */u.jsxs("li", {
      className: Fo,
      children: [/* @__PURE__ */u.jsxs("div", {
        className: kc,
        "data-name": a,
        children: [/* @__PURE__ */u.jsxs("div", {
          className: bc,
          children: [o || null, /* @__PURE__ */u.jsx("span", {
            ...i,
            children: e
          })]
        }), n ? /* @__PURE__ */u.jsx("p", {
          className: Mc,
          children: n
        }) : null]
      }), /* @__PURE__ */u.jsx("svg", {
        fill: "none",
        height: "17",
        viewBox: "0 0 16 17",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */u.jsx("g", {
          id: "right-icon",
          children: /* @__PURE__ */u.jsx("path", {
            d: "M10.4665 8.5L6.46654 12.5L5.5332 11.5667L8.59987 8.5L5.5332 5.43333L6.46654 4.5L10.4665 8.5Z",
            fill: "currentColor",
            id: "vector"
          })
        })
      })]
    })
  }) : /* @__PURE__ */u.jsx(yc, {
    asChild: !0,
    children: /* @__PURE__ */u.jsx("li", {
      children: /* @__PURE__ */u.jsxs("a", {
        className: s ? ye([ib, Fo]) : Fo,
        href: t,
        ...i,
        children: [/* @__PURE__ */u.jsxs("div", {
          className: kc,
          "data-name": a,
          children: [/* @__PURE__ */u.jsxs("div", {
            className: bc,
            children: [o || null, e]
          }), n ? /* @__PURE__ */u.jsx("p", {
            className: Mc,
            children: n
          }) : null]
        }), /* @__PURE__ */u.jsx("svg", {
          fill: "none",
          height: "17",
          viewBox: "0 0 16 17",
          width: "16",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */u.jsx("g", {
            id: "right-icon",
            children: /* @__PURE__ */u.jsx("path", {
              d: "M13.3334 8.50004L8.00008 13.8334L7.05008 12.9L10.7834 9.16671H2.66675V7.83337H10.7834L7.05008 4.10004L8.00008 3.16671L13.3334 8.50004Z",
              fill: "currentColor",
              id: "vector"
            })
          })
        })]
      })
    })
  });
}
function mb(_ref78) {
  let {
    children: e,
    ...t
  } = _ref78;
  return /* @__PURE__ */u.jsx("div", {
    className: nb,
    ...t,
    children: e
  });
}
function gb(_ref79) {
  let {
    children: e,
    icon: t,
    ...n
  } = _ref79;
  return t ? /* @__PURE__ */u.jsxs("div", {
    className: sb,
    children: [t || null, /* @__PURE__ */u.jsx("p", {
      className: xc,
      ...n,
      children: e
    })]
  }) : /* @__PURE__ */u.jsx("p", {
    className: xc,
    ...n,
    children: e
  });
}
const hb = ce((_ref80, s) => {
    let {
      isSticky: e,
      showMinimalUI: t,
      children: n,
      open: r,
      setOpen: o
    } = _ref80;
    const a = {
      ...(e ? {
        "data-sticky": ""
      } : {}),
      ...(t ? {
        "data-minimal-ui": ""
      } : {})
    };
    return /* @__PURE__ */u.jsx("div", {
      ref: s,
      className: ZM,
      ...a,
      children: /* @__PURE__ */u.jsx(WM, {
        open: r,
        onOpenChange: o,
        children: /* @__PURE__ */u.jsx("div", {
          className: GM,
          children: /* @__PURE__ */u.jsx("div", {
            className: XM,
            children: n
          })
        })
      })
    });
  }),
  vb = fb,
  _b = lb,
  jb = cb,
  yb = ub,
  xb = db,
  wc = lp,
  kb = gb,
  Mb = pb,
  ZN = lp,
  bb = mb;
var wb = "sqffg13",
  Cb = "sqffg14",
  Nb = "sqffg15",
  Ib = "sqffg16",
  Eb = "sqffg17",
  cp = "sqffg18",
  ba = "sqffg19",
  Sb = "sqffg1f",
  Tb = "sqffg1g",
  up = Ue({
    defaultClassName: "sqffg1h",
    variantClassNames: {
      placement: {
        topLeft: "sqffg1i",
        topRight: "sqffg1j",
        bottomLeft: "sqffg1k",
        bottomRight: "sqffg1l"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  Db = "sqffg1m",
  Ob = "sqffg1n",
  Ab = "sqffg1o",
  $b = "sqffg1p";
const wa = _ref81 => {
    let {
      placement: e,
      image: t,
      altText: n = ""
    } = _ref81;
    return /* @__PURE__ */u.jsx("div", {
      className: up({
        placement: e
      }),
      children: /* @__PURE__ */u.jsx("img", {
        alt: n,
        className: Db,
        src: t
      })
    });
  },
  Ca = _ref82 => {
    let {
      placement: e,
      title: t,
      description: n,
      link: r,
      actionText: o,
      index: s
    } = _ref82;
    return /* @__PURE__ */u.jsxs("div", {
      className: up({
        placement: e
      }),
      children: [/* @__PURE__ */u.jsx(ut, {
        as: "h5",
        className: Ob,
        children: t
      }), /* @__PURE__ */u.jsx("div", {
        className: Ab,
        children: n
      }), /* @__PURE__ */u.jsxs(Zt, {
        className: $b,
        url: r,
        "data-track-element": `mosaic-tile-${s}`,
        children: [o, /* @__PURE__ */u.jsx(zr, {})]
      })]
    });
  };
function Lb(e) {
  const t = [];
  for (let n = 0; n < e.length && n + 1 !== e.length; n += 2) {
    const {
        image: r,
        altText: o,
        ...s
      } = e[n],
      {
        image: a,
        altText: i,
        ...l
      } = e[n + 1];
    t.push(/* @__PURE__ */u.jsxs("div", {
      className: cp,
      children: [/* @__PURE__ */u.jsxs("div", {
        className: ba,
        children: [/* @__PURE__ */u.jsx(wa, {
          altText: o,
          image: r,
          placement: "topLeft"
        }), /* @__PURE__ */u.jsx(Ca, {
          altText: i,
          placement: "topRight",
          index: n,
          ...l
        })]
      }), /* @__PURE__ */u.jsxs("div", {
        className: ba,
        children: [/* @__PURE__ */u.jsx(Ca, {
          altText: o,
          placement: "bottomLeft",
          index: n + 1,
          ...s
        }), /* @__PURE__ */u.jsx(wa, {
          altText: i,
          image: a,
          placement: "bottomRight"
        })]
      })]
    }));
  }
  return t;
}
const GN = _ref83 => {
  let {
    tilesData: e,
    titleElement: t,
    description: n,
    introduction: r,
    ...o
  } = _ref83;
  return /* @__PURE__ */u.jsxs(pe, {
    ...o,
    className: ye([o.className, wb]),
    children: [/* @__PURE__ */u.jsxs(pe, {
      className: Cb,
      children: [/* @__PURE__ */u.jsx(pe, {
        className: Nb,
        children: r
      }), /* @__PURE__ */u.jsx(pe, {
        className: Ib,
        children: t
      }), /* @__PURE__ */u.jsx(pe, {
        className: Eb,
        children: n
      })]
    }), /* @__PURE__ */u.jsx("div", {
      className: Sb,
      children: e.map((_ref84, i) => {
        let {
          image: s,
          ...a
        } = _ref84;
        return /* @__PURE__ */u.jsx("div", {
          className: cp,
          children: /* @__PURE__ */u.jsxs("div", {
            className: ba,
            children: [/* @__PURE__ */u.jsx(wa, {
              altText: a.altText,
              image: s
            }), /* @__PURE__ */u.jsx(Ca, {
              ...a,
              index: i
            })]
          })
        }, `mobile-tile-${a.id}`);
      })
    }), /* @__PURE__ */u.jsx("div", {
      className: Tb,
      children: Lb(e)
    })]
  });
};
function zb(e) {
  const t = ee({
    value: e,
    previous: e
  });
  return it(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const Rb = /* @__PURE__ */ce((e, t) => /* @__PURE__ */F(Oe.span, V({}, e, {
    ref: t,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...e.style
    }
  }))),
  Pb = Rb,
  Hr = "NavigationMenu",
  [ki, Vb, Fb] = Yr(Hr),
  [Na, Ub, Yb] = Yr(Hr),
  [Mi, JN] = Vt(Hr, [Fb, Yb]),
  [Wb, Ft] = Mi(Hr),
  [Bb, Hb] = Mi(Hr),
  Qb = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        value: r,
        onValueChange: o,
        defaultValue: s,
        delayDuration: a = 200,
        skipDelayDuration: i = 300,
        orientation: l = "horizontal",
        dir: c,
        ...d
      } = e,
      [f, g] = le(null),
      p = Fe(t, T => g(T)),
      x = Wr(c),
      m = ee(0),
      h = ee(0),
      j = ee(0),
      [v, _] = le(!0),
      [k = "", y] = Nn({
        prop: r,
        onChange: T => {
          const z = T !== "",
            K = i > 0;
          z ? (window.clearTimeout(j.current), K && _(!1)) : (window.clearTimeout(j.current), j.current = window.setTimeout(() => _(!0), i)), o == null || o(T);
        },
        defaultProp: s
      }),
      b = ge(() => {
        window.clearTimeout(h.current), h.current = window.setTimeout(() => y(""), 150);
      }, [y]),
      C = ge(T => {
        window.clearTimeout(h.current), y(T);
      }, [y]),
      N = ge(T => {
        k === T ? window.clearTimeout(h.current) : m.current = window.setTimeout(() => {
          window.clearTimeout(h.current), y(T);
        }, a);
      }, [k, y, a]);
    return fe(() => () => {
      window.clearTimeout(m.current), window.clearTimeout(h.current), window.clearTimeout(j.current);
    }, []), /* @__PURE__ */F(qb, {
      scope: n,
      isRootMenu: !0,
      value: k,
      dir: x,
      orientation: l,
      rootNavigationMenu: f,
      onTriggerEnter: T => {
        window.clearTimeout(m.current), v ? N(T) : C(T);
      },
      onTriggerLeave: () => {
        window.clearTimeout(m.current), b();
      },
      onContentEnter: () => window.clearTimeout(h.current),
      onContentLeave: b,
      onItemSelect: T => {
        y(z => z === T ? "" : T);
      },
      onItemDismiss: () => y("")
    }, /* @__PURE__ */F(Oe.nav, V({
      "aria-label": "Main",
      "data-orientation": l,
      dir: x
    }, d, {
      ref: p
    })));
  }),
  qb = e => {
    const {
        scope: t,
        isRootMenu: n,
        rootNavigationMenu: r,
        dir: o,
        orientation: s,
        children: a,
        value: i,
        onItemSelect: l,
        onItemDismiss: c,
        onTriggerEnter: d,
        onTriggerLeave: f,
        onContentEnter: g,
        onContentLeave: p
      } = e,
      [x, m] = le(null),
      [h, j] = le(/* @__PURE__ */new Map()),
      [v, _] = le(null);
    return /* @__PURE__ */F(Wb, {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: i,
      previousValue: zb(i),
      baseId: sn(),
      dir: o,
      orientation: s,
      viewport: x,
      onViewportChange: m,
      indicatorTrack: v,
      onIndicatorTrackChange: _,
      onTriggerEnter: We(d),
      onTriggerLeave: We(f),
      onContentEnter: We(g),
      onContentLeave: We(p),
      onItemSelect: We(l),
      onItemDismiss: We(c),
      onViewportContentChange: ge((k, y) => {
        j(b => (b.set(k, y), new Map(b)));
      }, []),
      onViewportContentRemove: ge(k => {
        j(y => y.has(k) ? (y.delete(k), new Map(y)) : y);
      }, [])
    }, /* @__PURE__ */F(ki.Provider, {
      scope: t
    }, /* @__PURE__ */F(Bb, {
      scope: t,
      items: h
    }, a)));
  },
  Kb = "NavigationMenuList",
  Zb = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        ...r
      } = e,
      o = Ft(Kb, n),
      s = /* @__PURE__ */F(Oe.ul, V({
        "data-orientation": o.orientation
      }, r, {
        ref: t
      }));
    return /* @__PURE__ */F(Oe.div, {
      style: {
        position: "relative"
      },
      ref: o.onIndicatorTrackChange
    }, /* @__PURE__ */F(ki.Slot, {
      scope: n
    }, o.isRootMenu ? /* @__PURE__ */F(mp, {
      asChild: !0
    }, s) : s));
  }),
  Gb = "NavigationMenuItem",
  [Jb, dp] = Mi(Gb),
  Xb = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        value: r,
        ...o
      } = e,
      s = sn(),
      a = r || s || "LEGACY_REACT_AUTO_VALUE",
      i = ee(null),
      l = ee(null),
      c = ee(null),
      d = ee(() => {}),
      f = ee(!1),
      g = ge(function () {
        let x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "start";
        if (i.current) {
          d.current();
          const m = Ia(i.current);
          m.length && bi(x === "start" ? m : m.reverse());
        }
      }, []),
      p = ge(() => {
        if (i.current) {
          const x = Ia(i.current);
          x.length && (d.current = lw(x));
        }
      }, []);
    return /* @__PURE__ */F(Jb, {
      scope: n,
      value: a,
      triggerRef: l,
      contentRef: i,
      focusProxyRef: c,
      wasEscapeCloseRef: f,
      onEntryKeyDown: g,
      onFocusProxyEnter: g,
      onRootContentClose: p,
      onContentFocusOutside: p
    }, /* @__PURE__ */F(Oe.li, V({}, o, {
      ref: t
    })));
  }),
  Cc = "NavigationMenuTrigger",
  ew = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        disabled: r,
        ...o
      } = e,
      s = Ft(Cc, e.__scopeNavigationMenu),
      a = dp(Cc, e.__scopeNavigationMenu),
      i = ee(null),
      l = Fe(i, a.triggerRef, t),
      c = hp(s.baseId, a.value),
      d = vp(s.baseId, a.value),
      f = ee(!1),
      g = ee(!1),
      p = a.value === s.value;
    return /* @__PURE__ */F(gs, null, /* @__PURE__ */F(ki.ItemSlot, {
      scope: n,
      value: a.value
    }, /* @__PURE__ */F(gp, {
      asChild: !0
    }, /* @__PURE__ */F(Oe.button, V({
      id: c,
      disabled: r,
      "data-disabled": r ? "" : void 0,
      "data-state": wi(p),
      "aria-expanded": p,
      "aria-controls": d
    }, o, {
      ref: l,
      onPointerEnter: _e(e.onPointerEnter, () => {
        g.current = !1, a.wasEscapeCloseRef.current = !1;
      }),
      onPointerMove: _e(e.onPointerMove, Rs(() => {
        r || g.current || a.wasEscapeCloseRef.current || f.current || (s.onTriggerEnter(a.value), f.current = !0);
      })),
      onPointerLeave: _e(e.onPointerLeave, Rs(() => {
        r || (s.onTriggerLeave(), f.current = !1);
      })),
      onClick: _e(e.onClick, () => {
        s.onItemSelect(a.value), g.current = p;
      }),
      onKeyDown: _e(e.onKeyDown, x => {
        const h = {
          horizontal: "ArrowDown",
          vertical: s.dir === "rtl" ? "ArrowLeft" : "ArrowRight"
        }[s.orientation];
        p && x.key === h && (a.onEntryKeyDown(), x.preventDefault());
      })
    })))), p && /* @__PURE__ */F(gs, null, /* @__PURE__ */F(Pb, {
      "aria-hidden": !0,
      tabIndex: 0,
      ref: a.focusProxyRef,
      onFocus: x => {
        const m = a.contentRef.current,
          h = x.relatedTarget,
          j = h === i.current,
          v = m == null ? void 0 : m.contains(h);
        (j || !v) && a.onFocusProxyEnter(j ? "start" : "end");
      }
    }), s.viewport && /* @__PURE__ */F("span", {
      "aria-owns": d
    })));
  }),
  Nc = "navigationMenu.linkSelect",
  tw = /* @__PURE__ */ce((e, t) => {
    const {
      __scopeNavigationMenu: n,
      active: r,
      onSelect: o,
      ...s
    } = e;
    return /* @__PURE__ */F(gp, {
      asChild: !0
    }, /* @__PURE__ */F(Oe.a, V({
      "data-active": r ? "" : void 0,
      "aria-current": r ? "page" : void 0
    }, s, {
      ref: t,
      onClick: _e(e.onClick, a => {
        const i = a.target,
          l = new CustomEvent(Nc, {
            bubbles: !0,
            cancelable: !0
          });
        if (i.addEventListener(Nc, c => o == null ? void 0 : o(c), {
          once: !0
        }), Ls(i, l), !l.defaultPrevented && !a.metaKey) {
          const c = new CustomEvent(ms, {
            bubbles: !0,
            cancelable: !0
          });
          Ls(i, c);
        }
      }, {
        checkForDefaultPrevented: !1
      })
    })));
  }),
  Or = "NavigationMenuContent",
  nw = /* @__PURE__ */ce((e, t) => {
    const {
        forceMount: n,
        ...r
      } = e,
      o = Ft(Or, e.__scopeNavigationMenu),
      s = dp(Or, e.__scopeNavigationMenu),
      a = Fe(s.contentRef, t),
      i = s.value === o.value,
      l = {
        value: s.value,
        triggerRef: s.triggerRef,
        focusProxyRef: s.focusProxyRef,
        wasEscapeCloseRef: s.wasEscapeCloseRef,
        onContentFocusOutside: s.onContentFocusOutside,
        onRootContentClose: s.onRootContentClose,
        ...r
      };
    return o.viewport ? /* @__PURE__ */F(rw, V({
      forceMount: n
    }, l, {
      ref: a
    })) : /* @__PURE__ */F(un, {
      present: n || i
    }, /* @__PURE__ */F(fp, V({
      "data-state": wi(i)
    }, l, {
      ref: a,
      onPointerEnter: _e(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: _e(e.onPointerLeave, Rs(o.onContentLeave)),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !i && o.isRootMenu ? "none" : void 0,
        ...l.style
      }
    })));
  }),
  rw = /* @__PURE__ */ce((e, t) => {
    const n = Ft(Or, e.__scopeNavigationMenu),
      {
        onViewportContentChange: r,
        onViewportContentRemove: o
      } = n;
    return Et(() => {
      r(e.value, {
        ref: t,
        ...e
      });
    }, [e, t, r]), Et(() => () => o(e.value), [e.value, o]), null;
  }),
  ms = "navigationMenu.rootContentDismiss",
  fp = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        value: r,
        triggerRef: o,
        focusProxyRef: s,
        wasEscapeCloseRef: a,
        onRootContentClose: i,
        onContentFocusOutside: l,
        ...c
      } = e,
      d = Ft(Or, n),
      f = ee(null),
      g = Fe(f, t),
      p = hp(d.baseId, r),
      x = vp(d.baseId, r),
      m = Vb(n),
      h = ee(null),
      {
        onItemDismiss: j
      } = d;
    fe(() => {
      const _ = f.current;
      if (d.isRootMenu && _) {
        const k = () => {
          var y;
          j(), i(), _.contains(document.activeElement) && ((y = o.current) === null || y === void 0 || y.focus());
        };
        return _.addEventListener(ms, k), () => _.removeEventListener(ms, k);
      }
    }, [d.isRootMenu, e.value, o, j, i]);
    const v = it(() => {
      const k = m().map(z => z.value);
      d.dir === "rtl" && k.reverse();
      const y = k.indexOf(d.value),
        b = k.indexOf(d.previousValue),
        C = r === d.value,
        N = b === k.indexOf(r);
      if (!C && !N) return h.current;
      const T = (() => {
        if (y !== b) {
          if (C && b !== -1) return y > b ? "from-end" : "from-start";
          if (N && y !== -1) return y > b ? "to-start" : "to-end";
        }
        return null;
      })();
      return h.current = T, T;
    }, [d.previousValue, d.value, d.dir, m, r]);
    return /* @__PURE__ */F(mp, {
      asChild: !0
    }, /* @__PURE__ */F(Of, V({
      id: x,
      "aria-labelledby": p,
      "data-motion": v,
      "data-orientation": d.orientation
    }, c, {
      ref: g,
      onDismiss: () => {
        var _;
        const k = new Event(ms, {
          bubbles: !0,
          cancelable: !0
        });
        (_ = f.current) === null || _ === void 0 || _.dispatchEvent(k);
      },
      onFocusOutside: _e(e.onFocusOutside, _ => {
        var k;
        l();
        const y = _.target;
        (k = d.rootNavigationMenu) !== null && k !== void 0 && k.contains(y) && _.preventDefault();
      }),
      onPointerDownOutside: _e(e.onPointerDownOutside, _ => {
        var k;
        const y = _.target,
          b = m().some(N => {
            var T;
            return (T = N.ref.current) === null || T === void 0 ? void 0 : T.contains(y);
          }),
          C = d.isRootMenu && ((k = d.viewport) === null || k === void 0 ? void 0 : k.contains(y));
        (b || C || !d.isRootMenu) && _.preventDefault();
      }),
      onKeyDown: _e(e.onKeyDown, _ => {
        const k = _.altKey || _.ctrlKey || _.metaKey;
        if (_.key === "Tab" && !k) {
          const C = Ia(_.currentTarget),
            N = document.activeElement,
            T = C.findIndex(L => L === N),
            K = _.shiftKey ? C.slice(0, T).reverse() : C.slice(T + 1, C.length);
          if (bi(K)) _.preventDefault();else {
            var b;
            (b = s.current) === null || b === void 0 || b.focus();
          }
        }
      }),
      onEscapeKeyDown: _e(e.onEscapeKeyDown, _ => {
        a.current = !0;
      })
    })));
  }),
  pp = "NavigationMenuViewport",
  sw = /* @__PURE__ */ce((e, t) => {
    const {
        forceMount: n,
        ...r
      } = e,
      s = !!Ft(pp, e.__scopeNavigationMenu).value;
    return /* @__PURE__ */F(un, {
      present: n || s
    }, /* @__PURE__ */F(ow, V({}, r, {
      ref: t
    })));
  }),
  ow = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        children: r,
        ...o
      } = e,
      s = Ft(pp, n),
      a = Fe(t, s.onViewportChange),
      i = Hb(Or, e.__scopeNavigationMenu),
      [l, c] = le(null),
      [d, f] = le(null),
      g = l ? (l == null ? void 0 : l.width) + "px" : void 0,
      p = l ? (l == null ? void 0 : l.height) + "px" : void 0,
      x = !!s.value,
      m = x ? s.value : s.previousValue;
    return cw(d, () => {
      d && c({
        width: d.offsetWidth,
        height: d.offsetHeight
      });
    }), /* @__PURE__ */F(Oe.div, V({
      "data-state": wi(x),
      "data-orientation": s.orientation
    }, o, {
      ref: a,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !x && s.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": g,
        "--radix-navigation-menu-viewport-height": p,
        ...o.style
      },
      onPointerEnter: _e(e.onPointerEnter, s.onContentEnter),
      onPointerLeave: _e(e.onPointerLeave, Rs(s.onContentLeave))
    }), Array.from(i.items).map(_ref85 => {
      let [j, {
        ref: v,
        forceMount: _,
        ...k
      }] = _ref85;
      const y = m === j;
      return /* @__PURE__ */F(un, {
        key: j,
        present: _ || y
      }, /* @__PURE__ */F(fp, V({}, k, {
        ref: eo(v, b => {
          y && b && f(b);
        })
      })));
    }));
  }),
  aw = "FocusGroup",
  mp = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        ...r
      } = e,
      o = Ft(aw, n);
    return /* @__PURE__ */F(Na.Provider, {
      scope: n
    }, /* @__PURE__ */F(Na.Slot, {
      scope: n
    }, /* @__PURE__ */F(Oe.div, V({
      dir: o.dir
    }, r, {
      ref: t
    }))));
  }),
  Ic = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"],
  iw = "FocusGroupItem",
  gp = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeNavigationMenu: n,
        ...r
      } = e,
      o = Ub(n),
      s = Ft(iw, n);
    return /* @__PURE__ */F(Na.ItemSlot, {
      scope: n
    }, /* @__PURE__ */F(Oe.button, V({}, r, {
      ref: t,
      onKeyDown: _e(e.onKeyDown, a => {
        if (["Home", "End", ...Ic].includes(a.key)) {
          let l = o().map(f => f.ref.current);
          if ([s.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(a.key) && l.reverse(), Ic.includes(a.key)) {
            const f = l.indexOf(a.currentTarget);
            l = l.slice(f + 1);
          }
          setTimeout(() => bi(l)), a.preventDefault();
        }
      })
    })));
  });
function Ia(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: r => {
        const o = r.tagName === "INPUT" && r.type === "hidden";
        return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function bi(e) {
  const t = document.activeElement;
  return e.some(n => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function lw(e) {
  return e.forEach(t => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach(t => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function cw(e, t) {
  const n = We(t);
  Et(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
function wi(e) {
  return e ? "open" : "closed";
}
function hp(e, t) {
  return `${e}-trigger-${t}`;
}
function vp(e, t) {
  return `${e}-content-${t}`;
}
function Rs(e) {
  return t => t.pointerType === "mouse" ? e(t) : void 0;
}
const uw = Qb,
  dw = Zb,
  fw = Xb,
  pw = ew,
  er = tw,
  _p = nw,
  mw = sw,
  jp = "Tabs",
  [gw, XN] = Vt(jp, [to]),
  yp = to(),
  [hw, Ci] = gw(jp),
  vw = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeTabs: n,
        value: r,
        onValueChange: o,
        defaultValue: s,
        orientation: a = "horizontal",
        dir: i,
        activationMode: l = "automatic",
        ...c
      } = e,
      d = Wr(i),
      [f, g] = Nn({
        prop: r,
        onChange: o,
        defaultProp: s
      });
    return /* @__PURE__ */F(hw, {
      scope: n,
      baseId: sn(),
      value: f,
      onValueChange: g,
      orientation: a,
      dir: d,
      activationMode: l
    }, /* @__PURE__ */F(Oe.div, V({
      dir: d,
      "data-orientation": a
    }, c, {
      ref: t
    })));
  }),
  _w = "TabsList",
  jw = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeTabs: n,
        loop: r = !0,
        ...o
      } = e,
      s = Ci(_w, n),
      a = yp(n);
    return /* @__PURE__ */F(Wf, V({
      asChild: !0
    }, a, {
      orientation: s.orientation,
      dir: s.dir,
      loop: r
    }), /* @__PURE__ */F(Oe.div, V({
      role: "tablist",
      "aria-orientation": s.orientation
    }, o, {
      ref: t
    })));
  }),
  yw = "TabsTrigger",
  xw = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeTabs: n,
        value: r,
        disabled: o = !1,
        ...s
      } = e,
      a = Ci(yw, n),
      i = yp(n),
      l = xp(a.baseId, r),
      c = kp(a.baseId, r),
      d = r === a.value;
    return /* @__PURE__ */F(Bf, V({
      asChild: !0
    }, i, {
      focusable: !o,
      active: d
    }), /* @__PURE__ */F(Oe.button, V({
      type: "button",
      role: "tab",
      "aria-selected": d,
      "aria-controls": c,
      "data-state": d ? "active" : "inactive",
      "data-disabled": o ? "" : void 0,
      disabled: o,
      id: l
    }, s, {
      ref: t,
      onMouseDown: _e(e.onMouseDown, f => {
        !o && f.button === 0 && f.ctrlKey === !1 ? a.onValueChange(r) : f.preventDefault();
      }),
      onKeyDown: _e(e.onKeyDown, f => {
        [" ", "Enter"].includes(f.key) && a.onValueChange(r);
      }),
      onFocus: _e(e.onFocus, () => {
        const f = a.activationMode !== "manual";
        !d && !o && f && a.onValueChange(r);
      })
    })));
  }),
  kw = "TabsContent",
  Mw = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeTabs: n,
        value: r,
        forceMount: o,
        children: s,
        ...a
      } = e,
      i = Ci(kw, n),
      l = xp(i.baseId, r),
      c = kp(i.baseId, r),
      d = r === i.value,
      f = ee(d);
    return fe(() => {
      const g = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(g);
    }, []), /* @__PURE__ */F(un, {
      present: o || d
    }, _ref86 => {
      let {
        present: g
      } = _ref86;
      return /* @__PURE__ */F(Oe.div, V({
        "data-state": d ? "active" : "inactive",
        "data-orientation": i.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !g,
        id: c,
        tabIndex: 0
      }, a, {
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        }
      }), g && s);
    });
  });
function xp(e, t) {
  return `${e}-trigger-${t}`;
}
function kp(e, t) {
  return `${e}-content-${t}`;
}
const bw = vw,
  ww = jw,
  Cw = xw,
  Nw = Mw,
  Mp = qn(null),
  bp = (e, t) => {
    const n = Array.isArray(e) ? e : [e];
    return te.Children.toArray(t).filter(_ref87 => {
      let {
        type: r
      } = _ref87;
      return n.includes(r);
    });
  },
  Iw = (e, t) => bp(e, t).length > 0,
  Uo = _ref88 => {
    let {
      component: e
    } = _ref88;
    const t = Lr(Mp);
    return t === null ? (console.error("No scope for slots provided. 'Slot' must be used inside a 'SlotScope'"), null) : t.fills.find(_ref89 => {
      let {
        type: n
      } = _ref89;
      return n === e;
    }) || null;
  },
  Ew = _ref90 => {
    let {
      slots: e,
      fills: t,
      children: n
    } = _ref90;
    const r = bp(e, t);
    return /* @__PURE__ */u.jsx(Mp.Provider, {
      value: {
        fills: r
      },
      children: n
    });
  };
var wp = "_11lb20c0",
  Cp = "_11lb20c1",
  Np = "_11lb20c2",
  Ip = "_11lb20c3",
  Ep = "_11lb20c4",
  Sp = "_11lb20c5",
  Tp = "_11lb20c6",
  Dp = "_11lb20c7 _11lb20c6",
  Op = "_11lb20c8",
  Ap = "_11lb20c9",
  $p = "_11lb20ca",
  Lp = "_11lb20cb",
  zp = "_11lb20cc",
  Rp = "_11lb20cd",
  Pp = "_11lb20ce",
  Vp = "_11lb20cf",
  Fp = "_11lb20cg",
  Up = "_11lb20ch",
  Yp = "_11lb20ci",
  Wp = "_11lb20cj",
  Bp = "_11lb20ck",
  Hp = "_11lb20cl",
  Qp = "_11lb20cm",
  qp = "_11lb20cn",
  Kp = "_11lb20co",
  Zp = "_11lb20cp",
  Gp = "_11lb20cq";
const eI = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
  __proto__: null,
  actionsArea: Op,
  content: Ep,
  contentList: Qp,
  featured: zp,
  featuredCta: Fp,
  featuredDescription: Vp,
  featuredText: Rp,
  featuredTitle: Pp,
  link: qp,
  linkArrow: Zp,
  linkTitle: Kp,
  logoArea: Ip,
  main: Sp,
  mainList: Ap,
  nav: Np,
  popoverContent: $p,
  popoverInner: Lp,
  root: Cp,
  tabItem: Bp,
  tabItemDescription: Hp,
  tabList: Wp,
  tabPanel: Yp,
  tabRoot: Up,
  trigger: Tp,
  triggerLink: Dp,
  viewport: Gp,
  wrapper: wp
}, Symbol.toStringTag, {
  value: "Module"
}));
function Sw(_ref91) {
  let {
    children: e,
    className: t
  } = _ref91;
  return /* @__PURE__ */u.jsx(pw, {
    className: ye([Tp, t]),
    children: e
  });
}
function Ni(_ref92) {
  let {
    children: e,
    ...t
  } = _ref92;
  return /* @__PURE__ */u.jsx("div", {
    className: Op,
    ...t,
    children: e
  });
}
function Tw(_ref93) {
  let {
    children: e,
    ...t
  } = _ref93;
  return /* @__PURE__ */u.jsx(fw, {
    ...t,
    children: e
  });
}
function Dw(_ref94) {
  let {
    children: e,
    title: t,
    ...n
  } = _ref94;
  return /* @__PURE__ */u.jsx("li", {
    children: /* @__PURE__ */u.jsx(er, {
      asChild: !0,
      children: /* @__PURE__ */u.jsxs("a", {
        className: qp,
        ...n,
        children: [/* @__PURE__ */u.jsx("svg", {
          "aria-hidden": "true",
          className: Zp,
          fill: "none",
          height: "17",
          width: "16",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */u.jsx("path", {
            d: "M13.333 8.5 8 13.834l-.95-.934 3.733-3.733H2.667V7.834h8.116L7.05 4.1 8 3.167 13.333 8.5Z",
            fill: "#D0FF00"
          })
        }), /* @__PURE__ */u.jsx("div", {
          className: Kp,
          children: t
        }), /* @__PURE__ */u.jsx(ut, {
          as: "div",
          type: "sm",
          weight: 400,
          children: e
        })]
      })
    })
  });
}
function Ow(_ref95) {
  let {
    icon: e,
    eyebrow: t,
    title: n,
    children: r,
    ctaText: o,
    url: s
  } = _ref95;
  return /* @__PURE__ */u.jsxs("div", {
    className: zp,
    children: [e || null, /* @__PURE__ */u.jsxs("div", {
      className: Rp,
      children: [t ? /* @__PURE__ */u.jsx("div", {
        children: t
      }) : null, /* @__PURE__ */u.jsx("div", {
        className: Pp,
        children: n
      }), /* @__PURE__ */u.jsx(ut, {
        as: "div",
        className: Vp,
        type: "sm",
        children: r
      })]
    }), o && s ? /* @__PURE__ */u.jsx(Zt, {
      className: Fp,
      colorModes: "dark",
      size: "compact",
      url: s,
      variant: "text",
      children: o
    }) : null]
  });
}
function Aw(_ref96) {
  let {
    children: e,
    ...t
  } = _ref96;
  return /* @__PURE__ */u.jsx(bw, {
    className: Up,
    ...t,
    children: e
  });
}
function $w(_ref97) {
  let {
    children: e
  } = _ref97;
  return /* @__PURE__ */u.jsx(ww, {
    className: Wp,
    children: e
  });
}
function Lw(_ref98) {
  let {
    children: e,
    ...t
  } = _ref98;
  return /* @__PURE__ */u.jsx(Nw, {
    className: Yp,
    ...t,
    children: e
  });
}
function zw(_ref99) {
  let {
    title: e,
    icon: t,
    children: n,
    ...r
  } = _ref99;
  return /* @__PURE__ */u.jsxs(Cw, {
    className: Bp,
    ...r,
    onMouseOver: o => o.currentTarget.focus(),
    children: [t, /* @__PURE__ */u.jsxs("div", {
      children: [e, /* @__PURE__ */u.jsx("div", {
        className: Hp,
        children: n
      })]
    })]
  });
}
function Rw(_ref100) {
  let {
    children: e,
    ...t
  } = _ref100;
  return /* @__PURE__ */u.jsx("ul", {
    className: Qp,
    ...t,
    children: e
  });
}
function Pw(_ref101) {
  let {
    children: e,
    ...t
  } = _ref101;
  return /* @__PURE__ */u.jsx(dw, {
    className: Ap,
    ...t,
    children: e
  });
}
function Ii(_ref102) {
  let {
    children: e,
    viewport: t = !0,
    ...n
  } = _ref102;
  return /* @__PURE__ */u.jsxs(u.Fragment, {
    children: [/* @__PURE__ */u.jsx("div", {
      className: Sp,
      ...n,
      children: e
    }), t ? /* @__PURE__ */u.jsx(mw, {
      className: Gp
    }) : null]
  });
}
function Vw(_ref103) {
  let {
    children: e,
    className: t,
    ...n
  } = _ref103;
  return /* @__PURE__ */u.jsx(_p, {
    className: ye([$p, t]),
    ...n,
    children: /* @__PURE__ */u.jsx("div", {
      className: Lp,
      children: e
    })
  });
}
function Ei() {
  return /* @__PURE__ */u.jsx("nav", {});
}
const Fw = ce((_ref104, n) => {
  let {
    children: e,
    ...t
  } = _ref104;
  return /* @__PURE__ */u.jsx(er, {
    ref: n,
    className: Dp,
    ...t,
    children: e
  });
});
function Si(_ref105) {
  let {
    src: e,
    href: t = "/",
    title: n,
    children: r,
    ...o
  } = _ref105;
  return /* @__PURE__ */u.jsx("div", {
    className: Ip,
    ...o,
    children: r || /* @__PURE__ */u.jsx(er, {
      "aria-label": "Home",
      href: t,
      title: n,
      children: /* @__PURE__ */u.jsx(zs, {
        alt: "",
        src: e
      })
    })
  });
}
const Uw = [Ni, Si, Ii, Ei],
  Yw = ce((_ref106, a) => {
    let {
      isSticky: e,
      showMinimalUI: t,
      value: n,
      onValueChange: r,
      noMaxWidth: o,
      children: s
    } = _ref106;
    const i = Iw(Ei, s),
      l = {
        ...(e ? {
          "data-sticky": ""
        } : {}),
        ...(t ? {
          "data-minimal-ui": ""
        } : {}),
        ...(i ? {
          "data-secondary-navigation": ""
        } : {})
      },
      c = {
        ...(o ? {
          style: {
            "--size-navigation-max-content-width": "none"
          }
        } : {})
      };
    return /* @__PURE__ */u.jsx(Ew, {
      fills: s,
      slots: Uw,
      children: /* @__PURE__ */u.jsx("div", {
        ref: a,
        className: wp,
        ...l,
        children: /* @__PURE__ */u.jsx(uw, {
          className: Cp,
          ...c,
          value: n,
          onValueChange: r,
          children: /* @__PURE__ */u.jsx("div", {
            className: Np,
            children: /* @__PURE__ */u.jsxs("div", {
              className: Ep,
              children: [/* @__PURE__ */u.jsx(Uo, {
                component: Si
              }), /* @__PURE__ */u.jsx(Uo, {
                component: Ii
              }), /* @__PURE__ */u.jsx(Uo, {
                component: Ni
              })]
            })
          })
        })
      })
    });
  }),
  Ww = Si,
  Bw = Ii,
  Hw = Ni,
  tI = Ei,
  Qw = Pw,
  qw = Tw,
  Jp = Dw,
  nI = Vw,
  rI = Ow,
  Kw = Fw,
  Zw = Sw,
  sI = Aw,
  oI = $w,
  aI = Lw,
  iI = zw,
  Gw = Rw;
var Xp = "Expected a function",
  Ec = 0 / 0,
  Jw = "[object Symbol]",
  Xw = /^\s+|\s+$/g,
  e8 = /^[-+]0x[0-9a-f]+$/i,
  t8 = /^0b[01]+$/i,
  n8 = /^0o[0-7]+$/i,
  r8 = parseInt,
  s8 = typeof Dt == "object" && Dt && Dt.Object === Object && Dt,
  o8 = typeof self == "object" && self && self.Object === Object && self,
  a8 = s8 || o8 || Function("return this")(),
  i8 = Object.prototype,
  l8 = i8.toString,
  c8 = Math.max,
  u8 = Math.min,
  Yo = function () {
    return a8.Date.now();
  };
function d8(e, t, n) {
  var r,
    o,
    s,
    a,
    i,
    l,
    c = 0,
    d = !1,
    f = !1,
    g = !0;
  if (typeof e != "function") throw new TypeError(Xp);
  t = Sc(t) || 0, Ps(n) && (d = !!n.leading, f = "maxWait" in n, s = f ? c8(Sc(n.maxWait) || 0, t) : s, g = "trailing" in n ? !!n.trailing : g);
  function p(b) {
    var C = r,
      N = o;
    return r = o = void 0, c = b, a = e.apply(N, C), a;
  }
  function x(b) {
    return c = b, i = setTimeout(j, t), d ? p(b) : a;
  }
  function m(b) {
    var C = b - l,
      N = b - c,
      T = t - C;
    return f ? u8(T, s - N) : T;
  }
  function h(b) {
    var C = b - l,
      N = b - c;
    return l === void 0 || C >= t || C < 0 || f && N >= s;
  }
  function j() {
    var b = Yo();
    if (h(b)) return v(b);
    i = setTimeout(j, m(b));
  }
  function v(b) {
    return i = void 0, g && r ? p(b) : (r = o = void 0, a);
  }
  function _() {
    i !== void 0 && clearTimeout(i), c = 0, r = l = o = i = void 0;
  }
  function k() {
    return i === void 0 ? a : v(Yo());
  }
  function y() {
    var b = Yo(),
      C = h(b);
    if (r = arguments, o = this, l = b, C) {
      if (i === void 0) return x(l);
      if (f) return i = setTimeout(j, t), p(l);
    }
    return i === void 0 && (i = setTimeout(j, t)), a;
  }
  return y.cancel = _, y.flush = k, y;
}
function f8(e, t, n) {
  var r = !0,
    o = !0;
  if (typeof e != "function") throw new TypeError(Xp);
  return Ps(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), d8(e, t, {
    leading: r,
    maxWait: t,
    trailing: o
  });
}
function Ps(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function p8(e) {
  return !!e && typeof e == "object";
}
function m8(e) {
  return typeof e == "symbol" || p8(e) && l8.call(e) == Jw;
}
function Sc(e) {
  if (typeof e == "number") return e;
  if (m8(e)) return Ec;
  if (Ps(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ps(t) ? t + "" : t;
  }
  if (typeof e != "string") return e === 0 ? e : +e;
  e = e.replace(Xw, "");
  var n = t8.test(e);
  return n || n8.test(e) ? r8(e.slice(2), n ? 2 : 8) : e8.test(e) ? Ec : +e;
}
var g8 = f8;
const h8 = /* @__PURE__ */Ys(g8),
  em = {
    isSticky: !1,
    showMinimalUI: !1
  },
  v8 = (e, t) => {
    switch (t) {
      case 1:
        return {
          isSticky: !0,
          showMinimalUI: !1
        };
      case 2:
        return {
          isSticky: !0,
          showMinimalUI: !0
        };
      case 0:
        return em;
      default:
        throw new Error("stickyReducer was called with no action");
    }
  },
  lI = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
    const [t, n] = $r(v8, em),
      r = ee(null);
    return fe(() => {
      let o = 0;
      const s = h8(() => {
        const a = r != null && r.current ? r.current.getBoundingClientRect().y : 0,
          i = window.scrollY,
          l = o < i ? "down" : "up",
          c = l === "down" && i === Math.abs(a);
        i <= 0 && n(0
        /* Default */), l === "down" && i >= e && n(2
        /* StickyMinimal */), l === "up" && i >= e && n(1
        /* Sticky */), c && n(1
        /* Sticky */), o = i;
      }, 200);
      return window.addEventListener("scroll", s), () => {
        window.removeEventListener("scroll", s);
      };
    }, []), {
      ...t,
      navigationRef: r
    };
  };
var _8 = "zff0ua8",
  j8 = "zff0ua9",
  y8 = "zff0uaa",
  x8 = "zff0uab";
function Tc(e, t, n) {
  const r = n.getBoundingClientRect(),
    o = r.top + r.height,
    s = window.innerHeight + r.height,
    a = o / s,
    i = e.getBoundingClientRect().width,
    {
      width: l,
      height: c
    } = t.getBoundingClientRect(),
    d = l - i,
    f = c - i,
    g = {
      x: 0,
      y: 0
    };
  if (a > 0.8) {
    const p = (a - 0.8) * 5;
    g.x = Math.max(0, d - d * p), g.y = 0;
  } else if (a > 0.6) {
    const p = (a - 0.6) * 5;
    g.x = d, g.y = Math.max(0, f - f * p);
  } else if (a > 0.4) {
    const p = (a - 0.4) * 5;
    g.x = Math.min(p * d, d), g.y = f;
  } else if (a > 0.2) {
    const p = (a - 0.2) * 5;
    g.x = 0, g.y = Math.min(p * f, f);
  } else {
    const p = a * 5;
    g.x = Math.max(0, d - d * p), g.y = 0;
  }
  e.style.transform = `translate(${g.x}px, ${g.y}px)`;
}
const cI = _ref107 => {
  let {
    children: e
  } = _ref107;
  const t = ee(null),
    n = ee(null),
    r = ee(null),
    o = ee(!1);
  return fe(() => {
    const s = i => {
        o.current = i[0].isIntersecting, i[0].isIntersecting && r.current && n.current && t.current && Tc(r.current, n.current, t.current);
      },
      a = new IntersectionObserver(s);
    return t.current && a.observe(t.current), () => {
      a.disconnect();
    };
  }, []), fe(() => {
    const s = () => {
      o.current && r.current && n.current && t.current && Tc(r.current, n.current, t.current);
    };
    return window.addEventListener("scroll", s), () => {
      window.removeEventListener("scroll", s);
    };
  }, []), /* @__PURE__ */u.jsx("div", {
    ref: t,
    className: _8,
    children: /* @__PURE__ */u.jsxs("div", {
      ref: n,
      className: j8,
      children: [/* @__PURE__ */u.jsx("span", {
        ref: r,
        className: y8
      }), /* @__PURE__ */u.jsx("div", {
        className: x8,
        children: e
      })]
    })
  });
};
var k8 = "_1ln3bov2",
  M8 = "_1ln3bov3",
  tm = "_1ln3bov4",
  b8 = "_1ln3bov5",
  nm = Ue({
    defaultClassName: "_1ln3bov6",
    variantClassNames: {
      states: {
        active: "_1ln3bov7",
        inactive: "_1ln3bov8"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  w8 = "_1ln3bov9",
  C8 = "_1ln3bova",
  N8 = "_1ln3bovb",
  I8 = "_1ln3bovc",
  rm = Ue({
    defaultClassName: "_1ln3bovd",
    variantClassNames: {
      states: {
        active: "_1ln3bove",
        inactive: "_1ln3bovf"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  E8 = "_1ln3bovj",
  S8 = Ue({
    defaultClassName: "_1ln3bovk",
    variantClassNames: {
      states: {
        active: "_1ln3bovl",
        inactive: "_1ln3bovm"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  sm = "_1ln3bovn";
function uI(_ref108) {
  let {
    children: e,
    title: t,
    subtitle: n,
    products: r,
    ...o
  } = _ref108;
  const s = r.every(_ref109 => {
    let {
      image: a,
      videoID: i
    } = _ref109;
    return !!i || !!a;
  });
  return /* @__PURE__ */u.jsx(pe, {
    ...o,
    className: ye([k8, o.className]),
    children: /* @__PURE__ */u.jsxs(pe, {
      className: M8,
      children: [/* @__PURE__ */u.jsx(D8, {
        allProductsHaveMedia: s,
        products: r
      }), /* @__PURE__ */u.jsx(pe, {
        className: tm,
        children: r.map(_ref110 => {
          let {
            entryId: a,
            title: i,
            image: l,
            videoID: c,
            description: d,
            primaryActionText: f,
            primaryActionUrl: g
          } = _ref110;
          return /* @__PURE__ */u.jsx(T8, {
            allProductsHaveMedia: s,
            description: d,
            image: l,
            primaryActionText: f,
            primaryActionUrl: g,
            title: i,
            videoID: c
          }, a);
        })
      })]
    })
  });
}
function om(_ref111) {
  let {
    image: e,
    videoID: t
  } = _ref111;
  return e ? /* @__PURE__ */u.jsx("img", {
    alt: "",
    className: w8,
    src: e
  }) : t ? /* @__PURE__ */u.jsx("iframe", {
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    className: C8,
    frameBorder: 0,
    height: "100%",
    src: `https://www.youtube.com/embed/${t}?si=mj0oThwwdqksx6gg&amp;`,
    title: "YouTube video player",
    width: "100%",
    allowFullScreen: !0
  }) : /* @__PURE__ */u.jsx(pe, {
    className: N8
  });
}
function T8(_ref112) {
  let {
    title: e,
    description: t,
    image: n,
    videoID: r,
    primaryActionText: o,
    primaryActionUrl: s,
    active: a,
    allProductsHaveMedia: i,
    ...l
  } = _ref112;
  return /* @__PURE__ */u.jsxs(pe, {
    display: {
      _: "grid",
      md: "none"
    },
    ...l,
    className: ye([b8, l.className]),
    children: [i && /* @__PURE__ */u.jsx(pe, {
      className: nm({
        states: "active"
      }),
      children: /* @__PURE__ */u.jsx(om, {
        image: n,
        videoID: r
      })
    }), /* @__PURE__ */u.jsx(pe, {
      className: I8,
      children: e
    }), /* @__PURE__ */u.jsx(pe, {
      className: rm({
        states: "active"
      }),
      children: t
    }), s && o ? /* @__PURE__ */u.jsxs(Zt, {
      className: sm,
      colorModes: "dark",
      url: s,
      variant: "text",
      children: [o, /* @__PURE__ */u.jsx(zr, {})]
    }) : null]
  });
}
function D8(_ref113) {
  let {
    products: e,
    allProductsHaveMedia: t,
    ...n
  } = _ref113;
  const [r, o] = le(0),
    s = a => ({
      states: r === a ? "active" : "inactive"
    });
  return /* @__PURE__ */u.jsxs(pe, {
    display: {
      _: "none",
      md: "grid"
    },
    ...n,
    className: tm,
    children: [t ? e.map((_ref114, c) => {
      let {
        image: a,
        videoID: i,
        entryId: l
      } = _ref114;
      return l ? /* @__PURE__ */u.jsx(pe, {
        className: nm(s(c)),
        children: /* @__PURE__ */u.jsx(om, {
          image: a,
          videoID: i
        })
      }, `${l}-image`) : null;
    }) : null, /* @__PURE__ */u.jsx(pe, {
      className: E8,
      children: e.map((_ref115, l) => {
        let {
          title: a,
          entryId: i
        } = _ref115;
        return a ? /* @__PURE__ */u.jsx(O8, {
          active: l === r,
          title: a,
          onClick: () => o(l)
        }, `${i}-button`) : null;
      })
    }), e.map((_ref116, d) => {
      let {
        description: a,
        primaryActionText: i,
        primaryActionUrl: l,
        entryId: c
      } = _ref116;
      return /* @__PURE__ */u.jsxs(pe, {
        className: rm(s(d)),
        children: [a, l && i ? /* @__PURE__ */u.jsxs(Zt, {
          className: sm,
          colorModes: "dark",
          url: l,
          variant: "text",
          children: [i, /* @__PURE__ */u.jsx(zr, {})]
        }) : null]
      }, `${c}-description`);
    })]
  });
}
function O8(_ref117) {
  let {
    active: e,
    title: t,
    ...n
  } = _ref117;
  return /* @__PURE__ */u.jsx("button", {
    ...n,
    className: S8({
      states: e ? "active" : "inactive"
    }),
    children: t
  });
}
const A8 = (e, t) => {
  const n = ee(t);
  fe(() => {
    n.current = t;
  }, [t]), fe(() => {
    const r = s => n.current(s);
    if (window.addEventListener) return window.addEventListener(e, r), () => {
      window.removeEventListener(e, r);
    };
  }, [e]);
};
var $8 = "he67gu0",
  L8 = "he67guc",
  z8 = Ue({
    defaultClassName: "he67gud",
    variantClassNames: {
      states: {
        open: "he67gue",
        closed: "he67guf"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  R8 = "he67gug",
  P8 = "he67guh",
  V8 = "he67gui",
  am = Ue({
    defaultClassName: "he67guj",
    variantClassNames: {
      type: {
        erase: "he67guk",
        close: "he67gul"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  F8 = "he67gum",
  U8 = "he67gun",
  Y8 = Ue({
    defaultClassName: "he67guo",
    variantClassNames: {
      states: {
        empty: "he67gup",
        value: "he67guq"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  W8 = "he67gur",
  B8 = "he67gus",
  H8 = "he67gut",
  Q8 = "he67guu",
  q8 = "he67guv",
  K8 = "he67guw",
  Dc = "he67gux",
  Z8 = "var(--he67guz)",
  Wo = "he67gu10",
  Bo = "he67gu11",
  G8 = "he67gu12",
  J8 = "he67gu13",
  X8 = "he67gu14",
  e0 = "he67gu15",
  t0 = "he67gu16",
  n0 = "he67gu17",
  r0 = "he67gu18",
  s0 = "he67gu19",
  o0 = {
    up: "he67gu1a",
    down: "he67gu1b"
  };
const im = qn(void 0);
function Ti() {
  const e = Lr(im);
  if (!e) throw new Error("Search compound components cannot be rendered outside the Search component");
  return e;
}
var Kt = /* @__PURE__ */(e => (e[e.MagnifyingGlass = 0] = "MagnifyingGlass", e[e.SearchInput = 1] = "SearchInput", e[e.Responsive = 2] = "Responsive", e))(Kt || {}),
  Vs = /* @__PURE__ */(e => (e[e.Light = 0] = "Light", e[e.Dark = 1] = "Dark", e))(Vs || {});
const lm = e => {
    (e.key === "ArrowDown" || e.key === "ArrowUp") && e.preventDefault();
  },
  a0 = {
    [Kt.MagnifyingGlass]: B8,
    [Kt.SearchInput]: H8,
    [Kt.Responsive]: Q8
  },
  i0 = _ref118 => {
    let {
      placeholder: e = "",
      buttonVariant: t = Kt.MagnifyingGlass,
      showSearchOpenButton: n = !0,
      activeDescendant: r,
      isSearchOpen: o,
      setIsSearchOpen: s,
      dropdownHasValues: a,
      handleTargetText: i,
      targetText: l,
      handleCleanTarget: c,
      handleOnKeyDown: d,
      inputRef: f,
      closeButtonRef: g,
      eraseButtonRef: p,
      showSearchCloseButton: x,
      queryStatusPending: m,
      className: h,
      reset: j
    } = _ref118;
    if (!o && n) {
      const v = t === Kt.SearchInput || t === Kt.Responsive;
      return /* @__PURE__ */u.jsxs(c0, {
        className: a0[t],
        onClick: () => s(!0),
        children: [/* @__PURE__ */u.jsx(qi, {
          className: Dc
        }), v ? /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("span", {
            className: q8,
            children: "Search"
          }), /* @__PURE__ */u.jsx("span", {
            "aria-hidden": "true",
            className: K8
          }), " "]
        }) : null]
      });
    }
    return /* @__PURE__ */u.jsxs("form", {
      className: R8,
      children: [/* @__PURE__ */u.jsx(pe, {
        className: ye([U8, m ? X8 : ""]),
        children: m ? /* @__PURE__ */u.jsx(Oa, {}) : /* @__PURE__ */u.jsx(qi, {
          className: Dc
        })
      }), /* @__PURE__ */u.jsx("input", {
        ref: f,
        "aria-activedescendant": r,
        "aria-controls": "search-list",
        "aria-expanded": o,
        "aria-label": "Search",
        autoComplete: "off",
        autoFocus: n,
        className: ye([Y8({
          states: a ? "value" : "empty"
        }), h ?? ""]),
        name: "search",
        placeholder: e,
        role: "combobox",
        type: "text",
        value: l,
        onChange: i,
        onKeyDown: d
      }), /* @__PURE__ */u.jsxs("div", {
        className: P8,
        children: [o ? /* @__PURE__ */u.jsx(l0, {
          disabled: String(l).length === 0,
          eraseRef: p,
          onClick: c
        }) : null, x ? /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("span", {
            className: o ? V8 : void 0
          }), /* @__PURE__ */u.jsx(u0, {
            closeRef: g,
            reset: j
          })]
        }) : null]
      })]
    });
  },
  l0 = _ref119 => {
    let {
      onClick: e,
      disabled: t,
      eraseRef: n
    } = _ref119;
    const r = o => {
      o.preventDefault();
    };
    return /* @__PURE__ */u.jsx("button", {
      ref: n,
      className: am({
        type: "erase"
      }),
      disabled: t,
      onClick: e,
      onKeyDown: lm,
      onMouseDown: r,
      children: "Clear"
    });
  },
  c0 = _ref120 => {
    let {
      className: e,
      children: t,
      onClick: n
    } = _ref120;
    return /* @__PURE__ */u.jsx("button", {
      "aria-label": "Open search",
      className: ye([W8, e]),
      type: "submit",
      onClick: n,
      children: t
    });
  },
  u0 = _ref121 => {
    let {
      reset: e,
      closeRef: t
    } = _ref121;
    return /* @__PURE__ */u.jsx("button", {
      ref: t,
      className: am({
        type: "close"
      }),
      onClick: e,
      onKeyDown: lm,
      children: /* @__PURE__ */u.jsx(Ed, {
        className: F8
      })
    });
  },
  d0 = _ref122 => {
    let {
      url: e,
      title: t,
      description: n,
      contentType: r,
      showContentType: o,
      showDescription: s,
      id: a,
      extraClassName: i,
      isActive: l
    } = _ref122;
    var g;
    const c = ee(null),
      d = ee(null);
    l && ((g = c.current) == null || g.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest"
    }));
    const f = p => {
      d != null && d.current && d.current.click();
    };
    return /* @__PURE__ */u.jsxs("li", {
      ref: c,
      "aria-selected": l,
      className: ye([J8, i]),
      id: `search-option-${a}`,
      role: "option",
      tabIndex: l ? 0 : -1,
      onClick: f,
      children: [/* @__PURE__ */u.jsx("a", {
        ref: d,
        className: t0,
        "data-no-dark-mode": "true",
        href: e,
        children: t
      }), s ? /* @__PURE__ */u.jsx("div", {
        className: n0,
        children: n
      }) : null, o ? /* @__PURE__ */u.jsx("div", {
        className: r0,
        children: r
      }) : null]
    });
  },
  Ar = "visibility-toggle-",
  Ea = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    const n = [];
    return e.reduce((r, o) => {
      let s = [];
      return "idVisibilityMap" in o ? s = o.showAllResults ? Object.keys(o.idVisibilityMap) : Object.entries(o.idVisibilityMap).filter(a => t ? a[1] : !0).map(a => a[0]) : s = o.results.filter(a => t ? a.alwaysVisible : !0).map(a => a.id), o.allowVisibilityToggle && !o.showAllResults && s.push(`${Ar}${o.id}`), [...r, ...s];
    }, n);
  },
  f0 = e => {
    const t = {},
      n = [];
    return e.forEach((r, o) => {
      var i;
      const s = {};
      let a = !1;
      r.results.forEach(l => {
        t[l.id] = l, s[l.id] = l.alwaysVisible, !a && !l.alwaysVisible && (a = !0);
      }), n.push({
        id: r.id ?? ((i = r.title) == null ? void 0 : i.toLowerCase().replace(" ", "-")) ?? `group-${o}`,
        title: r.title,
        showAllResults: typeof r.showAllResults == "boolean" ? r.showAllResults : !1,
        allowVisibilityToggle: a,
        idVisibilityMap: s
      });
    }), [n, t];
  },
  Oc = (e, t) => {
    const n = e.toLowerCase(),
      r = t ? t == null ? void 0 : t.toLowerCase() : void 0;
    if (!n || !t || !r || !r.includes(n)) return t;
    const o = r.indexOf(n),
      s = t.split(""),
      a = s.slice(0, o).join(""),
      i = s.slice(o, o + n.length).join(""),
      l = s.slice(o + n.length).join("");
    return /* @__PURE__ */u.jsxs(u.Fragment, {
      children: [a, /* @__PURE__ */u.jsx("em", {
        children: i
      }), l]
    });
  },
  p0 = 2,
  m0 = (e, t) => e.map(n => {
    const r = {
      title: n[0],
      id: n[0].toLowerCase().replace(" ", "-"),
      showAllResults: !1,
      allowVisibilityToggle: !1,
      results: []
    };
    return Object.values(n[1]).forEach(s => {
      let a = 0;
      s.forEach(i => {
        a++, i.url && r.results.push({
          href: i.url,
          title: Oc(t, i.term),
          description: Oc(t, i.description),
          group: i.group,
          contentType: i.content_type,
          id: i.id,
          alwaysVisible: a <= p0
        });
      });
    }), r;
  }),
  Ac = _ref123 => {
    let {
      group: e,
      displayOptions: t,
      showAllGroupItems: n,
      buttonIsActive: r
    } = _ref123;
    const o = ee(null),
      {
        showGroupTitle: s
      } = t,
      {
        allowVisibilityToggle: a,
        showAllResults: i,
        results: l
      } = e;
    fe(() => {
      o.current && r && o.current.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    }, [o.current, r, e.showAllResults]);
    const c = l.filter(p => p.alwaysVisible),
      d = i ? l : c,
      f = l.length - c.length,
      g = p => /* @__PURE__ */u.jsx(d0, {
        url: p.href,
        title: p.title,
        description: p.description,
        contentType: p.contentType,
        showDescription: t.showDescription,
        showContentType: t.showContentType,
        isActive: p.isActive ?? !1,
        id: p.id,
        extraClassName: t.dropdownItemClassName
      }, p.id);
    return /* @__PURE__ */u.jsxs(u.Fragment, {
      children: [s && e.title ? /* @__PURE__ */u.jsx("div", {
        className: G8,
        children: e.title
      }) : null, d.map(g), a && !i ? /* @__PURE__ */u.jsxs("button", {
        ref: o,
        className: s0,
        onMouseDown: p => p.preventDefault(),
        onClick: () => n(e.id),
        id: `${Ar}${e.id}`,
        "data-group-id": e.id,
        "aria-selected": r,
        children: [`Show ${f} more in ${e.title}`, /* @__PURE__ */u.jsx(Zc, {
          className: o0.down
        })]
      }) : null]
    });
  },
  g0 = _ref124 => {
    let {
      queryStatusPending: e,
      isDropdownOpen: t,
      isSearchOpen: n,
      activeElementId: r,
      resultGroups: o,
      resultItems: s,
      showAllGroupItems: a,
      displayOptions: i,
      suggestedContent: l
    } = _ref124;
    const {
      targetText: c
    } = Ti();
    if (e || !t && !l || !n) return null;
    if (!t && l) {
      const f = l.results.map(p => ({
          ...p,
          isActive: r === p.id
        })),
        g = {
          ...l,
          results: f
        };
      return /* @__PURE__ */u.jsx("div", {
        className: Wo,
        id: "search-list",
        tabIndex: -1,
        children: /* @__PURE__ */u.jsx("ol", {
          "aria-orientation": "vertical",
          className: Bo,
          dir: "ltr",
          role: "listbox",
          tabIndex: -1,
          "aria-expanded": !0,
          onMouseDown: p => p.preventDefault(),
          children: /* @__PURE__ */u.jsx(Ac, {
            buttonIsActive: r === `${Ar}${g.id}`,
            displayOptions: i,
            group: g,
            showAllGroupItems: a
          }, g.id)
        })
      });
    }
    const d = it(() => o.map(f => {
      const g = Object.keys(f.idVisibilityMap).map(p => ({
        ...s[p],
        isActive: r === p
      }));
      return {
        ...f,
        results: g
      };
    }), [o, s, r]);
    if (Object.keys(s).length === 0) {
      const {
          noResultText: f,
          renderNoResults: g
        } = i,
        p = g ? g(c) : f ?? "Sorry, no results found";
      return /* @__PURE__ */u.jsx("div", {
        className: Wo,
        children: /* @__PURE__ */u.jsx("div", {
          className: Bo,
          children: /* @__PURE__ */u.jsx(pe, {
            className: e0,
            children: p
          })
        })
      });
    }
    return /* @__PURE__ */u.jsx("div", {
      className: Wo,
      id: "search-list",
      tabIndex: -1,
      children: /* @__PURE__ */u.jsx("ol", {
        "aria-expanded": t,
        "aria-orientation": "vertical",
        className: Bo,
        dir: "ltr",
        role: "listbox",
        tabIndex: -1,
        onMouseDown: f => f.preventDefault(),
        children: d.map(f => /* @__PURE__ */u.jsx(Ac, {
          buttonIsActive: r === `${Ar}${f.id}`,
          displayOptions: i,
          group: f,
          showAllGroupItems: a
        }, f.id))
      })
    });
  },
  cm = _ref125 => {
    let {
      children: e,
      minCharacters: t = 1,
      groupResults: n = !0,
      allowActivationViaKeyboard: r = !0,
      isAlwaysOpen: o = !1
    } = _ref125;
    const s = ee(null),
      a = ee(null),
      i = ee(null),
      [l, c] = le(""),
      [d, f] = le(0),
      [g, p] = le([]),
      [x, m] = le(o),
      [h, j] = le(!1),
      [v, _] = le({}),
      [k, y] = le([]),
      [b, C] = le(null),
      [N, T] = le(!1),
      z = it(() => {
        const P = [];
        return [s, i, a].reduce((D, O) => (O.current && D.push(O), D), P);
      }, [s.current, a.current, i.current]),
      K = () => {
        var P;
        j(!1), o || m(!1), c(""), f(0), (P = s.current) == null || P.blur();
      };
    b && !N && (p(b.results.map(P => P.id)), T(!0));
    const L = P => {
        const [D, O] = f0(P);
        b && Object.keys(O).length === 0 && l.length < t ? p(b.results.map(A => A.id)) : (y(D), _(O), p(Ea(D, n))), f(0);
      },
      H = P => {
        const D = g.findIndex(B => B === `${Ar}${P}`),
          O = g[D - 1],
          A = k.map(B => B.id === P ? {
            ...B,
            showAllResults: !B.showAllResults
          } : B),
          E = Ea(A, n),
          G = E.findIndex(B => B === O);
        f(G), p(E), y(A);
      },
      Y = P => (m(!0), () => P()),
      X = () => {
        var P;
        c(""), f(0), j(!1), (P = s.current) == null || P.focus();
      },
      ne = P => {
        var D;
        c(P.target.value), ((D = P.target.value) == null ? void 0 : D.length) >= t ? j(!0) : (j(!1), c(P.target.value));
      },
      U = P => {
        const D = z.filter(E => E.current && !E.current.disabled).map(E => E.current),
          O = D.findIndex(E => E === document.activeElement);
        let A = null;
        P.shiftKey && Number.isInteger(O) ? A = D[O - 1] ?? D[D.length - 1] : !P.shiftKey && Number.isInteger(O) && (A = D[O + 1] ?? D[0]), A && (P.preventDefault(), A.focus());
      },
      de = P => {
        const D = ["INPUT", "TEXTAREA", "SELECT", "OPTION"],
          A = P.target.tagName;
        x && P.key === "Tab" && U(P), !D.includes(A) && (P.key === "/" && r && (P.preventDefault(), m(!0)), P.key === "Escape" && (P.preventDefault(), K()));
      },
      Z = () => {
        var O;
        const P = window.document.querySelector('div#search-list li[aria-selected="true"] a');
        if (P) return P.click();
        const D = window.document.querySelector(`button#${g[d]}`);
        D && (H(D.dataset.groupId), (O = s.current) == null || O.focus());
      };
    A8("keydown", de);
    const S = P => {
        P.stopPropagation();
        const D = g.length;
        switch (P.key) {
          case "ArrowDown":
            P.preventDefault(), f(O => ((O ?? 0) + 1) % D);
            break;
          case "ArrowUp":
            P.preventDefault(), f(O => ((O ?? 0) - 1 + D) % D);
            break;
          case "Enter":
            P.preventDefault(), Z();
            break;
          case "Tab":
            U(P);
            break;
          case "Escape":
            K();
            break;
        }
      },
      R = {
        onClickFunc: Y,
        activeElementIndex: d,
        setActiveElementIndex: f,
        visibleElementIds: g,
        showAllGroupItems: H,
        isSearchOpen: x,
        setIsSearchOpen: m,
        targetText: l,
        handleTargetText: ne,
        handleCleanTarget: X,
        isDropdownOpen: h,
        setIsDropdownOpen: j,
        reset: K,
        handleOnKeyDown: S,
        inputRef: s,
        closeButtonRef: a,
        eraseButtonRef: i,
        setSearchResults: L,
        resultItems: v,
        resultGroups: k,
        suggestedContent: b,
        setSuggestedContent: C
      },
      ae = it(() => R, [l, c, d, f, g, H, h, x, m, Y, K, S, s, a, i, L, v, k, b, C]);
    return /* @__PURE__ */u.jsx(im.Provider, {
      value: ae,
      children: e
    });
  },
  h0 = e => {
    switch (e) {
      case Vs.Light:
        return L8;
      case Vs.Dark:
      default:
        return $8;
    }
  },
  v0 = _ref126 => {
    let {
      showSearchOpenButton: e,
      showSearchCloseButton: t,
      queryStatusPending: n,
      buttonVariant: r,
      theme: o = Vs.Dark,
      inputClassName: s,
      inputPlaceholderText: a,
      searchClassName: i,
      dropdownDisplayOptions: l
    } = _ref126;
    var H;
    const c = ee(null),
      {
        reset: d,
        isSearchOpen: f,
        setIsSearchOpen: g,
        isDropdownOpen: p,
        handleTargetText: x,
        targetText: m,
        handleCleanTarget: h,
        handleOnKeyDown: j,
        inputRef: v,
        closeButtonRef: _,
        eraseButtonRef: k,
        activeElementIndex: y,
        visibleElementIds: b,
        showAllGroupItems: C,
        resultGroups: N,
        resultItems: T,
        suggestedContent: z
      } = Ti(),
      K = ge(() => {
        d();
      }, []);
    Bm(c, K);
    const L = b.length > 0 ? b[y] : (H = T[y]) == null ? void 0 : H.id;
    return /* @__PURE__ */u.jsxs("div", {
      ref: c,
      className: ye([h0(o), z8({
        states: f ? "open" : "closed"
      }), i]),
      role: "search",
      style: _i({
        [Z8]: l.dropdownHeight
      }),
      children: [/* @__PURE__ */u.jsx(i0, {
        activeDescendant: `search-option-${L}`,
        buttonVariant: r,
        className: s,
        closeButtonRef: _,
        dropdownHasValues: f && (p || z !== null) && !n,
        eraseButtonRef: k,
        handleCleanTarget: h,
        handleOnKeyDown: j,
        handleTargetText: x,
        inputRef: v,
        isSearchOpen: f,
        placeholder: a,
        reset: d,
        setIsSearchOpen: g,
        showSearchCloseButton: t,
        showSearchOpenButton: e,
        queryStatusPending: n,
        targetText: m,
        theme: o
      }), /* @__PURE__ */u.jsx(g0, {
        activeElementId: b[y] ?? null,
        displayOptions: l,
        isDropdownOpen: p,
        isSearchOpen: f,
        queryStatusPending: n,
        resultGroups: N,
        resultItems: T,
        showAllGroupItems: C,
        suggestedContent: z
      })]
    });
  };
var _0 = "_69x9vj0",
  j0 = "_69x9vj1";
function dI(_ref127) {
  let {
    children: e
  } = _ref127;
  return /* @__PURE__ */u.jsx("div", {
    className: _0,
    children: /* @__PURE__ */u.jsx("nav", {
      className: j0,
      children: e
    })
  });
}
const um = "Collapsible",
  [y0, dm] = Vt(um),
  [x0, Di] = y0(um),
  k0 = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeCollapsible: n,
        open: r,
        defaultOpen: o,
        disabled: s,
        onOpenChange: a,
        ...i
      } = e,
      [l = !1, c] = Nn({
        prop: r,
        defaultProp: o,
        onChange: a
      });
    return /* @__PURE__ */F(x0, {
      scope: n,
      disabled: s,
      contentId: sn(),
      open: l,
      onOpenToggle: ge(() => c(d => !d), [c])
    }, /* @__PURE__ */F(Oe.div, V({
      "data-state": Oi(l),
      "data-disabled": s ? "" : void 0
    }, i, {
      ref: t
    })));
  }),
  M0 = "CollapsibleTrigger",
  b0 = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeCollapsible: n,
        ...r
      } = e,
      o = Di(M0, n);
    return /* @__PURE__ */F(Oe.button, V({
      type: "button",
      "aria-controls": o.contentId,
      "aria-expanded": o.open || !1,
      "data-state": Oi(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      disabled: o.disabled
    }, r, {
      ref: t,
      onClick: _e(e.onClick, o.onOpenToggle)
    }));
  }),
  fm = "CollapsibleContent",
  w0 = /* @__PURE__ */ce((e, t) => {
    const {
        forceMount: n,
        ...r
      } = e,
      o = Di(fm, e.__scopeCollapsible);
    return /* @__PURE__ */F(un, {
      present: n || o.open
    }, _ref128 => {
      let {
        present: s
      } = _ref128;
      return /* @__PURE__ */F(C0, V({}, r, {
        ref: t,
        present: s
      }));
    });
  }),
  C0 = /* @__PURE__ */ce((e, t) => {
    const {
        __scopeCollapsible: n,
        present: r,
        children: o,
        ...s
      } = e,
      a = Di(fm, n),
      [i, l] = le(r),
      c = ee(null),
      d = Fe(t, c),
      f = ee(0),
      g = f.current,
      p = ee(0),
      x = p.current,
      m = a.open || i,
      h = ee(m),
      j = ee();
    return fe(() => {
      const v = requestAnimationFrame(() => h.current = !1);
      return () => cancelAnimationFrame(v);
    }, []), Et(() => {
      const v = c.current;
      if (v) {
        j.current = j.current || {
          transitionDuration: v.style.transitionDuration,
          animationName: v.style.animationName
        }, v.style.transitionDuration = "0s", v.style.animationName = "none";
        const _ = v.getBoundingClientRect();
        f.current = _.height, p.current = _.width, h.current || (v.style.transitionDuration = j.current.transitionDuration, v.style.animationName = j.current.animationName), l(r);
      }
    }, [a.open, r]), /* @__PURE__ */F(Oe.div, V({
      "data-state": Oi(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !m
    }, s, {
      ref: d,
      style: {
        "--radix-collapsible-content-height": g ? `${g}px` : void 0,
        "--radix-collapsible-content-width": x ? `${x}px` : void 0,
        ...e.style
      }
    }), m && o);
  });
function Oi(e) {
  return e ? "open" : "closed";
}
const N0 = k0,
  I0 = b0,
  E0 = w0,
  dn = "Accordion",
  S0 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"],
  [Ai, T0, D0] = Yr(dn),
  [so, fI] = Vt(dn, [D0, dm]),
  $i = dm(),
  pm = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        type: n,
        ...r
      } = e,
      o = r,
      s = r;
    return /* @__PURE__ */te.createElement(Ai.Provider, {
      scope: e.__scopeAccordion
    }, n === "multiple" ? /* @__PURE__ */te.createElement(L0, V({}, s, {
      ref: t
    })) : /* @__PURE__ */te.createElement($0, V({}, o, {
      ref: t
    })));
  });
pm.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && !["single", "multiple"].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [mm, O0] = so(dn),
  [gm, A0] = so(dn, {
    collapsible: !1
  }),
  $0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        value: n,
        defaultValue: r,
        onValueChange: o = () => {},
        collapsible: s = !1,
        ...a
      } = e,
      [i, l] = Nn({
        prop: n,
        defaultProp: r,
        onChange: o
      });
    return /* @__PURE__ */te.createElement(mm, {
      scope: e.__scopeAccordion,
      value: i ? [i] : [],
      onItemOpen: l,
      onItemClose: te.useCallback(() => s && l(""), [s, l])
    }, /* @__PURE__ */te.createElement(gm, {
      scope: e.__scopeAccordion,
      collapsible: s
    }, /* @__PURE__ */te.createElement(hm, V({}, a, {
      ref: t
    }))));
  }),
  L0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        value: n,
        defaultValue: r,
        onValueChange: o = () => {},
        ...s
      } = e,
      [a = [], i] = Nn({
        prop: n,
        defaultProp: r,
        onChange: o
      }),
      l = te.useCallback(d => i(function () {
        let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return [...f, d];
      }), [i]),
      c = te.useCallback(d => i(function () {
        let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return f.filter(g => g !== d);
      }), [i]);
    return /* @__PURE__ */te.createElement(mm, {
      scope: e.__scopeAccordion,
      value: a,
      onItemOpen: l,
      onItemClose: c
    }, /* @__PURE__ */te.createElement(gm, {
      scope: e.__scopeAccordion,
      collapsible: !0
    }, /* @__PURE__ */te.createElement(hm, V({}, s, {
      ref: t
    }))));
  }),
  [z0, oo] = so(dn),
  hm = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        __scopeAccordion: n,
        disabled: r,
        dir: o,
        orientation: s = "vertical",
        ...a
      } = e,
      i = te.useRef(null),
      l = Fe(i, t),
      c = T0(n),
      f = Wr(o) === "ltr",
      g = _e(e.onKeyDown, p => {
        var x;
        if (!S0.includes(p.key)) return;
        const m = p.target,
          h = c().filter(T => {
            var z;
            return !((z = T.ref.current) !== null && z !== void 0 && z.disabled);
          }),
          j = h.findIndex(T => T.ref.current === m),
          v = h.length;
        if (j === -1) return;
        p.preventDefault();
        let _ = j;
        const k = 0,
          y = v - 1,
          b = () => {
            _ = j + 1, _ > y && (_ = k);
          },
          C = () => {
            _ = j - 1, _ < k && (_ = y);
          };
        switch (p.key) {
          case "Home":
            _ = k;
            break;
          case "End":
            _ = y;
            break;
          case "ArrowRight":
            s === "horizontal" && (f ? b() : C());
            break;
          case "ArrowDown":
            s === "vertical" && b();
            break;
          case "ArrowLeft":
            s === "horizontal" && (f ? C() : b());
            break;
          case "ArrowUp":
            s === "vertical" && C();
            break;
        }
        const N = _ % v;
        (x = h[N].ref.current) === null || x === void 0 || x.focus();
      });
    return /* @__PURE__ */te.createElement(z0, {
      scope: n,
      disabled: r,
      direction: o,
      orientation: s
    }, /* @__PURE__ */te.createElement(Ai.Slot, {
      scope: n
    }, /* @__PURE__ */te.createElement(Oe.div, V({}, a, {
      "data-orientation": s,
      ref: l,
      onKeyDown: r ? void 0 : g
    }))));
  }),
  Sa = "AccordionItem",
  [R0, Li] = so(Sa),
  P0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        __scopeAccordion: n,
        value: r,
        ...o
      } = e,
      s = oo(Sa, n),
      a = O0(Sa, n),
      i = $i(n),
      l = sn(),
      c = r && a.value.includes(r) || !1,
      d = s.disabled || e.disabled;
    return /* @__PURE__ */te.createElement(R0, {
      scope: n,
      open: c,
      disabled: d,
      triggerId: l
    }, /* @__PURE__ */te.createElement(N0, V({
      "data-orientation": s.orientation,
      "data-state": vm(c)
    }, i, o, {
      ref: t,
      disabled: d,
      open: c,
      onOpenChange: f => {
        f ? a.onItemOpen(r) : a.onItemClose(r);
      }
    })));
  }),
  V0 = "AccordionHeader",
  F0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        __scopeAccordion: n,
        ...r
      } = e,
      o = oo(dn, n),
      s = Li(V0, n);
    return /* @__PURE__ */te.createElement(Oe.h3, V({
      "data-orientation": o.orientation,
      "data-state": vm(s.open),
      "data-disabled": s.disabled ? "" : void 0
    }, r, {
      ref: t
    }));
  }),
  $c = "AccordionTrigger",
  U0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        __scopeAccordion: n,
        ...r
      } = e,
      o = oo(dn, n),
      s = Li($c, n),
      a = A0($c, n),
      i = $i(n);
    return /* @__PURE__ */te.createElement(Ai.ItemSlot, {
      scope: n
    }, /* @__PURE__ */te.createElement(I0, V({
      "aria-disabled": s.open && !a.collapsible || void 0,
      "data-orientation": o.orientation,
      id: s.triggerId
    }, i, r, {
      ref: t
    })));
  }),
  Y0 = "AccordionContent",
  W0 = /* @__PURE__ */te.forwardRef((e, t) => {
    const {
        __scopeAccordion: n,
        ...r
      } = e,
      o = oo(dn, n),
      s = Li(Y0, n),
      a = $i(n);
    return /* @__PURE__ */te.createElement(E0, V({
      role: "region",
      "aria-labelledby": s.triggerId,
      "data-orientation": o.orientation
    }, a, r, {
      ref: t,
      style: {
        "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
        "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
        ...e.style
      }
    }));
  });
function vm(e) {
  return e ? "open" : "closed";
}
const _m = pm,
  B0 = P0,
  jm = F0,
  H0 = U0,
  Q0 = W0;
var q0 = "cq59705",
  K0 = "cq59706",
  Z0 = "cq59707",
  G0 = "cq59708",
  ym = {
    inactive: "cq5970a cq59709",
    active: "cq5970b cq59709"
  },
  J0 = "cq5970d cq5970c",
  X0 = "cq5970e cq5970c";
const Lc = _ref129 => {
    let {
      position: e
    } = _ref129;
    const t = ee(null),
      [n, r] = te.useState(!1);
    return fe(() => {
      if (!t.current) return;
      const o = t.current,
        s = new IntersectionObserver(a => {
          a.forEach(i => {
            r(i.intersectionRatio === 0);
          });
        }, {
          root: null,
          threshold: 0.1
        });
      return s.observe(o), () => s.unobserve(o);
    }, [t]), /* @__PURE__ */u.jsxs(u.Fragment, {
      children: [/* @__PURE__ */u.jsx("div", {
        ref: t,
        "aria-hidden": "true",
        style: {
          height: 1
        }
      }), /* @__PURE__ */u.jsx("div", {
        "aria-hidden": "true",
        className: e === "bottom" ? J0 : X0,
        style: {
          visibility: n ? "visible" : "hidden"
        }
      })]
    });
  },
  pI = ce((_ref130, r) => {
    let {
      children: e,
      defaultValue: t,
      ...n
    } = _ref130;
    return /* @__PURE__ */u.jsx(pe, {
      as: "aside",
      className: q0,
      ...n,
      innerRef: r,
      children: /* @__PURE__ */u.jsx(_m, {
        defaultValue: t,
        type: "multiple",
        asChild: !0,
        children: /* @__PURE__ */u.jsxs("nav", {
          className: K0,
          children: [/* @__PURE__ */u.jsx(Lc, {
            position: "top"
          }), /* @__PURE__ */u.jsx(pe, {
            as: "ul",
            margin: "none",
            children: e
          }), /* @__PURE__ */u.jsx(Lc, {
            position: "bottom"
          })]
        })
      })
    });
  }),
  mI = ce((_ref131, n) => {
    let {
      children: e,
      ...t
    } = _ref131;
    return /* @__PURE__ */u.jsx(B0, {
      asChild: !0,
      ...t,
      children: /* @__PURE__ */u.jsx("li", {
        ref: n,
        className: G0,
        children: e
      })
    });
  }),
  gI = _ref132 => {
    let {
      children: e,
      active: t,
      ...n
    } = _ref132;
    const r = t ? "active" : "inactive";
    return /* @__PURE__ */u.jsx(jm, {
      asChild: !0,
      children: /* @__PURE__ */u.jsxs(H0, {
        className: ym[r],
        ...n,
        children: [/* @__PURE__ */u.jsx(Kc, {}), e]
      })
    });
  },
  hI = _ref133 => {
    let {
      children: e,
      active: t,
      showRevealers: n = !1,
      ...r
    } = _ref133;
    const o = t ? "active" : "inactive";
    return /* @__PURE__ */u.jsx(jm, {
      asChild: !0,
      children: /* @__PURE__ */u.jsxs(pe, {
        as: "a",
        className: ym[o],
        ...r,
        children: [n ? /* @__PURE__ */u.jsx(Kc, {}) : null, e]
      })
    });
  },
  vI = _ref134 => {
    let {
      children: e,
      ...t
    } = _ref134;
    return /* @__PURE__ */u.jsx(Q0, {
      children: /* @__PURE__ */u.jsx(_m, {
        asChild: !0,
        ...t,
        children: /* @__PURE__ */u.jsx("ul", {
          className: Z0,
          children: e
        })
      })
    });
  },
  eC = {
    navigationItems: [{
      id: "2wOcUObtkClJzzeekFES4r",
      name: "Products",
      type: "category",
      parent: null
    }, {
      id: "5H8DI71vzSVJUS8Q8xNAm6",
      name: "Edge Cloud Platform",
      url: "https://www.fastly.com/products",
      parent: "2wOcUObtkClJzzeekFES4r"
    }, {
      id: "2J49LU99RxHbn3FYo1VdDW",
      name: "Pricing",
      url: "https://www.fastly.com/pricing",
      parent: "2wOcUObtkClJzzeekFES4r"
    }, {
      id: "4xSX3KoED0o9N6NiFzv4rN",
      name: "Try Fastly Free",
      url: "https://www.fastly.com/signup",
      parent: "2wOcUObtkClJzzeekFES4r"
    }, {
      id: "2qx2v3GyVHn3JGgE4vUPVS",
      name: "Network Map",
      url: "https://www.fastly.com/network-map",
      parent: "2wOcUObtkClJzzeekFES4r"
    }, {
      id: "2YaWVUVo2MopDqY2iU97ut",
      name: "Solutions",
      type: "category",
      parent: null
    }, {
      id: "7lUfxNKma124HKY8qQJBHM",
      name: "Professional Services",
      url: "https://www.fastly.com/solutions/professional-services",
      parent: "2YaWVUVo2MopDqY2iU97ut"
    }, {
      id: "5uc5NK0t8lyJ5To3XPlNZl",
      name: "Managed CDN",
      url: "https://www.fastly.com/solutions/managed-cdn",
      parent: "2YaWVUVo2MopDqY2iU97ut"
    }, {
      id: "5kXeUWK1xeyrP1cVQVub9K",
      name: "Support Plans",
      url: "https://www.fastly.com/services/support-plans",
      parent: "2YaWVUVo2MopDqY2iU97ut"
    }, {
      id: "5rHP9x5Ju5VUMf0lzZVhGW",
      name: "Talk to an Expert",
      url: "https://www.fastly.com/contact-sales",
      parent: "2YaWVUVo2MopDqY2iU97ut"
    }, {
      id: "2v40eVVbP35BSVKxCjFMYy",
      name: "Learn",
      type: "category",
      parent: null
    }, {
      id: "d1glOpfrxh3It9byNp5C7",
      name: "Documentation",
      url: "https://www.fastly.com/documentation/",
      parent: "2v40eVVbP35BSVKxCjFMYy"
    }, {
      id: "41wUAnpLDX7v4e862vTXmv",
      name: "Developers",
      url: "https://www.fastly.com/documentation/developers/",
      parent: "2v40eVVbP35BSVKxCjFMYy"
    }, {
      id: "1bOPKUmTcYLN1mbXRBH62M",
      name: "Resource Library",
      url: "https://www.fastly.com/resources",
      parent: "2v40eVVbP35BSVKxCjFMYy"
    }, {
      id: "6KfOsygZV8WDxffzsglOoX",
      name: "Blog",
      url: "https://www.fastly.com/blog",
      parent: "2v40eVVbP35BSVKxCjFMYy"
    }, {
      id: "3JSujDzMHlKLH7KXOTDVz",
      name: "Events",
      url: "https://www.fastly.com/events",
      parent: "2v40eVVbP35BSVKxCjFMYy"
    }, {
      id: "6ArISFtzDjsNyQeSKLMWuP",
      name: "Support",
      type: "category",
      parent: null
    }, {
      id: "2El3CCBPHjyqfHZia7BbUf",
      name: "Support Center",
      url: "https://support.fastly.com/",
      parent: "6ArISFtzDjsNyQeSKLMWuP"
    }, {
      id: "2rlEkGofYllR9hL8ibmiZG",
      name: "Network Status",
      url: "https://www.fastlystatus.com/",
      parent: "6ArISFtzDjsNyQeSKLMWuP"
    }, {
      id: "eevRq1frQxCwV6SvWn09L",
      name: "Contact Us",
      url: "https://www.fastly.com/contact-us",
      parent: "6ArISFtzDjsNyQeSKLMWuP"
    }, {
      id: "1AjZtzRB3cMKDJd5hTM72d",
      name: "Company",
      type: "category",
      parent: null
    }, {
      id: "1L9PKfSlFjuNjmgyzNvKpV",
      name: "About Us",
      url: "https://www.fastly.com/company",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "xnK6qfCdCyQcKbl2ppCHH",
      name: "Careers",
      url: "https://www.fastly.com/about/careers",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "5obaKvjQfOYuw3FjHy3xHv",
      name: "Customer Stories",
      url: "https://www.fastly.com/customers",
      description: "See how the best of the web succeed",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "4nPd2YDZ0fkJDCFxCnioKq",
      name: "Partners",
      url: "https://www.fastly.com/partners",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "4xTB2so3SBVCIoQqtXilVf",
      name: "News",
      url: "https://www.fastly.com/press",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "2J4ZrDDIQ1jUdLCEnRrqh4",
      name: "Investor Relations",
      url: "https://investors.fastly.com/",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "2nFbsUhKdPdfahVJT5zCOa",
      name: "Trust",
      url: "https://www.fastly.com/trust",
      parent: "1AjZtzRB3cMKDJd5hTM72d"
    }, {
      id: "649CQnLEcdDYjuTuNXdAO4",
      name: "Archives",
      url: "https://docs.fastly.com/archives",
      parent: null
    }, {
      id: "6yLhQkIzSWiQQMhjMAOB4o",
      name: "Changelog",
      url: "https://docs.fastly.com/changes/",
      parent: null
    }, {
      id: "3DHoHE1JFP3L9QKz4Xtkz4",
      name: "Translations",
      url: "https://docs.fastly.com/translations",
      parent: null
    }, {
      id: "3nBuO0XEACuJgp8W13J970",
      name: "Terms of Service",
      url: "https://www.fastly.com/terms/",
      parent: null
    }, {
      id: "h4P8gKgJGKk6aM7z7butq",
      name: "Policy FAQ",
      url: "https://www.fastly.com/trust/faq",
      parent: null
    }]
  },
  tC = {
    navigationItems: [{
      id: "2OGEQdHOp2h8sFZpV8Vyrb",
      name: "Guides",
      url: "https://docs.fastly.com/en/guides/",
      primaryActionText: "See all guides",
      parent: null
    }, {
      id: "10zW9ePAyVxFdQUF1onFnJ",
      name: "Network services",
      type: "category",
      description: "Customize your content delivery.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "72VROd6UuQWEbssr1KmYG1",
      name: "Full-Site Delivery (CDN)",
      url: "https://docs.fastly.com/en/guides/full-site-delivery/ ",
      parent: "10zW9ePAyVxFdQUF1onFnJ"
    }, {
      id: "oTFUTM4BCN0qlR8TIe40o",
      name: "Streaming Delivery",
      url: "https://docs.fastly.com/en/guides/streaming-configuration-guidelines",
      parent: "10zW9ePAyVxFdQUF1onFnJ"
    }, {
      id: "5CZxQ4yiYd75KSA3KSswM4",
      name: "Purging",
      url: "https://docs.fastly.com/en/guides/purging",
      parent: "10zW9ePAyVxFdQUF1onFnJ"
    }, {
      id: "3MdsUJYDeWUnxKmxGhIo1V",
      name: "Image Optimizer",
      url: "https://docs.fastly.com/en/guides/about-fastly-image-optimizer",
      parent: "10zW9ePAyVxFdQUF1onFnJ"
    }, {
      id: "1DmZUwfiawT5w00e2BeUF7",
      name: "Security",
      type: "category",
      description: "Protect your services and applications.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "6AJ2RrT0ct8q1w1jcko72m",
      name: "Next-Gen WAF",
      url: "https://docs.fastly.com/en/ngwaf",
      parent: "1DmZUwfiawT5w00e2BeUF7"
    }, {
      id: "4c8LIGjOouOfhQcsG1nXGE",
      name: "Edge Rate Limiting",
      url: "https://docs.fastly.com/en/guides/about-rate-limiting",
      parent: "1DmZUwfiawT5w00e2BeUF7"
    }, {
      id: "3S463sKRSzavIo7dNVpoNL",
      name: "Access Control Lists",
      url: "https://docs.fastly.com/en/guides/about-acls",
      parent: "1DmZUwfiawT5w00e2BeUF7"
    }, {
      id: "32biBvYijXJ2BFgsx3fNPD",
      name: "TLS",
      url: "https://docs.fastly.com/en/guides/tls",
      parent: "1DmZUwfiawT5w00e2BeUF7"
    }, {
      id: "2XQkb6TVvTQRWi4BvpKqUj",
      name: "Compute",
      type: "category",
      description: "Experiment with Fastly's edge computing platform.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "29GBbmlIVyLQ9etsOh3T5v",
      name: "Compute services",
      url: "https://www.fastly.com/documentation/guides/compute/",
      parent: "2XQkb6TVvTQRWi4BvpKqUj"
    }, {
      id: "fMfpsSBHvXuazBWKvpQpx",
      name: "Testing and debugging",
      url: "https://www.fastly.com/documentation/guides/compute/testing/",
      parent: "2XQkb6TVvTQRWi4BvpKqUj"
    }, {
      id: "3LGxDJPgkVqaNy1KQgQpNr",
      name: "Edge Data Storage",
      url: "https://www.fastly.com/documentation/guides/concepts/edge-state/dynamic-config#config-stores",
      parent: "2XQkb6TVvTQRWi4BvpKqUj"
    }, {
      id: "7HcifCUm3Mrgh6hiM5Ufny",
      name: "Quick start",
      type: "category",
      description: "Go from zero to Fastly with these step-by-step guides and tutorials.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "4HtuOOO2i17iWpK2SUWa57",
      name: "CDN getting started guide",
      url: "https://docs.fastly.com/en/guides/start-here",
      parent: "7HcifCUm3Mrgh6hiM5Ufny"
    }, {
      id: "xYMioLTDBQ7Uj4vfaa15U",
      name: "Compute getting started guide",
      url: "https://www.fastly.com/documentation/guides/compute/",
      parent: "7HcifCUm3Mrgh6hiM5Ufny"
    }, {
      id: "1X37EEzwLjjEf8bFmRTCsB",
      name: "Building blocks",
      type: "category",
      description: "Start with the basics and learn how Fastly lets you take advantage of the modern internet.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "5U0tO16VojWNgotg99h2O2",
      name: "Services",
      url: "https://docs.fastly.com/en/guides/services",
      parent: "1X37EEzwLjjEf8bFmRTCsB"
    }, {
      id: "6WRaSIXpSPp47GapGvktrc",
      name: "Core concepts",
      url: "https://www.fastly.com/documentation/guides/concepts/",
      parent: "1X37EEzwLjjEf8bFmRTCsB"
    }, {
      id: "Mwd0dzHJJbrizVpkQF7Yy",
      name: "Web interface guides",
      url: "https://docs.fastly.com/en/guides/web-interface",
      parent: "1X37EEzwLjjEf8bFmRTCsB"
    }, {
      id: "BkdlJ4mk1JpN8JOstKcGA",
      name: "Integrations",
      type: "category",
      description: "Find out how Fastly services interoperate with non-Fastly services.",
      parent: "2OGEQdHOp2h8sFZpV8Vyrb"
    }, {
      id: "2reScoLQ3s7dPYaskxhF5E",
      name: "Streaming logs",
      url: "https://docs.fastly.com/en/guides/streaming-logs",
      parent: "BkdlJ4mk1JpN8JOstKcGA"
    }, {
      id: "5qSrgbUlFaqqWHepXme88e",
      name: "Logging endpoints",
      url: "https://docs.fastly.com/en/guides/logging-endpoints",
      parent: "BkdlJ4mk1JpN8JOstKcGA"
    }, {
      id: "2f0ftziZkRSgvjRrbUEoKf",
      name: "Non-Fastly services",
      url: "https://docs.fastly.com/en/guides/non-fastly-services",
      parent: "BkdlJ4mk1JpN8JOstKcGA"
    }, {
      id: "5He3yJzUyGW1ZQKoIfhenL",
      name: "Reference",
      url: "https://www.fastly.com/documentation/reference",
      parent: null
    }, {
      id: "6G0YMGqiLz4t2L1j3RMkPU",
      name: "VCL platform",
      url: "https://www.fastly.com/documentation/reference/vcl/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "3YjWtErPkHic8gkWoDWxPq",
      name: "Compute platform",
      url: "https://www.fastly.com/documentation/reference/compute/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "4Q7uwaiCHII1I2ufnmFFhW",
      name: "Fastly API",
      url: "https://www.fastly.com/documentation/reference/api/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "1Dmq2DtvaL1LZDs9tqvuai",
      name: "Next-Gen WAF API",
      url: "https://docs.fastly.com/signalsciences/api/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "1LinaNldSAnW0csldFLLAO",
      name: "Fastly CLI",
      url: "https://www.fastly.com/documentation/reference/cli/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "4ZRTpg7zLgoQ4Ltx7qnjX5",
      name: "Image Optimizer",
      url: "https://www.fastly.com/documentation/reference/io/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "6Atrzcmbb2JEnmpxvRQmFg",
      name: "HTTP reference",
      url: "https://www.fastly.com/documentation/reference/http/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "7h23nTpB9DJWOvTBSWZE71",
      name: "Tools",
      url: "https://www.fastly.com/documentation/reference/tools/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "6tmtxh0ssbp7jgo3vs2BqY",
      name: "Glossary",
      url: "https://www.fastly.com/documentation/reference/glossary/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "2mXKihmXuXsVn3uqgPUM3d",
      name: "Changelog",
      url: "https://www.fastly.com/documentation/reference/changes/",
      parent: "5He3yJzUyGW1ZQKoIfhenL"
    }, {
      id: "BO82kFmxkuCOOoGWspyex",
      name: "Solutions",
      url: "https://www.fastly.com/documentation/solutions",
      parent: null
    }, {
      id: "3bi0xcFmnVSlIFAGMdqZub",
      name: "Tutorials",
      url: "https://www.fastly.com/documentation/solutions/tutorials/",
      type: "category",
      description: "Step-by-step guides to developing with Fastly",
      parent: "BO82kFmxkuCOOoGWspyex"
    }, {
      id: "5f9VqtONFxfNNi2373QRuR",
      name: "Deliver a site with Fastly",
      url: "https://www.fastly.com/documentation/solutions/tutorials/deliver-your-site/",
      parent: "3bi0xcFmnVSlIFAGMdqZub"
    }, {
      id: "7k5WCIcMHLM9E2zgJQHAag",
      name: "Enhance your UX with Compute",
      url: "https://www.fastly.com/documentation/solutions/tutorials/enhance-ux/",
      parent: "3bi0xcFmnVSlIFAGMdqZub"
    }, {
      id: "6PSEMsSMGYsyMYVISn1Uov",
      name: "Edge deploy Next-Gen WAF",
      url: "https://www.fastly.com/documentation/solutions/tutorials/next-gen-waf-edge-integration/",
      parent: "3bi0xcFmnVSlIFAGMdqZub"
    }, {
      id: "5lS1DIi72si4FnKZSBSf9G",
      name: "See all tutorials",
      url: "https://www.fastly.com/documentation/solutions/tutorials/",
      parent: "3bi0xcFmnVSlIFAGMdqZub"
    }, {
      id: "4dWNASpN2XbMPQpWitYAJQ",
      name: "Demos",
      url: "https://www.fastly.com/documentation/solutions/demos/",
      type: "category",
      description: "Discover how Fastly can enhance your user experience.",
      parent: "BO82kFmxkuCOOoGWspyex"
    }, {
      id: "2DFE3zD7NG8GAqm60JI4dn",
      name: "Passwordless auth",
      url: "https://www.fastly.com/documentation/solutions/demos/passkeys/",
      parent: "4dWNASpN2XbMPQpWitYAJQ"
    }, {
      id: "3SVHYjzN1KluxJCmjNKb7Q",
      name: "Fanout chat",
      url: "https://www.fastly.com/documentation/solutions/demos/fanout-chat-demo/",
      parent: "4dWNASpN2XbMPQpWitYAJQ"
    }, {
      id: "5dhrtWVPFMVgTeRxH8SQVV",
      name: "Social sharing cards",
      url: "https://www.fastly.com/documentation/solutions/demos/edge-social-cards/",
      parent: "4dWNASpN2XbMPQpWitYAJQ"
    }, {
      id: "kGIYcZVoBkd4TTBLrvunp",
      name: "See all demos",
      url: "https://www.fastly.com/documentation/solutions/demos/",
      parent: "4dWNASpN2XbMPQpWitYAJQ"
    }, {
      id: "4Y4wwk7BXIRBqxhLeLaVdo",
      name: "Use Cases",
      url: "https://www.fastly.com/documentation/solutions/use-cases/",
      type: "category",
      description: "Get solutions to specific problems with curated topics.",
      parent: "BO82kFmxkuCOOoGWspyex"
    }, {
      id: "774up9a4erjUUwTXbvTzYW",
      name: "Authentication",
      url: "https://www.fastly.com/documentation/solutions/use-cases/authentication/",
      parent: "4Y4wwk7BXIRBqxhLeLaVdo"
    }, {
      id: "5FgSAgoFGsNmWYMpDrbIIf",
      name: "Geolocation",
      url: "https://www.fastly.com/documentation/solutions/use-cases/geolocation/",
      parent: "4Y4wwk7BXIRBqxhLeLaVdo"
    }, {
      id: "oY08m4bDzEuju6oVIalzx",
      name: "Personalization",
      url: "https://www.fastly.com/documentation/solutions/use-cases/personalization/",
      parent: "4Y4wwk7BXIRBqxhLeLaVdo"
    }, {
      id: "7G2AVHDn294x45DioA20Ln",
      name: "See all use cases",
      url: "https://www.fastly.com/documentation/solutions/use-cases/",
      parent: "4Y4wwk7BXIRBqxhLeLaVdo"
    }, {
      id: "1J7WyzwJNo4SrImDltCxJu",
      name: "Code Examples",
      url: "https://www.fastly.com/documentation/solutions/examples/",
      type: "category",
      description: "Try out Fastly code in the browser and easily remix it for your own project.",
      parent: "BO82kFmxkuCOOoGWspyex"
    }, {
      id: "4OHtEF8IyF8SC4CSaj84lw",
      name: "Geolocation at the edge",
      url: "https://www.fastly.com/documentation/solutions/examples/geo-ip-api-at-the-edge/",
      parent: "1J7WyzwJNo4SrImDltCxJu"
    }, {
      id: "4OSawArzYWLnk9ZKJofpjc",
      name: "Optimize images on the fly",
      url: "https://www.fastly.com/documentation/solutions/examples/image-optimization/",
      parent: "1J7WyzwJNo4SrImDltCxJu"
    }, {
      id: "4FuBoZtEFI2Ede46N3DPSp",
      name: "Redirect URLs at the edge",
      url: "https://www.fastly.com/documentation/solutions/examples/redirect-old-urls-at-the-edge/",
      parent: "1J7WyzwJNo4SrImDltCxJu"
    }, {
      id: "t1x7RN3dFJnyH2JTap2fh",
      name: "See all code examples",
      url: "https://www.fastly.com/documentation/solutions/examples/",
      parent: "1J7WyzwJNo4SrImDltCxJu"
    }, {
      id: "2ntbiHdHxd9eRmhyiRniBV",
      name: "Starter Kits",
      url: "https://www.fastly.com/documentation/solutions/starters/",
      type: "category",
      description: "Start developing your project immediately with Fastly from a functional template.",
      parent: "BO82kFmxkuCOOoGWspyex"
    }, {
      id: "giRovUqCFE6dFbNvJ16rj",
      name: "Rust default starter",
      url: "https://www.fastly.com/documentation/solutions/starters/compute-starter-kit-rust-default/",
      parent: "2ntbiHdHxd9eRmhyiRniBV"
    }, {
      id: "5Jq29AcgV4rxY0CYgIC0rP",
      name: "JavaScript default starter",
      url: "https://www.fastly.com/documentation/solutions/starters/compute-starter-kit-javascript-default/",
      parent: "2ntbiHdHxd9eRmhyiRniBV"
    }, {
      id: "6nF7QM0JvpzwTmCTLABPaJ",
      name: "Go default starter",
      url: "https://www.fastly.com/documentation/solutions/starters/compute-starter-kit-go-default/",
      parent: "2ntbiHdHxd9eRmhyiRniBV"
    }, {
      id: "7AOOUdmICWn4ZE5ppAV36B",
      name: "See all starter kits",
      url: "https://www.fastly.com/documentation/solutions/starters/",
      parent: "2ntbiHdHxd9eRmhyiRniBV"
    }, {
      id: "7EGCMnNqrCxYP5Kz80sxdL",
      name: "Products",
      url: "https://docs.fastly.com/products",
      parent: null
    }, {
      id: "5tDMd0H18OtD37JQh5YWmp",
      name: "Network services",
      url: "https://docs.fastly.com/products/product-network-services",
      parent: "7EGCMnNqrCxYP5Kz80sxdL"
    }, {
      id: "7d9mA7Dh582ugg22oN7kdH",
      name: "Security",
      url: "https://docs.fastly.com/products/product-security",
      parent: "7EGCMnNqrCxYP5Kz80sxdL"
    }, {
      id: "6YMjcDEsOtK5BfDplzgRpI",
      name: "Observability",
      url: "https://docs.fastly.com/products/product-observability",
      parent: "7EGCMnNqrCxYP5Kz80sxdL"
    }, {
      id: "3t3MGU8WUoyFFuOVATN4hG",
      name: "Compute",
      url: "https://docs.fastly.com/products/product-compute",
      parent: "7EGCMnNqrCxYP5Kz80sxdL"
    }, {
      id: "2ur4rDsY6EAHBPlnn3d59t",
      name: "Support solutions",
      url: "https://docs.fastly.com/products/product-support",
      parent: "7EGCMnNqrCxYP5Kz80sxdL"
    }, {
      id: "1ZU1xunZWYhTVdzRAkRjvV",
      name: "Developers",
      parent: null
    }, {
      id: "5mrH28qEf0aXVBZZoZsTKg",
      name: "Developers home",
      url: "https://www.fastly.com/documentation/developers/",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }, {
      id: "4brKmimETFu9LrzxJb4RWK",
      name: "Community",
      url: "https://www.fastly.com/documentation/developers/community/",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }, {
      id: "2dRP74jK3yMAqQvdVAwPWL",
      name: "Events",
      url: "https://www.fastly.com/documentation/developers/community/events/",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }, {
      id: "7yYnHHy1gfjRh0szIL8K4M",
      name: "Open source",
      url: "https://www.fastly.com/documentation/developers/community/open-source/",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }, {
      id: "52MlnvSlLgriG4bfGcl4bZ",
      name: "Blog",
      url: "https://dev.to/fastly",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }, {
      id: "7fZktwwx2FKDEDlI4sWoC8",
      name: "Labs",
      url: "https://www.fastly.com/documentation/developers/labs/",
      parent: "1ZU1xunZWYhTVdzRAkRjvV"
    }]
  },
  xm = {
    footer: eC,
    main: tC
  },
  {
    footer: nC
  } = xm,
  {
    navigationItems: rC
  } = nC,
  Ta = rC,
  sC = _ref135 => {
    let {
      category: e
    } = _ref135;
    const t = Ta.filter(n => n.parent === e.id);
    return /* @__PURE__ */u.jsxs(Uh, {
      children: [/* @__PURE__ */u.jsx(Yh, {
        children: e.name
      }), /* @__PURE__ */u.jsx(Ra, {
        children: t.map(n => /* @__PURE__ */u.jsx(Pa, {
          "data-no-dark-mode": "true",
          href: n.url,
          children: n.name
        }, n.id))
      })]
    });
  },
  oC = _ref136 => {
    let {
      onColorModeToggle: e,
      colorModeToggleProps: t
    } = _ref136;
    return e ? /* @__PURE__ */u.jsx(au, {
      flexDirection: "row",
      children: /* @__PURE__ */u.jsx(Ra, {
        children: /* @__PURE__ */u.jsx(Pa, {
          onClick: e,
          ...t,
          "data-no-dark-mode": "true"
        })
      })
    }) : null;
  },
  _I = e => {
    const t = Ta.filter(o => o.parent === null && o.type === "category"),
      n = Ta.filter(o => o.parent === null && o.type !== "category"),
      r = (/* @__PURE__ */new Date()).getFullYear();
    return /* @__PURE__ */u.jsxs(Ph, {
      "data-swiftype-index": "false",
      children: [/* @__PURE__ */u.jsx(Vh, {
        children: /* @__PURE__ */u.jsx("img", {
          alt: "Fastly",
          src: qM
        })
      }), /* @__PURE__ */u.jsx(Fh, {
        children: t.map(o => /* @__PURE__ */u.jsx(sC, {
          category: o
        }, o.id))
      }), /* @__PURE__ */u.jsx(oC, {
        ...e
      }), /* @__PURE__ */u.jsx(au, {
        flexDirection: "row",
        children: /* @__PURE__ */u.jsxs(pe, {
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "lg",
          children: [/* @__PURE__ */u.jsxs(Wh, {
            children: ["© Fastly ", r]
          }), /* @__PURE__ */u.jsx(Ra, {
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "xl",
            children: n.map(o => /* @__PURE__ */u.jsx(Pa, {
              "data-no-dark-mode": "true",
              href: o.url,
              children: o.name
            }, o.id))
          })]
        })
      })]
    });
  },
  zc = "data:image/svg+xml;base64,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",
  aC = "data:image/svg+xml;base64,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",
  iC = "dy68xLmkjSsmNno-h32E",
  lC = "https://search-api.swiftype.com/api/v1/public/engines/search.json";
function cC(e, t) {
  t.reverse().forEach(n => {
    e.sort((r, o) => r[0] === n ? -1 : 0);
  });
}
const Bt = {
    Idle: "idle",
    Pending: "pending",
    Fulfilled: "fulfilled",
    Errored: "errored"
  },
  uC = 300;
function dC() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  const [n, r] = le(null),
    [o, s] = le(Bt.Idle),
    a = ge(yf(async () => {
      try {
        const i = await fetch(lC, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
              engine_key: iC,
              q: e,
              document_types: ["unified"],
              per_page: 25,
              page: 1,
              spelling: "retry",
              // Trim the response to only the fields we need.
              // See: https://swiftype.com/documentation/site-search/searching#multi-public
              highlight_fields: {
                unified: ["term", "headings_joined"]
              },
              fetch_fields: {
                unified: ["group", "content_type",
                // "content_type_id",
                "category",
                // "tags",
                "collection", "term",
                // "headings" - enum fields require an exact match of the full field value
                "headings_joined", "heading_slugs",
                // "term_words",
                "url", "path", "description", "body", "data_type", "method"
                // "subroutines",
                // "returns",
                // "access",
                // "custom_weight"
                ]
              }
            })
          }),
          {
            records: {
              unified: l
            }
          } = await i.json(),
          c = {};
        (l || []).forEach(g => {
          c[g.group] = c[g.group] || {}, c[g.group][g.content_type] = c[g.group][g.content_type] || [], c[g.group][g.content_type].push(g);
        });
        const d = Object.entries(c);
        cC(d, ["Guides", "Reference", "Solutions", "Products", "Elsewhere on Fastly"]), r(d), s(Bt.Fulfilled);
      } catch {
        s(Bt.Errored), r(null);
      }
    }, uC), [e, r, s]);
  return fe(() => {
    if (!e || e.length < t) {
      s(Bt.Idle), r(null);
      return;
    }
    return s(Bt.Pending), a(), () => {
      a.cancel(), s(Bt.Idle);
    };
  }, [e]), {
    results: n,
    status: o
  };
}
var fC = "th7oxy0",
  pC = "th7oxy1",
  mC = "th7oxy2",
  gC = "th7oxy3",
  hC = "th7oxy6",
  Rc = {
    top: "th7oxy8 th7oxy7",
    bottom: "th7oxy9 th7oxy7"
  },
  vC = "th7oxya",
  _C = "th7oxyb",
  jC = "th7oxyc",
  yC = {
    closed: "th7oxye th7oxyd",
    open: "th7oxyf th7oxyd"
  },
  km = "th7oxyg",
  xC = "th7oxyh",
  kC = "th7oxyi";
const MC = _ref137 => {
    let {
      targetText: e
    } = _ref137;
    return /* @__PURE__ */u.jsxs("div", {
      className: Qm,
      children: [/* @__PURE__ */u.jsxs("h5", {
        children: [`We couldn't find any matches for "`, e, '"']
      }), /* @__PURE__ */u.jsxs("ul", {
        children: [/* @__PURE__ */u.jsx("li", {
          children: "Try searching for a different keyword."
        }), /* @__PURE__ */u.jsx("li", {
          children: "Check that all words are spelled correctly."
        }), /* @__PURE__ */u.jsx("li", {
          children: "Try using more general terms."
        })]
      }), /* @__PURE__ */u.jsx("h6", {
        children: "Still can't find what you're looking for?"
      }), /* @__PURE__ */u.jsxs("ul", {
        children: [/* @__PURE__ */u.jsxs("li", {
          children: [/* @__PURE__ */u.jsx("a", {
            href: "https://support.fastly.com/hc/en-us/requests/new?ticket_form_id=360000269711",
            children: "Contact support"
          }), " ", "to request help."]
        }), /* @__PURE__ */u.jsxs("li", {
          children: [/* @__PURE__ */u.jsx("a", {
            href: "https://community.fastly.com/",
            children: "Visit our community forums"
          }), " to talk to Fastly experts."]
        }), /* @__PURE__ */u.jsxs("li", {
          children: [/* @__PURE__ */u.jsx("a", {
            href: "https://www.fastly.com/contact-sales/",
            children: "Connect with an expert"
          }), " for a demonstration."]
        })]
      })]
    });
  },
  Mm = _ref138 => {
    let {
      showSearchOpenButton: e = !0,
      showSuggestedContent: t = !0,
      onBlur: n,
      onFocus: r
    } = _ref138;
    const [o, s] = le([]),
      [a, i] = le(!1),
      {
        targetText: l,
        isSearchOpen: c,
        isDropdownOpen: d,
        setSearchResults: f,
        setSuggestedContent: g
      } = Ti(),
      {
        results: p,
        status: x
      } = dC(l, 3);
    !c && a !== c && n && (n(), i(c)), c && a !== c && r && (r(), i(c)), fe(() => {
      e || (d && r ? r() : !d && n && n());
    }, [d, e, r, n]), fe(() => {
      t && g({
        title: "Suggested Content",
        id: "suggested-content",
        showAllResults: !0,
        allowVisibilityToggle: !1,
        results: [{
          id: "suggested-1",
          title: "Working with CNAME records and your DNS provider",
          href: "https://docs.fastly.com/en/guides/working-with-cname-records-and-your-dns-provider",
          alwaysVisible: !0
        }, {
          id: "suggested-2",
          title: "Adding or modifying headers on HTTP requests and responses",
          href: "https://docs.fastly.com/en/guides/adding-or-modifying-headers-on-http-requests-and-responses",
          alwaysVisible: !0
        }, {
          id: "suggested-3",
          title: "Caching configuration best practices",
          href: "https://docs.fastly.com/en/guides/caching-best-practices",
          alwaysVisible: !0
        }, {
          id: "suggested-4",
          title: "Fastly-generated 503 errors in VCL",
          href: "https://developer.fastly.com/learning/vcl/errors/",
          alwaysVisible: !0
        }, {
          id: "suggested-5",
          title: "Controlling caching",
          href: "https://docs.fastly.com/en/guides/controlling-caching",
          alwaysVisible: !0
        }]
      });
    }, [g, t]);
    const m = it(() => x === Bt.Fulfilled && p && p.length > 0 ? m0(p, l) : [{
        title: "All Results",
        allowVisibilityToggle: !1,
        showAllResults: !0,
        results: []
      }], [l, x, p]),
      h = Ea(m);
    JSON.stringify(h) !== JSON.stringify(o) && (f(m), s(h));
    const j = yC[c && e ? "open" : "closed"];
    return /* @__PURE__ */u.jsx("div", {
      className: j,
      children: /* @__PURE__ */u.jsx(v0, {
        showSearchOpenButton: e,
        showSearchCloseButton: c && e,
        queryStatusPending: x === Bt.Pending,
        dropdownDisplayOptions: {
          showGroupTitle: !0,
          showDescription: !1,
          showContentType: !0,
          renderNoResults: v => /* @__PURE__ */u.jsx(MC, {
            targetText: v
          })
        },
        buttonVariant: Kt.Responsive,
        inputClassName: kC
      })
    });
  },
  bm = () => typeof window < "u" && !!window.zoomCampaignSdk,
  bC = () => {
    var e;
    bm() && ((e = window.zoomCampaignSdk) == null || e.hide());
  },
  wC = () => {
    var e;
    bm() && ((e = window.zoomCampaignSdk) == null || e.show());
  };
var rt = /* @__PURE__ */(e => (e[e.TOGGLE_MENU = 0] = "TOGGLE_MENU", e[e.OPEN_MENU = 1] = "OPEN_MENU", e[e.CLOSE_MENU = 2] = "CLOSE_MENU", e[e.INCREMENT = 3] = "INCREMENT", e[e.DECREMENT = 4] = "DECREMENT", e[e.RESET = 5] = "RESET", e))(rt || {});
const wm = {
    level: 1,
    open: !1,
    activeItem: null,
    previousItem: null
  },
  CC = _ref139 => {
    let {
      logo: e,
      navigationItems: t,
      actions: n
    } = _ref139;
    const [r, o] = le(null),
      [s, a] = le(!1),
      [i, l] = $r(NC, wm),
      c = h => {
        h ? (l({
          type: rt.OPEN_MENU
        }), bC()) : (l({
          type: rt.CLOSE_MENU
        }), l({
          type: rt.RESET
        }), wC());
      },
      d = (h, j, v) => {
        h.preventDefault(), l({
          type: v,
          payload: j
        });
      },
      {
        activeItem: f,
        previousItem: g
      } = i,
      p = t.filter(h => h.parent === ((f == null ? void 0 : f.id) ?? null)),
      x = _ref140 => {
        let {
          item: h
        } = _ref140;
        const j = t.some(v => v.parent === h.id);
        return /* @__PURE__ */u.jsx(u.Fragment, {
          children: j ? /* @__PURE__ */u.jsx(wc, {
            dataName: h.name,
            description: h.description,
            onClick: v => d(v, h, rt.INCREMENT),
            children: h.name
          }) : /* @__PURE__ */u.jsx(wc, {
            dataName: h.name,
            description: h.description,
            href: h.url,
            children: h.name
          })
        });
      },
      m = () => i.level > 1 ? /* @__PURE__ */u.jsxs(vb, {
        children: [/* @__PURE__ */u.jsxs(pe, {
          as: "button",
          display: "flex",
          alignItems: "center",
          onClick: () => l({
            type: rt.RESET
          }),
          children: [/* @__PURE__ */u.jsx(og, {}), "Main menu"]
        }), i.level > 2 && g ? /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("span", {
            "aria-hidden": !0,
            children: "/"
          }), /* @__PURE__ */u.jsx(pe, {
            as: "button",
            display: "flex",
            alignItems: "center",
            onClick: () => l({
              type: rt.DECREMENT,
              payload: g
            }),
            children: g.name
          })]
        }) : null]
      }) : null;
    return /* @__PURE__ */u.jsxs(hb, {
      ref: o,
      open: i.open,
      setOpen: c,
      children: [/* @__PURE__ */u.jsx(jb, {
        src: e
      }), /* @__PURE__ */u.jsx(_b, {
        children: i.open ? /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("span", {
            children: "Close"
          }), /* @__PURE__ */u.jsx(ig, {})]
        }) : /* @__PURE__ */u.jsxs(u.Fragment, {
          children: [/* @__PURE__ */u.jsx("span", {
            children: "Menu"
          }), /* @__PURE__ */u.jsx(lg, {})]
        })
      }), /* @__PURE__ */u.jsx(yb, {
        container: r,
        children: /* @__PURE__ */u.jsxs(xb, {
          nestedLevel: i.level,
          children: [/* @__PURE__ */u.jsx("div", {
            className: xC,
            children: /* @__PURE__ */u.jsx(cm, {
              minCharacters: 3,
              groupResults: !0,
              isAlwaysOpen: !0,
              children: /* @__PURE__ */u.jsx(Mm, {
                showSearchOpenButton: !1,
                showSuggestedContent: !1,
                onBlur: () => a(!1),
                onFocus: () => a(!0)
              })
            })
          }), /* @__PURE__ */u.jsx(m, {}), f ? /* @__PURE__ */u.jsx(kb, {
            icon: null,
            children: f.name
          }) : null, /* @__PURE__ */u.jsx(Mb, {
            children: p.map(h => /* @__PURE__ */u.jsx(x, {
              item: h
            }, h.id))
          }), i.level === 1 ? /* @__PURE__ */u.jsx(bb, {
            children: n
          }) : null, s ? /* @__PURE__ */u.jsx("div", {
            className: km
          }) : null]
        })
      })]
    });
  };
function NC(e, t) {
  switch (t.type) {
    case rt.TOGGLE_MENU:
      return {
        ...e,
        open: !e.open
      };
    case rt.OPEN_MENU:
      return {
        ...e,
        open: !0
      };
    case rt.CLOSE_MENU:
      return {
        ...e,
        open: !1
      };
    case rt.INCREMENT:
      return {
        ...e,
        level: e.level + 1,
        activeItem: t.payload ?? null,
        previousItem: e.activeItem ?? null
      };
    case rt.DECREMENT:
      return {
        ...e,
        level: e.level - 1,
        activeItem: t.payload ?? null,
        previousItem: e.activeItem ?? null
      };
    case rt.RESET:
      return {
        ...wm,
        open: e.open
      };
    default:
      return e;
  }
}
const {
    main: IC
  } = xm,
  {
    navigationItems: EC
  } = IC,
  ao = EC,
  SC = ao.filter(e => e.parent === null),
  Pc = _ref141 => {
    let {
      category: e
    } = _ref141;
    const t = ao.filter(n => n.parent === e.id);
    return /* @__PURE__ */u.jsxs("div", {
      className: _C,
      children: [/* @__PURE__ */u.jsx(ut, {
        as: "h5",
        type: "lg",
        weight: 500,
        children: e.name
      }), /* @__PURE__ */u.jsx(ut, {
        as: "p",
        type: "sm",
        weight: 400,
        children: e.description
      }), /* @__PURE__ */u.jsx("ul", {
        className: vC,
        children: t.map(n => n.url ? /* @__PURE__ */u.jsx(Jp, {
          "data-no-dark-mode": "true",
          href: n.url,
          title: n.name
        }, n.id) : null)
      })]
    });
  },
  TC = _ref142 => {
    let {
      item: e,
      isActive: t,
      wasActive: n
    } = _ref142;
    const r = ao.filter(s => s.parent === e.id),
      o = r.filter(s => s.type === "category");
    return r.length <= 1 ? /* @__PURE__ */u.jsx(Kw, {
      "data-no-dark-mode": "true",
      href: e.url,
      children: e.name
    }) : /* @__PURE__ */u.jsxs(qw, {
      value: e.id,
      children: [/* @__PURE__ */u.jsx(Zw, {
        children: e.name
      }), /* @__PURE__ */u.jsx(_p, {
        className: pC,
        "data-active": t,
        "data-last-selected": n,
        forceMount: !0,
        children: /* @__PURE__ */u.jsx("div", {
          className: mC,
          children: o.length > 0 ? /* @__PURE__ */u.jsxs(ng, {
            gap: "xl",
            children: [/* @__PURE__ */u.jsxs("div", {
              className: hC,
              children: [/* @__PURE__ */u.jsx("div", {
                className: Rc.top,
                children: o.slice(0, 3).map(s => /* @__PURE__ */u.jsx(Pc, {
                  category: s
                }, s.id))
              }), /* @__PURE__ */u.jsx("div", {
                className: Rc.bottom,
                children: o.slice(3).map(s => /* @__PURE__ */u.jsx(Pc, {
                  category: s
                }, s.id))
              })]
            }), e.primaryActionText ? /* @__PURE__ */u.jsx(er, {
              className: jC,
              "data-no-dark-mode": "true",
              href: e.url,
              children: e.primaryActionText
            }) : null]
          }) : /* @__PURE__ */u.jsx("div", {
            className: gC,
            children: /* @__PURE__ */u.jsx(Gw, {
              children: r.map(s => s.url ? /* @__PURE__ */u.jsx(Jp, {
                "data-no-dark-mode": "true",
                href: s.url,
                title: s.name
              }, s.id) : null)
            })
          })
        })
      })]
    });
  },
  DC = () => /* @__PURE__ */u.jsxs(u.Fragment, {
    children: [/* @__PURE__ */u.jsx(Zt, {
      colorModes: "dark",
      "data-no-dark-mode": "true",
      url: "https://manage.fastly.com",
      variant: "outline",
      children: "Log in"
    }), /* @__PURE__ */u.jsx(Zt, {
      colorModes: "dark",
      "data-no-dark-mode": "true",
      url: "https://www.fastly.com/signup",
      children: "Try Fastly free"
    })]
  }),
  jI = _ref143 => {
    let {
      renderActions: e
    } = _ref143;
    const [t, n] = le(""),
      r = ee(""),
      [o, s] = le(!1),
      a = () => {
        s(!0);
      },
      i = () => {
        s(!1);
      };
    fe(() => {
      r.current = t;
    }, [t]);
    const l = r.current,
      c = e ?? DC;
    return /* @__PURE__ */u.jsxs("div", {
      className: fC,
      "data-swiftype-index": "false",
      children: [/* @__PURE__ */u.jsx("div", {
        className: hs({
          display: {
            _: "none",
            lg: "block"
          }
        }),
        children: /* @__PURE__ */u.jsxs(Yw, {
          value: t,
          noMaxWidth: !0,
          onValueChange: d => n(d),
          children: [/* @__PURE__ */u.jsxs(Ww, {
            children: [/* @__PURE__ */u.jsx(er, {
              "aria-label": "Fastly Home",
              href: "https://www.fastly.com/",
              children: /* @__PURE__ */u.jsx(zs, {
                alt: "",
                src: aC
              })
            }), /* @__PURE__ */u.jsx(er, {
              "aria-label": "Documentation Home",
              href: "https://www.fastly.com/documentation",
              children: /* @__PURE__ */u.jsx(zs, {
                alt: "",
                src: zc
              })
            })]
          }), /* @__PURE__ */u.jsxs(Bw, {
            viewport: !0,
            children: [/* @__PURE__ */u.jsx("div", {
              className: o ? km : "",
              children: /* @__PURE__ */u.jsx(Qw, {
                children: SC.map(d => /* @__PURE__ */u.jsx(TC, {
                  isActive: t === d.id,
                  item: d,
                  wasActive: l === d.id
                }, d.id))
              })
            }), /* @__PURE__ */u.jsxs(Hw, {
              children: [/* @__PURE__ */u.jsx(cm, {
                minCharacters: 3,
                groupResults: !0,
                children: /* @__PURE__ */u.jsx(Mm, {
                  onBlur: i,
                  onFocus: a
                })
              }), /* @__PURE__ */u.jsx(c, {})]
            })]
          })]
        })
      }), /* @__PURE__ */u.jsx("div", {
        className: hs({
          display: {
            _: "block",
            lg: "none"
          }
        }),
        children: /* @__PURE__ */u.jsx(CC, {
          actions: /* @__PURE__ */u.jsx(c, {}),
          logo: zc,
          navigationItems: ao
        })
      })]
    });
  };
var OC = "xg4goq1",
  AC = "xg4goq2",
  Vc = "xg4goq9",
  Fc = "xg4goqa",
  $C = "xg4goqb",
  LC = "xg4goqc",
  zC = "xg4goqd",
  RC = "var(--xg4goqe)",
  PC = "var(--xg4goqf)",
  VC = "xg4goqg",
  FC = "xg4goqh",
  UC = "xg4goqi",
  YC = "xg4goqj",
  WC = "xg4goqk",
  BC = "xg4goql",
  HC = "xg4goqm",
  QC = "xg4goqn",
  qC = "xg4goqo",
  KC = "xg4goqp",
  ZC = "xg4goqq",
  Uc = "xg4goqr",
  GC = "xg4goqs",
  JC = "xg4goqt",
  XC = "xg4goqu",
  eN = "xg4goqv",
  tN = "xg4goqw",
  nN = "xg4goqx",
  Yc = "xg4goqy",
  rN = "xg4goqz",
  sN = "xg4goq10",
  oN = "xg4goq11",
  aN = "xg4goq12",
  iN = "xg4goq13";
function lN() {
  return /* @__PURE__ */u.jsx("div", {
    className: OC,
    children: /* @__PURE__ */u.jsx("div", {
      className: AC
    })
  });
}
function yI(_ref144) {
  let {
    data: e,
    autoplayTime: t = 1e4,
    inView: n = !1
  } = _ref144;
  const [r, o] = te.useState(""),
    [s, a] = te.useState(!0),
    i = it(() => e.map(p => p.id) || [], [e]);
  fe(() => {
    (!r || !i.includes(r)) && o(i[0]);
  }, [e, i, r]);
  const {
    nextSlide: l,
    progressRef: c
  } = su({
    autoplay: s,
    autoplayTime: t,
    slidesIds: i,
    selectedSlide: r,
    setSelectedSlide: o
  });
  fe(() => {
    n && (s || a(!0));
  }, [n, s]);
  const d = p => {
      a(!1), o(p);
    },
    f = (p, x) => {
      a(!1);
      const m = i.indexOf(x);
      if (p.key === "ArrowLeft" || p.key === "Up") {
        if (m !== null && m > 0) {
          const h = i[m - 1];
          d(h), p.currentTarget.previousElementSibling instanceof HTMLButtonElement && p.currentTarget.previousElementSibling.focus();
        }
      } else if ((p.key === "ArrowRight" || p.key === "Down") && m < i.length - 1) {
        const h = i[m + 1];
        d(h), p.currentTarget.nextElementSibling instanceof HTMLButtonElement && p.currentTarget.nextElementSibling.focus();
      }
    },
    g = {
      none: null,
      black: "#000000",
      blue: "#000E3F",
      green: "#427100",
      indigo: "#730CDA",
      red: "#881007",
      orange: "#AE2F00",
      violet: "#80144E",
      yellow: "#887B00"
    };
  return /* @__PURE__ */u.jsxs("div", {
    className: $C,
    children: [/* @__PURE__ */u.jsx("div", {
      className: LC,
      children: e.map(p => {
        const x = r === p.id,
          m = x ? Vc : Fc,
          h = p.image ? p.image : "undefined";
        return /* @__PURE__ */u.jsxs("div", {
          "aria-labelledby": `tab-content-${p.id}`,
          className: zC,
          "data-visibility": x,
          children: [/* @__PURE__ */u.jsxs("div", {
            className: VC,
            style: _i({
              [RC]: `url(${h})`,
              [PC]: `${g[p.imageColorGradient]}`
            }),
            children: [/* @__PURE__ */u.jsxs("div", {
              className: ye([FC, m]),
              children: [/* @__PURE__ */u.jsx(ut, {
                className: UC,
                children: p.headline
              }), /* @__PURE__ */u.jsx("div", {
                className: eN,
                "data-active": x,
                children: p.industry
              })]
            }), /* @__PURE__ */u.jsxs("div", {
              className: ye([YC, m]),
              children: [p.logoOnDarkBackground ? /* @__PURE__ */u.jsx("div", {
                className: Uc,
                dangerouslySetInnerHTML: {
                  __html: p.logoOnDarkBackground
                }
              }) : null, !p.logoOnDarkBackground && p.logoOnLightBackground ? /* @__PURE__ */u.jsx("div", {
                className: ye([Uc, sN]),
                dangerouslySetInnerHTML: {
                  __html: p.logoOnLightBackground
                }
              }) : null, p.ctaUrl ? /* @__PURE__ */u.jsx(Zt, {
                colorModes: "dark",
                renderIconAfter: () => /* @__PURE__ */u.jsx(zr, {}),
                url: p.ctaUrl,
                variant: "solid"
              }) : null]
            })]
          }), p.highlightedStats ? /* @__PURE__ */u.jsx("div", {
            className: ye([KC, m]),
            children: p.highlightedStats.map(j => {
              var v;
              return /* @__PURE__ */u.jsxs("div", {
                className: ZC,
                children: [j != null && j.bigNumber ? /* @__PURE__ */u.jsx("div", {
                  className: oN,
                  children: j.bigNumber
                }) : null, (v = j == null ? void 0 : j.headlineEyebrow) != null && v.text ? /* @__PURE__ */u.jsx("div", {
                  className: aN,
                  children: j.headlineEyebrow.text
                }) : null, /* @__PURE__ */u.jsx("div", {
                  className: iN,
                  children: j.descriptor
                })]
              }, `stat-${j.id}`);
            })
          }) : null, p.highlightedStats ? null : /* @__PURE__ */u.jsx("div", {
            className: WC,
            children: /* @__PURE__ */u.jsxs("div", {
              className: ye([BC, r === p.id ? Vc : Fc]),
              "data-testimonial": "quotes",
              children: [/* @__PURE__ */u.jsx(ut, {
                as: "p",
                className: HC,
                children: p.quote
              }), /* @__PURE__ */u.jsxs("div", {
                children: [/* @__PURE__ */u.jsx(ut, {
                  as: "p",
                  className: QC,
                  children: p.attributionName
                }), /* @__PURE__ */u.jsx(ut, {
                  as: "p",
                  className: qC,
                  children: p.attributionJobTitle
                })]
              })]
            })
          })]
        }, `tab-content-${p.id}`);
      })
    }), i.length > 1 ? /* @__PURE__ */u.jsxs("div", {
      className: GC,
      children: [/* @__PURE__ */u.jsx("div", {
        className: nN,
        role: "tablist",
        children: e.map(p => {
          const x = r === p.id;
          return /* @__PURE__ */u.jsxs("button", {
            "aria-label": p.companyName,
            className: JC,
            role: "tab",
            tabIndex: x ? 0 : -1,
            type: "button",
            onClick: () => d(p.id),
            onKeyDown: m => f(m, p.id),
            children: [i.length > 1 && x ? /* @__PURE__ */u.jsx(lN, {}) : null, /* @__PURE__ */u.jsx("div", {
              className: x ? `${Yc} ${rN}` : Yc,
              dangerouslySetInnerHTML: {
                __html: p.logoOnLightBackground ?? ""
              }
            }), /* @__PURE__ */u.jsx("div", {
              className: XC,
              "data-active": x,
              children: p.industry
            })]
          }, `testimonial-button-${p.id}`);
        })
      }), /* @__PURE__ */u.jsx("div", {
        className: tN,
        children: /* @__PURE__ */u.jsx(ru, {
          activeSlide: r,
          nextSlide: l,
          progressRef: c,
          slidesIds: i,
          onClick: d
        })
      })]
    }) : null]
  });
}
var Wc = {
    grid: {
      rows: "var(--c7kc1v1)",
      columns: "var(--c7kc1v2)"
    }
  },
  cN = Ue({
    defaultClassName: "c7kc1v3",
    variantClassNames: {
      variant: {
        dark: "c7kc1v4",
        light: "c7kc1v5"
      }
    },
    defaultVariants: {},
    compoundVariants: []
  }),
  uN = "c7kc1v6";
function xI(_ref145) {
  let {
    children: e,
    variant: t = "light",
    padding: n = "xl",
    columnStart: r = void 0,
    columnCount: o = void 0,
    rowStart: s = void 0,
    rowCount: a = void 0,
    ...i
  } = _ref145;
  const l = () => {
    const c = {};
    return r ? c.gridColumn = `${r} / ${r + (o ?? 1)}` : o && (c.gridColumn = `1 / ${1 + o}`), s ? c.gridRow = `${s} / ${s + (a ?? 1)}` : a && (c.gridRow = `1 / ${1 + a}`), c;
  };
  return /* @__PURE__ */u.jsx(pe, {
    ...i,
    className: ye([cN({
      variant: t
    }), i.className]),
    padding: n,
    style: l(),
    children: e
  });
}
function kI(_ref146) {
  let {
    children: e,
    columnsCount: t = 1,
    rowsCount: n = 1,
    gap: r = "xl",
    display: o = {
      _: "flex",
      md: "grid"
    },
    flexDirection: s = "column",
    ...a
  } = _ref146;
  return /* @__PURE__ */u.jsx(pe, {
    ...a,
    className: ye([uN, a.className]),
    display: o,
    flexDirection: s,
    gap: r,
    style: {
      ..._i({
        [Wc.grid.columns]: `repeat(${t}, 1fr)`,
        [Wc.grid.rows]: `repeat(${n}, 1fr)`
      }),
      ...a.style
    },
    children: e
  });
}
export { IN as AnnouncementCard, jN as Body, pe as Box, Zt as Button, Kt as ButtonVariant, EN as Card, TN as Carousel, SN as CarouselItem, _N as ConsistentlyProvider, DN as CookieBanner, l0 as EraseIcon, CN as Eyebrow, Ph as Footer, ON as FooterBottomColumn, au as FooterBottomContainer, Pa as FooterLink, Uh as FooterLinksGroup, Yh as FooterLinksGroupHeading, Fh as FooterLinksGroupsContainer, Ra as FooterLinksList, Vh as FooterLogoWrapper, Wh as FooterText, AN as FormField, VN as FormFieldCheckbox, PN as FormFieldCreatableSelect, YN as FormFieldPassword, My as FormFieldRadio, FN as FormFieldRadioGroup, zN as FormFieldSelect, RN as FormFieldSelectItem, $N as FormFieldTextArea, yN as H1, xN as H2, kN as H3, MN as H4, bN as H5, wN as H6, Cn as Heading, BN as LANGUAGES, WN as LanguageSelector, uh as LeftSideContent, Oa as LoadingSpinner, HN as Marquee, QN as MarqueeItem, hb as MobileMenu, bb as MobileMenuActions, vb as MobileMenuBreadcrumbs, xb as MobileMenuContent, wc as MobileMenuItem, Mb as MobileMenuList, jb as MobileMenuLogo, yb as MobileMenuPortal, kb as MobileMenuSectionTitle, _b as MobileMenuTrigger, ZN as MobileSubMenuItem, Ca as MosaicContentTile, wa as MosaicImageTile, GN as MosaicSection, Yw as NavigationMenu, Hw as NavigationMenuActions, Jp as NavigationMenuContentItem, Gw as NavigationMenuContentList, rI as NavigationMenuFeaturedItem, qw as NavigationMenuItem, Kw as NavigationMenuLink, Qw as NavigationMenuList, Ww as NavigationMenuLogo, Bw as NavigationMenuMain, nI as NavigationMenuPopoverContent, tI as NavigationMenuSecondary, oI as NavigationMenuTabList, aI as NavigationMenuTabPanel, sI as NavigationMenuTabRoot, iI as NavigationMenuTabTrigger, Zw as NavigationMenuTrigger, Yt as PasswordRules, cI as PreFooter, D8 as ProductCardsDesktop, T8 as ProductTabMobile, uI as ProductTabs, dh as RightSideContent, v0 as Search, c0 as SearchButton, u0 as SearchCloseButton, im as SearchContext, g0 as SearchDropdown, d0 as SearchDropdownOption, i0 as SearchInput, cm as SearchProvider, Vs as SearchTheme, dI as SecondaryNavigation, pI as SideMenu, vI as SideMenuContent, mI as SideMenuItem, gI as SideMenuTrigger, hI as SideMenuTriggerLink, ng as Stack, _I as StaticFooter, jI as StaticNavigation, Ar as TOGGLE_ID_PREFIX, ph as TRANSITION_DURATION, fh as TRANSITION_NAME, yI as TestimonialsTabs, ut as Text, xI as Tile, kI as TilesContainer, wI as breakpoints, NN as buttonStyles, ye as classnames, CI as flattenObject, Ea as getVisibleIdsFromGroups, lm as handleKeyDownForButtons, Us as hideVisually, Oc as highlightSearchString, f0 as normalizeGroups, m0 as normalizeInternalResults, hN as proseRegularDarkTheme, gN as proseRegularLightTheme, Qm as proseSmallDarkTheme, vN as proseSmallLightTheme, NI as queries, II as queryRules, Hm as reset, EI as responsiveStyle, hs as sprinkles, eI as styles, Bm as useOnClickOutside, UN as usePasswordField, Ti as useSearchContext, lI as useStickyNavigation };